
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ui": { "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "type": "date picker", "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" } }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } } }, "salesUI": { "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "placeholder": "Select a range", "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDateRangeInputs": { "invalidDateRange": "Please select an end date that isn't before the given start date" }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading…" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" } }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option “{{label}}”", "plusMore": "+ {{count}} more", "andMore": "…and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITableSortToggle": { "ascendingSort": "Ascending sort", "descendingSort": "Descending sort", "noSort": "No sort" }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITextToolbarButton": { "remove": "Remove {{name}}", "noop": "You can't {{name}} the current selection" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-2.3233"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "cs": "static-2.3233",
    "da": "static-2.3233",
    "de": "static-2.3233",
    "el": "static-2.3233",
    "en": "static-2.3233",
    "es-mx": "static-2.3233",
    "es": "static-2.3233",
    "fi": "static-2.3233",
    "fr": "static-2.3233",
    "it": "static-2.3233",
    "ja": "static-2.3233",
    "ko": "static-2.3233",
    "nl": "static-2.3233",
    "no": "static-2.3233",
    "pl": "static-2.3233",
    "pt-br": "static-2.3233",
    "sv": "static-2.3233",
    "zh-cn": "static-2.3233",
    "zh-hk": "static-2.3233"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-2.3233'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "timezone_utils": { "the_time_in": "{{ cityList }} Time", "utc_plus_minus": "UTC {{ offset }} {{ timezone }}", "timezones": { "pacific_time": "Pacific Time", "mountain_time": "Mountain Time", "central_time": "Central Time", "eastern_time": "Eastern Time", "central_european_time": "Central European Time", "eastern_european_time": "Eastern European Time", "eastern_carribean_time": "Eastern Carribean Time", "greenwich_mean_time": "Greenwich Mean Time", "argentinian_time": "Argentinian Time", "south_africa_time": "South Africa Time", "east_africa_time": "East Africa Time", "indochina_time": "Indochina Time", "arizona_time": "Arizona Time", "aed_time": "Australian Eastern Daylight Time" }, "regions": { "africa": "Africa", "america": "America", "antarctica": "Antarctica", "arctic": "Arctic", "asia": "Asia", "atlantic": "Atlantic", "australia": "Australia", "brazil": "Brazil", "canada": "Canada", "chile": "Chile", "europe": "Europe", "indian": "Indian", "mexico": "Mexico", "pacific": "Pacific", "us": "US" }, "countries": { "china": "China" }, "cities": { "abidjan": "Abidjan", "accra": "Accra", "addis_ababa": "Addis Ababa", "algiers": "Algiers", "asmara": "Asmara", "asmera": "Asmera", "astrakhan": "Astrakhan", "bamako": "Bamako", "bangui": "Bangui", "banjul": "Banjul", "barnaul": "Barnaul", "bissau": "Bissau", "blantyre": "Blantyre", "brazzaville": "Brazzaville", "bujumbura": "Bujumbura", "cairo": "Cairo", "casablanca": "Casablanca", "ceuta": "Ceuta", "conakry": "Conakry", "dakar": "Dakar", "dar_es_salaam": "Dar es_Salaam", "djibouti": "Djibouti", "douala": "Douala", "el_aaiun": "El Aaiun", "freetown": "Freetown", "gaborone": "Gaborone", "guadeloupe": "Guadeloupe", "harare": "Harare", "johannesburg": "Johannesburg", "juba": "Juba", "kampala": "Kampala", "khartoum": "Khartoum", "kigali": "Kigali", "kinshasa": "Kinshasa", "lagos": "Lagos", "libreville": "Libreville", "lome": "Lome", "luanda": "Luanda", "lubumbashi": "Lubumbashi", "lusaka": "Lusaka", "malabo": "Malabo", "maputo": "Maputo", "maseru": "Maseru", "mbabane": "Mbabane", "mogadishu": "Mogadishu", "monrovia": "Monrovia", "nairobi": "Nairobi", "ndjamena": "Ndjamena", "niamey": "Niamey", "nouakchott": "Nouakchott", "ouagadougou": "Ouagadougou", "porto-novo": "Porto-Novo", "sao_tome": "Sao Tome", "timbuktu": "Timbuktu", "tripoli": "Tripoli", "tunis": "Tunis", "windhoek": "Windhoek", "adak": "Adak", "anchorage": "Anchorage", "anguilla": "Anguilla", "antigua": "Antigua", "araguaina": "Araguaina", "buenos_aires": "Buenos Aires", "catamarca": "Catamarca", "comodrivadavia": "ComodRivadavia", "cordoba": "Cordoba", "jujuy": "Jujuy", "la_rioja": "La Rioja", "mendoza": "Mendoza", "rio_gallegos": "Rio Gallegos", "salta": "Salta", "san_juan": "San Juan", "san_luis": "San Luis", "tucuman": "Tucuman", "ushuaia": "Ushuaia", "aruba": "Aruba", "asuncion": "Asuncion", "atikokan": "Atikokan", "atka": "Atka", "bahia": "Bahia", "bahia_banderas": "Bahia Banderas", "barbados": "Barbados", "belem": "Belem", "belize": "Belize", "blanc-sablon": "Blanc-Sablon", "boa_vista": "Boa Vista", "bogota": "Bogota", "boise": "Boise", "cambridge_bay": "Cambridge Bay", "campo_grande": "Campo Grande", "cancun": "Cancun", "caracas": "Caracas", "cayenne": "Cayenne", "cayman": "Cayman", "chicago": "Chicago", "chihuahua": "Chihuahua", "coral_harbour": "Coral Harbour", "costa_rica": "Costa Rica", "creston": "Creston", "cuiaba": "Cuiaba", "curacao": "Curacao", "danmarkshavn": "Danmarkshavn", "dawson": "Dawson", "dawson_creek": "Dawson Creek", "denver": "Denver", "detroit": "Detroit", "dominica": "Dominica", "edmonton": "Edmonton", "eirunepe": "Eirunepe", "el_salvador": "El Salvador", "ensenada": "Ensenada", "fort_wayne": "Fort Wayne", "fort_nelson": "Fort Nelson", "fortaleza": "Fortaleza", "glace_bay": "Glace Bay", "godthab": "Godthab", "goose_bay": "Goose Bay", "grand_turk": "Grand Turk", "grenada": "Grenada", "guatemala": "Guatemala", "guayaquil": "Guayaquil", "guyana": "Guyana", "halifax": "Halifax", "havana": "Havana", "hermosillo": "Hermosillo", "indiana": "Indiana", "indianapolis": "Indianapolis", "knox": "Knox", "marengo": "Marengo", "petersburg": "Petersburg", "tell_city": "Tell City", "vevay": "Vevay", "vincennes": "Vincennes", "winamac": "Winamac", "inuvik": "Inuvik", "iqaluit": "Iqaluit", "jamaica": "Jamaica", "juneau": "Juneau", "louisville": "Louisville", "monticello": "Monticello", "knox_in": "Knox IN", "kralendijk": "Kralendijk", "la_paz": "La Paz", "lima": "Lima", "los_angeles": "Los Angeles", "lower_princes": "Lower Princes", "maceio": "Maceio", "managua": "Managua", "manaus": "Manaus", "marigot": "Marigot", "martinique": "Martinique", "matamoros": "Matamoros", "mazatlan": "Mazatlan", "menominee": "Menominee", "merida": "Merida", "metlakatla": "Metlakatla", "mexico_city": "Mexico City", "miquelon": "Miquelon", "moncton": "Moncton", "monterrey": "Monterrey", "montevideo": "Montevideo", "montreal": "Montreal", "montserrat": "Montserrat", "nassau": "Nassau", "new_york": "New York", "nipigon": "Nipigon", "nome": "Nome", "noronha": "Noronha", "beulah": "Beulah", "center": "Center", "new_salem": "New Salem", "ojinaga": "Ojinaga", "panama": "Panama", "pangnirtung": "Pangnirtung", "paramaribo": "Paramaribo", "phoenix": "Phoenix", "port-au-prince": "Port-au-Prince", "port_of_spain": "Port of_Spain", "porto_acre": "Porto Acre", "porto_velho": "Porto Velho", "puerto_rico": "Puerto Rico", "punta_arenas": "Punta Arenas", "rainy_river": "Rainy River", "rankin_inlet": "Rankin Inlet", "recife": "Recife", "regina": "Regina", "resolute": "Resolute", "rio_branco": "Rio Branco", "rosario": "Rosario", "santa_isabel": "Santa Isabel", "santarem": "Santarem", "santiago": "Santiago", "santo_domingo": "Santo Domingo", "sao_paulo": "Sao Paulo", "scoresbysund": "Scoresbysund", "shiprock": "Shiprock", "sitka": "Sitka", "st_barthelemy": "St Barthelemy", "st_johns": "St Johns", "st_kitts": "St Kitts", "st_lucia": "St Lucia", "st_thomas": "St Thomas", "st_vincent": "St Vincent", "swift_current": "Swift Current", "tegucigalpa": "Tegucigalpa", "thule": "Thule", "thunder_bay": "Thunder Bay", "tijuana": "Tijuana", "toronto": "Toronto", "tortola": "Tortola", "vancouver": "Vancouver", "virgin": "Virgin", "whitehorse": "Whitehorse", "winnipeg": "Winnipeg", "yakutat": "Yakutat", "yellowknife": "Yellowknife", "casey": "Casey", "davis": "Davis", "dumontdurville": "DumontDUrville", "macquarie": "Macquarie", "mawson": "Mawson", "mcmurdo": "McMurdo", "palmer": "Palmer", "rothera": "Rothera", "south_pole": "South Pole", "syowa": "Syowa", "troll": "Troll", "vostok": "Vostok", "longyearbyen": "Longyearbyen", "aden": "Aden", "almaty": "Almaty", "amman": "Amman", "anadyr": "Anadyr", "aqtau": "Aqtau", "aqtobe": "Aqtobe", "ashgabat": "Ashgabat", "ashkhabad": "Ashkhabad", "baghdad": "Baghdad", "bahrain": "Bahrain", "baku": "Baku", "bangkok": "Bangkok", "beirut": "Beirut", "bishkek": "Bishkek", "brunei": "Brunei", "calcutta": "Calcutta", "chita": "Chita", "choibalsan": "Choibalsan", "chongqing": "Chongqing", "chungking": "Chungking", "colombo": "Colombo", "dacca": "Dacca", "damascus": "Damascus", "dhaka": "Dhaka", "dili": "Dili", "dubai": "Dubai", "dushanbe": "Dushanbe", "gaza": "Gaza", "harbin": "Harbin", "hebron": "Hebron", "ho_chi_minh": "Ho Chi_Minh", "hong_kong": "Hong Kong", "hovd": "Hovd", "irkutsk": "Irkutsk", "istanbul": "Istanbul", "jakarta": "Jakarta", "jayapura": "Jayapura", "jerusalem": "Jerusalem", "kabul": "Kabul", "kamchatka": "Kamchatka", "karachi": "Karachi", "kashgar": "Kashgar", "kathmandu": "Kathmandu", "katmandu": "Katmandu", "khandyga": "Khandyga", "kolkata": "Kolkata", "krasnoyarsk": "Krasnoyarsk", "kuala_lumpur": "Kuala Lumpur", "kuching": "Kuching", "kuwait": "Kuwait", "macao": "Macao", "macau": "Macau", "magadan": "Magadan", "makassar": "Makassar", "manila": "Manila", "muscat": "Muscat", "nicosia": "Nicosia", "novokuznetsk": "Novokuznetsk", "novosibirsk": "Novosibirsk", "omsk": "Omsk", "oral": "Oral", "phnom_penh": "Phnom Penh", "pontianak": "Pontianak", "pyongyang": "Pyongyang", "qatar": "Qatar", "qyzylorda": "Qyzylorda", "rangoon": "Rangoon", "riyadh": "Riyadh", "saigon": "Saigon", "sakhalin": "Sakhalin", "samarkand": "Samarkand", "seoul": "Seoul", "shanghai": "Shanghai", "singapore": "Singapore", "srednekolymsk": "Srednekolymsk", "taipei": "Taipei", "tashkent": "Tashkent", "tbilisi": "Tbilisi", "tehran": "Tehran", "tel_aviv": "Tel Aviv", "thimbu": "Thimbu", "thimphu": "Thimphu", "tokyo": "Tokyo", "tomsk": "Tomsk", "ujung_pandang": "Ujung Pandang", "ulaanbaatar": "Ulaanbaatar", "ulan_bator": "Ulan Bator", "urumqi": "Urumqi", "ust-nera": "Ust-Nera", "vientiane": "Vientiane", "vladivostok": "Vladivostok", "yakutsk": "Yakutsk", "yekaterinburg": "Yekaterinburg", "yerevan": "Yerevan", "azores": "Azores", "bermuda": "Bermuda", "canary": "Canary", "cape_verde": "Cape Verde", "faeroe": "Faeroe", "faroe": "Faroe", "jan_mayen": "Jan Mayen", "madeira": "Madeira", "reykjavik": "Reykjavik", "south_georgia": "South Georgia", "st_helena": "St Helena", "stanley": "Stanley", "act": "ACT", "adelaide": "Adelaide", "brisbane": "Brisbane", "broken_hill": "Broken Hill", "canberra": "Canberra", "currie": "Currie", "darwin": "Darwin", "eucla": "Eucla", "hobart": "Hobart", "lhi": "LHI", "lindeman": "Lindeman", "lord_howe": "Lord Howe", "melbourne": "Melbourne", "nsw": "NSW", "north": "North", "perth": "Perth", "queensland": "Queensland", "south": "South", "sydney": "Sydney", "tasmania": "Tasmania", "victoria": "Victoria", "west": "West", "yancowinna": "Yancowinna", "acre": "Acre", "denoronha": "DeNoronha", "east": "East", "atlantic": "Atlantic", "central": "Central", "east-saskatchewan": "East-Saskatchewan", "eastern": "Eastern", "mountain": "Mountain", "newfoundland": "Newfoundland", "pacific": "Pacific", "saskatchewan": "Saskatchewan", "yukon": "Yukon", "continental": "Continental", "easterisland": "EasterIsland", "amsterdam": "Amsterdam", "andorra": "Andorra", "athens": "Athens", "belfast": "Belfast", "belgrade": "Belgrade", "berlin": "Berlin", "bratislava": "Bratislava", "brussels": "Brussels", "bucharest": "Bucharest", "budapest": "Budapest", "busingen": "Busingen", "chisinau": "Chisinau", "copenhagen": "Copenhagen", "dublin": "Dublin", "gibraltar": "Gibraltar", "guernsey": "Guernsey", "helsinki": "Helsinki", "isle_of_man": "Isle of_Man", "jersey": "Jersey", "kaliningrad": "Kaliningrad", "kiev": "Kiev", "kirov": "Kirov", "lisbon": "Lisbon", "ljubljana": "Ljubljana", "london": "London", "luxembourg": "Luxembourg", "madrid": "Madrid", "malta": "Malta", "mariehamn": "Mariehamn", "minsk": "Minsk", "monaco": "Monaco", "moscow": "Moscow", "oslo": "Oslo", "paris": "Paris", "podgorica": "Podgorica", "prague": "Prague", "riga": "Riga", "rome": "Rome", "samara": "Samara", "san_marino": "San Marino", "sarajevo": "Sarajevo", "simferopol": "Simferopol", "skopje": "Skopje", "sofia": "Sofia", "stockholm": "Stockholm", "tallinn": "Tallinn", "tirane": "Tirane", "tiraspol": "Tiraspol", "uzhgorod": "Uzhgorod", "ulyanovsk": "Ulyanovsk", "vaduz": "Vaduz", "vatican": "Vatican", "vienna": "Vienna", "vilnius": "Vilnius", "volgograd": "Volgograd", "warsaw": "Warsaw", "zagreb": "Zagreb", "zaporozhye": "Zaporozhye", "zurich": "Zurich", "antananarivo": "Antananarivo", "chagos": "Chagos", "christmas": "Christmas", "cocos": "Cocos", "comoro": "Comoro", "kerguelen": "Kerguelen", "mahe": "Mahe", "maldives": "Maldives", "mauritius": "Mauritius", "mayotte": "Mayotte", "reunion": "Reunion", "bajanorte": "BajaNorte", "bajasur": "BajaSur", "general": "General", "apia": "Apia", "auckland": "Auckland", "bougainville": "Bougainville", "chatham": "Chatham", "chuuk": "Chuuk", "easter": "Easter", "efate": "Efate", "enderbury": "Enderbury", "fakaofo": "Fakaofo", "fiji": "Fiji", "funafuti": "Funafuti", "galapagos": "Galapagos", "gambier": "Gambier", "guadalcanal": "Guadalcanal", "guam": "Guam", "honolulu": "Honolulu", "johnston": "Johnston", "kiritimati": "Kiritimati", "kosrae": "Kosrae", "kwajalein": "Kwajalein", "majuro": "Majuro", "marquesas": "Marquesas", "midway": "Midway", "mumbai": "Mumbai", "nauru": "Nauru", "new_delhi": "New Delhi", "niue": "Niue", "norfolk": "Norfolk", "noumea": "Noumea", "pago_pago": "Pago Pago", "palau": "Palau", "pitcairn": "Pitcairn", "pohnpei": "Pohnpei", "ponape": "Ponape", "port_moresby": "Port Moresby", "rarotonga": "Rarotonga", "saipan": "Saipan", "samoa": "Samoa", "tahiti": "Tahiti", "tarawa": "Tarawa", "tongatapu": "Tongatapu", "truk": "Truk", "wake": "Wake", "wallis": "Wallis", "yap": "Yap", "alaska": "Alaska", "aleutian": "Aleutian", "arizona": "Arizona", "east-indiana": "East-Indiana", "hawaii": "Hawaii", "indiana-starke": "Indiana-Starke", "michigan": "Michigan", "pacific-new": "Pacific-New", "atyrau": "Atyrau", "famagusta": "Famagusta", "saratov": "Saratov", "yangon": "Yangon", "qostanay": "Kostanay" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "timezone-utils": {
    "en": "static-1.76"
  }
};
  result.translationsAvailable = {
  "timezone-utils": {
    "de": "static-1.76",
    "en": "static-1.76",
    "es": "static-1.76",
    "fr": "static-1.76",
    "ja": "static-1.76",
    "nl": "static-1.76",
    "pt-br": "static-1.76"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:timezone-utils:en', {version: 'static-1.76'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "EmailComponentsCrossFrame": { "emailFeaturesShowcase": { "title": "Marketing Hub", "upgradeButton": "Upgrade to Marketing Starter", "featuresButton": "Upgrade", "featuresButtonStarter": "Upgrade to Marketing Starter", "header": { "dashboard": "Upgrade to unlock more email features", "editor": "Upgrade to remove the HubSpot logo from all your emails" }, "branding": "HubSpot branding removed", "sendLimit": "An increased send limit", "analytics": "Additional analytics", "support": "Chat and email support", "sendingDomain": "Your own email sending domain" }, "rssUrl": { "label": "RSS feed URL", "placebolder": "http://www.website.com/rss.xml", "useFeedButton": "Use", "title": "Title", "url": "URL", "status": { "loading": "<em>Validating&hellip;</em>", "timeout": "The RSS feed at this URL is unavailable right now. Please refresh or try again later.", "required": "Please enter a URL for your RSS feed.", "feed_ok": "Great! This feed URL checks out.", "found_rss_feeds": "Several feeds for this address were found. Which one would you like to use?", "no_feeds_found": "Sorry. The RSS feed in this link wasn't found. Please try another one.", "invalid_url": "This feed URL is not valid. Please check it and try again.", "validator_error": "An unexpected error occurred when validating this feed URL.", "http_retrieval_error": "This feed URL failed to load. Please check it and try again.", "feed_empty": "This URL works, but there's no content. Your emails won't be sent until there's content in the RSS feed.", "no_generated_guid": "This URL works, but this email is at risk for sending problems. Add <a href=\"https://knowledge.hubspot.com/articles/kcs_article/email/why-didnt-my-rss-email-send\" target=\"_blank\">these fields</a> to your RSS feed to avoid duplicate emails.", "no_guid_or_link": "This URL works, but this email may have sending problems. Add <a href=\"https://knowledge.hubspot.com/articles/kcs_article/email/why-didnt-my-rss-email-send\" target=\"_blank\">these fields</a> to your RSS feed to avoid duplicate emails." } } }, "EmailComponents": { "alerts": { "probation": { "actionTitle": "What actions do I need to take?", "messageSupport": "If you don't take any action, <strong>your account will be suspended</strong>. You won't be able to send emails until you've taken action to fix the issue. ", "messageNoSupport": "If you don't take any action, <strong>your email account will be locked</strong>, and you'll no longer be able to send emails. " }, "suspension": { "remediation": { "EHAWK": { "title": "Send email with us again", "intro": "Once you fill in and send this form, your answers will be reviewed to decide whether your account can be unblocked.", "close": "Close", "send": "Send", "received": "We've received your form. We'll contact you with more details once your answers have been reviewed." }, "DEFAULT_FORM": { "title": "Create ticket", "intro": "To appeal your suspension, complete this ticket and submit it to HubSpot support. The team will review your appeal and come back to you with the next steps. You should receive a response in a few working days.", "confirm": "Please confirm the following:", "selectOption": "Select an option", "selectOneMoreOption": "Select one or more options", "received": "We've received your form. We'll contact you with more details once your answers have been reviewed.", "cancel": "Cancel", "close": "Close", "send": "Create ticket" } } } }, "timeZoneTable": { "recipientsTitle": "Recipients", "timeZoneTitle": "Recipients time zone", "timeZoneTimestampTitle": "Scheduled time *", "viewTimeZonesButton": "View recipients time zones", "unknownTimeZone": "Unknown", "otherTimeZone": "Other", "unknownTooltip": "These recipients will receive this email in your HubSpot time zone &ndash; {{timezone}} (UTC{{offset}})", "unknownTooltipPublished": "These recipients would receive the email in your HubSpot time zone &ndash; {{timezone}} (UTC{{offset}})", "timezonePassed": "The schedule time for this email has already passed in this timezone. It will be sent the following day.", "emptyRecipients": { "message": "The recipients chosen for this email don’t include any eligible contacts.", "action": "Choose more recipients now." }, "noRecipients": { "message": "It looks like you haven't selected the recipients for this email yet.", "action": "Choose recipients now." } }, "newFeatureShepherd": { "feedback": { "LIKE": "I like it", "DISLIKE": "I don't like it", "UNNOTICED": "I didn't notice", "UNUSED": "I haven't used it yet", "placeholder": "Tell us more..." }, "header": "New feature", "feedbackHeader": "How did we do?", "submit": "Submit", "dismiss": "Dismiss", "confirm": "Got it" }, "common": { "dismiss": "Dismiss", "new": "New" }, "testSend": { "modal": { "header": "Send a test email", "buttonShort": "Test", "button": "Send test email", "verificationRequired": "Your recipient addresses require verification" }, "form": { "header": "Make sure your email hits all the right notes. Send a test version to yourself or a colleague. Test emails are sent from <b>{{ fromAddress }}</b>", "plaintextCheckbox": "Send plain text version", "appearAsNewSendCheckbox": "Test the email as it would appear for new sends" }, "recipients": { "header": "Choose one or more recipients", "addCustom": "Add new recipient: {{email}}", "placeholder": "Search", "verification": { "error": { "one": "The following email address will need to be verified before sending a test email. Without verifying this email will not be sent to this address.", "other": "The following email addresses will need to be verified before sending a test email. Without verifying this email will not be sent to these addresses." }, "verifyAddress": { "one": "Verify address", "other": "Verify addresses" }, "resendVerificationEmail": { "one": "Resend verification email", "other": "Resend verification emails" } } }, "contacts": { "header": "Receive email as specific contact", "placeholder": "Choose contact to preview (optional)", "tooltip": "Preview your email personalization as a specific contact, or see it as an unspecified contact would.", "noPreview": "Choose contact to preview (optional)" }, "errorListHeading": "Sorry. Your test email couldn't be sent.", "sendSuccess": "Test email successfully sent to {{ formattedList }}", "sendFailure": "Test email not sent to {{ formattedList }}", "TEMPLATE_RENDERING_FAILED": "The email could not be rendered.", "renderError": "We couldn't generate the content of your email. Please make sure there are no remaining issues with it or contact support." }, "limitAlert": { "warningTitle": "You're close to the send limit.", "warningText": "You have {{remaining}} out of {{limit}} sends remaining this month. {{link}}", "dangerTitle": "You've used {{limit}} out of {{limit}} email sends.", "dangerText": "Unlock more emails with {{link}}.", "getMore": "Get more sends", "learnMore": "Learn more.", "upgrade": "Upgrade", "marketingPro": "Marketing Pro" }, "sendLimits": { "sendingLimitUsagePanelMessaging": "{{creditsRemaining}} sends remaining in your current billing term. Once you hit your email sending limit, scheduled and automated emails will no longer be sent from your account.", "usageLimitPanelButton": "View sending limits", "free": { "remaining_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You have ",
props.remaining,
" email sends left for this month. To add more emails to your sending limit, you’ll need to ",
createElement( options,
"UpgradeLink",
null,
"upgrade to Marketing Starter ",
createElement( options,
"ExternalLinkIcon",
{ name: "externalLink" } ) ) ); }, "aboveLimit_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You've reached your sending limit. In order to get more email sends you'll need to ",
createElement( options,
"UpgradeLink",
null,
"upgrade to Marketing Starter ",
createElement( options,
"ExternalLinkIcon",
{ name: "externalLink" } ) ) ); } }, "starter": { "remaining_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You have ",
props.remaining,
" email sends left for this month. To add more emails to your sending limit, you’ll need to ",
createElement( options,
"AdditionalContactsLink",
null,
"buy additional contacts ",
createElement( options,
"ExternalLinkIcon",
{ name: "externalLink" } ) ) ); }, "aboveLimit_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You’ve gone above your sending limit. This will affect your monthly bill. To add more emails to your sending limit, you’ll need to ",
createElement( options,
"AdditionalContactsLink",
null,
"buy additional contacts ",
createElement( options,
"ExternalLinkIcon",
{ name: "externalLink" } ) ) ); } }, "title": "Sending limit" }, "sendToMoreLimits": { "free": { "remaining_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You can use the Send to more features ",
props.remaining,
" more times." ); }, "aboveLimit_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You've reached the Send to more limit. To send this email to more recipients, you'll need to clone it." ); } }, "starter": { "remaining_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You can use the Send to more features ",
props.remaining,
" more times." ); }, "aboveLimit_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You've reached the Send to more limit. To send this email to more recipients, you'll need to clone it." ); } }, "title": "Send to more limit" }, "recipientsPicker": { "title": "Recipients", "tabs": { "lists": "Lists", "contacts": "Individual contacts" }, "nolists": { "title": "There are no lists in your portal", "content": "<p>Create a list using specific criteria or import contact who would be interested in this email. After you've created your list, come back to the recipients tab and select it to send those contacts your email.</p><p>Alternatively you can create a list using our suggested lists on the left.</p>", "contentFooter": "Go to {{link}} to create or import a list.", "contentFooterLink": "lists" }, "nocontacts": { "title": "There are no contacts in your account", "content": "In order to send any emails from your account you need to have at least one contact to send to", "contentFooter": "To create a contact you must navigate towards {{link}}", "contentFooterLink": "Contacts" }, "include": "Include", "exclude": "Exclude", "trySearch": "Can't find your list here? Try the search box above.", "selectionListName": { "lists": "List name", "contacts": "Contact name" }, "searchPlaceholder": { "lists": "Search lists", "contacts": "Search contacts" }, "createListButton": "Create new list", "importContactsButton": "Import a list of contacts", "apiError": "Sorry. An error occurred while trying to get your contacts. Please try again a litte later.", "noResults": "Sorry. There were no results for your search.", "tooManyContacts": "You've selected the maximum number of individual contacts for this email.", "tooManyLists": "You've selected the maximum number of lists for this email.", "useList": "Consider using a list.", "sendTo": "Send to", "dontSendTo": "Don't send to", "totalRecipients": "Total recipients", "processingPrefix": "Processing -", "processingLabel": "(Processing)", "errorFetchingCounts": "There was a problem loading your recipient count. Please try again later.", "processingAndDeletedItem": "(Processing) {{itemName}} (deleted)", "processingItem": "(Processing) {{itemName}}", "deletedItem": "{{itemName}} (deleted)", "label": "{{label}} {{name}}", "processingWarning": "We're experiencing a delay with the contacts tool at the moment. Your email send will be unaffected and will go out as normal. We're just unable to provide an estimated total of recipients right now.", "unknownRecipientCount": "Unknown", "viewAll": "View all", "noRecipientsIncluded": "You haven't included any recipients yet.", "noRecipientsExcluded": "You haven't excluded any recipients yet.", "individualContacts": "Individual contacts ({{numberOfContacts}})", "removeAllSelectedContacts": "Are you sure you want to remove all selected contacts?", "smartSuppression": "Would you like to enable smart suppression?", "suggestedLists": { "title": "Suggested lists", "create": "Create this list", "contactWhoFilledInAForm": "Contacts who have filled in a form", "contactsCreatedFromAForm": "Contacts created from form submissions" }, "graymail": { "header": "Contacts with low engagement", "listName": "Contacts with low engagement ({{numberOfContacts}})", "informationMessage": "{{numberOfSuppressedContacts}} of your selected contacts are disengaged and have not opened the last {{numberOfEmails}} emails you sent them. Not including these contacts will improve your deliverability and engagement rates for contacts that are engaged.", "readMore": "<a href='#'>Learn more about graymail</a>", "dontSendToContactsLink": { "zero": "Don't send to <a>unengaged contacts</a>", "other": "Don't send to <a>unengaged contacts ({{count}})</a>" }, "dontSendToContacts": { "zero": "Don't send to contacts with low engagement", "other": "Don't send to contacts with low engagement ({{count}})" }, "numberUnengaged": "{{numberOfContacts}} of your chosen contacts are disengaged with your emails.", "tooltipExplanation": "Unengaged contacts are those who haven’t opened your last 11 emails. You can improve your deliverability and engagement rates by not including them in your send. Learn more about unengaged contacts.", "readMoreLink": "Learn more about graymail", "shouldSuppressTitle": "Keep your deliverability high", "shouldSuppress": "Exclude these contacts now to keep your deliverability high." }, "gdpr": { "message": "This email will only be sent to contacts who have consent or another lawful basis recorded to receive \"{{subscriptionType}}\". {{link}}", "linkText": "Learn more about consent", "popoverTitle": "GDPR", "popoverBody": "Under the GDPR, you'll need to specify legitimate interest before sending to these contacts.", "createList": "Create list and add communication subscription", "defaultSubscription": "your selected subscription type", "modalTitle": "How to record a lawful basis to communicate with your contacts", "modalHeading": "<p>You've enabled \"Only send to contacts with lawful basis to communicate\" in your GDPR settings.</p><p>As a result, this email will only be sent to contacts who have consented or have another lawful basis recorded to receive communications about \"{{subscriptionType}}\" To send emails to the remaining contacts, you'll need to record a lawful basis to communicate with them.</p><p>To record a lawful basis to communicate with the recipients of this email:</p>", "modalList1": "Click {{linkToContacts}} to see a list of your email recipients", "modalList2": "Select the recipients who you'd like to record a lawful basis to communicate with", "modalList3": "Click \"More\"", "modalList4": "Click \"Add communication subscription for contact\"", "modalList5": "Fill in the details of your lawful basis", "modalList6": "Click \"Save\"", "modalFooter": "<p>After you've saved your changes, come back to your email to finish sending.</p><p>To learn more, see the <a href=\"https://www.hubspot.com/data-privacy/gdpr/hubspot-product-playbook\" target=\"_blank\">GDPR Playbook</a>.</p>", "linkToContacts": "here" }, "importAlert": { "title": "Importing...", "body": "Once your list is imported it will be available for selection." }, "compact": { "title": "Recipients" }, "select": { "include": { "label": "Send to*", "description": "Select which lists and contacts you would like to receive this email.", "help": "HELP INCLUDE", "disabledOptionTooltip": "This option is disabled because it is already selected in the Don't send to dropdown", "deletedOptionTooltip": "This recipient has been deleted", "placeholder": "Select recipients" }, "exclude": { "label": "Don't send to", "description": "Select the lists and contacts who you would like to exclude from receiving this email.", "help": "HELP EXCLUDE", "disabledOptionTooltip": "This option is disabled because it is already selected in the Send to dropdown", "deletedOptionTooltip": "This recipient has been deleted", "placeholder": "Select lists or contacts" }, "noImportAccessTooltip": "You don't have permission to import contacts", "lists": { "searchForMore": "Can't find your list here? Try the search box above." }, "contacts": { "searchForMore": "Can't find your contact here? Try the search box above." }, "error": { "noRecipients": "Select the recipients for your email in order to send or schedule it.", "deletedRecipients": "Some of your selected recipients have been deleted. You'll need to remove these to publish your email.", "abNoListsError": "At least one list needs to be included for A/B test emails." }, "noListOrContacts": "There are 0 lists or contacts in your account.", "searchPlaceholder": "Search for a list or contact" }, "recipientsCount": { "totalRecipients": "Total recipients :", "new": "New", "noEmail": { "title": "No email address", "tooltip": "There is no email address associated with this contact." }, "duplicate": { "title": "Duplicate contact", "tooltip": "Some of these contacts have been selected more than once. This can happen if they are included in more than one list. They’ll only receive this email once." }, "exclusionList": { "title": "Excluded", "tooltip": "These contacts were added to the ‘Don’t send to’ dropdown menu." }, "quarantined": { "title": "Quarantined", "tooltip": "These contacts are quarantined. This happens when HubSpot detects that they may be part of a purchased list." }, "bounced": { "title": "Previously hard bounced", "tooltip": "These contacts have hard bounced from a number of your emails." }, "notSubscribed": { "title": "Not subscribed", "tooltip": "These contacts have unsubscribed from your emails." }, "notDoiConfirmed": { "title": "Not double opted in", "tooltip": "These contacts need to confirm that they own their email address and consent to be emailed." }, "unengaged": { "title": "Unengaged", "tooltip": "You’ve selected ‘Don’t send to unengaged contacts’. This email won’t be sent to those contacts." }, "recipientFatigued": { "title": "Send frequency cap", "tooltip_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You have the send frequency cap option enabled. ",
createElement( options,
"KnowledgeBaseLink",
{ url: props.link } ) ); } }, "discrepanciesSubtitle": "Some contacts won't be sent this email. {{whyLink}}", "whyLink": "Why?" }, "fatigue": { "sendFrequencyLink": "send frequency cap", "checkboxText": { "zero": "Enable {{sendFrequencyLink}} for this send", "other": "Enable {{sendFrequencyLink}} for this send ({{count}})" }, "help": "Unchecking this checkbox will send this email to all recipients regardless of the send frequency cap.", "inProgress": "(Loading number of contacts in frequency cap)" } }, "modals": { "limitReached": { "starter": { "title": "Oh no. Looks like you've reached your emails send limit.", "description": "Your plan includes 5X contacts emails per month. E.g., if you have 1,000 contacts you can send 5,000 emails per calendar month.", "upgrade": "Buy additional contacts", "viewMyAccount": "View my account" }, "trial": { "title": "Oh no. Looks like you've reached your emails send limit.", "description": "Your marketing trial includes 5,000 email sends. You can keep sending email by upgrading to any paid marketing product.", "upgrade": "Upgrade" }, "free": { "title": "Oh no. Looks like you've reached your emails send limit.", "description": "Your marketing free includes 2,000 email sends. You can keep sending email by upgrading to any paid marketing product.", "upgrade": "Upgrade" } }, "verifyEmailAddress": { "title": "Verify email address", "body": "In order to send from this email address we need you to verify it.", "emailAddress": "Email address", "sendButton": "Send verification email", "sent": "Verification email has been sent to {{address}}. To verify this address please click the verification link in the email.", "alreadyVerified": "The email address {{address}} has already been verified.", "cancel": "Cancel" }, "creation": { "cancelButton": "Cancel", "continueButton": "Continue", "editButton": "Edit existing email", "selectAllRequiredFields": "Required fields are missing.", "cannotCreateNewBlogEmail": "You cannot create a new email for this blog. Please edit one of the listed emails.", "chooseEmailType": { "header": "Choose an email type", "mergedFlowAlert": "We've streamlined a few things. Once you select your email you'll see your templates together on one screen.", "notConvertible": "Your clone will use the classic email editor. The drag and drop editor isn't available for blog, RSS emails, or emails with custom HTML templates.", "label": { "REGULAR": "Regular", "AUTOMATED": "Automated", "BLOG_RSS": "Blog/RSS", "BLOG": "Blog" }, "description": { "create": { "REGULAR": "Create a beautiful, personalized email and send it to a segment of your contacts.", "AUTOMATED": "Create a personalized, automated email that's sent to contacts when they trigger a workflow.", "BLOG_RSS": "With blog or RSS email, you can publish your content once and send updates to your email subscribers.", "BLOG": "With blog email, you can publish your content once and send updates to your email subscribers." }, "clone": { "REGULAR": "Clone your email and send it to a segment of your contacts.", "AUTOMATED": "Clone your emails as an automated email that's sent to contacts when they trigger a workflow or fill out a form.", "BLOG_RSS": "With blog or RSS email, you can publish your content once and send updates to your email subscribers." } } }, "smartContent": { "header": "Smart content", "description": "This email contains smart content. Would you like to keep this content or remove it from the cloned email?", "smartContentLocations": "This email is using smart content in the following modules:", "remove": "Remove smart content", "keep": "Keep smart content", "location": { "SUBJECT": { "one": "Subject line" }, "BUTTON": { "one": "Button module", "other": "{{count}} Button modules" }, "IMAGE": { "one": "Image module", "other": "{{count}} Image modules" }, "RICH_TEXT": { "one": "Rich text module", "other": "{{count}} Rich text modules" }, "WEB_VERSION_LINK": { "one": "Web version module" }, "FOOTER": { "one": "Footer module", "other": "{{count}} Footer modules" }, "FOLLOW_ME": { "one": "Social module", "other": "{{count}} Social modules" }, "DIVIDER": { "one": "Divider module", "other": "{{count}} Divider modules" }, "HTML": { "one": "HTML module", "other": "{{count}} HTML modules" }, "customModule": { "one": "Custom module", "other": "{{count}} Custom modules" } } }, "blog": { "header": "Select blog" }, "blogRss": { "header": "Select blog or RSS feed", "blogSelect": "Blog", "selectPlaceholder": "Select blog", "selectFrequencyPlaceholder": "Select frequency", "externalRssFeed": "Link to external RSS feed", "feedSourceSelect": "Source", "hubspotBlog": "Hubspot blog", "externalBlog": "External blog", "frequencySelect": { "title": "Send frequency", "options": { "instant": "Instant", "daily": "Daily", "weekly": "Weekly", "monthly": "Monthly" } } }, "chooseEmailTemplateType": { "create": { "header": "Choose your email creation experience", "dragDrop": { "name": "Drag and drop", "label": "Create your email by dragging and dropping content in the editor.", "betaBadge": "In beta", "portalNotReady": "Your email tool is almost ready. This will only take a few minutes." }, "classic": { "name": "Classic editor", "label": "Create your email using a template from the design manager." } }, "clone": { "header": "Clone this email", "subtitle": "Choose an email clone experience", "dragDrop": { "name": "Drag and drop", "label": "Clone your email into our new drag and drop email editor.", "previewText": "<a href='{{url}}' target='_blank'>Preview your email</a> in the new editor.", "betaBadge": "In beta" }, "classic": { "name": "Classic editor", "label": "Clone your email into the classic email editor." } } } }, "importModal": { "cancelLoadingButton": "Cancel", "nextButton": "Next", "createButton": "Create", "dashboard": { "title": "Importing...", "body": "Once your list is imported it will be available for selection in your next email." }, "createLists": { "header": "Create contacts list", "contentHeader": "Which list do you want to create?", "createListsDescription": "By creating contacts lists, you can send emails to a group of your contacts at once and track their engagement. Here's a few recommendations for your first lists.", "limitError": "We couldn't create the list \"{{listName}}\" as you've hit the max allowed lists for your account.", "createButton": "Create", "cancelButton": "Cancel", "mostActiveContacts": { "button": "Most active contacts", "tooltip": "Automatically generate a list of contacts that have viewed a page on your site 10 or more times, have submitted 3 or more forms, and have opened 4 or more of your emails in the last 6 months." }, "importedContacts": { "button": "Imported contacts", "tooltip": "Automatically generate a list of contacts from those that have been imported." }, "recentlyConvertedLeads": { "button": "Recently converted leads", "tooltip": "Automatically generate a list of contacts that have converted on your website in the last 14 days." } } }, "optOut": { "cancelLoadingButton": "Cancel", "uploadButton": "Upload", "success": { "title": "Importing...", "body": "Once your opt-out list is imported, those contacts won't receive any emails from you unless you change their status to opted in." }, "importWarning": { "actions": { "importList": "Import opt-out list", "doNotHaveList": "I'll do it later", "doNotHaveListTooltip": "You can import an opt-out list at any time from the More tools dropdown menu." }, "body": { "whatIsIt": { "header": "What's an opt-out list?", "text": "It’s a list of contacts who have unsubscribed from your emails or have chosen not to receive them." }, "whyImport": { "header": "Why should I import an opt-out list?", "text": "When you import an opt-out list, we’ll make sure those contacts never receive an email from you. This will help you avoid spam complaints and high unsubscribe rates." }, "howCreateImport": { "header": "How do I create an opt-out list?", "text": "Open a spreadsheet and add a column with the header ‘Email'. In that column, input the email addresses you’d like to opt out of your emails. Save the file in a CSV format. That’s it!" }, "learnMore": "Learn more about importing an opt-out list." } } } }, "emailOwnership": { "verificationSent": "Verification email has been sent to {{address}}. To verify this address please click the verification link in the email.", "alreadyVerified": "The email address {{address}} has already been verified.", "verificationFailedToSend": "The verification email failed to send to {{address}}.", "errors": { "genericApiError": "Sorry, something went wrong. Please try again later.", "errorFetchingFromAddresses": "Sorry, an error occurred while fetching email addresses. Please try again later or contact support.", "DISPOSABLE_EMAIL_ADDRESS": "Disposable email addresses aren’t allowed.", "INVALID_FROM_CONTENT_VALUE": "You’ll need to use a valid email address or personalization token.", "INVALID_FROM_EMAIL_ADDRESS": "You’ll need to use a valid email address." } }, "emailFeaturesUpgradeModal": { "title": "Marketing Hub", "emailTitle": "Email", "variantEmailTitle": "Email Features", "seeAllFeatures": "See all Marketing Hub features", "upgradeButton": "Upgrade", "tableHeaders": { "features": "Features", "free": "Free", "starter": "Starter", "professional": "Professional", "enterprise": "Enterprise" }, "featureTitles": { "emailSends": "Email sends (per month)", "lists": "Lists", "postSendAnalytics": "Post-send analytics", "greymailSuppression": "Greymail suppression", "brandingRemoved": "HubSpot branding removed", "webVersion": "Web Version of email", "advancedWebVersion": "Advanced Web Version management", "templateBuilder": "Template Builder", "blogRss": "Blog/Rss emails", "dkimAuth": "DKIM Authentication", "clientPreview": "Client Preview", "abTesting": "A/B Testing", "smartContent": "Smart Content", "timezoneSending": "Time Zone Sending", "emailAutomation": "Email Automation", "multipleFooters": "Multiple CAN-SPAM footers", "sendFrequencyCap": "Send frequency cap" }, "limits": { "emailSends": { "free": "2,000", "starter": "5x contact tier", "professional": "10x contact tier", "enterprise": "10x contact tier" }, "lists": { "free": { "active": "5 active", "static": "25 static" }, "starter": { "active": "25 active", "static": "25 static" }, "professional": { "active": "1,000 active", "static": "1,000 static" }, "enterprise": { "active": "1,500 active", "static": "1,500 static" } } }, "postSendAnalyticsLimit": "Limited" }, "error403": { "title": "Sorry. You don't have permission to use this feature.", "message": "Talk to your account admin to get access." }, "import": { "importOptOut": "Import opt-out list", "importDenied": "You don't have permission to import contacts" }, "sendingLimit": { "header": "Sending limit", "limitBar": { "progress": "{{creditsUsed}} / {{creditsAvailable}}", "limitNotice": "{{creditsRemaining}} sends remaining in your current billing term. Once you hit your email sending limit, scheduled and automated emails will no longer be sent from your account." }, "limitCards": { "available": "Email limit", "used": "Emails sent", "left": "Emails sends remaining" }, "sends": { "header": "The following emails are at risk of not being sent", "headerTooltip": "Once you hit your sending limit, automated emails or emails that have been scheduled for a future date, won’t be sent.", "automatedPublished": "Published Automated email by {{author}}", "scheduled": "Scheduled email by {{author}}", "automatedPublishedNoAuthor": "Published Automated email", "scheduledNoAuthor": "Scheduled email", "upgrade_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
createElement( options,
"Link",
{ href: props.upgradeUrl, external: true },
"Upgrade contact tier" ),
" to get more sends" ); } } } }, "EmailData": { "subscriptions": { "doi": { "enabledForOptions": { "allPages": "All pages", "exceptPages": "Disabled for some pages only", "somePages": "Enabled for some pages only" } } }, "emailTypes": { "BATCH_EMAIL": "Regular", "AB_EMAIL": "AB", "AUTOMATED_EMAIL": "Automated", "BLOG_EMAIL": "Blog", "BLOG_EMAIL_CHILD": "Blog", "FOLLOWUP_EMAIL": "Followup", "LOCALTIME_EMAIL": "Time zone send", "OPTIN_EMAIL": "Opt in", "OPTIN_FOLLOWUP_EMAIL": "Opt in followup", "RESUBSCRIBE_EMAIL": "Resubscribe", "RSS_EMAIL": "RSS", "RSS_EMAIL_CHILD": "RSS", "SMTP_TOKEN": "SMTP", "SINGLE_SEND_API": "Single Send API", "LEADFLOW_EMAIL": "Form follow-up", "FEEDBACK_CES_EMAIL": "Customer effort survey", "FEEDBACK_NPS_EMAIL": "Customer loyalty survey", "FEEDBACK_CUSTOM_EMAIL": "Custom survey", "TICKET_EMAIL": "Ticket", "MEMBERSHIP_PASSWORD_SAVED_EMAIL": "Password saved confirmation", "MEMBERSHIP_PASSWORD_RESET_EMAIL": "Password reset", "MEMBERSHIP_REGISTRATION_EMAIL": "Registration" }, "precog": { "recovery": { "title": { "optOut": "Import opt-out list", "removeContacts": "Remove stale contacts", "removeStale": "Remove stale contacts" }, "steps": { "blacklisting_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"HubSpot was informed by a third party blacklist operator that one of your emails caused a blacklisting. Your account owner was sent an alert with the full details of the blacklisting from our Email Deliverability team. Please see the ",
createElement( options,
"Link",
{ url: props.link },
"Blacklist Remediation FAQ" ),
" on this process, and reply to the alert with any questions." ); }, "consent": "You should also take some time to understand opt-in consent for your email recipients, so you can make sure you have permission to email the contacts in your list.", "optOut": "If you have contacts that have already unsubscribed from your emails, import your opt-out lists, and we’ll make sure they don’t receive any emails from you.", "removeContacts": "Remove contacts from sources where recipients may not have expected email", "removeStale": "You should remove contacts who haven’t opened your email in over 3 months." }, "links": { "cleanLists": "Learn more about removing stale contacts", "optIn": "Understand opt-in consent", "optOut": "Learn more about importing an opt-out list", "viewLists": "View accepted list types", "whatToDo": "What should I do?", "whatToDoIfSuspended": "What should I do if my email sending is suspended?" } }, "probation": { "title": "You need to take action on your email account", "BOUNCES": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your bounce rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your average ",
createElement( options,
"Link",
{ href: props.link },
"hard bounce" ),
" rate is high. You'll need to take the actions outlined below to lower your bounce rate." ); } }, "SPAM": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your spam rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Too many emails have been sent to invalid email addresses. You'll need to take the actions outlined below to lower the number of emails sent to invalid email addresses." ); } }, "SPAMTRAP": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your spam rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Too many emails have been sent to invalid email addresses. You'll need to take the actions outlined below to lower the number of emails sent to invalid email addresses." ); } }, "UNSUBSCRIBES": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your unsubscribe rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your average ",
createElement( options,
"Link",
{ href: props.link },
"unsubscribe" ),
" rate is high. You'll need to take the actions outlined below to lower your unsubscribe rate." ); } }, "CANCELLATIONS": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your cancellation rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your average stopped sends rate is high. You'll need to take the actions outlined below to lower your stopped send rate." ); } }, "BLACKLISTING": { "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"HubSpot has been notified that an email you sent has caused a blacklisting event." ); } } }, "preSuspend": { "title": "You need to take action on your email account", "BOUNCES": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your bounce rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your average ",
createElement( options,
"Link",
{ href: props.link },
"hard bounce" ),
" rate is ",
createElement( options,
"Bold",
null,
"very high" ),
". You'll need to take the actions outlined below to lower your bounce rate." ); } }, "SPAM": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your spam rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Too many emails have been sent to invalid email addresses. You'll need to take the actions outlined below to lower the number of emails sent to invalid email addresses." ); } }, "SPAMTRAP": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your spam rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Too many emails have been sent to invalid email addresses. You'll need to take the actions outlined below to lower the number of emails sent to invalid email addresses." ); } }, "UNSUBSCRIBES": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your unsubscribe rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your average ",
createElement( options,
"Link",
{ href: props.link },
"unsubscribe" ),
" rate is ",
createElement( options,
"Bold",
null,
"very high" ),
". You'll need to take the actions outlined below to lower your unsubscribe rate." ); } }, "CANCELLATIONS": { "footer": "Make these changes and start sending emails again. This message will disappear over the coming weeks as long as your cancellation rate improves.", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your average stopped sends rate is ",
createElement( options,
"Bold",
null,
"very high" ),
". You'll need to take the actions outlined below to lower your stopped send rate." ); } }, "BLACKLISTING": { "heading": "There's an issue with your email account", "title_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"HubSpot has been notified that an email you sent has caused a blacklisting event." ); }, "body_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"A notification has been sent to your account owner from our Email Deliverability team with full details. You can reply to the notification with any questions. In the meantime, you can view our ",
createElement( options,
"Link",
{ url: props.link },
"blacklisting remediation FAQs" ),
"." ); } } }, "suspension": { "appeal": { "openTicket": "Create ticket", "error": "Something went wrong. We didn't receive your appeal form. Please resend the form and we'll review it.", "pending": "Hold tight. Your appeal form has been received and we’re currently reviewing your answers. We’ll be in contact with you soon.", "rejected": "We've reviewed your appeal and this account isn't eligible for marketing email. You can still use other tools in HubSpot.", "submitted": "Your ticket has been submitted to HubSpot support. You can track the status of your ticket at any time from the Help panel at the bottom of any HubSpot page.", "view": "View ticket" }, "portal": { "free": { "title": "You can’t send emails right now", "message_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Email sending for this account has been locked. You won't be able to send emails through HubSpot. If you have any questions, please read our ",
createElement( options,
"Link",
{ url: props.link },
"account suspensions FAQ" ),
"." ); }, "messageSupportAccess_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your email account has been suspended. You’ll need to create a support ticket to provide some more information about your contacts and how you'll prevent further bounces.",
createElement( options,
"BR",
null ),
"Once you’ve created a ticket, we’ll look into the suspension and get back to you. ",
createElement( options,
"Link",
{ url: props.link },
"Learn more about account suspensions" ),
"." ); }, "moreInfo_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Email sending for this account has been locked. You won't be able to send emails through HubSpot. If you have any questions, please read our ",
createElement( options,
"Link",
{ url: props.link },
"account suspensions FAQ" ) ); }, "blacklisting": { "title": "This email account has been suspended", "intro": "HubSpot has been notified that an email you sent has caused a blacklisting event. Your email account has been suspended.", "description_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"A notification has been sent to your account owner from our Email Deliverability team with full details. You can reply to the notification with any questions. In the meantime, you can learn more about ",
createElement( options,
"Link",
{ url: props.link },
"blacklisting" ),
"." ); } }, "ehawk": { "description_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your email account has been suspended while we carry out some additional checks. Please fill in ",
createElement( options,
"Link",
{ use: props.use, onClick: props.click },
"this form" ),
" to provide us with some more information, so you can start sending emails again." ); } }, "manual": { "description_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Email sending will remain locked. You may still continue to use other tools in the HubSpot platform. ",
createElement( options,
"Link",
{ url: props.link },
"Account suspended FAQ" ) ); } } }, "others": { "title": "You can’t send emails right now", "message_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your email account has been suspended. You’ll need to create a support ticket to provide some more information about your contacts and how you'll prevent further bounces.",
createElement( options,
"BR",
null ),
"Once you’ve created a ticket, we’ll look into the suspension and get back to you. ",
createElement( options,
"Link",
{ url: props.link },
"Learn more about account suspensions" ),
"." ); }, "manual": { "description_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your email account has been suspended. We’ve sent an email to the primary contact for this account with details on how you can start sending emails again. You’ll need to reply to the email you received from ",
props.replyAddress,
". We’ll get back to you within 1 business day. Learn more about ",
createElement( options,
"Link",
{ url: props.link },
"account suspensions" ) ); } } } }, "reason": { "BLACKLISTING": "The email’s sending IP addresses were blacklisted.<br>", "BOUNCES": "Too many emails have bounced after being sent from this account.<br>", "CANCELLATIONS": "Too many cancellations have taken place on emails sent from this account.<br>", "HEALTH_SCORE": "There has been very low engagement on emails sent from this account.<br>", "NONPAYMENT": "Email has been disabled on this account.<br>", "OVERRIDE": "Email has been disabled on this account.<br>", "OVERRIDE_UNSUBSCRIBES_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your email account has been locked and you’re no longer able to send emails because your average unsubscribe rate is high. You can still use the other tools in HubSpot. If you have any questions, please see ",
createElement( options,
"Link",
{ url: props.link },
"our account suspensions FAQ" ),
". ",
createElement( options,
"BR",
null ) ); }, "OVERRIDE_UNSUBSCRIBE_REASONS_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your email account has been locked and you’re no longer able to send emails because your unsubscribe rate is high. Contacts have indicated they did not sign up for emails. You can still use the other tools in HubSpot. If you have any questions, please see ",
createElement( options,
"Link",
{ url: props.link },
"our account suspensions FAQ" ),
". ",
createElement( options,
"BR",
null ) ); }, "OVERRIDE_SPAM_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your email account has been locked and you’re no longer able to send emails because your average spam report rate is high. You can still use the other tools in HubSpot. If you have any questions, please see ",
createElement( options,
"Link",
{ url: props.link },
"our account suspensions FAQ" ),
". ",
createElement( options,
"BR",
null ) ); }, "OVERRIDE_PHISHING": "This account has been suspended from sending emails. HubSpot's automatic systems have detected potential abuse with email sending from this portal.", "PHISHING": "This account has been suspended from sending emails. HubSpot's automatic systems have detected potential abuse with email sending from this portal.", "SPAM": "There have been reports of spam emails sent from this account.<br>", "SPAMTRAP": "There have been reports of spam emails sent from this account.<br>", "UNSUBSCRIBES": "Too many recipients have unsubscribed after being sent emails from this account.<br>" }, "remediation": { "EHAWK": { "business": "1. Tell us about your business and how you plan to use HubSpot:", "contacts": "2. For marketing email, how are you sourcing and opting-in the contacts that you'll be sending to?", "domain": "3. What domain do you use for your business and email:" }, "DEFAULT_FORM": { "subject": "Email performance suspension appeal", "optOut": "I've uploaded an opt-out list", "removedContacts": "I've removed stale contacts", "removedCount": "Number of stale contacts removed", "process_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"3. How did these contacts provide their email addresses? Please let us know how they gave you permission to send them marketing emails. ",
createElement( options,
"Link",
{ url: props.link },
"Learn more" ) ); }, "process": "3. How did these contacts provide their email addresses? Please let us know how they gave you permission to send them marketing emails.", "period": "2. Have all of these contacts been emailed by your company within the past year?", "periodOptions": { "aff": "Yes", "neg": "No" }, "contacts": "1. Where did you obtain these contacts?", "contactsOptions": { "affiliate": "Affiliate marketing", "atendees": "Attendees at company-hosted event", "atendeesThird": "Attendees at event hosted by another company", "crawler": "Scraped online with web crawler", "customers": "Current or former customers and clients", "guessed": "Guessed based on company email format", "imported": "Imported from ESP or CRM", "linkedIn": "Social media connections, i.e. from LinkedIn", "meet": "People I met in person", "public": "Publicly available list of email addresses", "sales": "Sales team provided list", "subscribers": "Subscribed through a form", "third": "Third party list", "trade": "Trade show booth visitors" } } } } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailComponents": {
    "en": "static-1.4977"
  }
};
  result.translationsAvailable = {
  "EmailComponents": {
    "de": "static-1.4977",
    "en": "static-1.4977",
    "es": "static-1.4977",
    "fr": "static-1.4977",
    "ja": "static-1.4977",
    "nl": "static-1.4977",
    "pt-br": "static-1.4977"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailComponents:en', {version: 'static-1.4977'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "settingsuilib": { "freemium": { "proBadge": "Pro", "starterBadge": "Starter" }, "save": "Save", "cancel": "Cancel", "stylesheetControl": { "tileHeader": "Attached style sheets", "tileSubheader": "These style sheets will affect all pages, with the files placed at the bottom of the list taking precedence over the rest.", "addStylesheet": "Add style sheet", "includePrimaryCssFile": "Include primary CSS file", "zeroState": "No style sheets have been attached.", "alertTitle": "Important" }, "stylesheetSelectModal": { "header": "Add style sheet", "addButton": "Add", "placeholder": "Choose a style sheet" }, "readOnly": "To edit these settings, you must be an authorized user.", "invalidColor": "Invalid hex color", "max": "Max: {{max}}{{units}}", "min": "Min: {{min}}{{units}}", "unrecoverableError": "<p>There was a problem loading your settings.<br /> Refresh the page or log in again.</p><p>If this keeps happening, please contact support.</p>" } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "settings-ui-lib": {
    "en": "static-1.4353"
  }
};
  result.translationsAvailable = {
  "settings-ui-lib": {
    "de": "static-1.4353",
    "en": "static-1.4353",
    "es": "static-1.4353",
    "fr": "static-1.4353",
    "ja": "static-1.4353",
    "nl": "static-1.4353",
    "pt-br": "static-1.4353"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:settings-ui-lib:en', {version: 'static-1.4353'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "settingsContentModals": { "propertyDefaultsModals": { "inputPlaceholders": { "defaultCompanyProperties": "Search company properties", "defaultContactProperties": "Search contact properties", "defaultOwnerProperties": "Search owner properties" }, "sectionTitles": { "setDefaultContactProperties": "Set default values for contact properties", "setDefaultOwnerProperties": "Set default values for owner properties", "setDefaultCompanyProperties": "Set default values for company properties" }, "noCompanyPropertySearchMatches": "No company properties match your search.", "noContactPropertySearchMatches": "No contact properties match your search.", "noOwnerPropertySearchMatches": "No owner properties match your search.", "inputLabels": { "defaultValue": "Default value", "ownerPlaceholder": "Select an owner" }, "firstNameLastName": "{{ firstName }} {{ lastName }}", "buttonLabels": { "cancel": "Cancel", "save": "Save" }, "notifications": { "defaultMessage": { "success": "Success! Your web page settings were saved.", "error": "Something went wrong and your settings weren't saved. Please try again, and contact support if it keeps happening." }, "slugConflict": { "PAGE_EXISTS": "A page already exists at {{ pageUrl }}.", "BLOG_EXISTS": "A blog already exists at {{ blogUrl }}.", "REDIRECT_EXISTS": "A URL redirect already exists at {{ redirectSource }}.", "RESERVED_NAMESPACE": "URLs that start with \"{{ reservedNamespace }}\" are reserved." } } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "settings-content-modals": {
    "en": "static-1.772"
  }
};
  result.translationsAvailable = {
  "settings-content-modals": {
    "de": "static-1.772",
    "en": "static-1.772",
    "es": "static-1.772",
    "fr": "static-1.772",
    "ja": "static-1.772",
    "pt-br": "static-1.772"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:settings-content-modals:en', {version: 'static-1.772'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "settings-ui-nav": { "page-title": "Settings", "beta": "Beta", "back": "Back", "dashboard": "Dashboard", "your-preferences": "Your preferences" } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "settings-ui-nav": {
    "en": "static-2.1457"
  }
};
  result.translationsAvailable = {
  "settings-ui-nav": {
    "de": "static-2.1457",
    "en": "static-2.1457",
    "es": "static-2.1457",
    "fr": "static-2.1457",
    "ja": "static-2.1457",
    "nl": "static-2.1457",
    "pt-br": "static-2.1457"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:settings-ui-nav:en', {version: 'static-2.1457'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "FileManagerCore": { "rootFolder": "Home", "selectFolder": "Select folder", "folderNameValidation": { "tooLong": "Folder names are limited to 100 characters. Please choose a shorter name.", "invalidCharsDoubleQuote": "Folder names may not contain \"{{invalidChars}}\".", "invalidCharsSingleQuote": "Folder names may not contain '{{invalidChars}}'.", "invalidNameOnlyWhitespace": "Folder names must include at least one character that is not a space.", "existingFolder": "A folder with that name already exists in this folder." }, "fileNameValidation": { "invalidNameOnlyWhitespace": "File names must include at least one character that is not a space." }, "loadFailed": { "message": "Goodness gracious.", "moreInfo": "It's unclear what's gone wrong, but something sure has.", "tryAgain": "Try {{refreshPageLink}} or {{loginLink}}.", "loginLink": "log in again", "refreshPageLink": "refreshing the page", "help": "If this keeps happening, please contact support" }, "actions": { "cancel": "Cancel", "delete": "Delete", "save": "Save", "rename": "Rename", "replace": "Replace", "move": "Move", "edit": "Edit", "archive": "Archive", "unarchive": "Unarchive", "uploadFiles": "Upload files", "cloneAndEdit": "Clone and edit", "cloneAndEditDisabledTooltip": "Animated GIF files can't be edited.", "export": "Export", "selectAll": "Select all", "select": "Select item", "acquire": "Save to your files", "changeFolder": "Change folder", "browseFiles": "Browse files", "browseImages": "Browse images", "upload": "Upload", "uploadVideos": "Upload videos", "openLink": "Open in a new window" }, "objectTypes": { "file": "file", "folder": "folder" }, "addFolderModal": { "createFolder": "Create folder", "folderName": "Folder name" }, "deleteModal": { "deleteFolderMessage": "Delete folder?", "deleteFileMessage": "Delete file?", "deleteFileDescription": "Deleting <strong>{{name}}</strong> can't be undone.", "deleteFolderDescription": "Deleting <strong>{{name}}</strong> can't be undone. Any files and folders within it will also be deleted.", "deleteFolderConfirmLabel": "Delete folder", "deleteFileConfirmLabel": "Delete file", "cancel": "Cancel", "fileUsage": "This file will be removed from the following pages and posts:", "fileMightBeUsed": "Deleting this file will remove it from any pages or posts. Go to <a href={{href}} target='_blank'>Files</a> to see where it's being used." }, "videoDetailPanel": { "header": "Edit video details", "thumbnail": { "changeThumbnail": "Change thumbnail image", "uploadCustomThumbnail": "Upload custom image", "uploadCustomThumbnailHint": "Upload a JPG, PNG, or GIF file.", "cancel": "Cancel", "done": "Done" }, "fileNameLabel": "File name", "titleLabel": "Title", "titlePlaceholder": "Add title", "descriptionLabel": "Description", "descriptionPlaceholder": "Add description", "descriptionCharCount": { "one": "{{count}} character", "other": "{{count}} characters" }, "tagLabel": "Meta tags", "tagSubmitButton": "Add tag" }, "imageEditor": { "cropButton": "Crop", "resizeButton": "Resize", "backButton": "Back", "cancelButton": "Cancel", "saveButton": "Save clone", "resetButton": "Revert to original", "sizeLabel": "Size", "cropSizeLabel": "Crop", "widthLabel": "width", "heightLabel": "height", "aspectRatios": { "CUSTOM": "Custom", "SQUARE": "Instagram (Square)", "TWO_ONE": "Twitter", "IG_LANDSCAPE": "Instagram (Landscape)", "LINKEDIN": "LinkedIn", "FOUR_FIVE": "Instagram (Portrait)", "FB_LANDSCAPE": "Facebook" } }, "shutterstock": { "saveTo": "Image will be saved to the <strong>{{folder}}</strong> folder.", "license": { "header": "Shutterstock Terms of Service", "termsOfUse": "All images offered under Stock images are provided by Shutterstock to HubSpot customers free of charge. Images may be used multiple times. By clicking below, you are agreeing to abide by {{websiteTermsLink}}, {{privacyPolicyLink}}, and {{licensingTermsLink}} when using these images.", "acceptButton": "I agree" }, "websiteTerms": "Shutterstock's website terms", "privacyPolicy": "Privacy policy", "licensingTerms": "Licensing terms" }, "video": { "termsOfServiceModal": { "title": "Turn on the new and improved video features", "body": { "part1": "These HubSpot features are powered by HubSpot’s partner Vidyard.", "part2": { "sales": { "item1": "Create personalized videos for your customers and prospects", "item2": "Segment contacts based on video activity", "item3": "Measure video performance and watch time" }, "marketing": { "item1": "Embed video files directly in your HubSpot content", "item2": "Optimize videos for search engines and conversions", "item3": "Segment contacts based on video activity", "item4": "Measure video performance and watch time" } }, "part3": "By turning on these HubSpot features, you agree to the {{eulaLink}}. No cost or upgrade required.", "part4": "If you choose “Not now,” you can still upload and use video files in HubSpot.", "part5": "You can always turn these features on or off later in your {{integrationsPageLink}}." }, "dontShowMeAgain": "Don't show me this again.", "integrationsPage": "integrations page", "eula": "Vidyard end user license agreement", "confirm": "Turn on new features", "decline": "Not now" }, "VidyardBanner": { "title": "Get the latest HubSpot video features.", "message": "Embed video files in your content, optimize them for search, and track their performance with new and improved video features. {{openModal}}", "openModal": "Turn on new video features." } }, "notifications": { "upload": { "error": { "title": "Upload", "message": "The file {{filename}} failed to upload.", "virusFoundMessage": "The file {{filename}} failed to upload because a virus was found in the file." } }, "uploadEditedFile": { "success": { "title": "Your image clone has been saved as \"{{ fileName }}\"" }, "error": { "title": "There was a problem saving your image.", "message": "Please try again." } }, "replace": { "error": { "title": "Replace file", "message": "Failed to replace {{filename}} with the new file.", "virusFoundMessage": "The file {{filename}} failed to be replaced because a virus was found in the file being uploaded." } }, "addFolder": { "success": { "title": "Add folder", "message": "The folder {{folder}} has been added." }, "error": { "title": "Add folder", "message": "Failed to add {{folder}}." } }, "renameFile": { "error": { "title": "Rename file", "message": "Failed to rename {{filename}}.", "FILE_MOVE_CONFLICT": "A file with that name already exists in the same folder." } }, "renameFolder": { "error": { "title": "Rename folder", "message": "Failed to rename {{folder}}." } }, "moveFile": { "error": { "title": "Move file", "message": "Failed to move {{filename}}.", "FILE_MOVE_CONFLICT": "A file with that name already exists in this folder." } }, "moveFolder": { "error": { "title": "Move folder", "message": "Failed to move {{folder}}." } }, "deleteFile": { "error": { "title": "Delete file", "message": "Failed to delete {{filename}}." } }, "deleteFolder": { "error": { "title": "Delete folder", "message": "Failed to delete {{folder}}." } }, "updateVidyardToS": { "success": { "title": "Your new video features are ready.", "message": "Go to a video file or upload a new one to check them out." }, "error": { "title": "Terms of Service failed to update", "message": "Please try again." } }, "syncToVidyard": { "error": { "title": "Video update", "message": "Failed to activate video tracking" } }, "unsyncFromVidyard": { "error": { "title": "Video update", "message": "Failed to turn off video tracking, embedding, and sharing" } }, "editVideo": { "error": { "title": "There was a problem loading this video.", "message": "Please try again." } }, "editFile": { "error": { "title": "There was a problem editing this file.", "message": "Please try again." } }, "videoThumbnail": { "error": { "title": "There was a problem saving the new thumbnail image.", "message": "Please try again." } }, "videoThumbnailFolder": { "error": { "title": "There was a problem creating a folder for your thumbnail.", "message": "You thumbnail will be added to your root folder." } }, "animatedGifVideoThumbnail": { "error": { "title": "Video thumbnails can't be animated GIFs.", "message": "Please try again with a different image." } }, "fetchHubUsers": { "error": { "title": "Error fetching portal users.", "message": "Refresh this page to try again." } }, "fetchSignedURL": { "error": { "title": "Download file", "message": "There was a problem starting your download." } } }, "errors": { "imageNotFound": "Image not found" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "FileManagerCore": {
    "en": "static-1.6390"
  }
};
  result.translationsAvailable = {
  "FileManagerCore": {
    "de": "static-1.6390",
    "en": "static-1.6390",
    "es": "static-1.6390",
    "fr": "static-1.6390",
    "ja": "static-1.6390",
    "nl": "static-1.6390",
    "pt-br": "static-1.6390"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:FileManagerCore:en', {version: 'static-1.6390'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "FileManagerLib": { "fileUploadRenamed": "File uploaded, and renamed \"{{fileName}}\".", "percentDownloadOf": "{{ part }} of {{ total }}", "fileUploadError": "There was an issue with the file upload.", "actions": { "select": "Select", "addImage": "Add image", "addVideo": "Add video", "addDocument": "Add document", "addFile": "Add file", "addFromUrl": "From a URL", "addFromDropbox": "Dropbox", "addFromGoogleDrive": "Google Drive and Photos", "browseFolders": "Browse all folders", "insert": "Insert", "preview": "Preview", "addFromCanva": "Design with Canva", "canvaIsDownloading": "Downloading image from Canva", "canvaNotSupportedForFilter": "Canva images are PNG, which are not supported for the current filter", "canvaNotSupportedForIE11": "Canva is not available in IE 11", "canvaNotLoaded": "Canva has not loaded yet" }, "canva": { "typeLabels": { "A4Document": "A4 Document (21 × 29.7 cm)", "Announcement": "Announcement (5 × 7 in)", "BlogBanner": "Blog Banner (560 × 315 px)", "BookCover": "Book Cover (1410 × 2250 px)", "BusinessCard": "Business Card (3.5 × 2 in)", "Card": "Card (7 × 5 in)", "Certificate": "Certificate (11 × 8.5 in)", "DesktopWallpaper": "Desktop Wallpaper (1920 × 1080 px)", "EmailHeader": "Email Header (600 × 200 px)", "FacebookAd": "Facebook Ad (1200 × 628 px)", "FacebookCover": "Facebook Cover (820 × 312 px)", "FacebookPost": "Facebook Post (940 × 788 px)", "Flyer": "Flyer (8.5 × 11 in)", "GiftCertificate": "Gift Certificate (6 × 4 in)", "Infographic": "Infographic (800 × 2000 px)", "InstagramPost": "Instagram Post (1080 × 1080 px)", "Invitation": "Invitation (14 × 14 cm)", "Label": "Label (6 × 4 in)", "LeaderboardAd": "Leaderboard Ad (728 × 90 px)", "LinkedInBanner": "LinkedIn Banner (1400 × 425 px)", "Logo": "Logo (500 × 500 px)", "MagazineCover": "Magazine Cover (8.5 × 11 in)", "Menu": "Menu (8.5 × 11 in)", "PhotoCollage": "Photo Collage (25 × 20 cm)", "PinterestGraphic": "Pinterest Graphic (735 × 1102 px)", "Postcard": "Postcard (5.5 × 4.3 in)", "Poster": "Poster (18 × 24 in)", "Presentation": "Presentation (1920 × 1080 px)", "Resume": "Resume (8.5 × 11 in)", "SocialMedia": "Social Media (800 × 800 px)", "TumblrGraphic": "Tumblr Graphic (540 × 810 px)", "TwitterHeader": "Twitter Header (1500 × 500 px)", "TwitterPost": "Twitter Post (1024 × 512 px)", "Yearbook": "Yearbook (8.5 × 11 in)", "YouTubeThumbnail": "YouTube Thumbnail (1280 × 720 px)" }, "welcomePopup": { "header": "Design with Canva", "body": "Now you can add images created and designed in Canva.", "learnMore": "Learn more" } }, "filterHint": { "action": { "IMAGE": "Select an image to insert.", "VIDEO": "Select a video to insert.", "HUBL_VIDEO": "Select a video to insert.", "DOCUMENT": "Select a document to insert.", "FILE": "Select a file to insert." }, "message": { "SUPPORTED": { "one": "The only supported extension is {{extensions}}.", "other": "Only {{extensions}} files are supported." }, "UNSUPPORTED": { "other": "{{extensions}} files are not supported." } } }, "insertImage": "Insert image", "insertVideo": "Insert video", "insertHubLVideo": "Insert video", "insertDocument": "Insert document", "insertFile": "Insert file", "selectFolder": "Select folder", "addFolderButton": "Add folder", "backButton": "Back", "browseFolders": "Browse folders", "searchImagesPlaceholder": "Search images, folders or stock images", "searchVideosPlaceholder": "Search videos and folders", "searchFilesPlaceholder": "Search files and folders", "noResults": { "message": "Sorry, no results were found." }, "emptyFolder": { "message": "This folder is empty.", "hint": "Drop files in here to upload or {{button}}.", "inlineButtonText": "create a new folder" }, "emptyBrowser": { "video": { "message": "Your video files will appear here.", "uploadHint": "Drag and drop or upload a video here to insert it in your content.", "noVideos": "Not seeing your videos? Go to <a href={{href}} target='_blank'>Files</a> and turn on embedding, sharing, and tracking for each video." }, "default": { "message": "Start adding files.", "uploadHint": "Drag and drop right onto this screen or upload from your desktop." } }, "vidyardPickerBanner": { "enableVidyard": "Turn on video features", "title": "Your videos will appear here.", "message": { "tosMessage": "To insert videos in your content, you'll need to turn on the improved video features.", "noVideos": "Drag and drop or upload your video files to HubSpot and easily insert them in your content with the Vidyard integration." } }, "fileDetail": { "dimensions": "Dimensions: {{dimensions}}", "size": "Size: {{size}}", "type": "Type: {{type}}" }, "fromUrlPlaceholder": "Type an image URL", "dimensions": { "widthLabel": "Width", "heightLabel": "Height", "resetLabel": "Reset" }, "panels": { "searchResults": "Results matching '{{term}}'", "tabs": { "files": "Your files", "shutterstock": { "saving": "Saving", "actions": { "previewLink": "Preview in full screen" }, "heading": "Stock images", "headerTerms": "Stock images are provided by Shutterstock. For more information visit {{websiteTermsLink}} and\n {{licensingTermsLink}}", "websiteTermsAndPolicy": "Shutterstocks's Terms of Use & Privacy Policy", "licensingTerms": "Licensing Terms", "copyInformation": "Inserting this image will automatically save it to the <strong>{{stockFolder}}</strong> folder." } }, "recentImages": "Recent images", "recentVideos": "Recent videos", "recentDocuments": "Recent documents", "recentFiles": "Recent files", "fromUrl": { "imageUrl": "Image URL", "imagePreview": "Image preview", "errors": { "loadingError": "Image URL could not be loaded.", "dataUri": "Inserting images inline using a data URL is not allowed." } }, "tiles": { "SUPPORTED": { "one": "Only the {{ extensions }} file extension is supported.", "other": "Only {{ extensions }} file extensions are supported." }, "UNSUPPORTED": { "one": "The {{ extensions }} file extension is not supported.", "other": "{{ extensions }} file extensions are not supported." } } }, "videoLimit": { "uploadVideosDisabledTooltip": { "message": "You can turn on embedding, sharing, and tracking for {{limit}} videos at a time. You can still upload videos without these features in {{filesLink}}.", "filesLink": "your files" }, "banner": { "title": "You've reached your video limit", "message": "You can turn on embedding, sharing, and tracking for {{limit}} videos at a time. You can still upload videos without these features in {{filesLink}}.", "filesLink": "your files" } }, "notifications": { "upload": { "expectedImage": { "title": "Upload", "message": "The file {{filename}} is not an image." }, "expectedVideo": { "title": "Upload", "message": "The file {{filename}} is not a video." } } }, "imageOptimizationSettings": { "label": "Image Optimization", "description": "Optimize this image for faster load times or better image quality when it's resized on a page, email, or blogpost.", "text": { "low": "Low", "medium": "Default", "high": "High" }, "help": { "low": "Faster load times", "medium": "Balanced for speed and quality", "high": "Better image quality" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "FileManagerLib": {
    "en": "static-1.6538"
  }
};
  result.translationsAvailable = {
  "FileManagerLib": {
    "de": "static-1.6538",
    "en": "static-1.6538",
    "es": "static-1.6538",
    "fr": "static-1.6538",
    "ja": "static-1.6538",
    "nl": "static-1.6538",
    "pt-br": "static-1.6538"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:FileManagerLib:en', {version: 'static-1.6538'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "InboxConnectUtils": { "mailIntegration": { "syncError": "This account couldn't be enabled. Please try again.", "unsync": { "error": "This account couldn't be disabled. Please try again.", "success": "Account sync disabled", "title": "Remove {{ email }}", "message": "To fully disconnect and block further access from HubSpot, go to your <a href=\"https://security.google.com/settings/security/permissions\" target=\"_blank\">Google</a> or Outlook 365 security settings and remove HubSpot Sales from your list of allowed apps.<br><br>This process of disconnecting is encouraged by Google, Microsoft, and other companies to best protect your data now and in the future. You can reconnect at any time.", "button": "Disable this account in HubSpot" }, "delete": { "success": "Account deleted", "error": "This account couldn't be deleted. Please try again." } }, "wizard": { "continue": "Continue", "agree": "Agree", "cancel": "Cancel", "skip": "Skip", "connectInbox": { "whatToExpect": "Here's what to expect when you connect to HubSpot:", "gmail": { "title": "Connect your Google account to HubSpot CRM", "description": "Connect your Google account to HubSpot CRM and sync your outgoing emails and replies. HubSpot will monitor for changes and automatically keep your contact records up to date.", "label": "Google / Gmail", "providerDetected": "HubSpot detected that your inbox is hosted by Google / Gmail. Not a Google / Gmail account? {{ chooseLink }}", "chooseLink": "Choose a provider", "legal": " <p> When you integrate your Google account with the HubSpot platform, you can connect a number of Google services to your HubSpot account. By doing so, HubSpot will be able to access data and information from your Google account. Those services and types of data are outlined below; </p>\n<ul> <li> <strong>Gmail</strong>: You can send and receive Gmail messages, schedule email sends, and modify email drafts in the HubSpot app. You will also be able to log and track emails sent in-app. HubSpot will have access to your Gmail data, like email headers, subject lines, and email bodies. </li> <li> <strong>Google Calendar</strong>: You can use the Meetings tool to create new or modify existing meetings on your primary Google Calendar. </li> <li> <strong>Google Drive</strong>: You can import text or files from Google Drive to publish blog posts on your websites. You can also use import docs to our Documents tool. </li> <li> <strong>Google Search Console</strong>: You will be able to view and manage your Search Console in HubSpot’s Content Management System. </li> </ul>\n<p> We’ll only use your Google data to power different parts of our product that connect with the G Suite tools you use every day. It's your data. We just want to help you grow better. </p>\n<p> You can remove the integration in the HubSpot app by navigating to Settings &gt; Integrations &gt; Email Integrations and clicking ‘Disable’. You can also revoke HubSpot’s access from within your Google account by following the instructions listed <a href=\"https://support.google.com/accounts/answer/3466521\" target=\"_blank\" >here</a >. </p>\n<p> For more information on the Google integration and the types of data we can access, please see our <a href=\"https://legal.hubspot.com/product-privacy-policy\" target=\"_blank\" >Product Privacy Policy</a >. </p> " }, "outlook365": { "title": "Connect your Office 365 account to HubSpot CRM", "description": "Connect your Office 365 account to HubSpot CRM to sync your outgoing emails and replies. HubSpot will monitor for changes and automatically keep your contact records up to date.", "label": "Office 365", "providerDetected": "HubSpot detected that your inbox is hosted by Office 365. Not an Office 365 account? {{ chooseLink }}", "chooseLink": "Choose a provider", "legal": " <p> First, by granting HubSpot access to your inbox, your HubSpot will be able to locate relevant email conversations and log them in your CRM so you and your team can work on them together. Emails that you send from HubSpot will also appear in your Outlook sent folder, so there'll be no confusion about which emails live where. </p> <p> This means that your HubSpot will have access to some information about your emails, like the email address you’re sending them from, the email addresses of your recipients, what’s in the subject line, and what’s in the body of the email. We’ll only use that access to power your HubSpot Outlook integration and make life easier for you, never for any nefarious purposes of our own. It's your data. We just want to help you use it better. You'll always be able to delete specific email records from your CRM with just a couple of clicks. HubSpot will also have access to view and create calendar events so we can ensure your CRM and calendar are perfectly in sync. </p> <p> You'll be able to make more sweeping changes to how your integration works (for instance, removing the integration or adding another email account) just by adjusting your settings. It's all up to you. Want to learn more? Visit <a href=\"https://www.hubspot.com/security\" target=\"_blank\">www.hubspot.com/security</a> for more information on our security policies and <a href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/hubspot-crm-email-integration-faqs\" target=\"_blank\">read the FAQ page</a> about the HubSpot Outlook 365 integration. </p> " }, "imap": { "title": "Connect your inbox to HubSpot CRM", "description": "Connect your inbox to HubSpot CRM to sync your outgoing emails and replies. HubSpot will monitor for changes and automatically keep your contact records up to date.", "label": "Generic inbox", "providerDetected": "HubSpot detected that your inbox is hosted by a provider other than Google / Gmail or Office 365. Incorrect? {{ chooseLink }}", "chooseLink": "Choose a provider", "legal": " <p> First, by granting HubSpot access to your inbox, your HubSpot will be able to locate relevant email conversations and log them in your CRM so you and your team can work on them together. Emails that you send from HubSpot will also appear in your sent folder, so there'll be no confusion about which emails live where. </p> <p> This means that your HubSpot will have access to some information about your emails, like the email address you’re sending them from, the email addresses of your recipients, what’s in the subject line, and what’s in the body of the email. We’ll only use that access to power your HubSpot email integration and make life easier for you, never for any nefarious purposes of our own. It's your data. We just want to help you use it better. </p> <p> You'll always be able to delete specific email records from your CRM with just a couple of clicks. You'll also be able to make more sweeping changes to how your integration works (for instance, removing the integration or adding another email account) just by adjusting your settings. It's all up to you. </p> <p> Want to learn more? Visit <a href=\"https://www.hubspot.com/security\" target=\"_blank\">www.hubspot.com/security</a> for more information on our security policies and <a href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/hubspot-crm-email-integration-faqs\" target=\"_blank\">read the FAQ page</a> about the HubSpot IMAP integration. </p> " }, "exchange": { "title": "Connect your Exchange inbox to HubSpot CRM", "beta": "Beta", "description": "Connect your Exchange inbox to HubSpot CRM to sync your outgoing emails and replies. HubSpot will monitor for changes and automatically keep your contact records up to date.", "label": "Exchange", "providerDetected": "HubSpot detected that your inbox is hosted by Exchange. Not an Exchange account? {{ chooseLink }}", "chooseLink": "Choose a provider", "legal": " <p> First, by granting HubSpot access to your inbox, your HubSpot will be able to locate relevant email conversations and log them in your CRM so you and your team can work on them together. Emails that you send from HubSpot will also appear in your sent folder, so there'll be no confusion about which emails live where. </p> <p> This means that your HubSpot will have access to some information about your emails, like the email address you’re sending them from, the email addresses of your recipients, what’s in the subject line, and what’s in the body of the email. We’ll only use that access to power your HubSpot email integration and make life easier for you, never for any nefarious purposes of our own. It's your data. We just want to help you use it better. </p> <p> You'll always be able to delete specific email records from your CRM with just a couple of clicks. You'll also be able to make more sweeping changes to how your integration works (for instance, removing the integration or adding another email account) just by adjusting your settings. It's all up to you. </p> <p> Want to learn more? Visit <a href=\"https://www.hubspot.com/security\" target=\"_blank\">www.hubspot.com/security</a> for more information on our security policies and <a href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/hubspot-crm-email-integration-faqs\" target=\"_blank\">read the FAQ page</a> about the HubSpot IMAP integration. </p> " }, "button": "Connect inbox", "chooseOther": "Connect a different account" }, "chooseProvider": { "title": "Choose your email provider", "errorTitle": "Sorry!", "errorMsg": "We couldn't detect your provider", "notSure": "Not sure which to choose?", "gmail": "Google / Gmail", "outlook365": "Office 365", "imap": "Other mail account", "exchange": "Exchange", "link": "Not sure which to choose?" }, "errorCodes": { "body": { "generic": { "0": "Could not submit settings. Please try again.", "500": "Server Error: Unable to create inbox.", "error": "Unable to create inbox for this user.", "CONNECTIONS_RATE_LIMITED": "Sorry. HubSpot can’t connect your inbox right now. Please try again in a few minutes.", "TRANSIENT": "Sorry. HubSpot can’t access your inbox." }, "imap": { "APP_PASSWORD_REQUIRED_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"HubSpot can't access your inbox because it requires an app-specific password to log in. Create an app-specific password in your provider for HubSpot and try again. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); }, "IMAP_AUTHENTICATION_ERROR_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"HubSpot cannot validate the connection with the corresponding IMAP server on the given port. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); }, "IMAP_VALIDATE_ERROR_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"HubSpot cannot validate the connection with the corresponding IMAP server on the given port. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); }, "IMAP_SETTINGS_INCORRECT_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"HubSpot can’t access your inbox because the IMAP settings are incorrect. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); }, "SMTP_SETTINGS_INCORRECT_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"HubSpot can’t access your inbox because the SMTP settings are incorrect. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); }, "UNAUTHORIZED_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"HubSpot can't access your inbox because the credentials are incorrect. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); }, "UNTRUSTED_CERTIFICATES_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Hubspot can't access your inbox because your SSL certificate does not appear to be signed by a Certificate Authority. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); } }, "exchange": { "UNAUTHORIZED": "Unauthorized. Please check the email address and password and try again.", "IMAP_AUTHENTICATION_ERROR": "HubSpot can’t access your inbox. Please check your username, password, servers, and ports for your inbox connection here.", "IMAP_VALIDATE_ERROR": "HubSpot can’t access your inbox. Please check your hostname and port settings for your inbox connection.", "IMAP_SETTINGS_INCORRECT": "HubSpot can’t access your inbox because the IMAP settings are incorrect.", "SMTP_SETTINGS_INCORRECT": "HubSpot can’t access your inbox because the SMTP settings are incorrect.", "AUTODISCOVERY_FAILURE_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Additional information is required to connect. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); }, "EXCHANGE_URL_INVALID_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Exchange URL is invalid. Please check that the URL is correct. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); }, "EXCHANGE_VERSION_INVALID_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Unable to connect due to Exchange version. Please update your Exchange server to Exchange 2010 SP2 or above. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); }, "EXCHANGE_VALIDATE_ERROR_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Unable to connect to Exchange server. ",
createElement( options,
"UILink",
props,
"Learn more" ) ); } } }, "title": { "generic": { "error": "Error", "APP_PASSWORD_REQUIRED": "Unauthorized - App password required for connection", "UNAUTHORIZED": "Unauthorized", "UNTRUSTED_CERTIFICATES": "Unauthorized - SSL Certificates not trusted" }, "imap": { "IMAP_AUTHENTICATION_ERROR": "IMAP authentication error", "IMAP_VALIDATE_ERROR": "IMAP validation error", "IMAP_SETTINGS_INCORRECT": "IMAP settings incorrect", "SMTP_SETTINGS_INCORRECT": "SMTP settings incorrect" } } }, "imapInbox": { "title": "Set up your email account", "titleExchange": "Set up your Exchange account", "optOutText": "I don’t want to connect", "learnMore": "Learn more", "beta": "Beta", "errorTitle": "Error", "errors": { "0": "Could not submit settings. Please try again.", "500": "Server Error: Unable to create inbox.", "error": "Unable to create inbox for this user.", "CONNECTIONS_RATE_LIMITED": "Sorry. HubSpot can’t connect your inbox right now. Please try again in a few minutes.", "APP_PASSWORD_REQUIRED": "Sorry. HubSpot can’t access your inbox because a unique password to allow HubSpot access is required. Create your unique password for HubSpot with these <a target=\"_blank\" href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/how-can-i-resolve-an-unavailable-or-unauthorized-inbox-connection-error#unauthorized-app-password-required-for-connection\">instructions</a>.", "GENERIC_IMAP_DISABLED": "Sorry. HubSpot can’t access your inbox. Please enable IMAP in your inbox settings.", "GENERIC_MISSING_FOLDER": "Sorry. HubSpot can’t access your inbox. Please contact support.", "IMAP_AUTHENTICATION_ERROR": "Sorry. HubSpot can’t access your inbox. Please check your username, password, servers, and ports for your inbox connection here.", "IMAP_VALIDATE_ERROR": "Sorry. HubSpot can’t access your inbox. Please check your hostname and port settings for your inbox connection.", "IMAP_SETTINGS_INCORRECT": "Sorry. HubSpot can’t access your inbox because the IMAP settings are incorrect.", "SMTP_SETTINGS_INCORRECT": "Sorry. HubSpot can’t access your inbox because the SMTP settings are incorrect.", "UNAUTHORIZED": "Unauthorized. Please check the email address and password and try again.", "UNTRUSTED_CERTIFICATES": "Sorry. HubSpot can’t access your inbox. Please allow non-secure certifications using these <a target=\"_blank\" href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/how-can-i-resolve-an-unavailable-or-unauthorized-inbox-connection-error#unauthorized-ssl-certificates-not-trusted\">instructions</a> and try again.", "MISSING_INBOX_FOLDER": "Sorry. HubSpot can’t access your inbox. Please update your inbox settings with these <a target=\"_blank\" href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/how-can-i-resolve-an-unavailable-or-unauthorized-inbox-connection-error#unavailable-missing-drafts-or-inbox-folder-in-gmail\">instructions</a>.", "MISSING_DRAFTS_FOLDER": "Sorry. HubSpot can’t access your inbox. Please update your inbox settings with these <a target=\"_blank\" href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/how-can-i-resolve-an-unavailable-or-unauthorized-inbox-connection-error#unavailable-missing-drafts-or-inbox-folder-in-gmail\">instructions</a>.", "GMAIL_IMAP_DISABLED": "Sorry. HubSpot can’t access your inbox. Please enable IMAP in your inbox settings with these <a target=\"_blank\" href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/how-can-i-resolve-an-unavailable-or-unauthorized-inbox-connection-error#unavailable-imap-disabled-in-gmail\">instructions</a>.", "OFFICE_ERROR": "Sorry. HubSpot can’t access your inbox.", "OFFICE_ERROR_ORGANIZATION_ACCESS_BLOCKED": "Sorry. HubSpot can’t access your inbox. Please reach out to your Office 365 administrator and request access to the Office 365 Mail API.", "OFFICE_ERROR_REST_API_NOT_ENABLED_FOR_COMPONENT_SHARED_MAILBOX": "Sorry. HubSpot can’t access your inbox. Please update your inbox settings with these <a target=\"_blank\" href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/how-can-i-resolve-an-unavailable-or-unauthorized-inbox-connection-error#unavailable-api-access-not-enabled-for-mailbox\">instructions</a>.", "OFFICE_ERROR_INVALID_LICENSE": "Sorry. HubSpot can’t access your inbox due to an invalid license. Please reach out to your Office 365 administrator.", "TRANSIENT": "Sorry. HubSpot can’t access your inbox.", "IMAP_DISABLED_OR_LOGIN_FAILURE": "Sorry. HubSpot can’t access your inbox. Please enable IMAP in your inbox settings and try again." }, "button": "Connect inbox" }, "detectProvider": { "title": "Let's connect your inbox", "description": "Please enter your email address", "email": "Email address", "continue": "Continue", "invalidEmail": "Please enter a valid email address", "detecting": "Detecting your email provider" }, "finish": { "title": "Success!", "description": "Your account has successfully been connected.", "button": "Done", "cancelButton": "No, thanks", "downloadLinkButton": "Download Extension", "nowConnected": "{{ emailAddress }} <br> is now connected to HubSpot", "install": { "title": "Did you know?", "description": "HubSpot has extensions for {{ link }} that let you quickly access your CRM and sales tools from within your own inbox. Stop switching tabs, and get your work done faster.", "downloadExtensionLink": "Gmail and Outlook" } }, "failure": { "title": "Sorry. HubSpot couldn't connect to your inbox.", "reconnectButton": "Reconnect", "showLog": "Show Log", "moreHelp": "Need more help?", "closeButton": "Close", "repairButton": "Repair", "repairSucceeded": "Repair Succeeded. Please reconnect account.", "repairFailed": "Repair Failed. Error: {{ errorMessage }}", "whatYouCanDo": { "title": "Here's what you can do:", "steps": { "shareMessage": "Share this message with your admin or IT team to resolve.", "reconnect": "Reconnect your inbox once the issue is resolved." } }, "errorResponse": { "reconnect": "Please reconnect your email account.", "updateYourInbox": "Please update your inbox settings with <a href=\"{{ link }}\" target=\"_blank\">these instructions</a>.", "enableImap": "Please enable IMAP in your inbox settings with <a href=\"{{ link }}\" target=\"_blank\">these instructions</a>.", "reachOutToOfficeAdmin": "Please reach out to your Office 365 administrator and request access to the Office 365 Mail API.", "testEmailFailed": "This test email was unsuccessful. HubSpot can't access your inbox to send email.", "invalidLicense": "It looks like your Office 365 license is invalid. This can happen if your admin revoked the license, the license expired, or a payment failed.", "sharedInbox": { "alreadyConnected": "{{ emailAddress }} is already connected to this account. This shared inbox can only be connected once per account.", "alreadyConnectedAsPersonal": "{{ emailAddress }} is already connected to this account as a personal inbox. This inbox must be removed from the following users accounts before continuing: {{ usersEmailsCSV }}. <a href=\"{{ link }}\" target=\"_blank\">Learn more.</a>", "invalidDowngrade": "{{ emailAddress }} is already connected as a shared inbox. This inbox must be removed before connecting as a personal inbox.", "conversationsConflict": " Looks like {{ emailAddress }} is already connected to another conversations inbox.\n\n To continue, please choose a different email address. " } } }, "testMessage": { "establishingConnection": "Establishing connection...", "sendingTestEmail": "Sending a test email from your inbox...", "verifyingConnection": "Verifying connection..." }, "calDav": { "title": "Set up your calendar account", "optOutText": "I don’t want to connect", "connect": "Connect calendar", "fields": { "username": { "label": "Username", "tooltip": "Enter the username you use to sign in to your CalDAV provider." }, "password": { "label": "Password", "tooltip": "Enter the app password generated by your CalDAV provider that grants HubSpot access to your calendar." }, "hostname": { "label": "Hostname", "tooltip": "Enter the full URL of your calendar." } }, "errorTitle": "HubSpot couldn't connect to your calendar.", "errors": { "NOT_FOUND": { "header": "Please enter the full URL of your CalDAV calendar.", "hostname": "Please enter the full URL of your CalDAV calendar." }, "READ_ONLY": { "header": "Please use an account that can write to this calendar.", "username": "Please use an account that can write to this calendar." }, "UNAUTHORIZED": { "header": "Please check the username and password and try again.", "username": "Please check the username and try again.", "password": "Please enter the app password generated by your CalDAV provider that grants HubSpot access to your calendar." } }, "success": { "title": "Succcess!", "description": "Your calendar has successfully been connected." } } }, "optIn": { "gmail": { "title": "Connect Your Google Account", "confirmButton": "Accept and connect to Google", "cancelButton": "Cancel", "subTitle": "Connecting your account is kind of a big deal", "body": " <p> When you integrate your Google account with the HubSpot platform, you can connect a number of Google services to your HubSpot account. By doing so, HubSpot will be able to access data and information from your Google account. Those services and types of data are outlined below; </p>\n<ul> <li> <strong>Gmail</strong>: You can send and receive Gmail messages, schedule email sends, and modify email drafts in the HubSpot app. You will also be able to log and track emails sent in-app. HubSpot will have access to your Gmail data, like email headers, subject lines, and email bodies. </li> <li> <strong>Google Calendar</strong>: You can use the Meetings tool to create new or modify existing meetings on your primary Google Calendar. </li> <li> <strong>Google Drive</strong>: You can import text or files from Google Drive to publish blog posts on your websites. You can also use import docs to our Documents tool. </li> <li> <strong>Google Search Console</strong>: You will be able to view and manage your Search Console in HubSpot’s Content Management System. </li> </ul>\n<p> We’ll only use your Google data to power different parts of our product that connect with the G Suite tools you use every day. It's your data. We just want to help you grow better. </p>\n<p> You can remove the integration in the HubSpot app by navigating to Settings &gt; Integrations &gt; Email Integrations and clicking ‘Disable’. You can also revoke HubSpot’s access from within your Google account by following the instructions listed <a href=\"https://support.google.com/accounts/answer/3466521\" target=\"_blank\" >here</a >. </p>\n<p> For more information on the Google integration and the types of data we can access, please see our <a href=\"https://legal.hubspot.com/product-privacy-policy\" target=\"_blank\" >Product Privacy Policy</a >. </p> " }, "imap": { "title": "Connect Your Inbox", "confirmButton": "Accept and connect", "cancelButton": "Cancel", "subTitle": "Connecting your inbox is kind of a big deal", "body": " <p> We get it. So we want to be perfectly clear about how this'll work. </p> <p> First, by granting HubSpot access to your inbox, <strong>your HubSpot will be able to locate relevant email conversations and log them in your CRM</strong> so you and your team can work on them together. Emails that you send from HubSpot will also appear in your sent folder, so there'll be no confusion about which emails live where. </p> <p> This means that your <strong>HubSpot will have access to some information about your emails</strong>, like the email address you’re sending them from, the email addresses of your recipients, what’s in the subject line, and what’s in the body of the email. We’ll only use that access to power your HubSpot email integration and make life easier for you, never for any nefarious purposes of our own. <strong>It's your data.</strong> We just want to help you use it better. </p> <p> You'll always be able to delete specific email records from your CRM with just a couple of clicks. <strong>You'll also be able to make more sweeping changes to how your integration works</strong> (for instance, removing the integration or adding another email account) just by adjusting your settings. It's all up to you. </p> <p> Want to learn more? Visit <a href=\"https://www.hubspot.com/security\" target=\"_blank\">www.hubspot.com/security</a> for more information on our security policies and <a href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/hubspot-crm-email-integration-faqs\" target=\"_blank\">read the FAQ page</a> about the HubSpot IMAP integration. </p> " }, "calDav": { "title": "Connect Your Calendar", "confirmButton": "Accept and connect", "cancelButton": "Cancel", "subTitle": "Connecting your calendar is kind of a big deal", "body": " <p> We get it. So we want to be perfectly clear about how this'll work. </p> <p> First, by granting HubSpot access to your calendar, <strong>your HubSpot will be able to read your calendar events</strong> so you and your team can book meetings successfully. New meetings booked through HubSpot will also appear in your calendar, so there'll be no confusion about which meetings live where. </p> <p> This means that your <strong>HubSpot will have access to some information about your calendar events</strong>, like the event times, the event descriptions, and the email addresses of invitees. We’ll only use that access to power your HubSpot calendar integration and make life easier for you, never for any nefarious purposes of our own. <strong>It's your data.</strong> We just want to help you use it better. </p> <p> <strong>You'll be able to make sweeping changes to how your integration works</strong> (for instance, removing the integration or adding another calendar account) just by adjusting your settings. It's all up to you. </p> " }, "outlook": { "title": "Connect Your Outlook 365 Inbox", "confirmButton": "Accept and connect to Outlook 365", "cancelButton": "Cancel", "subTitle": "Connecting your inbox is kind of a big deal", "body": " <p> We get it. So we want to be perfectly clear about how this'll work. </p> <p> First, by granting HubSpot access to your inbox, <strong>your HubSpot will be able to locate relevant email conversations and log them in your CRM</strong> so you and your team can work on them together. Emails that you send from HubSpot will also appear in your Outlook sent folder, so there'll be no confusion about which emails live where. </p> <p> This means that your <strong>HubSpot will have access to some information about your emails</strong>, like the email address you’re sending them from, the email addresses of your recipients, what’s in the subject line, and what’s in the body of the email. We’ll only use that access to power your HubSpot Outlook integration and make life easier for you, never for any nefarious purposes of our own. <strong>It's your data</strong>. We just want to help you use it better. You'll always be able to delete specific email records from your CRM with just a couple of clicks. HubSpot will also have access to view and create calendar events so we can ensure your CRM and calendar are perfectly in sync. </p> <p> <strong>You'll be able to make more sweeping changes to how your integration works</strong> (for instance, removing the integration or adding another email account) just by adjusting your settings. It's all up to you. Want to learn more? Visit <a href=\"https://www.hubspot.com/security\" target=\"_blank\">www.hubspot.com/security</a> for more information on our security policies and <a href=\"https://knowledge.hubspot.com/articles/kcs_article/email-notifications/hubspot-crm-email-integration-faqs\" target=\"_blank\">read the FAQ page</a> about the HubSpot Outlook 365 integration. </p> " } }, "genericInboxForm": { "emailInvalid": "That email address looks invalid.", "emailLabel": "Email address", "emailPlaceholder": "yours@example.com", "optionalField": "(Optional)", "advancedSettingsHeading": "Advanced Options", "customUsernameLabel": "Username", "incomingServer": { "heading": "Incoming Mail (IMAP)", "hostLabel": "Server", "hostPlaceholder": "imap.example.com", "hostInvalid": "That domain looks invalid.", "portLabel": "Port", "portPlaceholder": "993" }, "outgoingServer": { "heading": "Outgoing Mail (SMTP)", "hostLabel": "Server", "hostPlaceholder": "smtp.example.com", "hostInvalid": "That domain looks invalid.", "portLabel": "Port", "portPlaceholder": "465", "usernameInvalid": "Please provide your SMTP username.", "customCredentials": "Outgoing mail uses the same credentials as incoming" }, "exchange": { "usernamePlaceholder": "DOMAIN\\username or email address", "urlLabel": "Exchange URL", "urlPlaceholder": "https://outlook.example.com/EWS/Exchange.asmx", "urlAppearsToBeIncorrect": "This Exchange URL looks invalid.", "urlAppearsToBeIncorrectSuggestion": "This Exchange URL looks invalid. Did you mean {{ suggestedUrl }}?", "domainLabel": "Domain", "domainPlaceholder": "yourcompany", "supportedProducts": "Only Microsoft Exchange Server 2010 Service Pack 2 and above are supported currently" }, "security": { "heading": "Server Security", "acceptUntrustedCertLabel": "Allow non-secure certificate" }, "passwordLabel": "Password", "passwordPlaceholder": "password", "submit": "Connect your inbox", "credentials": "Inbox credentials", "isAdminTemplate": "Admins can manage these fields by going to Advanced Options > IMAP settings" }, "adminEmail": { "subject": "HubSpot couldn't connect to my inbox", "greeting": "Hey there,", "preface": "I tried connecting my email account to HubSpot in order to use their email tools. I ran into this error that you might be able to help me with.", "postface": "Thank you" }, "removeAllConnectionsPrompt": { "heading": "Unable to connect {{ emailAddress }}", "otherAccountsPreface": "The following users have already connected this email address to another inbox in this HubSpot account:", "howToConnect": "To connect {{ emailAddress }}, disconnect these users and try again.", "disconnectUsersButton": "Disconnect Users", "cancelButton": "Cancel", "disconnectionNotice": "Disconnecting these users won't remove any information from the account, but any meetings links tied to the account will no longer sync to the calendar." }, "providers": { "name": { "GOOGLE_FREE": "Gmail", "GOOGLE_APPS": "G Suite", "OUTLOOK": "Outlook", "OUTLOOK365": "Outlook 365", "UNKNOWN_IMAP": "IMAP+SMTP", "UNKNOWN": "other", "EXCHANGE": "Exchange", "HUBSPOT_HOSTED": "Hosted Email" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "InboxConnectUtils": {
    "en": "static-4.2886"
  }
};
  result.translationsAvailable = {
  "InboxConnectUtils": {
    "de": "static-4.2886",
    "en": "static-4.2886",
    "es": "static-4.2886",
    "fr": "static-4.2886",
    "ja": "static-4.2886",
    "nl": "static-4.2886",
    "pt-br": "static-4.2886"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:InboxConnectUtils:en', {version: 'static-4.2886'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "signatureEditorModal": { "labels": { "ok": "Okay", "signature": "Signature", "preview": "Preview", "editEmailSignature": "Edit email signature", "save": "Save", "visual": "Simple", "text": "HTML", "cancel": "Cancel", "update": { "prompt": "Also update my account signature with these changes", "tooltip": "Leave this box unchecked to only update the signature in the email you are composing" }, "signatureSaved": "Your signature has been saved." }, "descriptions": { "signature": "Your signature will be used in one-on-one emails throughout the HubSpot CRM." }, "errors": { "title": "Something went wrong", "unableToLoadSignature": "An error occurred while trying to load your email signature. Please try again.", "unableToUpdateSignature": "An error occurred while trying to save your email signature. Please try again.", "signatureTooLong": "Your email signature is too long and can't be saved. It must be less than {{ maxLength }} characters. Try making it smaller." }, "unsupportedHTML": { "header": "Unable to switch modes", "description": "Your signature has some HTML elements that aren't supported in the simple editor. Please use the HTML button to edit your signature with the raw HTML editor.", "saveButtonDisabled": "Your signature has unsupported HTML. Please remove any of the following tags from your signature:" }, "unsubscribeLink": { "link": "here", "RELEVANT": "Is this email not relevant to you? Click {{ link }}", "STOP_GETTING_MESSAGES": "To stop receiving these emails, click {{ link }}", "PREFER_LESS": "Prefer fewer emails from me? Click {{ link }}", "edit": { "header": "Choose an unsubscribe link", "submit": "Apply", "cancel": "Cancel", "removeLink": "Remove link" }, "info": { "header": "Why is this here?", "list": { "one": "HubSpot respects the sender and the recipient by allowing both sides to manage communications.", "two": "This is legally necessary. {{ infoLink }} to read more." }, "infoLink": "Click here" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "EmailSignatureEditor": {
    "en": "static-1.4532"
  }
};
  result.translationsAvailable = {
  "EmailSignatureEditor": {
    "cs": "static-1.4532",
    "da": "static-1.4532",
    "de": "static-1.4532",
    "el": "static-1.4532",
    "en": "static-1.4532",
    "es-mx": "static-1.4532",
    "es": "static-1.4532",
    "fi": "static-1.4532",
    "fr": "static-1.4532",
    "it": "static-1.4532",
    "ja": "static-1.4532",
    "ko": "static-1.4532",
    "nl": "static-1.4532",
    "no": "static-1.4532",
    "pl": "static-1.4532",
    "pt-br": "static-1.4532",
    "sv": "static-1.4532",
    "zh-cn": "static-1.4532",
    "zh-hk": "static-1.4532"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:EmailSignatureEditor:en', {version: 'static-1.4532'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18nAddon": { "fullNameInput": { "givenName": "First name", "familyName": "Last name" }, "phoneNumberInput": { "extensionPlaceholder": "Extension" }, "countryInfo": { "invalidCountryOption": "Invalid country" }, "languagesBeta": "In Beta", "languages": { "en": "English", "fr": "French", "de": "German", "ja": "Japanese", "pt": "Portuguese", "es-mx": "Spanish - Latin America", "es": "Spanish", "da": "Danish", "cs": "Czech", "fi": "Finnish", "it": "Italian", "nl": "Dutch", "no-no": "Norwegian", "pl": "Polish", "sv": "Swedish", "ko": "Korean", "el": "Greek", "zh-si": "Chinese (Simplified)", "zh-tr": "Chinese (Traditional)" }, "locales": { "en-us": "United States", "en-ca": "Canada", "en-gb": "United Kingdom", "en-ie": "Ireland", "en-au": "Australia", "en-nz": "New Zealand", "en-in": "India", "es-ar": "South America", "es-mx": "Mexico and Central America", "es": "Spain", "pt-br": "Brazil", "cs": "Czech Republic", "da": "Denmark", "pl": "Poland", "de": "Germany", "fr": "France", "it": "Italy", "fi": "Finland", "sv": "Sweden", "sv-fi": "Finland", "nl": "Netherlands", "nl-be": "Belgium", "no-no": "Norway", "noNO": "Norway", "ja": "Japan", "zh-cn": "China", "zh-hk": "Hong Kong", "el": "Greece", "ko": "South Korea" }, "supportLink": { "learnMore": "Learn more." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "ui-addon-i18n": {
    "en": "static-1.2966"
  }
};
  result.translationsAvailable = {
  "ui-addon-i18n": {
    "de": "static-1.2966",
    "en": "static-1.2966",
    "es": "static-1.2966",
    "fr": "static-1.2966",
    "ja": "static-1.2966",
    "nl": "static-1.2966",
    "pt-br": "static-1.2966"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ui-addon-i18n:en', {version: 'static-1.2966'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "SharedI18nStrings": { "countryCodes": { "AF": "Afghanistan", "AL": "Albania", "AQ": "Antarctica", "AX": "Åland Islands", "DZ": "Algeria", "AS": "American Samoa", "AD": "Andorra", "AO": "Angola", "AI": "Anguilla", "AG": "Antigua and Barbuda", "AW": "Aruba", "AP": "Asia/Pacific Region", "AZ": "Azerbaijan", "AR": "Argentina", "AM": "Armenia", "AU": "Australia", "AT": "Austria", "BS": "Bahamas", "BH": "Bahrain", "BD": "Bangladesh", "BB": "Barbados", "BE": "Belgium", "BT": "Bhutan", "BO": "Bolivia", "BA": "Bosnia and Herzegovina", "BW": "Botswana", "BV": "Bouvet Island", "BR": "Brazil", "BQ": "Caribbean Netherlands", "BZ": "Belize", "SB": "Solomon Islands", "BN": "Brunei", "BG": "Bulgaria", "BI": "Burundi", "BY": "Belarus", "BM": "Bermuda", "KH": "Cambodia", "KY": "Cayman Islands", "CM": "Cameroon", "CA": "Canada", "CV": "Cape Verde", "CF": "Central African Republic", "CU": "Cuba", "CW": "Curaçao", "LK": "Sri Lanka", "TD": "Chad", "CL": "Chile", "CN": "China", "CX": "Christmas Island", "CC": "Cocos (Keeling) Islands", "CO": "Colombia", "KM": "Comoros", "CG": "Congo", "CD": "Democratic Republic of the Congo", "CK": "Cook Islands", "CR": "Costa Rica", "HR": "Croatia", "CY": "Cyprus", "CZ": "Czech Republic", "BJ": "Benin", "DK": "Denmark", "DM": "Dominica", "DO": "Dominican Republic", "EC": "Ecuador", "SV": "El Salvador", "GQ": "Equatorial Guinea", "ET": "Ethiopia", "ER": "Eritrea", "EE": "Estonia", "EU": "Europe", "GS": "South Georgia and the South Sandwich Islands", "FJ": "Fiji", "FI": "Finland", "FR": "France", "FK": "Falkland Islands", "FO": "Faroe Islands", "PF": "French Polynesia", "TF": "French Southern and Antarctic Lands", "DJ": "Djibouti", "GA": "Gabon", "GE": "Georgia", "GM": "Gambia", "DE": "Germany", "GH": "Ghana", "GL": "Greenland", "GP": "Guadeloupe", "GG": "Guernsey", "KI": "Kiribati", "GR": "Greece", "GD": "Grenada", "GU": "Guam", "GT": "Guatemala", "GN": "Guinea", "GY": "Guyana", "GF": "French Guiana", "GI": "Gibraltar", "HT": "Haiti", "HM": "Heard Island and McDonald Islands", "VA": "Vatican City", "HN": "Honduras", "HU": "Hungary", "HK": "Hong Kong", "IM": "Isle of Man", "IR": "Iran", "JE": "Jersey", "MO": "Macau", "MQ": "Martinique", "MS": "Montserrat", "MM": "Myanmar (Burma)", "KP": "North Korea", "PS": "Palestine", "PR": "Puerto Rico", "RE": "Réunion", "BL": "Saint Barthélemy", "MF": "Saint Martin", "SX": "Sint Maarten", "SS": "South Sudan", "SD": "Sudan", "SY": "Syria", "TW": "Taiwan", "TC": "Turks and Caicos Islands", "VI": "U.S. Virgin Islands", "IS": "Iceland", "IN": "India", "ID": "Indonesia", "IQ": "Iraq", "IE": "Ireland", "IL": "Israel", "IT": "Italy", "IO": "British Indian Ocean Territory", "CI": "Cote d'Ivoire", "JM": "Jamaica", "JP": "Japan", "KZ": "Kazakhstan", "JO": "Jordan", "KE": "Kenya", "KR": "South Korea", "KW": "Kuwait", "KG": "Kyrgyzstan", "LA": "Laos", "LB": "Lebanon", "LS": "Lesotho", "LV": "Latvia", "LR": "Liberia", "LY": "Libya", "LI": "Liechtenstein", "LT": "Lithuania", "LU": "Luxembourg", "MG": "Madagascar", "MW": "Malawi", "MY": "Malaysia", "MV": "Maldives", "ML": "Mali", "MT": "Malta", "MR": "Mauritania", "MU": "Mauritius", "YT": "Mayotte", "MX": "Mexico", "MC": "Monaco", "MN": "Mongolia", "MD": "Moldova", "ME": "Montenegro", "MA": "Morocco", "MZ": "Mozambique", "OM": "Oman", "NA": "Namibia", "NR": "Nauru", "NP": "Nepal", "NL": "Netherlands", "NC": "New Caledonia", "VU": "Vanuatu", "AN": "Netherlands Antilles", "NZ": "New Zealand", "NI": "Nicaragua", "NE": "Niger", "NG": "Nigeria", "NU": "Niue", "NF": "Norfolk Island", "NO": "Norway", "MP": "Northern Mariana Islands", "UM": "United States Minor Outlying Islands", "FM": "Micronesia", "MH": "Marshall Islands", "PW": "Palau", "PK": "Pakistan", "PA": "Panama", "PG": "Papua New Guinea", "PY": "Paraguay", "PE": "Peru", "PH": "Philippines", "PN": "Pitcairn Islands", "PL": "Poland", "PT": "Portugal", "GW": "Guinea-Bissau", "TL": "East Timor", "QA": "Qatar", "RO": "Romania", "RU": "Russia", "RW": "Rwanda", "SH": "Saint Helena", "KN": "Saint Kitts and Nevis", "LC": "Saint Lucia", "PM": "Saint Pierre and Miquelon", "VC": "Saint Vincent and the Grenadines", "SM": "San Marino", "ST": "Sao Tome and Principe", "SA": "Saudi Arabia", "SN": "Senegal", "SJ": "Svalbard and Jan Mayen", "RS": "Serbia", "SC": "Seychelles", "SL": "Sierra Leone", "SG": "Singapore", "SK": "Slovakia", "UK": "United Kingdom", "VN": "Vietnam", "EH": "Western Sahara", "SI": "Slovenia", "SO": "Somalia", "ZA": "South Africa", "ZW": "Zimbabwe", "ES": "Spain", "SR": "Suriname", "SZ": "Swaziland", "SE": "Sweden", "CH": "Switzerland", "TJ": "Tajikistan", "TH": "Thailand", "TG": "Togo", "TK": "Tokelau", "TO": "Tonga", "TT": "Trinidad and Tobago", "AE": "United Arab Emirates", "TN": "Tunisia", "TR": "Turkey", "TM": "Turkmenistan", "TV": "Tuvalu", "UG": "Uganda", "UA": "Ukraine", "MK": "Macedonia (FYROM)", "EG": "Egypt", "GB": "United Kingdom", "TZ": "Tanzania", "US": "United States", "BF": "Burkina Faso", "UY": "Uruguay", "UZ": "Uzbekistan", "VE": "Venezuela", "VG": "British Virgin Islands", "WF": "Wallis and Futuna", "WS": "Samoa", "YE": "Yemen", "ZM": "Zambia" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "cs": "static-1.62",
    "da": "static-1.62",
    "de": "static-1.62",
    "el": "static-1.62",
    "en": "static-1.62",
    "es-mx": "static-1.62",
    "es": "static-1.62",
    "fi": "static-1.62",
    "fr": "static-1.62",
    "it": "static-1.62",
    "ja": "static-1.62",
    "ko": "static-1.62",
    "nl": "static-1.62",
    "no": "static-1.62",
    "pl": "static-1.62",
    "pt-br": "static-1.62",
    "sv": "static-1.62",
    "zh-cn": "static-1.62",
    "zh-hk": "static-1.62"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanian", "sq-al": "Albanian - Albania", "ar": "Arabic", "ar-dz": "Arabic - Algeria", "ar-bh": "Arabic - Bahrain", "ar-eg": "Arabic - Egypt", "ar-iq": "Arabic - Iraq", "ar-jo": "Arabic - Jordan", "ar-kw": "Arabic - Kuwait", "ar-lb": "Arabic - Lebanon", "ar-ly": "Arabic - Libya", "ar-ma": "Arabic - Morocco", "ar-om": "Arabic - Oman", "ar-qa": "Arabic - Qatar", "ar-sa": "Arabic - Saudi Arabia", "ar-sd": "Arabic - Sudan", "ar-sy": "Arabic - Syria", "ar-tn": "Arabic - Tunisia", "ar-ae": "Arabic - United Arab Emirates", "ar-ye": "Arabic - Yemen", "hy": "Armenian", "eu": "Basque", "be": "Belarusian", "be-by": "Belarusian - Belarus", "bg": "Bulgarian", "bg-bg": "Bulgarian - Bulgaria", "ca": "Catalan", "ca-es": "Catalan - Catalan", "zh": "Chinese", "zh-cn": "Chinese - China", "zh-hk": "Chinese - Hong Kong SAR", "zh-mo": "Chinese - Macau SAR", "zh-sg": "Chinese - Singapore", "zh-tw": "Chinese - Taiwan", "zh-chs": "Chinese (Simplified)", "zh-cht": "Chinese (Traditional)", "zh-hans": "Chinese (Simplified Han)", "zh-hant": "Chinese (Traditional Han)", "hr": "Croatian", "hr-hr": "Croatian - Croatia", "cs": "Czech", "cs-cz": "Czech - Czech Republic", "da": "Danish", "da-dk": "Danish - Denmark", "nl": "Dutch", "nl-be": "Dutch - Belgium", "nl-nl": "Dutch - The Netherlands", "en": "English", "en-au": "English - Australia", "en-ca": "English - Canada", "en-hk": "English - Hong Kong", "en-in": "English - India", "en-ie": "English - Ireland", "en-my": "English - Malaysia", "en-mt": "English - Malta", "en-nz": "English - New Zealand", "en-ph": "English - Philippines", "en-pk": "English - Pakistan", "en-sg": "English - Singapore", "en-za": "English - South Africa", "en-gb": "English - United Kingdom", "en-us": "English - United States", "en-zw": "English - Zimbabwe", "et": "Estonian", "et-ee": "Estonian - Estonia", "fo": "Faroese", "fa": "Farsi", "fi": "Finnish", "fi-fi": "Finnish - Finland", "fr": "French", "fr-be": "French - Belgium", "fr-ca": "French - Canada", "fr-fr": "French - France", "fr-lu": "French - Luxembourg", "fr-mc": "French - Monaco", "fr-ch": "French - Switzerland", "gl": "Galician", "ka": "Georgian", "de": "German", "de-at": "German - Austria", "de-de": "German - Germany", "de-gr": "German - Greece", "de-li": "German - Liechtenstein", "de-lu": "German - Luxembourg", "de-ch": "German - Switzerland", "el": "Greek", "el-cy": "Greek - Cyprus", "el-gr": "Greek - Greece", "gu": "Gujarati", "he": "Hebrew", "iw-il": "Hebrew - Israel", "hi": "Hindi", "hi-in": "Hindi - India", "hu": "Hungarian", "hu-hu": "Hungarian - Hungary", "is": "Icelandic", "is-is": "Icelandic - Iceland", "id": "Indonesian", "in-id": "Indonesian - Indonesia", "ga": "Irish", "ga-ie": "Irish - Ireland", "it": "Italian", "it-it": "Italian - Italy", "it-ch": "Italian - Switzerland", "ja": "Japanese", "ja-jp": "Japanese - Japan", "kn": "Kannada", "kk": "Kazakh kok Konkani", "kok": "Konkani", "ko": "Korean", "ko-kr": "Korean - South Korea", "ky": "Kyrgyz", "lv": "Latvian", "lv-lv": "Latvian - Latvia", "lt": "Lithuanian", "lt-lt": "Lithuanian - Lithuania", "mk": "Macedonian", "mk-mk": "Macedonian - Macedonia", "ms": "Malay", "ms-bn": "Malay - Brunei", "ms-my": "Malay - Malaysia", "mt": "Maltese", "mt-mt": "Maltese - Malta", "mr": "Marathi", "mn": "Mongolian", "my": "Burmese", "my-mm": "Burmese - Myanmar (Burma)", "no": "Norwegian", "nb": "Norwegian Bokmal", "no-no": "Norwegian - Norway", "pl": "Polish", "pl-pl": "Polish - Poland", "pt": "Portuguese", "pt-br": "Portuguese - Brazil", "pt-pt": "Portuguese - Portugal", "pa": "Punjabi", "ro": "Romanian", "ro-ro": "Romanian - Romania", "ru": "Russian", "ru-ru": "Russian - Russia", "sa": "Sanskrit", "sr": "Serbian", "sr-ba": "Serbian - Bosnia and Herzegovina", "sr-me": "Serbian - Montenegro", "sr-rs": "Serbian - Serbia", "sr-cs": "Serbian - Serbia and Montenegro (Former)", "sk": "Slovak", "sk-sk": "Slovak - Slovakia", "sl": "Slovenian", "sl-si": "Slovenian - Slovenia", "es": "Spanish", "es-ar": "Spanish - Argentina", "es-bo": "Spanish - Bolivia", "es-cl": "Spanish - Chile", "es-co": "Spanish - Colombia", "es-cr": "Spanish - Costa Rica", "es-cu": "Spanish - Cuba", "es-do": "Spanish - Dominican Republic", "es-ec": "Spanish - Ecuador", "es-sv": "Spanish - El Salvador", "es-gt": "Spanish - Guatemala", "es-hn": "Spanish - Honduras", "es-mx": "Spanish - Mexico", "es-ni": "Spanish - Nicaragua", "es-pa": "Spanish - Panama", "es-py": "Spanish - Paraguay", "es-pe": "Spanish - Peru", "es-pr": "Spanish - Puerto Rico", "es-es": "Spanish - Spain", "es-us": "Spanish - United States", "es-uy": "Spanish - Uruguay", "es-ve": "Spanish - Venezuela", "sw": "Swahili", "sv": "Swedish", "sv-fi": "Swedish - Finland", "sv-se": "Swedish - Sweden", "sy": "Syriac", "ta": "Tamil", "tt": "Tatar", "te": "Telugu", "th": "Thai", "th-th": "Thai - Thailand", "tr": "Turkish", "tr-tr": "Turkish - Turkey", "uk": "Ukrainian", "uk-ua": "Ukrainian - Ukraine", "ur": "Urdu", "vi": "Vietnamese", "vi-vn": "Vietnamese - Vietnam" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.62",
    "ar-eg": "static-1.62",
    "ar-sa": "static-1.62",
    "ar": "static-1.62",
    "be": "static-1.62",
    "ca-es": "static-1.62",
    "cs": "static-1.62",
    "da": "static-1.62",
    "de": "static-1.62",
    "el": "static-1.62",
    "en": "static-1.62",
    "es-ar": "static-1.62",
    "es-es": "static-1.62",
    "es-mx": "static-1.62",
    "es": "static-1.62",
    "et": "static-1.62",
    "eu": "static-1.62",
    "fi": "static-1.62",
    "fr-ca": "static-1.62",
    "fr": "static-1.62",
    "gl": "static-1.62",
    "gu": "static-1.62",
    "he": "static-1.62",
    "hi": "static-1.62",
    "hr": "static-1.62",
    "hu": "static-1.62",
    "hy": "static-1.62",
    "id": "static-1.62",
    "is": "static-1.62",
    "it": "static-1.62",
    "ja": "static-1.62",
    "ka": "static-1.62",
    "kk": "static-1.62",
    "kn": "static-1.62",
    "ko": "static-1.62",
    "ky": "static-1.62",
    "lt": "static-1.62",
    "lv": "static-1.62",
    "mk": "static-1.62",
    "mn": "static-1.62",
    "mr": "static-1.62",
    "ms-my": "static-1.62",
    "ms": "static-1.62",
    "nl-be": "static-1.62",
    "nl-nl": "static-1.62",
    "nl": "static-1.62",
    "no": "static-1.62",
    "pl": "static-1.62",
    "pt-br": "static-1.62",
    "pt-pt": "static-1.62",
    "ro": "static-1.62",
    "ru": "static-1.62",
    "sk": "static-1.62",
    "sl": "static-1.62",
    "sq": "static-1.62",
    "sr": "static-1.62",
    "sv": "static-1.62",
    "sw": "static-1.62",
    "ta": "static-1.62",
    "te": "static-1.62",
    "th": "static-1.62",
    "tr": "static-1.62",
    "uk": "static-1.62",
    "ur": "static-1.62",
    "vi": "static-1.62",
    "zh-cn": "static-1.62",
    "zh-hk": "static-1.62",
    "zh-tw": "static-1.62"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "colorPicker": { "favorites": "Favorites", "popover": { "mode": { "simple": "Simple", "advanced": "Advanced" }, "edit": "Edit", "reset": "Reset to default" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "react-colorpicker": {
    "en": "static-2.2754"
  }
};
  result.translationsAvailable = {
  "react-colorpicker": {
    "de": "static-2.2754",
    "en": "static-2.2754",
    "es": "static-2.2754",
    "fr": "static-2.2754",
    "ja": "static-2.2754",
    "nl": "static-2.2754",
    "pt-br": "static-2.2754"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:react-colorpicker:en', {version: 'static-2.2754'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "draftPlugins": { "alignmentPlugin": { "tooltips": { "align": "Align", "center": "Align center", "left": "Align left", "right": "Align right" } }, "backgroundColorPlugin": { "tooltip": "Background color" }, "blockStyle": { "tooltips": { "plain": "Paragraph", "h1": "Heading 1", "h2": "Heading 2", "h3": "Heading 3", "h4": "Heading 4", "h5": "Heading 5", "h6": "Heading 6", "blockquote": "Blockquote", "ul": "Unordered list", "ol": "Ordered list", "codeblock": "Code block" } }, "fontStyle": { "tooltip": "Font" }, "highlightPlugin": { "tooltip": "Highlight" }, "imagePlugin": { "resetSize": "Full size", "tooltip": "Insert image", "uploadFailedBody": "{{ fileName }} could not be uploaded.", "uploadFailedTitle": "Your file failed to upload." }, "inlineStylesPlugin": { "tooltips": { "clear": "Clear formatting", "bold": "Bold", "italic": "Italic", "underline": "Underline" } }, "inlineInsertPlugin": { "popoverTitle": { "menu": "Insert options", "snippets": "Snippets", "templates": "Templates" }, "noResults": "No results match your query." }, "insertGroupPlugin": { "attachments": "File", "popoverButtonText": "Insert", "documents": "Document", "knowledgeArticles": "Knowledge article", "link": "Link", "manageContentLink": "Manage", "meetings": "Meeting link", "mergeTags": "Token", "signature": "Signature", "snippets": "Snippet", "video": "Video", "insertItem": { "documents": "Insert document", "knowledgeArticles": "Insert knowledge article", "meetings": "Insert meeting link", "snippets": "Insert snippet", "video": "Insert video" } }, "meetings": { "default": "{{ name }} (Default)", "linkTo": "Link to:", "button": "Meeting link", "meetingDuration": "{{ durationList }} meeting", "meetingsLinkNotYours": "Not your meeting link", "popoverTitle": "Insert meeting link", "popoverTitleEdit": "Edit meeting link", "updateTitle": "Edit meetings link", "linkLabel": "Link type", "textLabel": "Text to display", "previewBookingPage": "Preview booking page", "textPlaceholder": "e.g. Schedule a call with me", "confirm": "Insert", "confirmUpdate": "Update", "cancel": "Cancel", "manageLinks": "Manage links", "sendermeetingslink": "Sender's meetings link", "ownermeetingslink": "Contact owner’s meeting link", "custommeetingslink": "Your meeting link", "ctaHeader": "Book meetings without the hassle", "ctaText": "Say goodbye to the endless back and forth of scheduling meetings with your own dedicated link. Your schedule, your way.", "emptyStateTitle": "You haven’t set a meeting link yet", "emptyStateBodyText": "Meeting links are synced to your Google or Outlook calendar. Prospects can directly book time with you through meeting links, skipping the back and forth emailing!", "emptyStateConfirm": "Set up meetings", "emptyStateCancel": "Cancel", "ctaButton": "Get started", "notMyMeetingsLinkPopover": { "title": "Not your meeting link", "copiedTemplate": "If you copied this template from someone on your team, any meeting links are still theirs.", "deleteLink": "Unless you want them in your email, you should delete these links and insert your own." }, "proTip": { "title": "Pro Tip:", "description": "Turn \"...{{ phrase }}...\" into a meeting link. Prospects can then directly book time on your personal booking page.", "turnIntoMeeting": "Turn into meeting link", "setUpMeeting": "Set up a meeting link", "dismiss": "Dismiss" } }, "richtext": { "cancel": "Cancel", "more": "More", "submit": "Save", "link": { "header": "Edit link", "placeholder": "http://", "remove": "Remove link", "url": { "label": "URL" }, "target": { "label": "Open in new tab" } } }, "sizeStyle": { "tooltip": "Size" }, "textColorPlugin": { "tooltip": "Text color" }, "linkPlugin": { "openInNewTab": "Open in new tab", "noFollow": "Instruct search engines not to follow this link", "newLink": "Create link", "editLink": "Edit link", "imageLink": "Image link", "save": "Save", "apply": "Apply", "cancel": "Cancel", "visitLink": "Visit link", "removeLink": "Remove link", "url": "URL", "text": "Link text", "yourPagesPlaceholder": "Paste a link or search for an existing page", "promptText": "Click here to apply this link", "tooltip": "Insert link", "unstyledButtonText": "Link" }, "tokenPlugin": { "atMentions": { "resultsZeroState": { "notFound": "“{{search}}” doesn't seem to be here. Invite them to HubSpot so they can join in.", "teamInvitations": { "cta": "Invite", "cancel": "Cancel", "placeholderEmail": "e.g., email@client.com", "emailLabel": "Email address", "invitePending": "Writing a nice welcome note…", "inviteSent": "You're all set. Your friends at {{email}} will receive an invitation to join your team.", "confirm": "Okay", "invitationSendError": "Sorry. Something went wrong.", "invalidEmailError": "Invalid email entered" } } }, "resultsZeroState": { "text": "No matches found" } }, "snippetsPlugin": { "button": "Snippets", "tooltip": "Insert Snippet", "popover": { "header": { "insertSnippet": "Insert snippet", "manage": "Manage", "createNew": "Create new" }, "search": { "placeholder": "Search snippets..." }, "emptyState": { "title": "Create shortcuts to your most typed sentences", "description": "Snippets are prewritten responses to standard questions that can be used to quickly respond to live chats on your website or serve as building blocks for an email.", "createFirstSnippet": "Create your first snippet" } }, "resultsZeroState": { "text": "No matches found", "link": "Create a new snippet" }, "fetchError": "Your snippets could not be loaded. Please try again later." }, "knowledgeArticlesPlugin": { "tooltip": "Insert knowledge article", "manage": "Manage", "popover": { "search": { "placeholder": "Search knowledge articles..." }, "emptyState": { "title": "Help customers help themselves", "description": "Create new articles based on your customers' most frequently asked questions, or import articles from an existing knowledge base.", "createFirstKnowledgeArticle": "Get started" } }, "resultsZeroState": { "text": "No matches found", "link": "Create a new knowledge article" }, "fetchError": "Your knowledge articles could not be loaded. Please try again later." }, "documentLinkPlugin": { "editPopover": { "title": "Edit link preview", "previewTitle": "Link preview title", "previewDescription": "Link preview description", "save": "Save", "cancel": "Cancel" }, "unknownDeck": "Unknown Deck" }, "documentLinkPreviewPlugin": { "missing": { "name": "{{ name }} was deleted." } }, "documents": { "document": "Document", "tooltip": "Insert document", "mergeTag": { "tooltip": "A unique link will be generated each time you send the template." }, "decksModal": { "title": "Insert Document Link", "requireEmail": "Require email to view document", "includeLinkPreview": "Include link preview", "insertButton": "Insert", "cancelButton": "Cancel", "selectDocument": "Document", "noDecks": "You haven't created any documents yet.", "noDecksButton": "Create a document", "linkTextLabel": "Link display text" }, "emptyStateTitle": "You haven’t uploaded any documents ", "emptyStateBodyText": "Documents are trackable so you have more insight into what content your prospects engage with, enabling you to follow-up accurately and close deals.", "emptyStateConfirm": "Upload a document", "emptyStateCancel": "Cancel" }, "mergeTags": { "missingMergeTags": { "company": "Company", "contact": "Contact", "agent": "Agent", "deal": "Deal", "ticket": "Ticket", "quote": "Quote", "sender": "Sender", "placeholder": "Custom", "missingMeeting": "Meeting Link", "missingDocument": "Document Link", "unknown": "Unrecognized Token" }, "button": { "searchPlaceholder": "Start typing to search..." }, "company": { "name": "Company token" }, "contact": { "name": "Contact token" }, "deal": { "name": "Deal token" }, "ticket": { "name": "Ticket token" }, "quote": { "name": "Quote token" } }, "mergeTagGroupPlugin": { "buttonText": "Personalize", "token": "Token", "tagLabel": "{{propertyType}}: {{propertyLabel}}", "newBadge": "New", "mergeTags": { "contact": "Contact", "company": "Company", "deal": "Deal", "ticket": "Ticket", "quote": "Quote", "sender": "Sender", "placeholder": "Custom text token" }, "header": { "title": "Insert personalization token", "label": "Type", "placeholder": "Select a token" }, "form": { "label": "Type", "typePlaceholder": "Select a token", "header": "Insert personalization token", "customLabel": "Custom token", "customDescription": "Custom tokens must be filled out before sending a template or sequence. This will make sure you've personalized your outreach.", "searchPlaceholder": { "contact": "Search contact tokens", "company": "Search company tokens", "deal": "Search deal tokens", "ticket": "Search ticket tokens", "quote": "Search quote tokens", "sender": "Search sender tokens" } }, "footer": { "buttons": { "insert": "Insert", "cancel": "Cancel" } }, "senderProperties": { "groupDisplayName": "Sender information", "properties": { "firstname": "First Name", "lastname": "Last Name", "fullname": "Full Name", "email": "Email", "phonenumber": "Phone Number" } }, "shepherd": { "header": "New token types are here", "body": { "templates": "Good news. You can now use Sender tokens and Custom placeholder tokens to further personalize your templates.", "snippets": "Good news. You can now use Sender tokens and Custom placeholder tokens to further personalize your snippets." }, "footer": { "button": "Got it" } } }, "videoPlugin": { "tooltip": "Insert video", "video": "Video", "popover": { "header": "Increase your email reply rates", "body": "Personalize your emails using videos made right here in the CRM. First time recording a video?", "bodyLink": "Watch the video lesson in the learning center.", "acceptButton": "Get started", "closeButton": "Close" } }, "goVideoModal": { "title": "Insert video" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "draft-plugins": {
    "en": "static-2.4724"
  }
};
  result.translationsAvailable = {
  "draft-plugins": {
    "cs": "static-2.4724",
    "da": "static-2.4724",
    "de": "static-2.4724",
    "el": "static-2.4724",
    "en": "static-2.4724",
    "es-mx": "static-2.4724",
    "es": "static-2.4724",
    "fi": "static-2.4724",
    "fr": "static-2.4724",
    "it": "static-2.4724",
    "ja": "static-2.4724",
    "ko": "static-2.4724",
    "nl": "static-2.4724",
    "no": "static-2.4724",
    "pl": "static-2.4724",
    "pt-br": "static-2.4724",
    "sv": "static-2.4724",
    "zh-cn": "static-2.4724",
    "zh-hk": "static-2.4724"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:draft-plugins:en', {version: 'static-2.4724'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "exportDialog": { "fields": { "formatLabel": "File format", "emailLabel": "Email", "emailDescription": "Your export will be sent to this email" }, "formats": { "csv": "CSV", "xls": "XLS", "xlsx": "XLSX" }, "exportCta": "Export", "cancel": "Cancel", "dialogHeading": "Export", "whitelistHelpText": "Not getting our emails? Make sure that you've added HubSpot email addresses to <a href='{{whitelistUrl}}' target='_blank'>your whitelist</a> and turned on your <a href='{{notificationUrl}}' target='_blank'>export notifications</a>", "emailErrors": { "invalidEmail": "Please enter a valid email." }, "preference": { "exportToBothText": "The exported file will be emailed to <b>{{value}}</b> and posted in your <b>Notifications Center</b>", "exportToEmailText": "The exported file will be emailed to <b>{{value}}</b>", "exportToNotificationCenterText": "The exported file will be posted in your <b>Notifications Center</b>", "notificationsOffText": "In order to receive your exported file you need to turn on at least one export notification either email or the notification center.", "notificationCta": "Go to notifications", "notificationsOffHeading": "Your export notifications are turned off" } }, "exportWizard": { "title": "Export", "details": "Export details" } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "ExportDialog": {
    "en": "static-6.1176"
  }
};
  result.translationsAvailable = {
  "ExportDialog": {
    "de": "static-6.1176",
    "en": "static-6.1176",
    "es": "static-6.1176",
    "fr": "static-6.1176",
    "ja": "static-6.1176",
    "nl": "static-6.1176",
    "pt-br": "static-6.1176"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ExportDialog:en', {version: 'static-6.1176'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ContentComponents": { "fullscreenModal": { "back": "Back" }, "audienceAccess": { "statuses": { "all": "Public", "specificContacts": "Private - Registration required", "password": "Private - Password required" }, "changeAccess": { "default": "(default)", "passwordError": "You must enter a password!", "passwordPlaceholder": "Set password", "lists": "Lists", "listsErrorMessage": "Lists are taking too long to load, or aren't available right now.", "listsErrorTryAgainMessage": "Try reloading lists.", "selectLists": "Select lists", "sendEmailMessage": { "domainsNotConnected": "When you connect a domain, registration emails will be automatically sent to all of the contacts on these lists.", "draft": { "one": "When this page is published, a registration email will be sent to any contacts on these lists that haven't already registered", "other": "When these pages are published, a registration email will be sent to any contacts on these lists that haven't already registered" }, "hasPublished": "This will send a registration email to any contacts on these lists who haven't already registered" }, "knowledgeArticleLink": "<a target='_blank' href='https://knowledge.hubspot.com/articles/kcs_article/cms-pages-editor/control-audience-access-to-pages'>Learn about audience access and how to set up sign-in links</a>", "options": { "all": { "label": "Public", "subtitle": "Your page will be available to anyone who goes to the URL" }, "password": { "label": "Private - Password required", "subtitle": { "one": "Set a single password and share it with your audience. Visitors will need to enter this password to access the page.", "other": "Set a single password and share it with your audience. Visitors will need to enter this password to access the pages." } }, "specificContacts": { "label": "Private - Registration required", "subtitle": { "one": "Give specific contacts access to this page using lists. They’ll need to register and sign in with their own email and password to access this page.", "other": "Give specific contacts access to these pages using lists. They’ll need to register and sign in with their own email and password to access these pages." } } } } }, "contentActionModals": { "pages": { "archive": { "header": { "one": "Archive this page?", "other": "Archive these pages?" }, "body": { "one": "This page will be archived.", "other": "{{count}} pages will be archived." }, "bodyWithTranslations": { "one": "This page and its language variation will be archived.", "other": "This page and its {{translationsCount}} language variations will be archived." }, "LANDING_PAGE": { "body": { "one": "This page will be archived. You can access it later by selecting \"Archived\" in the left navigation under \"All landing pages\"", "other": "{{count}} pages will be archived. You can access them later by selecting \"Archived\" in the left navigation under \"All landing pages\"" }, "bodyWithTranslations": { "one": "This page and its language variation will be archived. You can access them later by selecting \"Archived\" in the left navigation under \"All landing pages\"", "other": "This page and its {{translationsCount}} language variations will be archived. You can access them later by selecting \"Archived\" in the left navigation under \"All landing pages\"" } }, "SITE_PAGE": { "body": { "one": "This page will be archived. You can access it later by selecting \"Archived\" in the left navigation under \"All website pages\"", "other": "{{count}} pages will be archived. You can access them later by selecting \"Archived\" in the left navigation under \"All website pages\"" }, "bodyWithTranslations": { "one": "This page and its language variation will be archived. You can access them later by selecting \"Archived\" in the left navigation under \"All website pages\"", "other": "This page and its {{translationsCount}} language variations will be archived. You can access them later by selecting \"Archived\" in the left navigation under \"All website pages\"" } } }, "changeAudienceAccess": { "title": { "one": "Control audience access", "other": "Control audience access for {{count}} pages" }, "bulkAlert": "The changes you make below will override and replace the current privacy settings for all selected pages", "body": { "one": "Control the privacy of this page and how visitors can access it", "other": "Control the privacy of these <strong>{{count}} pages</strong> and how visitors can access them" }, "pageSelectorLabel": "What language variation would you like to change audience access for?", "save": "Save", "saveAndEmail": "Save and send emails" }, "clone": { "confirm": "Clone", "header": "Clone this page", "inputLabel": "Choose a name for the new cloned page" }, "convert": { "body": "Moving this page to {{ contentType }} will change the information and metrics displayed, but the old page information and metrics can be restored at any time by moving the page back to its old location.", "bodyWithTranslations": { "one": "Moving this page and its language variation to {{ contentType }} will change the information and metrics displayed, but the old page information and metrics can be restored at any time by moving the page and its language variation back to its old location.", "other": "Moving this page and its {{translationsCount}} language variations to {{ contentType }} will change the information and metrics displayed, but the old page information and metrics can be restored at any time by moving the page and its language variations back to its old location." }, "cancel": "Cancel", "confirm": "Move to {{ contentType }}", "header": "Move to {{ contentType }}", "pageSelectorLabel": "What language variation would you like to move?" }, "delete": { "header": { "one": "Delete this page?", "other": "Delete these pages?" }, "body": { "one": "Deleting <em>{{name}}</em> will permanently remove it from your account and it will no longer be available. <strong>This can't be undone.</strong>", "other": "Deleting these pages will permanently remove them and their translations from your account. <strong>This can’t be undone.</strong>" }, "deleteMatchLabel": { "one": "Type \"{{deleteMatchText}}\" below to verify that you want to delete this page.", "other": "Type \"{{deleteMatchText}}\" below to verify that you want to delete all the pages listed above." }, "confirm": { "one": "Delete page", "other": "Delete pages" }, "translations": { "one": "<strong>This page contains translated children that will <em>also</em> be deleted. If you only wish to delete the master language page, click the globe icon and delete that one.</strong>", "other": "<strong>If you only want to delete one of these pages, click cancel and hover over the globe icon for this page. Click the trashcan icon next to the specific page you’d like to delete.</strong>" } }, "unarchive": { "body": { "one": "This page will be unarchived.", "other": "{{count}} pages will be unarchived." }, "bodyWithTranslations": { "one": "This page and its language variation will be unarchived.", "other": "This page and its {{translationsCount}} language variations will be unarchived." }, "header": { "one": "Unarchive this page?", "other": "Unarchive these pages?" } }, "unpublish": { "body": "Are you sure you want to unpublish this page?", "header": "Unpublish this page?" } }, "blog": { "archive": { "header": { "one": "Archive this blog post?", "other": "Archive these blog posts?" }, "body": { "one": "This blog post will be archived. You can access it later by filtering by \"Archived.\"", "other": "These {{count}} blog posts will be archived. You can access them later by filtering by \"Archived.\"" } }, "clone": { "confirm": "Clone", "header": "Clone this blog post", "inputLabel": "Choose a name for the new cloned blog post" }, "delete": { "header": { "one": "Do you really want to delete this post?", "other": "Do you really want to delete these posts?" }, "body": { "one": "Deleting <em>{{name}}</em> will permanently remove it from your account and it will no longer be available. <strong>This cannot be undone.</strong>", "other": "Deleting these posts will permanently remove them from your account. <strong>This can’t be undone.</strong> These posts will no longer be available:" }, "deleteMatchLabel": { "one": "Type \"{{deleteMatchText}}\" below to verify that you want to delete this post", "other": "Type \"{{deleteMatchText}}\" below to verify that you want to delete all the posts listed above" }, "confirm": { "one": "Delete post", "other": "Delete posts" } }, "unarchive": { "header": { "one": "Unarchive this blog post?", "other": "Unarchive these blog posts?" }, "body": { "one": "This blog post will be unarchived.", "other": "{{count}} blog posts will be unarchived." } }, "unpublish": { "body": "Are you sure you want to unpublish this blog post?", "header": "Unpublish this blog post?" } }, "folders": null, "shared": { "archive": { "archiveAndUnpublish": "Archive and unpublish", "confirm": "Archive", "pageSelectorLabel": "What language variation would you like to archive?" }, "clone": { "confirm": "Clone", "cloneName": "{{originalName}} (Clone)", "pageSelectorLabel": "What language variation would you like to clone?" }, "cancel": "Cancel", "contentTypes": { "BLOG_POST": "Blog posts", "EXTERNAL_PAGE": "External pages", "LANDING_PAGE": "Landing pages", "SITE_PAGE": "Website pages" }, "createVariation": { "body": "Choose a name for this variation", "cancel": "Cancel", "confirm": "Create", "defaultName": "{{ name }} (variation)", "header": "Create variant", "pageSelectorLabel": "What language variation would you like to create an A/B variation of?" }, "delete": { "deleteMatchText": "delete", "pageSelectorLabel": "What language variation would you like to delete?" }, "unarchive": { "confirm": "Unarchive", "pageSelectorLabel": "What language variation would you like to unarchive?" }, "unpublish": { "cancel": "Cancel", "confirm": "Unpublish", "pageSelectorLabel": "What language variation would you like to unpublish?" } } }, "teams": { "assignTeams": { "title": { "withUsers": "Assign users & teams", "withoutUsers": "Assign teams" }, "defaultMessage": { "withUsers": "Choose which users and teams have access to this content.", "withoutUsers": "Choose which teams have access to this content." }, "hierarchyMessage": "You can only assign your teams and child teams.", "bulkWarning": "The changes you make below will override and replace the current team assignment settings for all selected.", "warning": "If nobody is chosen, access is open to all in this account. This could affect access to related content, such as lists and workflows.", "save": "Save", "cancel": "Cancel", "tabs": { "teams": "Teams", "users": "Users", "usersTabDisabledTooltip": { "noAccess": "You do not have permission to assign users.", "noSelectedTeams": "You must assign at least one team in order to assign users." } }, "userTooltip": "To remove this user, you must deselect the team that they are on.", "disabledTeamTooltip": "You can’t unassign your own team.", "usersButNoTeamsError": "You must select at least one team if users are assigned.", "zeroState": { "title": "You haven't created any teams.", "message": "Go to <a target='_blank' href='{{settingsUrl}}'>settings</a> to create a team." } }, "filter": { "allTeams": "All teams", "searchPlaceholder": "Search teams", "screenReader": "Teams filter. Selected value is {{value}}" } }, "previewDevices": { "header": "Preview mode", "buttonText": "Preview", "shareButton": "Share", "previewAsContact": { "title": "Preview as a specific contact", "selectAContact": "Select a contact" }, "details": { "to": "<strong>To :</strong> {{name}} ({{email}})", "notSelectedTo": "<strong>To :</strong> ", "from": "<strong>From :</strong> {{name}} ({{email}})", "subject": "<strong>Subject :</strong> {{prop}}" }, "sampleRecipient": { "email": "hubspotcustomer@test.com", "name": "Hubspot Customer" }, "sampleSubject": "Special offer" }, "buttons": { "save": "Save", "cancel": "Cancel", "edit": "Edit", "create": "Create", "replace": "Replace", "remove": "Remove" }, "cmv2": { "errorIcon": { "message": "This field has an error. Click to view.", "editMessage": "This field has an error. Click edit to view." }, "backLink": { "backToLabel": "Back to {{ label }}" }, "occurrence": { "addLink": "+ Add", "noOccurrences": { "placeholder": "No {{ fieldLabel }} yet. {{ addLink }}", "addLink": "Add one" }, "actions": { "delete": "Delete", "clone": "Clone", "edit": "Edit" } }, "fields": { "baseResource": { "add": "Create new", "firstAdd": "Create a {{ type }}", "name": "Name", "create": "Create a new {{ type }}", "placeholder": "Select a {{ type }}", "conflictErrorMessage": "There is already a {{ type }} with that name. Please enter a different name and try again.", "emptyMessage": "There aren't any {{ type }} in this account", "typeLabels": { "followupemail": { "one": "follow-up email", "other": "follow-up emails" }, "form": { "one": "form", "other": "forms" }, "workflow": { "one": "workflow", "other": "workflows" }, "page": { "one": "page", "other": "pages" }, "blog": { "one": "blog", "other": "blogs" }, "tag": { "one": "tag", "other": "tags" }, "menu": { "one": "menu", "other": "menus" }, "meeting": { "one": "meeting", "other": "meetings" }, "hubdbtable": { "one": "HubDB table", "other": "HubDB tables" }, "survey": { "one": "survey", "other": "surveys" }, "cta": { "one": "cta", "other": "ctas" }, "font": { "one": "font", "other": "fonts" } } }, "blog": { "defaultBlogLabel": "Default" }, "followupEmail": { "unpublishedErrorMessage": "Followup email must be published", "noWriteAccess": "Only users with email write permissions can create an email", "noReadAccess": "Only users with email editor permission can access the email editor", "noEmailClassicAccess": "The selected email was created using a design manager template, which is not available in this product tier." }, "form": { "rawHTMLWarning": { "description": "This form will take on the style of your page." }, "responseType": { "label": "What will a visitor see after submitting your form?", "options": { "redirect": "Redirect to another page", "inline": "Display an inline thank you message" } }, "default": { "message": "Thanks for submitting the form." }, "message": { "label": "Thank you message" }, "redirect": { "label": "Redirect link", "selectPlaceholder": "Select a page or enter an external link", "addRedirectUrl": "Add external link", "viewLink": "View this link" }, "addRedirectUrlModal": { "header": "Redirect to an external link", "message": "Please enter a valid URL, like: http://www.hubspot.com.", "input": { "label": "Redirect to this URL", "placeholder": "e.g. http://www.hubspot.com" }, "invalidUrlMessage": "This URL is not valid.", "buttons": { "add": "Add", "cancel": "Cancel" } }, "goToWebinar": { "header": { "label": "GoToWebinar registration" }, "placeholder": { "label": "Select a webinar" }, "helpMessage": { "label": "Don't see your webinar here? Turn it on in {{ link }}", "link": "GoToWebinar settings" } }, "workflowIds": { "label": "Add to workflows", "tooltip": "Users who fill out this form will be added to these workflows", "manageWorkflows": "Manage workflows" } }, "cta": { "placeholder": "Select a call-to-action", "preview": "Preview", "insertCta": "Choose call-to-action", "noCtaSelected": "No call-to-action selected", "editCta": "Edit call-to-action" }, "email": { "placeholder": "Choose email addresses..." }, "emptyMessage": { "noFields": "This module does not have any editable options.", "locked": "The creator of this template prevented editing this module in the content editors." }, "file": { "uploadFile": "Upload", "browseFiles": "Browse files" }, "font": { "allFonts": "All fonts", "commonFonts": "Common fonts", "defaultButtonText": "Select font", "fontSizeUnit": { "label": "Font size units", "tooltip": "Font units can't be changed in the content editors" }, "sampleText": "Sample", "googleFonts": "Browse on Google fonts", "googleFontsLink": "Browse on Google fonts", "popularFonts": "Common fonts", "apiError": "An error occurred while retrieving fonts. Please try again.", "styles": { "bold": "Bold", "italic": "Italic", "underline": "Underline" }, "weights": { "100": "Thin", "200": "Extra-light", "300": "Light", "400": "Regular", "500": "Medium", "600": "Semi-bold", "700": "Bold", "800": "Extra-bold", "900": "Black", "italic": "{{ weight }} italic" } }, "hubdb": { "disabledTooltip": "This table must be published to be used." }, "icon": { "tooltipTitle": "These icons are provided by Font Awesome", "learnMore": "Learn more", "noneSelected": "No icon selected", "replaceLabel": "Replace icon", "selectLabel": "Select an icon", "removeLabel": "Remove", "iconNameLabel": "Icon name", "loadMoreLabel": "Load more", "showMoreLabel": "...and {{ count }} more. {{ link }}", "empty": "No results" }, "image": { "altTextLabel": "Alt text", "altTextHelp": "Alt text provides a description of the image", "uploadImage": "Upload", "sizing": { "sizeType": { "label": "Size", "options": { "auto": "Automatically adjust", "autoTooltip": "Your image will scale based on browser and device size (responsive)", "exact": "Exact width and height", "exactTooltip": "Your image will always be this exact size on all devices (not responsive)" }, "widthLabel": "Width", "heightLabel": "Height" }, "maxSizeType": { "label": "Maximum size", "options": { "original": "Image's original size", "custom": "Custom" }, "widthLabel": "Maximum width", "heightLabel": "Maximum height" } }, "browseImages": "Browse images", "removeTooltip": "Image is required" }, "page": { "placeholder": "Select a page...", "useExternalUrlLink": "Redirect to an external page", "externalUrlPlaceholder": "External page URL", "disabledTooltip": "This page must be published to be used" }, "text": { "invalidFormat": "Invalid format" }, "richText": { "invalidFormat": "Invalid Format" }, "logo": { "overrideDefaultLogoLabel": "Override default logo on this page", "suppressCompanyNameLabel": "Show company name when logo isn't set", "editLogoLinkLabel": "Edit default logo in this domain", "logoLabel": "Logo", "emptyLogo": { "message": "Your logo module is empty. Set a global default logo in {{ link }}.", "linkLabel": "content settings" }, "sourceLabel": { "label": "Default logo for {{ domain }}", "allDomains": "all domains" } }, "salesforcecampaign": { "placeholder": { "label": "Select a campaign" }, "loading": { "label": "Loading Salesforce campaigns..." }, "emptyMessage": { "label": "There are no available campaigns. Make sure your Salesforce credentials are up to date in {{ link }}", "link": "Salesforce settings" }, "disabledMessage": { "label": "Your Salesforce integration is disabled. Please enable your integration in {{ link }}", "link": "Salesforce settings" }, "unauthorizedMessage": { "label": "You're not authorized to use the Salesforce integration. Please reauthorize in {{ link }}", "link": "Salesforce settings" }, "notIntegratedMessage": { "label": "No Salesforce integration found. Please enable Salesforce in {{ link }}", "link": "Salesforce settings" }, "delayMessage": { "label": "You have exceeded your API limits for the Salesforce integration. Please see your {{ link }}", "link": "Salesforce settings" } }, "survey": { "options": { "CES": "Support Survey (CES, 1-7 Rating)" }, "enabledToggle": "Survey on", "manage": "Manage survey settings", "confirmModal": { "rejectLabel": "Cancel", "disable": { "message": "Are you sure you want to turn off this survey?", "description": "Once turned off recipients will no longer see this feedback survey. The survey will still appear in your email editor but it won't be included in the sent email until you turn it on.", "confirmLabel": "Turn off survey" }, "enable": { "message": "You're about to turn your survey on", "description": "Once turned on the survey will be included with sent emails and recipients can submit a response. Do you want to turn on the survey?", "confirmLabel": "Turn on survey", "rejectLabel": "Cancel" } } }, "url": { "linkType": { "label": "Link to", "linkLabels": { "EXTERNAL": "External", "CONTENT": "Content", "FILE": "File", "EMAIL_ADDRESS": "Email address", "BLOG": "Blog" } }, "input": { "labelsByType": { "EXTERNAL": "URL", "CONTENT": "Content", "FILE": "File", "EMAIL_ADDRESS": "Email address", "BLOG": "Blog" }, "validation": { "EXTERNAL": "Invalid external URL", "EMAIL_ADDRESS": "Invalid email address" } } }, "link": { "toggles": { "open_in_new_tab": { "label": "Open link in new window" }, "no_follow": { "label": "Tell search engines not to follow this link" } } }, "video": { "overlayOptions": { "header": { "label": "Overlay" }, "choices": { "NONE": "None", "CTA": "Call-to-action", "FORM": "Form" } }, "displayTimeOptions": { "header": { "label": "Display time" }, "choices": { "PRE": "Before video starts", "POST": "After video finishes" } }, "playerColor": { "label": "Player color", "help": "The color of the play button and progress bar." } }, "meeting": { "embeddable": { "header": "Embedding meetings", "body": "All Sales Hub users can create meetings, but only Sales Hub Starter/Professional users can create embeddable ones. If a meeting doesn’t appear on the dropdown list, it was created by a free user and can’t be embedded. If you need this functionality, talk to an admin about upgrading your account.", "linkText": "Why isn't my meeting listed?" } } }, "requiredMessage": "This field is required" }, "videoFormPicker": { "buttons": { "select": "Select a form", "edit": "Edit", "remove": "Remove" } }, "videoPicker": { "buttons": { "uploadVideo": "Upload", "browseVideos": "Browse videos", "replace": "Replace", "remove": "Remove" } }, "preview": { "hoverLabel": "Open preview", "header": "Preview" }, "export": { "successTitle": "Your file is being prepared now.", "successMessage": "When it's ready, you'll receive an email with a link to your file.", "errorTitle": "There was an error exporting your CMS pages.", "errorMessage": "Please refresh the page to try again. If this keeps happening, please contact support." }, "language": { "domainLanguageModal": { "title": "Select a primary language", "info": "Choose the primary language for your domain. This will help you optimize for SEO, clean up your URL slugs, and translate your pages into multiple languages. ", "placeholder": "Select a language", "warning": "Note: The pages in your domain's primary language will not include a language slug (like \"/en/\") in the URL. To change the primary language for a domain once multi-language features are in use, please contact support. ", "errors": { "apiError": "An error occurred, could not save. ", "noLanguage": "No language selected. " } }, "buttons": { "save": "Save", "cancel": "Cancel" }, "placeholder": "Select a language", "createMultiLangVariationModal": { "header": "Create a multi-language variation", "description": "This page will be a multi-language variation of the master page <strong>{{masterPageName}}</strong>.", "masterPageLanguageLabel": "Language of master page", "selectVariationLanguageLabel": "Select language of the new variation", "selectMasterLanguageLabel": "Select language of the master page", "variantLangSameAsMasterError": "New variation's language can't be same as master page's language" }, "attachToLanguageMasterModal": { "header": "Add page to a multi-language group", "description": "The selected page, <strong>{{selectedPageName}}</strong>, will be moved under and associated with the master page.", "selectedPageLanguageLabel": "Language of selected page", "selectMasterPageLabel": "Select a master page", "pageLanguageExistsError": "Selected language exists in selected multi-language group. Change this page's language or select another master page." }, "switchLanguageMasterModal": { "header": "Switch Language Master Page", "placeholder": "Select a new master translation", "info": "Designate a new master page for the translated versions of this content. ", "switchMaster": "Set new master", "extraMsg": { "cannotDeleteMaster": "Cannot delete the master version of a translated page. " }, "errors": { "default": "There was an error while reassigning the new master. ", "CONTENT_IS_MASTER": "The selected variation is already the language master. ", "CONTENT_NOT_FOUND": "The selected variation was not found. ", "NO_LANGUAGE": "The selected variation has no language defined. " } } }, "marketplace": { "goodTile": { "noRatings": "No ratings", "subTypes": { "COS_TEMPLATE_PACK": "Template pack", "EMAIL": "Email template", "LANDING_PAGE": "Landing page template", "SITE_PAGE": "Website page template", "BLOG": "Blog template", "UNSUBSCRIBE_CONFIRMATION": "Subscription update confirmation template", "UNSUBSCRIBE_SIMPLE": "Backup unsubscribe template", "ERROR_PAGE": "Error page template", "PASSWORD_PAGE": "Password prompt template", "SUBSCRIPTION_PREFERENCES": "Subscription preferences template", "CUSTOM_MODULE": "Module", "CONTENT_SEARCH_RESULTS": "Search results template" }, "price": { "free": "Free" }, "detailsButtonText": "View details", "packCounts": { "title": { "one": "Pack includes {{ count }} template", "other": "Pack includes {{ count }} templates" }, "overflowText": "(and {{numberOfMoreTemplates}} more)", "subTypes": { "EMAIL": { "one": "1 email template", "other": "{{count}} email templates" }, "LANDING_PAGE": { "one": "1 landing page template", "other": "{{count}} landing page templates" }, "SITE_PAGE": { "one": "1 website page template", "other": "{{count}} website page templates" }, "BLOG": { "one": "1 blog template", "other": "{{count}} blog templates" }, "UNSUBSCRIBE_CONFIRMATION": { "one": "1 subscription update confirmation template", "other": "{{count}} subscription update confirmation templates" }, "UNSUBSCRIBE_SIMPLE": { "one": "1 backup unsubscribe template", "other": "{{count}} backup unsubscribe templates" }, "ERROR_PAGE": { "one": "1 error page template", "other": "{{count}} error page templates" }, "PASSWORD_PAGE": { "one": "1 password prompt template", "other": "{{count}} password prompt templates" }, "SUBSCRIPTION_PREFERENCES": { "one": "1 subscription preferences template", "other": "{{count}} subscription preferences templates" }, "CUSTOM_MODULE": { "one": "1 module", "other": "{{count}} modules" }, "CONTENT_SEARCH_RESULTS": { "one": "1 search results template", "other": "{{count}} search results templates" } } }, "moduleSummary": { "header": "About this module" }, "moduleCompatibility": { "header": "Works with", "types": { "COMPATIBLE_BLOG": "Blog", "COMPATIBLE_EMAIL": "Email", "COMPATIBLE_PAGE": "Website / Landing page" } } } }, "iconNames": { "align-center": "align center", "align-justify": "align justify", "align-left": "align left", "align-right": "align right", "ambulance": "ambulance", "american-sign-language-interpreting": "american sign language interpreting", "anchor": "anchor", "angle-double-down": "angle double down", "angle-double-left": "angle double left", "angle-double-right": "angle double right", "angle-double-up": "angle double up", "angle-down": "angle down", "angle-left": "angle left", "angle-right": "angle right", "angle-up": "angle up", "archive": "archive", "arrow-circle-down": "arrow circle down", "arrow-circle-left": "arrow circle left", "arrow-circle-right": "arrow circle right", "arrow-circle-up": "arrow circle up", "arrow-down": "arrow down", "arrow-left": "arrow left", "arrow-right": "arrow right", "arrow-up": "arrow up", "arrows-alt": "arrows alt", "arrows-alt-h": "arrows alt h", "arrows-alt-v": "arrows alt v", "assistive-listening-systems": "assistive listening systems", "asterisk": "asterisk", "at": "at", "audio-description": "audio description", "backward": "backward", "balance-scale": "balance scale", "ban": "ban", "barcode": "barcode", "bars": "bars", "baseball-ball": "baseball ball", "basketball-ball": "basketball ball", "bath": "bath", "battery-empty": "battery empty", "battery-full": "battery full", "battery-half": "battery half", "battery-quarter": "battery quarter", "battery-three-quarters": "battery three quarters", "bed": "bed", "beer": "beer", "bicycle": "bicycle", "binoculars": "binoculars", "birthday-cake": "birthday cake", "blind": "blind", "bold": "bold", "bolt": "bolt", "bomb": "bomb", "book": "book", "bowling-ball": "bowling ball", "braille": "braille", "briefcase": "briefcase", "bug": "bug", "bullhorn": "bullhorn", "bullseye": "bullseye", "bus": "bus", "calculator": "calculator", "camera": "camera", "camera-retro": "camera retro", "car": "car", "caret-down": "caret down", "caret-left": "caret left", "caret-right": "caret right", "caret-up": "caret up", "cart-arrow-down": "cart arrow down", "cart-plus": "cart plus", "certificate": "certificate", "chart-area": "chart area", "chart-line": "chart line", "chart-pie": "chart pie", "check": "check", "chess": "chess", "chess-bishop": "chess bishop", "chess-board": "chess board", "chess-king": "chess king", "chess-knight": "chess knight", "chess-pawn": "chess pawn", "chess-queen": "chess queen", "chess-rook": "chess rook", "chevron-circle-down": "chevron circle down", "chevron-circle-left": "chevron circle left", "chevron-circle-right": "chevron circle right", "chevron-circle-up": "chevron circle up", "chevron-down": "chevron down", "chevron-left": "chevron left", "chevron-right": "chevron right", "chevron-up": "chevron up", "child": "child", "circle-notch": "circle notch", "cloud": "cloud", "cloud-download-alt": "cloud download alt", "cloud-upload-alt": "cloud upload alt", "code": "code", "code-branch": "code branch", "coffee": "coffee", "cog": "cog", "cogs": "cogs", "columns": "columns", "compress": "compress", "crop": "crop", "crosshairs": "crosshairs", "cube": "cube", "cubes": "cubes", "cut": "cut", "database": "database", "deaf": "deaf", "desktop": "desktop", "dollar-sign": "dollar sign", "download": "download", "eject": "eject", "ellipsis-h": "ellipsis h", "ellipsis-v": "ellipsis v", "envelope-square": "envelope square", "eraser": "eraser", "euro-sign": "euro sign", "exchange-alt": "exchange alt", "exclamation": "exclamation", "exclamation-circle": "exclamation circle", "exclamation-triangle": "exclamation triangle", "expand": "expand", "expand-arrows-alt": "expand arrows alt", "external-link-alt": "external link alt", "external-link-square-alt": "external link square alt", "eye": "eye", "eye-dropper": "eye dropper", "fast-backward": "fast backward", "fast-forward": "fast forward", "fax": "fax", "female": "female", "fighter-jet": "fighter jet", "film": "film", "filter": "filter", "fire": "fire", "fire-extinguisher": "fire extinguisher", "flag-checkered": "flag checkered", "flask": "flask", "font": "font", "football-ball": "football ball", "forward": "forward", "gamepad": "gamepad", "gavel": "gavel", "genderless": "genderless", "gift": "gift", "glass-martini": "glass martini", "globe": "globe", "golf-ball": "golf ball", "graduation-cap": "graduation cap", "h-square": "h square", "hashtag": "hashtag", "heading": "heading", "headphones": "headphones", "heartbeat": "heartbeat", "history": "history", "hockey-puck": "hockey puck", "home": "home", "hourglass-end": "hourglass end", "hourglass-half": "hourglass half", "hourglass-start": "hourglass start", "i-cursor": "i cursor", "inbox": "inbox", "indent": "indent", "industry": "industry", "info": "info", "info-circle": "info circle", "italic": "italic", "key": "key", "language": "language", "laptop": "laptop", "leaf": "leaf", "level-down-alt": "level down alt", "level-up-alt": "level up alt", "link": "link", "lira-sign": "lira sign", "list": "list", "list-ol": "list ol", "list-ul": "list ul", "location-arrow": "location arrow", "lock": "lock", "lock-open": "lock open", "long-arrow-alt-down": "long arrow alt down", "long-arrow-alt-left": "long arrow alt left", "long-arrow-alt-right": "long arrow alt right", "long-arrow-alt-up": "long arrow alt up", "low-vision": "low vision", "magic": "magic", "magnet": "magnet", "male": "male", "map-marker": "map marker", "map-marker-alt": "map marker alt", "map-pin": "map pin", "map-signs": "map signs", "mars": "mars", "mars-double": "mars double", "mars-stroke": "mars stroke", "mars-stroke-h": "mars stroke h", "mars-stroke-v": "mars stroke v", "medkit": "medkit", "mercury": "mercury", "microchip": "microchip", "microphone": "microphone", "microphone-slash": "microphone slash", "minus": "minus", "minus-circle": "minus circle", "mobile": "mobile", "mobile-alt": "mobile alt", "motorcycle": "motorcycle", "mouse-pointer": "mouse pointer", "music": "music", "neuter": "neuter", "outdent": "outdent", "paint-brush": "paint brush", "paperclip": "paperclip", "paragraph": "paragraph", "paste": "paste", "pause": "pause", "paw": "paw", "pen-square": "pen square", "pencil-alt": "pencil alt", "percent": "percent", "phone": "phone", "phone-square": "phone square", "phone-volume": "phone volume", "plane": "plane", "play": "play", "plug": "plug", "plus": "plus", "plus-circle": "plus circle", "podcast": "podcast", "pound-sign": "pound sign", "power-off": "power off", "print": "print", "puzzle-piece": "puzzle piece", "qrcode": "qrcode", "question": "question", "quidditch": "quidditch", "quote-left": "quote left", "quote-right": "quote right", "random": "random", "recycle": "recycle", "redo": "redo", "redo-alt": "redo alt", "reply": "reply", "reply-all": "reply all", "retweet": "retweet", "road": "road", "rocket": "rocket", "rss": "rss", "rss-square": "rss square", "ruble-sign": "ruble sign", "rupee-sign": "rupee sign", "search": "search", "search-minus": "search minus", "search-plus": "search plus", "server": "server", "share": "share", "share-alt": "share alt", "share-alt-square": "share alt square", "shekel-sign": "shekel sign", "shield-alt": "shield alt", "ship": "ship", "shopping-bag": "shopping bag", "shopping-basket": "shopping basket", "shopping-cart": "shopping cart", "shower": "shower", "sign-in-alt": "sign in alt", "sign-language": "sign language", "sign-out-alt": "sign out alt", "signal": "signal", "sitemap": "sitemap", "sliders-h": "sliders h", "sort": "sort", "sort-alpha-down": "sort alpha down", "sort-alpha-up": "sort alpha up", "sort-amount-down": "sort amount down", "sort-amount-up": "sort amount up", "sort-down": "sort down", "sort-numeric-down": "sort numeric down", "sort-numeric-up": "sort numeric up", "sort-up": "sort up", "space-shuttle": "space shuttle", "spinner": "spinner", "square-full": "square full", "step-backward": "step backward", "step-forward": "step forward", "stethoscope": "stethoscope", "stop": "stop", "stopwatch": "stopwatch", "street-view": "street view", "strikethrough": "strikethrough", "subscript": "subscript", "subway": "subway", "suitcase": "suitcase", "superscript": "superscript", "sync": "sync", "sync-alt": "sync alt", "table": "table", "table-tennis": "table tennis", "tablet": "tablet", "tablet-alt": "tablet alt", "tachometer-alt": "tachometer alt", "tag": "tag", "tags": "tags", "tasks": "tasks", "taxi": "taxi", "terminal": "terminal", "text-height": "text height", "text-width": "text width", "th": "th", "th-large": "th large", "th-list": "th list", "thermometer-empty": "thermometer empty", "thermometer-full": "thermometer full", "thermometer-half": "thermometer half", "thermometer-quarter": "thermometer quarter", "thermometer-three-quarters": "thermometer three quarters", "thumbtack": "thumbtack", "ticket-alt": "ticket alt", "times": "times", "tint": "tint", "toggle-off": "toggle off", "toggle-on": "toggle on", "trademark": "trademark", "train": "train", "transgender": "transgender", "transgender-alt": "transgender alt", "trash": "trash", "tree": "tree", "trophy": "trophy", "truck": "truck", "tty": "tty", "tv": "tv", "umbrella": "umbrella", "underline": "underline", "undo": "undo", "undo-alt": "undo alt", "universal-access": "universal access", "university": "university", "unlink": "unlink", "unlock": "unlock", "unlock-alt": "unlock alt", "upload": "upload", "user-md": "user md", "user-plus": "user plus", "user-secret": "user secret", "user-times": "user times", "users": "users", "utensil-spoon": "utensil spoon", "utensils": "utensils", "venus": "venus", "venus-double": "venus double", "venus-mars": "venus mars", "video": "video", "volleyball-ball": "volleyball ball", "volume-down": "volume down", "volume-off": "volume off", "volume-up": "volume up", "wheelchair": "wheelchair", "wifi": "wifi", "won-sign": "won sign", "wrench": "wrench", "yen-sign": "yen sign", "address-card": "address card", "arrow-alt-circle-down": "arrow alt circle down", "arrow-alt-circle-left": "arrow alt circle left", "arrow-alt-circle-right": "arrow alt circle right", "arrow-alt-circle-up": "arrow alt circle up", "bell": "bell", "bell-slash": "bell slash", "bookmark": "bookmark", "building": "building", "calendar": "calendar", "calendar-alt": "calendar alt", "calendar-check": "calendar check", "calendar-minus": "calendar minus", "calendar-plus": "calendar plus", "calendar-times": "calendar times", "caret-square-down": "caret square down", "caret-square-left": "caret square left", "caret-square-right": "caret square right", "caret-square-up": "caret square up", "chart-bar": "chart bar", "check-circle": "check circle", "check-square": "check square", "circle": "circle", "clipboard": "clipboard", "clock": "clock", "clone": "clone", "closed-captioning": "closed captioning", "comment": "comment", "comment-alt": "comment alt", "comments": "comments", "compass": "compass", "copy": "copy", "copyright": "copyright", "credit-card": "credit card", "dot-circle": "dot circle", "edit": "edit", "envelope": "envelope", "envelope-open": "envelope open", "eye-slash": "eye slash", "file": "file", "file-alt": "file alt", "file-archive": "file archive", "file-audio": "file audio", "file-code": "file code", "file-excel": "file excel", "file-image": "file image", "file-pdf": "file pdf", "file-powerpoint": "file powerpoint", "file-video": "file video", "file-word": "file word", "flag": "flag", "folder": "folder", "folder-open": "folder open", "frown": "frown", "futbol": "futbol", "gem": "gem", "hand-lizard": "hand lizard", "hand-paper": "hand paper", "hand-peace": "hand peace", "hand-point-down": "hand point down", "hand-point-left": "hand point left", "hand-point-right": "hand point right", "hand-point-up": "hand point up", "hand-pointer": "hand pointer", "hand-rock": "hand rock", "hand-scissors": "hand scissors", "hand-spock": "hand spock", "handshake": "handshake", "hdd": "hdd", "heart": "heart", "hospital": "hospital", "hourglass": "hourglass", "id-badge": "id badge", "id-card": "id card", "image": "image", "images": "images", "keyboard": "keyboard", "lemon": "lemon", "life-ring": "life ring", "lightbulb": "lightbulb", "list-alt": "list alt", "map": "map", "meh": "meh", "minus-square": "minus square", "money-bill-alt": "money bill alt", "moon": "moon", "newspaper": "newspaper", "object-group": "object group", "object-ungroup": "object ungroup", "paper-plane": "paper plane", "pause-circle": "pause circle", "play-circle": "play circle", "plus-square": "plus square", "question-circle": "question circle", "registered": "registered", "save": "save", "share-square": "share square", "smile": "smile", "snowflake": "snowflake", "square": "square", "star": "star", "star-half": "star half", "sticky-note": "sticky note", "stop-circle": "stop circle", "sun": "sun", "thumbs-down": "thumbs down", "thumbs-up": "thumbs up", "times-circle": "times circle", "trash-alt": "trash alt", "user": "user", "user-circle": "user circle", "window-close": "window close", "window-maximize": "window maximize", "window-minimize": "window minimize", "window-restore": "window restore" }, "columnSwitcher": { "columnSwitcherModal": { "cancel": "Cancel", "header": "Edit columns", "properties": "Column options", "save": "Save", "search": "Search", "selected": { "one": "Selected column", "other": "Selected columns ({{count}})" }, "tooManyColumns": "You can only have {{ maxColumns }} columns in your table. Deselect a current property to add this as a column." } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "ContentComponents": {
    "en": "static-2.6926"
  }
};
  result.translationsAvailable = {
  "ContentComponents": {
    "de": "static-2.6926",
    "en": "static-2.6926",
    "es": "static-2.6926",
    "fr": "static-2.6926",
    "ja": "static-2.6926",
    "nl": "static-2.6926",
    "pt-br": "static-2.6926"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ContentComponents:en', {version: 'static-2.6926'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "statusMessage": { "USER_DISABLED": { "title": "{{ appName }} connection is paused", "body": "The connection between HubSpot and {{ appName }} is paused. No data is being exchanged.", "emailHeader": "", "emailFooter": "", "statusLabel": "Connection paused" }, "AUTH_ERROR": { "title": "Please reconnect {{ appName }}", "body": "Sorry. {{ appName }} has disconnected. This may be affecting some tools and features that your app was intended to work with in HubSpot.", "emailHeader": "", "emailFooter": "", "statusLabel": "Disconnected" }, "THIRD_PARTY_AVAILABILITY_ERROR": { "title": "{{ appName }} is unavailable", "body": "HubSpot can't access {{ appName }}. This may be affecting some tools and features that your app was intended to work with in HubSpot.", "emailHeader": "", "emailFooter": "", "statusLabel": "Unavailable" }, "UNKNOWN_ERROR": { "title": "{{ appName }} is unavailable", "body": "HubSpot can't access {{ appName }}. This may be affecting some tools and features that your app was intended to work with in HubSpot.", "emailHeader": "", "emailFooter": "", "statusLabel": "Unavailable" }, "THIRD_PARTY_LICENSE_ERROR": { "title": "Please renew your {{ appName }} license and reconnect {{ appName }}", "body": "Sorry. {{ appName }} has disconnected. This may be affecting some tools and features that your app was intended to work with in HubSpot.", "emailHeader": "", "emailFooter": "", "statusLabel": "Disconnected" }, "THIRD_PARTY_MISSING_SCOPE_ERROR": { "title": "There's been a change in your {{ appName }} service plan", "body": "A change to your {{ appName }} service plan may have also changed how some of its tools and features work in HubSpot. This will need a quick reconnect to keep everything up to date.", "emailHeader": "", "emailFooter": "", "statusLabel": "Update Available" }, "DEPRECATED_AUTH_TOKEN": { "title": "Please reconnect {{ appName }}", "body": "Your connection to {{ appName }} may expire soon. To prevent any disruption in service, your account needs to be reconnected.", "statusLabel": "Reconnect required" }, "CONNECTED": { "title": "Success. You're now connected to {{ appName }}" } }, "customOverrides": { "THIRD_PARTY_MISSING_SCOPE_ERROR": { "APP_38577": { "title": "Update available", "body": "We have made some updates to the Salesforce integration with HubSpot. Please, reauthenticate to get the improved integration." } } }, "cta": { "REVOKE_TOKEN_AND_RECONNECT": { "label": "Please, take a moment to reconnect.", "action": "Reconnect" }, "RECONNECT": { "label": "Please, take a moment to reconnect.", "action": "Reconnect" }, "RESOLVE_IN_SETTINGS": { "action": "Resolve in settings" }, "RENEW_LICENSE_AND_RECONNECT": { "label": "Please, take a moment to renew your {{ appName }} license and reconnect.", "action": "Reconnect" }, "CONTACT_SUPPORT": { "label": "We're working on identifying and fixing the issue, but if the impact is urgent please contact support.", "label_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"We're working on identifying and fixing the issue, but if the impact is urgent, please ",
createElement( options,
"Link",
{ url: props.url },
"contact support" ),
"." ); } }, "RESUME": { "action": "Resume" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "native-integrations-shared-strings": {
    "de": "static-1.35",
    "en": "static-1.35",
    "es": "static-1.35",
    "fr": "static-1.35",
    "ja": "static-1.35",
    "nl": "static-1.35",
    "pt-br": "static-1.35"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "upgrades": { "pricing": { "lowestPrice": "Starting at {{ price }} per month." }, "products": { "salesStarter": "Sales Starter", "salesProfessional": "Sales Professional", "salesEnterprise": "Sales Enterprise", "salesPro": "Sales Pro", "marketingStarter": "Marketing Starter", "marketingStarterEmail": "Marketing Starter", "marketingBasic": "Marketing Basic", "marketingProfessional": "Marketing Professional", "marketingEnterprise": "Marketing Enterprise", "serviceFree": "Service Free", "serviceStarter": "Service Starter", "serviceProfessional": "Service Professional", "serviceEnterprise": "Service Enterprise", "enterprise": "Enterprise", "ads": "the Ads Add-on", "website": "the Website Add-on", "reporting": "the Reporting Add-on", "cms": "the CMS Add-on", "crm": "the HubSpot CRM", "dedicatedIp": "the Dedicated IP Add-on", "transactionalEmail": "the Transactional Email Add-on", "additionalAccount": "the Additional HubSpot Account Add-on", "designatedTechnicalSupport": "Designated Technical Support", "inPersonTraining": "In-person HubSpot Training", "sales-free": "the free sales tools", "sales-starter": "Sales Hub Starter", "sales-pro": "Sales Hub Professional", "sales-professional": "Sales Hub Professional", "sales-enterprise": "Sales Hub Enterprise", "marketing-free": "the free marketing tools", "marketing-starter": "Marketing Hub Starter", "marketing-starter-email": "Marketing Hub Starter", "marketing-pro": "Marketing Hub Professional", "marketing-enterprise": "Marketing Hub Enterprise", "service-free": "the free service tools", "service-starter": "Service Hub Starter", "service-professional": "Service Hub Professional", "service-enterprise": "Service Hub Enterprise", "dedicated-ip": "the Dedicated IP Add-on", "transactional-email": "the Transactional Email Add-on", "additional-account": "the Additional HubSpot Account Add-on", "brand-domain": "the Brand Domain Add-on", "designated-technical-support": "Designated Technical Support", "in-person-training": "In-person HubSpot Training", "starter-kit": "Starter Kit", "sales-professional-onboarding": "Sales Professional Onboarding", "service-professional-onboarding": "Service Professional Onboarding", "default": "a product" }, "contactSales": "Talk to sales", "message": { "productName": "{{ productName }}." }, "lockedFeatureBanner": { "text": "Unlock premium features with", "button": "Upgrade" }, "removeBrandingBanner": { "text": "Let your company brand and message shine without HubSpot branding getting in the way.", "titles": { "placeholder": "Remove the HubSpot logo from this feature.", "leadFlows": "Remove the HubSpot logo from your pop-up forms.", "bookingPage": "Remove the HubSpot logo from your booking page.", "liveChat": "Remove the HubSpot logo from your live chat.", "forms": "Remove the HubSpot logo from your forms.", "documents": "Remove the HubSpot logo from your documents.", "email": "Remove the HubSpot logo from your emails." } }, "requestSeatBanner": { "requestSeatFromAdmin": { "text": "Request {{ productName }} access from your account administrator.", "button": "Request access" }, "assignYourselfASeat": { "text": "Assign yourself a {{ productName }} seat.", "button": "Go to Users & Teams" } }, "activationModal": { "new": { "successModal": { "header": "Success! You’ve activated your trial", "subHeader": "All of your account’s users can now access our {{ productName }} features.", "firstAction": "What do you want to do first?", "academyHeader": "Do you want to explore your trial features now or finish your course first?", "actions": { "createNewUsers": "Create new users and invite them to my trial", "specificFeature": "Try out a specific feature", "exploreOnYourOwn": "Explore on my own", "exploreTrial": "Explore my trial", "finishCourse": "Finish my course" } }, "redirectModal": { "header": "Let’s get started", "subHeader": "Which feature do you want to try first?" } }, "trialTitle": "Your trial has started.", "productTitle": "Your product has been activated.", "getStarted": "Let's go", "featureExplore": "Which feature would you like to explore first?", "modalTitle": "{{ productName }} Trial", "survey": { "landing-pages": { "feature": "Landing Pages", "description": "Convert more website visitors into leads" }, "email": { "feature": "Email", "description": "Run a successful email campaign" }, "marketing-workflows": { "feature": "Marketing Automation", "description": "Save time through marketing automation" }, "content-strategy": { "feature": "Content Strategy & SEO", "description": "Increase traffic to my website" }, "sales-workflows": { "feature": "Sales Automation", "description": "Save time through sales automation" }, "playbooks": { "feature": "Playbooks", "description": "Provide my team with call scripts and playbooks" }, "sequences": { "feature": "Sequences", "description": "Streamline outreach to my prospects" }, "quotes": { "feature": "Quotes", "description": "Send a quote to a prospect" }, "tickets": { "feature": "Tickets", "description": "Organize and track my customer engagements" }, "feedback": { "feature": "Feedback", "description": "Truly understand your customers" }, "knowledge-base": { "feature": "Knowledge Base", "description": "Build solutions that help customers help themselves" }, "service-workflows": { "feature": "Service Automation", "description": "Build an automated help desk" }, "meetings": { "feature": "Meetings", "description": "Get meetings automatically booked on my calendar" }, "other": "I just want to explore on my own" }, "errorTitle": "Sorry, something went wrong.", "errorMessage": "Please refresh the page and try again.", "close": "Close" }, "confirmationModal": { "title": "Start your trial today", "subTitle": "This will start a {{ duration }}-day trial of the {{ productName }} product in your account.", "confirm": "Start {{ duration }}-Day Trial", "cancel": "Cancel" }, "adminModal": { "requestSeatUpgrade": { "title": "Good news! Looks like your team has already upgraded.", "paragraph": "To join the rest of your team using {{ productName }}, you'll need to request access from an account admin.", "button": "Request access" }, "requestSeatUpgradeBanner": { "title": "Request access from your account admin.", "paragraph": "It looks like your account already has {{ productName }}. To join the rest of your team, send an email to your account administrator to request access.", "button": "Request access" }, "requestAdditionalSeats": { "title": "Looks like you're not an account administrator.", "paragraph": "In order to buy additional users, you'll need to request them from an account admin.", "button": "Request access" }, "requestSKU": { "title": "Looks like you're not an account administrator.", "paragraph": "In order to get {{ productName }}, you'll need to request it from an account admin.", "button": "Request product" }, "requestTrial": { "title": "Looks like you're not an account administrator.", "paragraph": "In order to start a trial of {{ productName }}, you'll need to request it from an account admin.", "button": "Request trial" }, "requestProduct": { "title": "Looks like you're not an account administrator.", "paragraph": "In order to activate {{ productName }}, you'll need to request it from an account admin.", "button": "Request product" }, "requestQuote": { "title": "Looks like you're not an account administrator.", "paragraph": "In order to buy this quote, you'll need to request purchase from an account admin.", "button": "Request quote purchase" }, "requestPartnerScope": { "title": "Looks like you're not an account administrator.", "paragraph": "In order to become a HubSpot Partner, you must be an account administrator. You can request administrator status from the current admin or have them enroll on your behalf.", "button": "Got it" }, "default": { "title": "Looks like you're not an account administrator.", "paragraph": "In order to buy, you must be an account administrator. You can request administrator status from the current admin or have them buy on your behalf.", "button": "Got it" } }, "productActivationButton": { "marketing-free": "Activate free marketing tools", "sales-free": "Activate free sales tools", "service-free": "Start using tickets", "cms": "Activate HubSpot CMS", "crm": "Start for free" }, "trialActivationButton": { "marketing-pro": "Start a free 14-day trial", "marketing-enterprise": "Start a free 14-day trial", "sales-professional": "Start a free 14-day trial", "sales-enterprise": "Start a free 14-day trial", "service-professional": "Start a free 14-day trial", "service-enterprise": "Start a free 14-day trial", "reporting": "Start a free 10-day trial", "cms": "Start a free 14-day trial" }, "trial": { "marketing-pro": "Marketing Hub Professional", "marketing-enterprise": "Marketing Hub Enterprise", "sales-enterprise": "Sales Hub Enterprise", "service-enterprise": "Service Hub Enterprise", "enterprise-trial": "Enterprise", "reporting": "Reporting Add-on", "website": "Website Add-on", "cms": "HubSpot CMS" }, "checkoutButton": { "default": "Buy now", "monthly": "Buy monthly plan", "annual": "Buy annual plan" }, "usageLimitButton": { "calling": "Make a call" }, "usageLimitBanner": { "button": "Upgrade", "header": { "custom-reports": "Your team has created {{ value }} out of {{ limit }} custom reports.", "custom-dashboards": "Your team has created {{ value }} out of {{ limit }} custom dashboards.", "documents": "Your team has uploaded {{ value }} out of {{ limit }} documents.", "templates": "Your team has created {{ value }} out of {{ limit }} templates.", "email": "You've used {{ value }} out of {{ limit }} email sends.", "calling": "You have used {{ value }} out of {{ limit }} minutes.", "meetings": "You've used your {{ limit }} free booking page.", "sequences": "Your team has used {{ value }} out of {{ limit }} sequences.", "notifications": "You've received {{ value }} out of {{ limit }} notifications.", "snippets": "Your team has created {{ value }} out of {{ limit }} snippets.", "teams": "Your team has created {{ value }} out of {{ limit }} teams.", "lead-flows": "Your team has created {{ value }} out of {{ limit }} follow-up emails.", "marketing-templates": { "static": "Your team has created {{ value }} out of {{ limit }} static lists.", "dynamic": "Your team has created {{ value }} out of {{ limit }} active lists." }, "workflows": "You've created {{ value }} out of {{ limit }} Workflows.", "ad-spend": "You've spent {{currencyCode}}{{ value }} out of {{currencyCode}}{{ limit }} ad spend across all your connected ad accounts in the last 30 days.", "contact-list-audiences": "You've created {{ value }} out of {{ limit }} contact list audiences.", "ad-accounts": "You've connected {{ value }} out of {{ limit }} ad accounts.", "quotes-esign": "You've used {{ value }} out of {{ limit }} eSignatures." }, "subtext": { "custom-reports": "Unlock more custom reports with", "custom-dashboards": "Unlock more custom dashboards with", "documents": "Unlock more documents with", "templates": "Unlock more templates with", "email": "Unlock more emails with", "calling": "Unlock more minutes with", "meetings": "Unlock more booking pages with", "sequences": "Unlock more sequences with", "notifications": "Unlock more notifications with", "snippets": "Unlock more snippets with", "teams": "Unlock more teams with", "lead-flows": "Unlock more follow-up emails with", "marketing-templates": { "static": "Unlock more static lists with", "dynamic": "Unlock more active lists with" }, "workflows": "Unlock more Workflows in", "ad-spend": "Increase your ad spend limit to start creating and managing your ads again directly in HubSpot with", "contact-list-audiences": "Unlock more audiences with", "ad-accounts": "Connect more ad accounts with", "starter-contacts": "Unlock more email sends by buying additional contacts.", "quotes-esign": "Unlock more eSignatures with" } }, "contactSalesButton": { "text": "Talk to sales", "success": "Thanks! Our team will reach out soon.", "callNow": "Or you can call us now at:" }, "productCatalog": { "tableHeader": { "features": "Features", "free": "Free", "starter": "Starter", "professional": "Professional", "enterprise": "Enterprise" }, "footer": { "productServicesCatalogPrompt_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"For more detailed information on product packaging and the limits that apply, please see our ",
createElement( options,
"UILink",
{ href: "https://legal.hubspot.com/hubspot-product-and-services-catalog", external: true, onClick: props.onClick },
"Product and Services Catalog." ) ); } } }, "upgradeButton": { "default": "Upgrade", "upgrade": "Upgrade to {{ productTitle }}", "info": "Learn more about {{ productTitle }}" }, "communicationMethods": { "salesRepIntroduction": "I’m {{ name }}, your personal sales rep. I'm here to help you figure out which HubSpot product is right for you.", "backButton": "Back to other options", "title": "How would you like to connect with sales?", "salesRepConnect": "How would you like to get in touch?", "salesRepGreeting": "Need help? I’m right here.", "chat": "Live chat", "whatsapp": "Chat on WhatsApp", "email": "Send an email", "meeting": "Schedule a meeting", "call": "Get a call", "callTitle": "Great! We'll call you.", "callSuccess": "Thanks. Someone will be in contact soon.", "callButton": "Submit", "phoneCallNow": "You can call us now at:", "successCta": "Close window", "localization": { "or": "or", "callNow": "Call us now:", "viewAllButton": "View all phone numbers" }, "mon177": { "variantA": { "header": "Sales can help you …", "chooseRightPlan": "Choose the right plan", "getTheMost": "Get the most from HubSpot features", "determineBestWays": "Determine the best ways to meet your goals", "noCommitment": "No commitment required" }, "variantB": { "header": "Did you know …?", "body": "HubSpot sales reps are product experts who can show you how to use our tools to meet your goals." } } }, "emailModal": { "header": "Send an email to sales", "subject": "Subject", "subjectDropdown": { "placeholder": "How can we help you?", "options": { "purchase": "I’m interested in purchasing a product", "learnMore": "I want to learn more about a product or feature", "help": "I need setup help or have a technical question", "other": "Other" } }, "body": "Message", "bodyPlaceholder": "Tell us more about the products you’re interested in or questions you have.", "send": "Send", "cancel": "Cancel", "errorMessages": { "subject": "Please select a subject.", "body": "Please add an email message." }, "submissionErrors": { "title": "Your email could not be sent.", "body": "Please try again." } }, "pqlModal": { "call": "Get a call", "chat": "Live chat", "connectTitle": "How would you like to connect with sales?", "done": "Done", "phoneCallNow": "You can call us now at:", "phoneInfo": "to learn more.", "sales-starter": "Sales Hub Starter", "sales-professional": "Sales Hub Professional", "sales-enterprise": "Sales Hub Enterprise", "service-starter": "Service Hub Starter", "service-professional": "Service Hub Professional", "service-enterprise": "Service Hub Enterprise", "schedule": "Schedule a meeting", "successBody": "You'll receive an email shortly to schedule a meeting with our sales team.", "successCta": "Close window", "successTitle": "Thank you. Please check your email.", "talkToSales": "Talk to sales", "upgradeNow": "Upgrade now", "upgradeTo": "Upgrade to {{ productName }}", "viewPricing": "View pricing" }, "expiredTrialModal": { "title": "Your trial has ended. Have questions or need more time?", "generalSubTitle": "Connect with a member of the HubSpot team to upgrade to {{ productName }} or extend your trial.", "subTitle": { "marketing-pro": "Connect with a member of the HubSpot team to upgrade to Marketing Hub Professional or extend your trial." } }, "landingPagesZeroState": { "createLandingPage": "Create a landing page", "title": "Marketing Hub", "landingPagesTitle": "| Landing Pages", "body": "Eye-catching landing pages in no time", "seeAllFeaturesLink": "See all Marketing Hub features", "free": { "title": "Everything you need to get started", "subtitle": "Included in Marketing Hub Starter", "buttonText": "Create first email" }, "premium": { "title": "More ways to customize your pages", "subtitle": "With Marketing Hub Professional", "upgradeButton": "Upgrade now" }, "features": { "noBranding": "No HubSpot branding", "customDomain": "Custom domain", "simpleEditor": "Simple editor", "basicReporting": "Basic reporting", "basicThemes": "Basic themes", "ssl": "SSL", "advancedEditor": "Advanced Editor", "advancedReporting": "Advanced Reporting", "additionalThemese": "Additional Themes", "seoTools": "SEO Tools", "abTestingAbilities": "A/B testing abilities", "multiLanguage": "Multi-language content management", "smartContent": "Smart content", "additionalThemes": "Additional themes" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "ui-addon-upgrades": {
    "en": "static-9.1956"
  }
};
  result.translationsAvailable = {
  "ui-addon-upgrades": {
    "de": "static-9.1956",
    "en": "static-9.1956",
    "es": "static-9.1956",
    "fr": "static-9.1956",
    "ja": "static-9.1956",
    "nl": "static-9.1956",
    "pt-br": "static-9.1956"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ui-addon-upgrades:en', {version: 'static-9.1956'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "accountdefaults": { "notifications": { "success": "Successfully saved account defaults settings.", "error": "There was a problem saving your changes. Please try again, or contact support if it keeps happening." }, "tabs": { "generalInfo": "General Info", "branding": "Branding", "brandingCompanyInfo": "Company Info", "brandingLogo": "Logo", "brandingColors": "Colors", "brandingDescription": "Set your company name, logo, and colors for places where you can show your branding. These changes will help you quickly choose brand options when creating public facing content.", "multicurrency": "Currencies", "multicurrencyDescription": "Currencies" }, "language": { "title": "Language", "help": "Choose the default language for new users.", "languages": { "en": "English", "fr": "Français", "de": "Deutsch", "ja": "日本語", "pt": "Português", "es": "Español" }, "languagesBeta": "Beta", "locales": { "en-us": "United States", "en-ca": "Canada", "en-gb": "United Kingdom", "en-ie": "Ireland", "en-au": "Australia", "en-nz": "New Zealand", "en-in": "India", "es-ar": "South America", "es-mx": "Mexico and Central America", "es": "Spain", "pt-br": "Brazil", "de": "Germany", "fr": "France", "it": "Italy", "fi": "Finland", "sv": "Sweden", "nl": "Netherlands", "ja": "Japan", "zh-cn": "China", "zh-hk": "Hong Kong" }, "loadError": "There was a problem loading your language setting." }, "accountName": { "title": "Account name", "loadError": "There was a problem loading your account name setting.", "required": "Your account name can't be blank.", "tooLong": "Please choose a name less than 25 characters.", "save": "Save", "cancel": "Cancel", "help": "Set a name for your account. For example, you could enter your company name or domain.", "modal": { "title": "Name your account", "description": "Identify this account with a handy nickname. Your company name might be a good start.", "save": "Save name", "cancel": "Set later" } }, "dateAndNumberFormat": { "title": "Date and number format", "loadError": "There was a problem loading your date and number setting.", "dateAndNumberFormatExample": "Format: {{ exampleDate }} and {{ exampleNumber }}", "help": "Choose the default date and number stylings for new users." }, "timeZone": { "title": "Time zone", "loadError": "There was a problem loading your time zone setting.", "help": "Setting your timezone in HubSpot helps you localize several of your tools, such as scheduled email sends, scheduled social media messages, and web analytics and reporting to your company's location and time zone.", "notifications": { "success": "Successfully saved the time zone setting.", "error": "There was a problem saving the time zone setting. Please try again, or contact support if it keeps happening." }, "confirmationModal": { "title": "Change your time zone?", "body": "When you change the default time zone for your account it will affect the way that reports are calculated and displayed for all users in the account.", "confirm": "Yes, change time zone", "reject": "No, go back" } }, "currency": { "title": "Currency", "loadError": "There was a problem loading your currency setting.", "help": "Set currency for revenue and deals.", "addCurrency": "Add Currency", "addCurrencies": { "normal": "Add currencies", "noPermission": "Contact your admin to add more currencies" }, "maxCurrencies": "You have reached your maximum of {{ maxCurrencies }} currencies.", "companyCurrency": "<b>Company currency:</b> {{ companyCurrency }}", "format": "<b>Format:</b> ", "formatExample": "{{ format }} {{ formatExample }}", "edit": "Edit", "pql": { "body": "Track and report on your deals in the currency they were sold in.", "title": "Use multiple currencies on your deals." }, "helpbanner": { "button": "Learn more", "description": "Sell with and report on multiple currencies", "title": "Use more currencies." }, "table": { "actionButtons": { "archive": "Archive", "edit": "Edit" }, "label": { "name": "Name", "exchangeRate": "Exchange Rate", "format": "Format", "lastModified": "Last Modified" }, "modifiedCell": "{{ name }} on {{ date }}" }, "zerostate": { "header": "Track your deals in multiple currencies", "body": "Let your team track and report on their deals using the currency they are sold in." }, "editCompanyCurrencyModal": { "dropdownTitle": "Company currency", "title": "Edit company currency", "tooltip": "Choose a new company currency. This will replace {{ companyCurrency }}." }, "editMultiCurrencyModal": { "description": "The exchange rate from {{ currency }} to {{ companyCurrency }}", "inputTitle": "Exchange rate", "title": "Edit {{ formattedCurrencyCode }}" }, "archiveMultiCurrencyModal": { "description": "Archiving a currency will remove it as an option on new deals. Existing deals will keep any archived currencies.", "title": "Archive {{ currency }}?", "confirm": "Archive currency", "reject": "Cancel" }, "modal": { "confirm": "Save", "currencyTooltip": "Choose a new currency to add to your list of options.", "dropdownTitle": "Currency", "exchangeRate": "Exchange rate", "exchangeRateDescription": "The exchange rate from {{ currency }} to {{ companyCurrency }}", "placeholderCurrency": "Select a currency", "reject": "Cancel", "title": "Add currency" } }, "leadRevisitNotifications": { "title": "Lead revisit notifications", "description": "Notify users on your account when a lead revisits your site. Users can manage their notification preferences in Profile & Preferences.", "loadError": "There was a problem loading your lead revisit notification setting." }, "gdprCompliance": { "title": "EU General Data Protection Regulation (GDPR)", "description": "Make all GDPR compliance options available and turned on by default for all tools that collect personal data.", "loadError": "There was a problem loading your GDPR compliance setting.", "privacy": "Privacy & consent", "cookies": "Cookies & tracking", "learnMore": "Learn more", "workflowsText": "Workflows & subscriptions", "checkboxLabel": "Only allow marketing emails to be sent to contacts who have a legal basis to communicate. This setting doesn’t apply to emails sent by the CRM.", "unsubscribeCheckboxLabel": "Prevent users in this portal from disabling unsubscribe links in 1:1 emails.", "confirmationModal": { "title": "Enable GDPR tools?", "body_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Enabling these tools will affect how you interact with your contacts. Before you continue, please read the guide about ",
createElement( options,
"Link",
{ href: "https://www.hubspot.com/data-privacy/gdpr/hubspot-product-playbook", external: true },
"GDPR compliance" ),
"." ); }, "confirm": "Yes, enable GDPR tools", "reject": "Cancel" } }, "ecommerce": { "title": "Ecommerce", "description": "Does your company sell things online? Unlock integrations and other tools built for ecommerce.", "loadError": "There was a problem loading your ecommerce settings.", "beta": "Beta" }, "editCompanyInfo": { "loadError": "There was a problem loading your company info.", "companyAddressLine1": "Company address", "companyAddressLine2": "Company address line 2", "companyCity": "City", "companyCountry": "Country", "companyName": "Company name", "companyDomain": "Company domain", "companyState": "State", "companyZip": "Zip", "invalidDomain": "Invalid domain." }, "companyInfo": { "loadError": "There was a problem loading your company info.", "companyName": "Company name", "companyAddress": "Primary company address" }, "companyLogo": { "title": "Company logo", "squareTitle": "Square logo", "logo": "Logo", "empty": "No logo uploaded", "loadError": "There was a problem loading your company logo setting." }, "companyLogoAltText": { "title": "Logo alt text", "tooLong": "Please choose a logo alt text less than 100 characters." }, "brandColors": { "help": "This is used to populate your color picker and for your accent color in meetings, documents, and quotes.", "invalidColor": "Please choose a valid color", "colorsLoadError": "There was a problem loading your brand colors.", "primaryColor": "Primary color", "secondaryColor": "Secondary color", "accentColor": "Accent color 1", "accent2Color": "Accent color 2" }, "removeHubSpotBranding": { "marketing": "Remove HubSpot branding from Marketing apps", "sales": "Remove HubSpot branding from Sales apps", "marketingModalTitle": "Let your brand shine", "marketingModalBody": "Speak with your Admin about removing HubSpot branding from the Marketing tools", "salesModalTitle": "Let your brand shine", "salesModalBody": "Speak with your Admin about removing HubSpot branding from the Sales tools", "admin": { "marketingModalTitle": "Let your brand shine", "marketingModalBody": "Remove HubSpot branding from your website and the other Marketing apps", "salesModalTitle": "Let your brand shine", "salesModalBody": "Remove HubSpot branding from the Sales tools" } }, "security": { "heading": "Security", "loginAuditExport": { "title": "Export Login History", "instructions": "Export a login history report showing when users logged in to your HubSpot account in the last 90 days.", "button": "Export", "modal": { "title": "Export login history", "body": "Export a CSV file of login history for your HubSpot account for the last 90 days. This includes info about the location, email address, and device used to log in to your account. Your export will be delivered via email to {{userEmail}} and available in your notifications center.", "export": "Export", "cancel": "Cancel" }, "notifications": { "success": "Your login history is being prepared for export. This shouldn’t take long.", "failure": "Your login history export failed" }, "disabledTooltip": "You don't have permission to export login history. Please contact your account administrator to get access." }, "criticalActionsExport": { "title": "Export Critical Action History", "instructions": "Export a history report showing notable actions taken in your HubSpot account in the last year.", "button": "Export", "disabledTooltip": "You don't have permission to export critical actions. Please contact your account administrator to get access.", "modal": { "title": "Export Critical Actions", "body": "Export a CSV file of critical action history for your HubSpot account for the last year. This includes info about actions in your account like changing security settings. Your export will be delivered through email to {{userEmail}} and available in your notifications center.", "export": "Export", "cancel": "Cancel" }, "notifications": { "success": "Your critical actions history is being prepared for export. This shouldn’t take long.", "failure": "Your critical actions export failed" } }, "singleSignOn": { "buttons": { "disable": "Disable", "edit": "Edit", "setup": "Set up" }, "description": "Use your company's login credentials", "disabledTooltip": "You don't have permission to change these settings. Please contact your account administrator.", "errors": { "initialLoadError": "There was a problem loading your Single Sign-on settings." }, "modals": { "disable": { "description": "This will delete your current settings and force your users to log in through HubSpot.", "title": "Sure You Want to Disable Single Sign-on?" }, "edit": { "moreInfo": { "description_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Our Knowledge Base has the information you need to get started using Single Sign-on with HubSpot. ",
createElement( options,
"KnowledgeBaseButton",
props ) ); }, "title": "Learn more about Single Sign-on" }, "instructions": "Then provide the values from your identity provider.", "certificate": "X.509 Certificate", "errors": { "INVALID_URL": "Please enter a valid url.", "INVALID_URL_OR_URN": "Please enter a valid url or URN.", "NULL_OR_EMPTY": "Please enter a non-empty value." }, "issuer": "Identity Provider Identifier or Issuer URL", "title": "Set up Single Sign-on", "verify": "Verify", "ssoLoginUrl": "Identity Provider Single Sign-on URL" }, "require": { "description": "<p> From now on, users will need to use Single Sign-on (SSO) to access this account. </p> <p> Anyone currently signed in to the account will be asked to sign in again with SSO. </p> <p> You’ll automatically be excluded from the SSO requirement. This is so you can still access the account in case there's an issue with your identity provider. </p>", "title": "Are you sure you want to require Single Sign-on for this account?" }, "service": { "instructions": "You'll need these values to set up HubSpot as a service provider in your identity provider.", "audience": "Audience URI (Service Provider Entity ID)", "acs": "Sign on URL, ACS, Recipient, or Redirect", "tabs": { "most": "Most Identity Providers", "adfs": "Microsoft AD FS" } }, "unrequire": { "description": "Users on your hub will be able to log in and access your data using non Single Sign-on methods, such as using their HubSpot password. This will not log your users out.", "title": "Are you sure you want to stop requiring Single Sign-on for login?" } }, "notifications": { "deleteError": "There was a problem disabling Single Sign-on. Please try again, or contact support if it keeps happening.", "deleteSuccess": "Single Sign-on successfully disabled.", "fetchError": "There was a problem loading your Single Sign-on settings. Please try again, or contact support if it keeps happening.", "saveError": "There was a problem saving your Single Sign-on changes. Please try again, or contact support if it keeps happening.", "saveSuccess": "Single Sign-on settings saved.", "confirmError": "Unable to confirm your Single Sign-on settings.", "saveErrors": { "CERTIFICATE_EXPIRED": "Sorry, your X.509 certificate is expired. Please get a new one from your identity provider.", "CERTIFICATE_FUTURE": "Sorry, your X.509 certificate isn't valid yet. Please complete the setup steps in your identity provider.", "CERTIFICATE_ERROR": "Sorry, there was an error reading your X.509 certificate. Please check your entry and try again.", "ISSUER_ABSENT": "Identity provider issuer must be present. Please enter an issuer and try again.", "SSO_URL_INVALID": "Identity provider Single Sign-on URL must be a valid URL.", "UNKNOWN": "There was a problem saving your identity provider configuration. Please try again, or contact support if it keeps happening." }, "exemptions": { "fetchError": "There was a problem loading the exempt users. Please try again, or contact support if it keeps happening.", "saveError": "There was a problem saving the exempt users. Please try again, or contact support if it keeps happening.", "saveSuccess": "Exempt users saved." } }, "pql": { "leftBody": "Upgrade to HubSpot Enterprise to leverage Single Sign-on for your account.", "leftTitle": "Use Single Sign-on to log into HubSpot", "rightBody_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Make accessing your HubSpot account secure and effortless with our Single Sign-on support. ",
createElement( options,
"KnowledgeBaseButton",
props ) ); }, "rightTitle": "Enhance your account security" }, "requirement": { "description": "Require Single Sign-on to log in." }, "exclusions": { "descriptionEmpty": "Exclude users", "descriptionNonEmpty": "Manage excluded users", "modal": { "emptyNotification": { "description": "We recommend you exclude at least one user from this requirement. This is so the account can always be accessed, in case there's an issue with your identity provider.", "title": "All users on this account are currently required to log in with Single Sign-on." }, "title": "Exclude users from Single Sign-on requirement", "placeholder": "Choose users", "save": "Save", "cancel": "Cancel" } }, "title": "Single Sign-on", "require": { "title": "Require single sign-on (SSO)" } }, "twoFactorAuth": { "description": "Require all users to set up 2FA to log-in.", "disabledTooltip": "You don't have permission to change these settings. Please contact your account admin.", "errors": { "initialLoadError": "There was a problem loading your two-factor authentication settings." }, "modals": { "require": { "description": "In 24 hours, users on your account will be required to use two-factor authentication. Until then, encourage your users to set it up so they're ready for the change.</br>Everyone without 2FA set up will be notified and directed to do so.", "title": "Require 2FA for login?" }, "unrequire": { "description": "Users on your hub will be able to log in and access your data without confirming their identity with a 2FA device. This won't log your users out.", "title": "Stop requiring 2FA for login?" } }, "notifications": { "fetchError": "There was a problem loading your two-factor authentication settings. Please try again, or contact support if it keeps happening.", "saveError": "There was a problem saving your two-factor authentication settings. Please try again, or contact support if it keeps happening." }, "title": "Require Two-factor Authentication (2FA)" }, "jita": { "heading": "Account Access", "description": "Allow HubSpot employees access to your account for support and assistance", "disabledTooltip": "You don't have permission to change these settings. Please contact your account admin.", "disabledNotice": "Disabled by {{ firstName }} {{ lastName }} on {{ updatedAt }}", "enabledNotice": "Enabled by {{ firstName }} {{ lastName }} on {{ updatedAt }}", "errors": { "initialLoadError": "There was a problem loading your HubSpot employee access settings." }, "modals": { "enable": { "description": "Enabling this setting will allow HubSpot support and engineering to access your account for troubleshooting. It will also allow your account to be accessed by our account management team.", "title": "Enable HubSpot employee access?" }, "disable": { "description": "Disabling HubSpot employee access will block our team from accessing your account for any reason, including troubleshooting support issues. If you disable this setting, you will need to enable it again to give the HubSpot team access to your account. If you'd like to grant an individual HubSpot employee access, you can add them as a user in your account.", "title": "Disable HubSpot employee access?" } }, "notifications": { "fetchError": "There was a problem loading your HubSpot employee access settings. Please try again, or contact support if it keeps happening.", "saveError": "There was a problem saving your HubSpot employee access settings. Please try again, or contact support if it keeps happening." }, "title": "HubSpot Employee Access" } }, "brandingLogoInfo": { "title": "Looking for your page, email, and knowledge base logo?", "description": "You can set it under website branding settings.", "buttonText": "Edit logos" }, "brandingColorInfo": { "title": "Looking for your page and email colors?", "description": "You can set them in email settings.", "buttonText": "Edit page and email colors" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "de": "static-1.16253",
    "en": "static-1.16253",
    "es": "static-1.16253",
    "fr": "static-1.16253",
    "ja": "static-1.16253",
    "pt-br": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ecommerce": { "title": "Ecommerce", "error": { "title": "Something went wrong.", "message": "Please try again, or contact support if this keeps happening." }, "adminPanel": { "actions": "Actions", "adminLink": "Manage store", "disconnect": "Remove store", "disconnectModal": { "confirmationDescription": "If you remove your store, existing data will stay in HubSpot, but will no longer update. Reports, lists, and workflows using your data will also stay, but will be turned off.", "confirmationPrompt": "Type \"REMOVE\" below to confirm this action", "confirmationText": "REMOVE", "confirmButton": "Remove Shopify", "cancelButton": "Cancel", "deal": { "one": "{{ count }} deal", "other": "{{ count }} deals" }, "product": { "one": "{{ count }} product", "other": "{{ count }} products" }, "contact": { "one": "{{ count }} contact", "other": "{{ count }} contacts" }, "description_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"The shopify store ",
createElement( options,
"Emphasis",
null,
props.storeName ),
" is syncing data with ",
createElement( options,
"Link",
{ href: props.contactsHref, external: true },
createElement( options,
"ContactCount",
null ) ),
", ",
createElement( options,
"Link",
{ href: props.productsHref, external: true },
createElement( options,
"ProductCount",
null ) ),
", and ",
createElement( options,
"Link",
{ href: props.dealsHref, external: true },
createElement( options,
"DealCount",
null ) ),
"." ); }, "header": "Disconnect store?", "confirm": "Disconnect store", "reject": "Cancel" }, "importing": "Importing ...", "reconnect": "Reconnect" }, "importPreview": { "title": "One last step to connect {{ storeLabel }}", "description": "Import past data from Shopify to HubSpot. This could take several minutes depending on the size of your store.", "startImport": "Continue importing", "disconnect": "Disconnect store" }, "recentImport": { "title": "Creating objects from a recent import.", "message": "Your import is done, but it may be a few minutes before all your products, customers, and orders are ready in HubSpot. Check back soon." }, "importProgress": { "description": "Importing from {{ storeLabel }}", "stages": { "INITIALIZING": "Getting ready to import...", "RECEIVING": "Receiving data from your store...", "PROCESSING": "Creating objects in HubSpot...", "FINAL_PROCESSING": "Processing...", "COMPLETE": "Import complete!" } }, "storeSelector": { "noStores": "No stores connected", "connectAnotherStore": "Connect another store" }, "connect": { "title": "Connect your store to HubSpot", "locked": { "salesforceInstalled": { "message": "This integration isn't possible if you've already connected your account to Salesforce." }, "ecommBridgeAppInstalled": { "message": "This integration isn't possible if you've already connected certain other ecommerce integrations." }, "learnMore": "Find out more" }, "description": "Welcome new customers, follow up on abandoned carts, report on buyer behavior, and more. HubSpot integrates quickly and easily with multiple ecommerce platforms.", "shopifyButton": "Connect a Shopify store", "connectStore": "Connect a store now", "otherPlatformButton": "Connect to another ecommerce platform", "customStoreLink": "Connect to a custom store using Ecommerce Bridge", "modal": { "title": "Install Shopify for HubSpot", "description": "Once your store is connected to HubSpot we'll:", "track_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Install your ",
createElement( options,
"Link",
props,
"tracking code" ),
" on your Shopify pages." ); }, "import": "Begin importing all your order and customer data.", "learnMore": "Learn more about ecommerce integrations.", "shopifyUrl": { "label": "Store's Shopify URL", "placeholder": "my-store-name", "help": { "link": "Where can I find this?", "title": "Store's Shopify URL", "description": "<p>This is the web address for your store's Shopify dashboard.</p><p>You can find the URL at the top of your browser when viewing your dashboard. It ends with <strong>myshopify.com</strong>.</p>" }, "error": { "invalid": "That doesn't look quite right. Please enter a valid Shopify store URL.", "failed": "We couldn't verify this is a valid Shopify store URL." } }, "shopifyLite": "I'm connecting a Shopify Lite store", "connect": "Connect to Shopify", "cancel": "Cancel" }, "connecting": "Connecting...", "success": { "title": "Shopify for HubSpot was installed", "description": "Your Shopify store is now connected to HubSpot and your data will begin importing now. <b>This could take a while depending on the size of your store.</b> You can check on the progress of the import any time in ecommerce settings.", "learnMore": "Learn more about using Shopify with HubSpot", "settingsButton": "Go to ecommerce settings" } }, "dashboard": { "getStarted": { "title": "Get started with ecommerce and HubSpot", "list": { "title": "Uncover customer buying patterns", "text": "Segment contacts based on order criteria using deal properties.", "cta": "Create a deal-based list" }, "workflow": { "title": "Automated ecommerce campaigns", "text": "Welcome new customers, recover abandoned carts, or market directly to past customers.", "cta": "Set up an ecommerce workflow", "disabledCta": "Coming soon" }, "dashboard": { "title": "Explore marketing & sales performance", "text": "Visualize store sales and marketing campaign performance with a new ecommerce dashboard.", "cta": "Check out your ecommerce dashboard", "disabledCta": "Coming soon" } }, "stats": { "title": "Store data", "description": "Track the products, customers, and orders syncing from Shopify to HubSpot." }, "dataSync": { "notify": { "twoWay": { "success": "Two-way sync is now enabled for {{ storeName }}", "failure": "There was a problem enabling two-way sync for {{ storeName }}" }, "oneWay": { "success": "One-way sync is now enabled for {{ storeName }}", "failure": "There was a problem enabling one-way sync for {{ storeName }}" } }, "confirm": { "title": "Turn on two-way sync*", "description": "When you turn on two-way sync, data syncing from Shopify to HubSpot won't change.<br/><br/>Going forward, contact property updates made in HubSpot or Shopify will be reflected in both systems.", "learnMore": "Learn more", "turnOn": "Turn on", "cancel": "Cancel", "footnote": "*Requires Shopify login." }, "title": "Data sync", "default": "default", "oneWay": { "title": "One-way sync", "description": "Products, customers, and orders will sync from Shopify to HubSpot." }, "twoWay": { "title": "Two-way sync", "description": "Products and orders will still sync from Shopify to HubSpot. Certain customer updates made in either HubSpot or Shopify will be reflected in both systems.", "learnMore": "Learn more" } }, "products": { "title": "Products", "action": "Product library" }, "customers": { "title": "Customers", "tooltip": "Store customers will show up as standard HubSpot contacts. Note that these contacts will <strong>not</strong> be set to the \"customer\" lifecycle stage by default.", "action": "Customer contacts" }, "orders": { "title": "Orders", "tooltip": "Orders from your store will show up as deals in HubSpot.", "action": "Order pipeline" }, "overview": { "manageInShopify": "Manage in Shopify", "disconnect": "Disconnect", "error": { "header": "Something went wrong.", "body": "There was a problem getting your Shopify shop information. Please try again." } }, "disconnect": { "confirmation": { "header": "Are you sure you want to disconnect Shopify?", "body": "Data synced between HubSpot and Shopify will stay, but will no longer be updated. All active workflows will be disabled.", "confirm": "Disconnect", "reject": "Cancel" }, "success": { "header": "You're all set.", "body": "Your Shopify store has been successfully disconnected." }, "failed": { "header": "Something went wrong.", "body": "Your Shopify store could not be disconnected. Please try again later or contact support." } }, "automation": { "title": "Automation", "description_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Trigger the actions below when your contacts meet different criteria for this store. Not sure what to say in your emails? ",
createElement( options,
"Link",
{ external: true, href: props.href },
"Use an ecommerce email template" ) ); }, "createWorkflow": { "failure": "There was a problem creating this workflow. Please try again, or contact support if the problem persists." }, "expandWorkflow": { "one": "Expand {{ count }} action", "other": "Expand {{ count }} actions" }, "collapseWorkflow": "Fewer actions", "save": "Save", "cancel": "Cancel", "delay": { "separator": ", ", "minutes": { "one": "{{ count }} minute", "other": "{{ count }} minutes" }, "hours": { "one": "{{ count }} hour", "other": "{{ count }} hours" }, "days": { "one": "{{ count }} day", "other": "{{ count }} days" }, "success": "Success! Your email send delay has updated.", "failure": "There was a problem updating your email send delay. Please try again, or contact support if the problem persists." }, "delayLabels": { "days": "Days", "hours": "Hours", "minutes": "Minutes" }, "update": { "failure": "There was a problem updating your automation step. Please try again, or contact support if the problem persists.", "success": "Success! Your automation step has updated." }, "emailPanel": { "select": "Select an email", "save": "Save", "cancel": "Cancel", "helpNote": "Only emails saved for automation will appear here. {{ helpLink }}", "helpLinkText": "Why?", "lastUpdated": { "dateWithAuthor": "Updated {{ date }} by {{ authorName }}", "date": "Updated {{ date }}" } }, "welcomeNewCustomers": { "title": "Welcome new customers", "description": "A warm greeting goes a long way. After someone becomes a customer, keep them engaged with a series of welcome emails spaced out over days or weeks.", "afterFirstPurchase": "After a customer's first purchase...", "afterOrderDelivery": "When the order has been delivered" }, "abandonedCart": { "title": "Follow up on abandoned carts", "description": "Sometimes all you need is a gentle nudge. If someone navigates away from a full cart, send them a convenient email reminder to help them complete their order.", "afterCustomerAbandons": "24 hours after a customer abandons their cart..." }, "reengagement": { "title": "Re-engage with old customers", "description": "Nurture lasting relationships. Send customers who haven't come back in a while an email that keeps your brand top-of-mind.", "afterNoRepeatPurchase": "If a customer hasn't bought in 3 months..." } }, "shepherd": { "getStarted": { "header": "Ecommerce marketing workflows", "body": "Use your store data to send automatic and personalized emails to new, inactive, and potential customers.", "confirm": "Got it" } } }, "import": { "title": "Importing data from your store", "objectType": { "product": { "header": "Products", "creating": "Creating HubSpot products..." }, "contact": { "header": "Customers", "creating": "Creating HubSpot contacts..." }, "deal": { "header": "Orders", "creating": "Creating HubSpot deals..." } }, "downloading": "Downloading from your store...", "stage": { "INITIALIZING": "Getting ready to import...", "RECEIVING": "Receiving data from your store...", "PROCESSING": "Creating objects in HubSpot...", "FINAL_PROCESSING": "Processing...", "COMPLETE": "Import complete!" }, "information": { "title": "What's next?", "description": "HubSpot is connecting to your store. Once your product, customer, and deal information is imported, you can:", "emailAutomation": "Send your contacts automated emails when they buy something or abandon their cart.", "dealPipeline": "Track your order revenue with your ecommerce deal pipeline.", "productLibrary": "View your store's inventory in your product library." }, "goToSettings": "Continue to settings", "failure": { "import": { "title": "There was a problem importing your store data.", "message": "Please contact support." }, "request": { "title": "There was a problem checking the status of your store import.", "message": "Please try again, or contact support if this keeps happening." } } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "de": "static-1.16253",
    "en": "static-1.16253",
    "es": "static-1.16253",
    "fr": "static-1.16253",
    "ja": "static-1.16253",
    "pt-br": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "simpleMenusLib": { "components": { "addMenuButton": { "label": "Add menu item", "actions": { "NO_LINK": "Add item without link", "PAGE_LINK": "Add page link", "PAGE_LINK_WITH_PARAMS": "Add Page link with URL parameter", "URL_LINK": "Add URL Link" } }, "menuItemLabel": { "placeholder": "Menu item label" }, "pagesLinkSelect": { "draft": { "label": "Draft", "tooltip": "This page is a draft. It won't appear in your menu until it's published." } }, "menuItemOptions": { "actions": { "label": "Actions", "primaryOptions": { "MENU_TREE_ADD_NODE": "Add item below", "MENU_TREE_ADD_CHILD": "Add child item below", "MENU_TREE_CLONE_NODE": "Clone item", "MENU_NODE_REPLACE": "Replace With" }, "swapOptions": { "NO_LINK": "Item without link", "PAGE_LINK": "Page link", "PAGE_LINK_WITH_PARAMS": "Page link with URL parameter", "URL_LINK": "URL Link" }, "openInEditor": { "label": "Open in editor" }, "external": "Open link in new window" }, "options": { "NO_LINK": { "placeholder": "No link" }, "PAGE_LINK": { "placeholder": "Select page" }, "PAGE_LINK_WITH_PARAMS": { "placeholder": "URL parameter" }, "URL_LINK": { "placeholder": "URL" } } }, "menuItemDivider": { "addItems": { "NO_LINK": "Add item without link", "PAGE_LINK": "Add page link", "PAGE_LINK_WITH_PARAMS": "Add Page link with URL parameter", "URL_LINK": "Add URL Link" } }, "modals": { "deleteNodeModal": { "header": "Delete {{ linkLabel }}?", "button": "Delete", "body": "There are child items below the {{ linkLabel }} menu item. Deleting {{ linkLabel }} will also delete its child items.", "placeholder": "Menu Item" } } }, "emptyState": { "header": "Your menu items will appear here", "body": " Add a page or link to your menu to help your visitors get around.", "button": "Add menu item" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "simple-menus-lib": {
    "en": "static-1.3888"
  }
};
  result.translationsAvailable = {
  "simple-menus-lib": {
    "de": "static-1.3888",
    "en": "static-1.3888",
    "es": "static-1.3888",
    "fr": "static-1.3888",
    "ja": "static-1.3888",
    "pt-br": "static-1.3888"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:simple-menus-lib:en', {version: 'static-1.3888'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "advancedMenusLib": { "advancedMenus": { "emptyState": { "header": { "label": "Your menus will appear here." }, "message": { "label": "Create a menu to help people navigate your website and find what they need." }, "button": { "label": "Create menu" } }, "buttons": { "actions": { "label": "Actions" }, "publish": { "label": "Publish" }, "addMenu": { "label": "+ Add menu" } }, "actions": { "RENAME": { "label": "Rename" }, "DELETE": { "label": "Delete" }, "DISCARD": { "label": "Discard changes" }, "CLONE": { "label": "Clone" }, "SHOW_REVISIONS": { "label": "Show revisions" } }, "notifications": { "errorTitle": "Error", "namingError": "\"{{ menuName }}\" is already in use, please choose a different name", "default": "There was an error {{ actionText }}", "actions": { "CLONE_MENU": "cloning \"{{ menuName }}\"", "FETCH_MENUS": "fetching menus", "CREATE_MENU": "creating \"{{ menuName }}\"", "DELETE_MENU": "deleting \"{{ menuName }}\"", "PUBLISH_MENU": "publishing \"{{ menuName }}\"", "DISCARD_MENU_BUFFER": "discarding changes", "FETCH_MENU_BUFFER": "fetching the menu", "SAVE_MENU_BUFFER": "saving changes", "RENAME_MENU": "renaming the menu to \"{{ menuName }}\"" } }, "modals": { "renameModal": { "header": "Rename \"{{ label }}\"", "button": "Rename", "form": { "label": "Menu name", "placeholder": "Menu name", "validation": "Name is required" } }, "deleteModal": { "header": "Delete \"{{ label }}\"", "button": "Delete", "body": "Are you sure you want to delete \"{{ label }}\"?" }, "createModal": { "header": "Name your new menu", "body": "In order to keep your menus organized, give it a descriptive name. This name won't appear on the menu itself, but will be useful if you need to edit it in the future.", "button": "Create menu", "form": { "label": "Menu name", "placeholder": "Menu name", "validation": "Name is required" } }, "cloneModal": { "header": "Clone \"{{ label }}\"", "button": "Clone", "warning": "This menu has unpublished changes. Publish your changes to include them in your clone.", "form": { "label": "Cloned menu name", "placeholder": "Cloned menu name", "validation": "Name is required" } }, "revisionsModal": { "header": "Chose a revision for \"{{ menuName }}\"", "buttons": { "confirm": "Choose", "cancel": "Cancel" }, "items": { "currentLabel": "{{ timestamp }} (current)" } } } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "advanced-menus-lib": {
    "en": "static-1.3104"
  }
};
  result.translationsAvailable = {
  "advanced-menus-lib": {
    "de": "static-1.3104",
    "en": "static-1.3104",
    "es": "static-1.3104",
    "fr": "static-1.3104",
    "ja": "static-1.3104",
    "pt-br": "static-1.3104"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:advanced-menus-lib:en', {version: 'static-1.3104'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "options": { "marketing": "Marketing", "sales": "Sales", "email": "Email", "call": "Call", "lawfulBasis": { "LEGITIMATE_INTEREST_PQL": "Legitimate interest - prospect/lead", "LEGITIMATE_INTEREST_CLIENT": "Legitimate interest - client", "LEGITIMATE_INTEREST_OTHER": "Legitimate interest - other", "PERFORMANCE_OF_CONTRACT": "Performance of a contract", "CONSENT_WITH_NOTICE": "Freely given consent from contact", "NON_GDPR": "Not applicable", "help": { "LEGITIMATE_INTEREST_PQL": "Some help text", "LEGITIMATE_INTEREST_CLIENT": "Some help text", "PERFORMANCE_OF_CONTRACT": "Some help text", "CONSENT_WITH_NOTICE": "Some help text", "NON_GDPR": "Some help text" } } }, "buttons": { "save": "Save", "cancel": "Cancel", "add": "Add" }, "labels": { "subscriptionType": "Subscription type", "lawfulBasis": "Lawful basis", "explanation": "Explanation", "process": "Process", "operation": "Operation", "optStatus": "Opt status" }, "placeholders": { "subscriptionType": "Select subscription type", "lawfulBasis": "Select lawful basis", "explanation": "Provide explanation for lawful basis", "process": "Choose process", "operation": "Choose operation", "addOption": "Add option", "optStatus": "Select opt status" }, "errors": { "optionExists": "This option already exists." }, "optStatuses": { "OPT_IN": "Opted in", "OPT_OUT": "Opted out", "NOT_OPTED": "Not opted" }, "events": { "portalWide": "Portal Wide", "editColumns": "Edit columns", "allColumns": "All columns", "selectedColumns": "Selected columns", "noHistory": "There aren't any subscription changes for the following email addresses:", "status": { "OPT_IN": "Opted in", "OPT_OUT": "Opted out", "NOT_OPTED": "Not opted", "GLOBAL_OPT_OUT": "Opted out from all" }, "headers": { "created": "Date", "newStatus": "New status", "subscription": "Subscription", "requestedBy": "Requested by", "lawfulBasis": "Lawful basis", "source": "Source", "explanation": "Explanation", "extras": "Extras", "emailCampaignId": "Email Campaign id", "pageUrl": "Page url", "ipAddress": "IP", "userAgent": "User agent", "email": "Email" }, "sources": { "SOURCE_LIST_UNSUBSCRIBE": "List-unsubscribe header", "SOURCE_IMPORT": "Portal import", "SOURCE_SPAM_REPORT": "Automated spam report", "SOURCE_NON_DELIVERY_REPORT": "Non-delivery report", "SOURCE_HUBSPOT": "Hubspot employee", "SOURCE_DIRECT_COMPLAINT": "Complaint to abuse@hubspot.com", "SOURCE_MTA_RECORD": "Delivery provider", "SOURCE_SENDGRID": "SendGrid", "SOURCE_RECIPIENT": "Contact", "SOURCE_HUBSPOT_CUSTOMER": "Portal user", "SOURCE_MIGRATION": "CMS migration", "SOURCE_HUBSPOT_CLEANUP": "HubSpot cleanup", "SOURCE_KNOWN_SPAM_TRAP": "Spam trap", "SOURCE_SDFC_SYNC": "SDFC", "SOURCE_PUBLIC_API": "Public API", "SOURCE_RECIPIENT_VIA_API_GENERATED_TOKEN": "Contact through public API", "SOURCE_TWO_FIFTY_OK_SPAM_TRAP": "Spam trap report", "SOURCE_LINKED_PORTAL": "Linked portal", "SOURCE_CONVERSATIONS": "Live chat conversation", "SOURCE_BOTS": "Bots conversation", "SOURCE_FORM_SUBMIT": "Form submission", "SOURCE_FEEDBACK_FORM": "Feedback form submission", "SOURCE_WORKFLOW": "Workflow", "Unknown": "Unknown" } }, "unknown": "Unknown" } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "ui-gdpr-components": {
    "en": "static-1.2392"
  }
};
  result.translationsAvailable = {
  "ui-gdpr-components": {
    "de": "static-1.2392",
    "en": "static-1.2392",
    "es": "static-1.2392",
    "fr": "static-1.2392",
    "ja": "static-1.2392",
    "nl": "static-1.2392",
    "pt-br": "static-1.2392"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ui-gdpr-components:en', {version: 'static-1.2392'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ErrorMessaging": { "errors": { "401": { "title": "Error", "message": "This is an unauthorized request. Click here to go back to <a href='//app.hubspot.com'>HubSpot homepage</a>." }, "403": { "title": "Error", "message": "You are not allowed to access this feature." }, "404": { "title": "Error", "message": "The page was not found. Please try again." }, "409": { "title": "Error", "message": "Something went wrong while performing your action. Please try again." }, "500": { "title": "Error", "message": "Please try again later." }, "default": { "title": "Error", "message": "Please try again." } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "error-messaging-js": {
    "en": "static-1.264"
  }
};
  result.translationsAvailable = {
  "error-messaging-js": {
    "de": "static-1.264",
    "en": "static-1.264",
    "es": "static-1.264",
    "fr": "static-1.264",
    "ja": "static-1.264",
    "nl": "static-1.264",
    "pt-br": "static-1.264"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:error-messaging-js:en', {version: 'static-1.264'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ADS_ACCOUNT_CONNECTION": { "adAccountConnectModal": { "title": { "FACEBOOK": { "one": "Select Facebook ad account", "other": "Select Facebook ad accounts" }, "LINKEDIN": { "one": "Select LinkedIn ad account", "other": "Select LinkedIn ad accounts" }, "ADWORDS": { "one": "Select Google ad account", "other": "Select Google ad accounts" } }, "table": { "headers": { "adAccount": "Ad Account", "autoTracking": "Auto Tracking", "autoTrackingToolTip": "Track which ads your contacts are clicking on and converting on. We will automatically add tracking parameters to all of your ads without overwriting any existing parameters. <a href='https://knowledge.hubspot.com/articles/kcs_article/reports/how-does-tracking-work-in-the-ads-add-on' target='_blank'>Learn more.</a>" } }, "limits": { "header": { "one": "You can connect <strong>{{count}}</strong> ad account.", "other": "You can connect up to <strong>{{count}}</strong> ad accounts." }, "tooltip": { "one": "You can only connect {{count}} ad account.", "other": "You can connect up to {{count}} ad accounts." } }, "differentUser": "This ad account is connected by {{connectedUserName}}.", "connectButton": "Connect", "cancelButton": "Cancel", "connected": "Connected", "adwordsMcc": "Your selected Google Ads account(s) will be added to HubSpot's Google Manager account. You will receive an email from Google confirming this.", "learnMore": "Learn more", "newAdAccount": "Create ad account", "noAdAccounts": { "header": { "FACEBOOK": "Create a new Facebook ad account", "ADWORDS": "Create a new Google ad account", "LINKEDIN": "Create a new LinkedIn ad account" }, "body": { "FACEBOOK": "You'll need to create a Facebook ad account. Once that's done you can connect it to HubSpot and start reporting on who converts on your ads.", "ADWORDS": "You'll need to create a Google ad account. Once that's done you can connect it to HubSpot and start reporting on who converts on your ads.", "LINKEDIN": "You'll need to create a LinkedIn ad account. Once that's done you can connect it to HubSpot and start reporting on who converts on your ads." }, "getStarted": "Create ad account" } }, "missingPermissions": { "title": "Heads up", "message": "You'll need to update your permissions in Facebook to create and manage ads, and get accurate reports.", "required": "The HubSpot app doesn't have enough permissions. Please reconnect your account.", "learnMore": "Learn More", "updatePermissions": "Update Permissions" }, "connectAccountErrorBanner": { "title": "Sorry", "message": "Your ad account couldn't be connected. If you're using an ad blocker, please turn it off, and try again.", "ADWORDS_TOO_MANY_ACCOUNTS_UNDER_MCC": "Sorry. There are too many ad accounts to show right now.", "adWordsCustomerNotFound": "It looks like you haven't finished setting up your account. To connect your ad account to HubSpot, you'll need to finish setting up your account within Google, and then try again.", "NOT_AN_ADWORDS_USER": "Sorry. Your Google account wasn't connected because it doesn't have an Ads account associated with it. You’ll need to use an account that has Google Ads or create an Ads account.", "ADWORDS_ACCOUNT_NOT_SETUP": "It looks like you haven't finished setting up your account. To connect your ad account to HubSpot, you'll need to finish setting up your account within Google, and then try again.", "ADWORDS_NO_BILLING_INFO": "It looks like you haven't finished setting up your account. To connect your ad account to HubSpot, you'll first need to add your billing information within Google.", "ADWORDS_USER_MULTIPLE_ACCOUNTS": "It looks like this user is connected to more than one Google Ads accounts. We don't support multiple Ads accounts for a single user right now. Try connecting with a user that only has one Google Ads account." }, "audiences": { "pixels": { "selectPixelPlaceholder": "Select a pixel", "installedPixelOption": "{{pixelId}} (Permission needed)" }, "installPixelModal": { "header": "Add pixel", "disabledPixelTooltip": { "alreadyInstalled": "You can only add one pixel per network.", "accountInactive": "Pixels are not available for {{accountName}} due to it being inactive. Please go to {{network}} for more information", "missingAccountPermissions": "You'll need to update your permissions in {{network}} to create audiences." }, "addPixel": "Add pixel", "action": { "one": "Add pixel", "other": "Add {{ count }} pixels" }, "description": "You will be able to re-engage with people who have visited your website and are aware of your company, wherever they are online. The pixel will be added to all your HubSpot website pages automatically.", "disclaimer": "Remember to remove any existing pixel installations on your website to avoid double counting.", "pixelLabel": "Pixel", "pixelPlaceholder": "Select a pixel", "facebookDefaultName": "{{accountName}}'s pixel", "defaultName": "{{accountName}} pixel" }, "website": { "learnMore": "Upgrade", "limitReached": "You've created 1 out of 1 all website visitors audience for this network. Unlock more audiences with Marketing Hub Starter." }, "websitePrivacyPolicy": { "privacyPolicy": "Privacy policy", "message": "Let your visitors know that you're using cookies. {{link}}", "link": "Go to settings", "tooltip": "When asking visitors for consent, the pixel won't work until consent is given." } }, "permissions": { "needsRole_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your ",
props.networkDisplayName,
" user needs Admin permissions on ",
props.accountName,
" ad account. ",
createElement( options,
"Link",
{ network: props.network },
"How do I do this?" ) ); }, "permissionsNeeded": "Permissions needed", "inactive": "Inactive", "inactive_account_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your ",
props.accountName,
" ad account isn't active. Go to ",
props.networkDisplayName,
" and reactivate your ad account. ",
createElement( options,
"Link",
{ network: props.network, onClick: props.onClick },
"How do I do this?" ) ); } }, "networks": { "adwords": "Google Ads", "allNetworks": "All networks", "googleAdwords": "Google Ads", "facebook": "Facebook", "linkedin": "LinkedIn" }, "leadSync": { "missingEmailSettings_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"One or more of your lead ad forms doesn't have an email field. By default, form submissions that don't include an email field won't create contacts. If you'd like these submissions to create contacts, turn this setting on: ",
createElement( options,
"FormSettingsLink",
null,
"Go to lead syncing settings" ) ); } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "ads-account-connection": {
    "en": "static-1.10476"
  }
};
  result.translationsAvailable = {
  "ads-account-connection": {
    "de": "static-1.10476",
    "en": "static-1.10476",
    "es": "static-1.10476",
    "fr": "static-1.10476",
    "ja": "static-1.10476",
    "pt-br": "static-1.10476"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ads-account-connection:en', {version: 'static-1.10476'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "marketing": { "movingPages": { "blog": { "heading": "Blog settings will be moving here soon.", "subText": "Go to blog settings" }, "website": { "heading": "Web page settings will be moving here soon.", "subText": "Go to web page settings" }, "email": { "heading": "Email settings will be moving here soon.", "subText": "Go to email settings" }, "ads": { "heading": "Ads settings will be moving here soon.", "subText": "Go to ads settings" }, "domains": { "domains": { "heading": "Domains will be moving here soon.", "subText": "Go to domain settings" }, "heading": "Domains & URLs will be moving here soon.", "subText": "Go to the domain manager", "urlRedirects": { "heading": "URL Mappings will be moving here soon.", "subText": "Go to URL Mappings manager" } } }, "links": { "edit": "Edit", "create": "Create", "ads": "Ads", "blog": "Blog", "webPages": "Pages", "setup": "Setup" }, "ads": { "errors": { "genericError": "Sorry, something’s gone wrong. Please refresh the page or try again later.", "details": "Details" }, "networks": { "adwords": "Google Ads", "facebook": "Facebook", "linkedin": "LinkedIn" }, "emptyState": { "connectButton": "Connect account", "title": "Create and manage all your ads in one place.", "manageCampaigns": "Connect your ad accounts and start creating targeted, relevant ads, for every stage of your buyers’ journey with HubSpot.", "audiences": "You can manage ads across multiple networks from one place and create custom audiences that you can target in just a few clicks.", "reporting": "Find out how your ads are performing with custom reports and integrate your ads with the rest of your marketing tools, like your CRM." }, "pageTitle": "Ads", "saved": { "success": "ROI settings saved successfully.", "error": "An error occurred while saving ROI settings." }, "tabs": { "accounts": "Accounts", "leadSyncing": "Lead syncing", "pixels": "Pixels", "roiCalculation": "ROI" }, "oauth": { "connecting": "Connecting..." }, "search": "There are no results for this search.", "insufficientPermissions": "You need ads publishing permission to change this setting.", "accounts": { "connectModal": { "title": "Select ad network", "ADWORDS": "Google Ads", "FACEBOOK": "Facebook", "LINKEDIN": "LinkedIn" }, "table": { "label": "Ad accounts", "search": "Search ad accounts", "connectAccount": "Connect account", "account": "Account", "hubSpotUserName": "HubSpot User", "hubSpotUserNameToolTip": "The HubSpot user who connected the ad account.", "networkUserName": "Network User", "networkUserNameToolTip": "The ad network user account that was used to connect the ad account. This user's permissions will be used to decide what they have access to in the Ads tool.", "autoTracking": "Auto Tracking", "autoTrackingToolTip": "Track which ads your contacts are clicking on and converting on. We will automatically add tracking parameters to all of your ads without overwriting any existing parameters. <a href='https://knowledge.hubspot.com/articles/kcs_article/reports/how-does-tracking-work-in-the-ads-add-on' target='_blank'>Learn more.</a>", "statuses": { "connected": "Connected", "adwordsDisconnected": "This account isn't connected. Disconnecting and reconnecting the account may solve this problem.", "FACEBOOK": { "warning": "Reconnect the Facebook user account {{accountName}} by {{expDate}} to keep syncing this ad account.", "expired": "The Facebook user account {{accountName}} that's associated with this ad account isn't connected.", "inaccessible": "{{accountName}} no longer has permissions for this ad account. Update permissions or remove ad account.", "inactive": "Inactive", "missingPermissions": "Permissions needed" }, "LINKEDIN": { "warning": "Reconnect the LinkedIn user account {{accountName}} by {{expDate}} to keep syncing this ad account.", "expired": "The LinkedIn user account {{accountName}} that's associated with this ad account isn't connected.", "inaccessible": "{{accountName}} no longer has permissions for this ad account. Update permissions or remove ad account." }, "ADWORDS": { "inactive": "Inactive", "inaccessible": "{{accountName}} no longer has permissions for this ad account. Update permissions or remove ad account." } }, "tooltips": { "FACEBOOK": { "missingPermissions": "You'll need to update permissions in Facebook and give HubSpot access to the following: <ul className=\"m-top-3\"><li><strong>Ads management:</strong> Turn on this permission to create ads, track contacts, and get ad reports.</li><li><strong>Manage pages:</strong> Turn on this permission to create lead generation ads and sync leads.</li><li><strong>Leads retrieval:</strong> Turn on this permission to sync leads from lead generation ads.</li></ul>" } } }, "connectAccountButton": "Connect", "disconnectAccountButton": "Disconnect", "reconnectUserButton": { "default": "Reconnect user", "missingPermissions": "Update permissions" }, "onlyOwningUser": "Only the user that connected the account can update it.", "fixAccount": "You can't update this account until all errors are corrected.", "cancelButton": "Cancel", "oauthErrorBanner": { "title": "An issue occurred while connecting your account.", "details": "Details", "defaultBody": { "ADWORDS": "Double-check your account settings in <a target='_blank' href='https://adwords.google.com/'>Google Ads</a> and try again.", "FACEBOOK": "Double-check your account settings in <a target='_blank' href='https://business.facebook.com/'>Facebook Ads Manager</a> and try again.", "LINKEDIN": "Double-check your account settings in <a target='_blank' href='https://www.linkedin.com/psettings/'>LinkedIn</a> and try again." } }, "leadSyncingStatuses": { "lastSynced": "Last synced {{lastSyncedAt}}", "syncing": "Syncing", "generic": "Lead syncing error", "FACEBOOK": { "warning": "Reconnect the Facebook user account {{accountName}} by {{expDate}} to keep syncing leads from this page.", "expired": "The personal account {{accountName}} that's associated with this page isn't connected.", "missingPermissions": "Permissions needed", "missingEntityPermissions": "Page permissions needed", "accountNotConnected": "Account disconnected", "throttled": "Lead syncing issue", "pageNotFound": "Page not found", "pageMoved": "Page moved" }, "LINKEDIN": { "warning": "Reconnect the LinkedIn user account {{accountName}} by {{expDate}} to keep syncing leads from this account.", "expired": "The personal account {{accountName}} that's associated with this page isn't connected.", "missingPermissions": "Permissions needed", "missingEntityPermissions": "Permissions needed", "accountNotConnected": "Account disconnected", "throttled": "Lead syncing issue", "pageNotFound": "Page not found" }, "ADWORDS": { "missingPermissions": "Permissions needed", "missingEntityPermissions": "Permissions needed", "accountNotConnected": "Account disconnected", "throttled": "Lead syncing issue", "pageNotFound": "Page not found" } }, "leadSyncingTooltips": { "FACEBOOK": { "accountNotConnected_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You need to reconnect your Facebook user to create and manage ads, and get accurate reports." ); }, "leadLevelFailures_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your Facebook user needs Admin permissions to this page." ); }, "missingEntityPermissions_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your Facebook user needs Admin permissions to this page." ); }, "missingPermissions_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You'll need to update permissions in Facebook and give HubSpot access to the following: ",
createElement( options,
"ul",
{ className: "m-top-3" },
createElement( options,
"li",
null,
createElement( options,
"strong",
null,
"Ads management:" ),
" Turn on this permission to create ads, track contacts, and get ad reports." ),
createElement( options,
"li",
null,
createElement( options,
"strong",
null,
"Manage pages:" ),
" Turn on this permission to create lead generation ads and sync leads." ),
createElement( options,
"li",
null,
createElement( options,
"strong",
null,
"Leads retrieval:" ),
" Turn on this permission to sync leads from lead generation ads." ) ) ); }, "throttled_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"We're experiencing issues with Facebook at this moment. Leads will continue to sync but they may be delayed." ); }, "noValues_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your lead ad form is using fields that can't be synced to HubSpot. You'll need to update your form to use the provided fields; email, first name, etc.",
createElement( options,
"br",
null ),
createElement( options,
"KnowledgeBaseButton",
{ url: "https://knowledge.hubspot.com/articles/kcs_article/ads/manage-facebook-pages-syncing-leads-to-hubspot#ensure-your-lead-ad-form-has-an-email-address-field" },
"Learn more" ) ); }, "pageNotFound_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"The page could not be found. It may have been deleted, or you may no longer have permision ot access it. Please verify the page still exists and that the user who connected it has admin permissions." ); }, "pageMoved_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"The page has been moved. It may have been merged with another page. Please connect the new page." ); }, "unknown_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"We're experiencing issues with Facebook at this moment. Please check back later." ); } }, "LINKEDIN": { "accountNotConnected_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You need to reconnect your LinkedIn user to create and manage ads, and get accurate reports." ); }, "leadLevelFailures_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your LinkedIn user needs Admin permissions to this page." ); }, "missingEntityPermissions_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your LinkedIn user needs Designated Admin or Lead Gen Forms Manager permission to this page to be able to sync leads." ); }, "missingPermissions_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You'll need to update permissions in LinkedIn and give HubSpot access to sync your leads." ); }, "throttled_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"We're experiencing issues with LinkedIn at this moment. Leads will continue to sync but they may be delayed." ); }, "noValues_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your lead ad form is using fields that can't be synced to HubSpot. You'll need to update your form to use the provided fields; email, first name, etc.",
createElement( options,
"br",
null ),
createElement( options,
"KnowledgeBaseButton",
{ url: "https://knowledge.hubspot.com/articles/kcs_article/ads/manage-linkedin-ads-accounts-syncing-leads-to-hubspot#ensure-your-lead-gen-form-has-an-email-address-field" },
"Learn more" ) ); }, "pageNotFound_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"The page could not be found. It may have been deleted, or you may no longer have permision ot access it. Please verify the page still exists and that the user who connected it has admin permissions." ); }, "unknown_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"We're experiencing issues with LinkedIn at this moment. Please check back later." ); } }, "ADWORDS": { "accountNotConnected_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You need to reconnect your Google Ads user to create and manage ads, and get accurate reports." ); }, "leadLevelFailures_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your Google Ads user needs Admin permissions to this page." ); }, "missingEntityPermissions_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your Google Ads user needs Admin permissions to this page." ); }, "missingPermissions_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"You'll need to update permissions in Google Ads and give HubSpot access to sync your leads." ); }, "throttled_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"We're experiencing issues with Google Ads at this moment. Leads will continue to sync but they may be delayed." ); }, "noValues_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Your lead ad form is using fields that can't be synced to HubSpot. You'll need to update your form to use the provided fields; email, first name, etc." ); }, "unknown_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"We're experiencing issues with Google Ads at this moment. Please check back later." ); } } }, "facebook": { "addPixelButton": "Add pixel", "pagesStatusDescription": "When people convert on your lead generation ads their contact data will be automatically synced to your HubSpot CRM. All of your lead generation ad leads from the last 90 days will also sync over to HubSpot.", "searchPages": "Search", "managePages": "Manage", "pagesTable": { "pageName": "Name", "pageId": "Page ID", "hubSpotUserName": "HubSpot User", "networkUserName": "Network User" }, "addPixelModal": { "header": "Add Facebook Pixel", "newPixelPrompt": "You'll need to create a Facebook pixel to create custom audiences based on your website visitors.", "existingPixelPrompt": "You already have a Pixel associated with the ads account <b>{{ facebookAdAccountName }}</b>.", "subheader": "Here's your custom Facebook pixel:", "termsOfService": "By clicking Add pixel, you agree to Facebook's <a href='https://www.facebook.com/customaudiences/app/tos/?ref=u2u' target='_blank'>terms and conditions</a> and are still subject to HubSpot's <a href='http://legal.hubspot.com/terms-of-service' target='_blank'>terms of service</a>.", "pixelName": "Pixel name: {{ facebookPixelName }}", "pixelId": "Pixel ID: {{ facebookPixelId }}", "confirmationCheckboxLabel": "Yes, please install", "confirmAddPixelButton": "Add pixel", "cancelButton": "Cancel", "termsOfServiceHeader": "Accept terms of service", "agreeToTermsOfService": "I agree to Facebook's terms of service" } }, "networkSelect": { "FACEBOOK": "Facebook", "LINKEDIN": "LinkedIn", "label": "Network:", "multiple": { "one": "{{ count }} network", "other": "{{ count }} networks" } }, "disconnectPage": { "FACEBOOK": { "headerSingle": "Remove \"{{pageName}}\" page?", "headerMultiple": "Remove {{count}} pages?", "message": "Removing this page will stop any new leads from syncing into your CRM. You can add this page and sync any leads you may have missed at any time as long as you have admin permissions on the page." }, "LINKEDIN": { "headerSingle": "Remove \"{{pageName}}\"?", "headerMultiple": "Remove {{count}} accounts?", "message": "Removing this ad account will stop any new leads from syncing into your CRM. You can add this ad account and sync any leads you may have missed at any time as long as you have admin permissions on the account." }, "removeButton": "Remove", "cancelButton": "Cancel" }, "managePagesModal": { "FACEBOOK": { "header": "Manage pages for lead syncing", "text": "Choose the pages you'd like to sync. To make sure HubSpot can sync leads for these pages, please check you have the right permissions in Facebook. You’re the only person that will see these pages.", "missingPermissions": { "title": "Heads up", "message": "You'll need to update your permissions in Facebook to create lead generation ads and sync leads." } }, "LINKEDIN": { "header": "Manage LinkedIn lead syncing", "text": "Select the ad accounts you would like to sync leads from." }, "save": "Save", "cancel": "Cancel", "selectAll": "Select all", "updatePermissions": "Update permissions" }, "disconnectAccount": { "headerMultiple": { "FACEBOOK": "Disconnect {{count}} Facebook accounts?", "LINKEDIN": "Disconnect {{count}} LinkedIn accounts?" }, "header": { "FACEBOOK": "Disconnect Facebook ad account {{accountName}}?", "LINKEDIN": "Disconnect LinkedIn ad account {{accountName}}?", "ADWORDS": "Disconnect Google Ads account {{accountName}}?" }, "reportOrManage": "You won't be able to report or manage your ad campaigns from HubSpot. All ads related events on existing contacts will stay in HubSpot.", "trackingParameters": "Tracking parameters won't be removed from your ads, you will need to remove these manually.", "messagePixel": "Your pixel will be removed from your website.", "audiences": "Contact list audiences will no longer sync to {{network}}. You will still be able to target ads at this audience but the audience will no longer update. Syncing will start back up if you reconnect this ad account." }, "adwords": { "connectButton": "Connect", "cancelButton": "Cancel" } }, "leadSyncing": { "networkSelect": { "disabled": { "LINKEDIN": "Please connect a LinkedIn account.", "FACEBOOK": "Please connect a Facebook account." } }, "connectButton": { "disabled": "Only users who have connected a Facebook or LinkedIn ad account can manage pages." }, "emptyState": { "title": "Sync your leads from Facebook and LinkedIn lead generation ads into HubSpot.", "description": "Connect your Facebook or LinkedIn ad accounts to start syncing leads." }, "noChosenPages": { "title": "Automatically sync all your new contacts from lead ads.", "description": "When you turn on lead syncing for a page or ad account, your new contacts from the last 90 days will be synced to your HubSpot contacts." }, "emailLessFormSubmissions": { "titleText": "Allow submissions without email addresses to create contacts", "message": "By default, form submissions that don't include an email field won't create contacts. Turn this on if you'd like these submissions to create contacts.", "warning": "One or more of your lead ad forms doesn't have an email field. By default, form submissions that don't include an email field won't create contacts. If you'd like these submissions to create contacts, turn this setting on below." }, "pagePermission": { "FACEBOOK": { "message": "It appears you do not have the correct permissions to sync leads from this page." }, "LINKEDIN": { "message": "Your LinkedIn user needs Designated Admin or Lead Gen Forms Manager permission to the page associated with this ad account in order to be able to sync leads." } } }, "pixels": { "failedToLoad": "Sorry. There was a problem loading your pixels. It might be due to a change in permissions.", "noPixelInstalled": { "header": "Track visitors to your website", "description": "Add a pixel to your website to track your visitors and then re-engage them with relevant ads, wherever they are online. Your pixel will be added to your website automatically using your HubSpot tracking code." }, "sectionHeader": "Pixels", "sectionDescription": "Add a pixel to your website to track your visitors and show them targeted ads. Your pixel will be added to your website automatically using your HubSpot tracking code. Remember to remove any existing pixel installations on your website to avoid double counting.", "modalDescription": "Add a Facebook pixel to your website to track your website visitors and show them targeting ads on Facebook and Instagram. Your pixel will be added to your website automatically using your HubSpot tracking code.", "installPixelDropdownPlaceholder": "Select a pixel", "addPixelModalHeader": "Add pixel", "addPixelModalDescription": "You'll be able to re-engage with people who have visited your website and are aware of your company, whenever they're online. The pixel will be automatically added to all your HubSpot website pages.", "addPixelModalFormLabel": "Pixel", "modalSections": { "facebookPixel": "Facebook pixel", "privacyPolicy": "Privacy policy" }, "privacyPolicy": { "message": "Notify your visitors that you're using cookies. {{link}}", "link": "Go to settings", "tooltip": "When asking visitors for consent, the pixel will not work until consent is given." }, "addPixelButtonDisabledTooltip": "Only one Facebook pixel can be installed at a time.", "disabledPixelTooltip": "You can only add one pixel per network.", "addPixelButton": "Add pixel", "removeButton": "Remove", "selectPixelPlaceholder": "Select a pixel", "tableHeader": { "name": "Pixel name", "account": "Ad account", "dateAdded": "Date added" }, "emptyState": { "title": "See who's coming to your website.", "description": "Connect an ad account to manage pixel settings" }, "facebookDefaultName": "{{accountName}}'s pixel", "removePixelModal": { "normalPrompt": "Remove pixel {{pixelName}}?", "noPixelNamePrompt": "Remove pixel associated with account {{accountName}}?", "removalWarning": "The pixel will be removed from all pages that have the HubSpot tracking code installed.", "audienceWarning": "Any website audiences created using this pixel will no longer populate with visitor data.", "cancelButton": "Cancel" }, "inaccessible": { "status": "Permission needed", "tooltip": "The ad account \"{{accountName}}\" no longer has access to this pixel. It could be due to a change in permissions. Go to {{adNetwork}} to update permissions or remove this pixel and install a new one." } }, "roiCalculation": { "sectionHeader": "Measuring your ads return on investment will help you determine whether the money you're spending on ads is profitable.", "how": { "label": "How is ROI calculated?", "formula": "((Revenue - Amount spent) / Amount spent) * 100%" }, "sectionPrompt": "Select how you would like to calculate the revenue for ROI.", "useCRMDealsOption": "Revenue from your deals", "useEstimateROIOption": "Estimate revenue", "dealsRevenueTooltip": "Use the closed won deal revenue associated with the contacts that convert on your ads.", "estimateROITooltip": "Use your average sale price and how likely your contacts are to become customers.", "noRoiChangePermissions": "You need ads publishing permission to change ROI settings.", "estimateROI": { "averageSalePriceLabel": "Average sale price", "averageSalePriceTooltip": "The average value of a single customer.", "leadToCustomerRateLabel": "Contact to customer rate", "leadToCustomerRateTooltip": "The percentage of your contacts that become customers.<br><br>Number of customers / Number of contacts * 100", "leadToCustomerRateDecimalError": "Fractional percentages are not supported.", "example": "Example: If 100 contacts interacted with your ads, it would be estimated that {{newContacts}} ({{leadCloseRatePercent}}) contacts would become customers for a total estimated revenue of {{totalRevenue}} ({{avgSalePrice}} each)." } } }, "blog": { "emptyState": { "body": "Once you add a blog, you can come back to your blog settings to set up your meta description, template, subscriptions, and more.", "title": "Your blog settings will appear here.", "ctaCopy_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
createElement( options,
"CreateLink",
{ onClick: props.onClickCreateBlog, use: "link" },
"Create a new blog" ),
" or ",
createElement( options,
"ImportLink",
{ href: props.importHref },
"import your existing blog" ),
" to get started." ); } }, "notifications": { "createSuccess": "Your blog was created.", "saveSuccess": "Your blog was updated.", "deleteSuccess": "Your blog was deleted.", "notificationEmailsUpdateSuccess": "The notification emails for your blog were updated.", "notificationEmailsUpdateFailureGeneric": "Sorry. The notification emails for your blog could not be updated. Please try again later or contact support.", "notificationEmailsCreateFailureGeneric": "There was a problem creating this email. Please try again in a few minutes.", "notificationEmailsUpdateFailureCompleteSetup": "Please complete the setup of your email notifications for the chosen frequency. Click 'Edit' to go to the email editor and publish your email for that frequency.", "customDateTimeFormatCreateSuccess": "Custom date format created.", "customDateTimeFormatCreateFailureGeneric": "Sorry. The custom date format you entered could not be created. Please try again later or contact support." }, "sectionTitles": { "blogPostComments": "Blog Post Comments", "shareButtons": "Social sharing buttons", "autoSharing": "Blog auto publishing", "customDateFormats": "Custom Date Formats", "dateFields": "Date Fields", "timeFields": "Time Fields", "rssFeed": "RSS Feed", "notificationEmails": "Blog subscriber notification emails", "templateForBlog": "Template for blog posts", "cssAndStylesheets": "CSS & Stylesheets", "googleAmp": "Google AMP", "html": "HTML", "listingPage": "Listing page" }, "buttonLabels": { "default": "General", "dateFormats": "Date Formats", "create": "Create", "creating": "Creating...", "deleting": "Deleting...", "createBlog": "Create new blog", "deleteBlog": "Delete blog", "importBlog": "Import blog", "viewBlog": "View blog", "cancel": "Cancel", "general": "General", "language": "Language", "socialSharing": "Social Sharing", "templates": "Templates", "comments": "Comments", "subscriptions": "Subscriptions", "urlRedirects": "URL Redirects", "whatsThis": "What's this?", "customizeFormat": "Customize format", "createDateFormat": "Create date format", "socialSettings": "Social Settings", "twitterCards": "Twitter Cards", "donePreviewing": "Done previewing", "googleAmp": "Google AMP" }, "inputLabels": { "selectDomain": "Select a domain", "modifyBlog": "Modify", "selectBlog": "Select a blog to modify", "blogName": "Blog name", "blogHeader": "Blog header", "blogPageTitle": "Page title", "blogMetaDescription": "Meta description", "blogURL": "Blog URL", "blogRootURL": "Blog root URL", "defaultTwitter": "Default Twitter account", "languageForDates": "Language for dates", "publishDateFormat": "Publish date format", "postsByMonthFormat": "Posts by month format", "shareButtons": "Choose which social sharing buttons to display at the top of your blog posts, so visitors can share your posts with their networks in a single click.", "format": "Format", "autoSharing": "Enable social media auto-publishing", "numPostsInRssFeed": "Number of posts in RSS feed", "showSummariesInRss": "Show summaries in RSS", "showSummariesInEmails": "Show summaries in emails", "enableCommenting": "Enable commenting", "allowCommentsContacts": "Allow comments to create contacts", "moderateComments": "Moderate comments", "closeCommentsDays": "Close comments after this many days", "enableAutoCloseComments": "Automatically close comments", "commentNotifications": "Comment notifications", "selectEmailAddress": "Select an email address", "commentNotificationEmails": "Who should receive notifications of new comments on this blog?", "threadedComments": "Threaded comments (level)", "commentVerificationText": "Comment form verification text", "importExternalBlog": "Import external blog to new blog", "currentTemplate": "Current template", "useSameTemplate": "Use same template for blog listing page", "useCustomTemplate": "Use custom template for blog listing page", "listingTemplate": "Template for listing pages", "postsPerListingPage": "Number of Posts Per Listing Page", "showSummaries": "Show summaries on listing page", "useFeaturedImage": "Use featured image in listing summaries", "enableGoogleAmp": "Enable Google AMP formatted pages", "headerHtml": "Blog listing pages header HTML", "headerHtmlShared": "Use the same header HTML for blog posts", "headerHtmlCustom": "Use custom header HTML for blog posts", "postHeadHtml": "Blog post header HTML", "footerHtml": "Blog listing pages footer HTML", "footerHtmlShared": "Use the same footer HTML for blog posts", "footerHtmlCustom": "Use custom footer HTML for blog posts", "postFooterHtml": "Blog post footer HTML", "templateLayouts": "Template Layouts", "templateFiles": "Template Files", "driftIntegration": "Enable Drift", "audienceAccess": "Control audience access", "registrationRequired": "This is a private blog - registration required", "edit": "Edit", "view": "View" }, "inputDescriptions": { "blogName": "Internal name used for organization", "blogHeader": "Appears at the top of blog pages if the blog templates use \"public title\" in header", "blogPageTitle": "Appears in the browser title bar and in search results", "blogMetaDescription": "Used for the meta description tag in blog listing pages", "blogRootURL": "Changing a live blog URL may break your existing inbound links and hurt your search rankings.", "autoSharing": "Looking for a way to enable social auto-publishing for blog? Go to {{ link }}.", "defaultTwitter": "This account will be used for {{ link }} when content is shared on Twitter", "enableCommenting": "Allow people to comment on your blog posts", "enableGoogleAmp": "Accelerated Mobile Pages (AMP) allows your content to load instantly, which keeps your visitors on your pages and reading more of your content.", "contactsAccess": "<strong>Total contacts with access: {{ count }}</strong>", "sendContactEmails": { "one": "<strong>Saving this setting will send {{ count }} email to register contact</strong>", "other": "<strong>Saving this setting will send {{ count }} emails to register contacts</strong>" }, "alreadyRegisteredContacts": { "one": "{{ count }} contact is already registered and will not receive an email.", "other": "{{ count }} contacts are already registered and will not receive an email." }, "noDomainConnected": "<strong>There is no domain connected. No registration emails will be sent until you connect a domain.</strong>", "noDomainConnectedDescription": "When a domain is connected, all emails inviting contacts to register will be sent automatically.", "audienceAccess": "Control the privacy of this blog and how visitors can access it", "contactLists": "Saving this setting will send a registration email to any contacts on these lists who haven't already registered" }, "tooltips": { "audienceAccess": "Give specific contacts access to this blog using lists. They’ll need to register and sign in with their own email and password to access this page.", "noTemplatesAccess": "You don't have permission to edit templates." }, "placeholders": { "selectLists": "Select Lists" }, "customDateFormats": { "createCustomDate": "Create a custom date format", "invalidValue": "A custom format cannot contain any numbers", "datePreview": "Date preview", "ldml": "Locale Data Markup Language specification", "explanation": "In addition to the built-in date formats provided for your selected language, you may also create completely customized date formats using the {{link}} (LDML), which defines them as follows:", "quoteOne": "A date/time pattern is a string of characters, where specific strings of characters are replaced with date and time data from a calendar when formatting or used to generate data for a calendar when parsing. […]", "quoteTwo": "Characters may be used multiple times. For example, if y is used for the year, yy might produce \"99\", whereas yyyy produces \"1999\". For most numerical fields, the number of characters specifies the field width. For example, if h is the hour, h might produce \"5\", but hh produces \"05\". For some characters, the count specifies whether an abbreviated or full form should be used […]", "quoteThree": "Two single quotes represent a literal single quote, either inside or outside single quotes. Text within single quotes is not interpreted in any way (except for two adjacent single quotes).", "examplesTitle": "Below are some formatting examples for the date February 21, 2017 at 9:30 AM:", "examplesFooter": "The syntax for custom datetime format patterns is described in detail in the {{link}}.", "babelUserGuide": "Babel User Guide", "dateTimeFieldsTitle": "The following tables are a relatively bref overview. (Source {{link}})", "language": "Language", "formatPattern": "Format Pattern", "dateDisplayed": "Date Displayed", "en_us": "English (United States)", "german": "German", "field": "Field", "symbol": "Symbol", "description": "Description", "era": "Era", "eraSymbol": "G", "eraDescription": "Replaced with the era string for the current date. One to three letters for the abbreviated form, four letters for the long form, five for the narrow form.", "year": "Year", "yearSymbolOne": "y", "yearDescriptionOne": "Replaced by the year. Normally the length specifies the padding, but for two letters it also specifies the maximum length.", "yearSymbolTwo": "Y", "yearDescriptionTwo": "Same as y but uses the ISO year-week calendar.", "quarter": "Quarter", "quarterSymbolOne": "Q", "quarterDescriptionOne": "Use one or two for the numerical quarter, three for the abbreviation, or four for the full name.", "quarterSymbolTwo": "q", "quarterDescriptionTwo": "Use one or two for the numerical quarter, three for the abbreviation, or four for the full name.", "month": "Month", "monthSymbolOne": "M", "monthDescriptionOne": "Use one or two for the numerical month, three for the abbreviation, or four for the full name, or five for the narrow name.", "monthSymbolTwo": "L", "monthDescriptionTwo": "Use one or two for the numerical month, three for the abbreviation, or four for the full name, or 5 for the narrow name.", "week": "Week", "weekSymbolOne": "w", "weekDescriptionOne": "Week of year.", "weekSymbolTwo": "W", "weekDescriptionTwo": "Week of month.", "day": "Day", "daySymbolOne": "d", "dayDescriptionOne": "Day of month.", "daySymbolTwo": "D", "dayDescriptionTwo": "Day of year.", "daySymbolThree": "F", "dayDescriptionThree": "Day of week in month.", "weekDay": "Week day", "weekDaySymbolOne": "E", "weekDayDescriptionOne": "Day of week. Use one through three letters for the short day, or four for the full name, or five for the narrow name.", "weekDaySymbolTwo": "e", "weekDayDescriptionTwo": "Local day of week. Same as E except adds a numeric value that will depend on the local starting day of the week, using one or two letters.", "period": "Period", "periodSymbol": "a", "periodDescription": "AM or PM", "hour": "Hour", "hourSymbolOne": "h", "hourDescriptionOne": "Hour [1-12]", "hourSymbolTwo": "H", "hourDescriptionTwo": "Hour [0-23]", "hourSymbolThree": "K", "hourDescriptionThree": "Hour [0-11]", "hourSymbolFour": "k", "hourDescriptionFour": "Hour [1-24]", "minute": "Minute", "minuteSymbol": "m", "minuteDescription": "Use one or two for zero places padding.", "second": "Second", "secondSymbolOne": "s", "secondDescriptionOne": "Use one or two for zero places padding.", "secondSymbolTwo": "S", "secondDescriptionTwo": "Fractional second, rounds to the count of letters.", "secondSymbolThree": "A", "secondDescriptionThree": "Milliseconds in day.", "timezone": "Timezone", "timezoneSymbolOne": "z", "timezoneDescriptionOne": "Use one to three letters for the short timezone or four for the full name.", "timezoneSymbolTwo": "Z", "timezoneDescriptionTwo": "Use one to three letters for RFC 822, four letters for GMT format.", "timezoneSymbolThree": "v", "timezoneDescriptionThree": "Use one letter for short wall (generic) time, four for long wall time.", "timezoneSymbolFour": "V", "timezoneDescriptionFour": "Same as z, except that timezone abbreviations should be used regardless of whether they are in common use by the locale." }, "socialSharing": { "twitter": "Twitter", "linkedin": "Linkedin", "facebook": "Facebook" }, "subscriptions": { "toggleText": "Allow people to subscribe to notification emails about when your content is updated.", "toggleTitle": "Enable blog subscriber notification emails", "frequency": "Frequency", "replyToAddress": "Reply to address", "emailStatus": "Email Status", "emailLink": "Email Link", "send": "send", "create": "create", "edit": "edit", "instantNotifications": "Instant notifications", "dailyNotifications": "Daily notifications", "weeklyNotifications": "Weekly notifications", "monthlyNotifications": "Monthly notifications", "notSet": "(No Reply To Address Set)", "notCreated": "Not created", "incomplete": "Incomplete", "completed": "Completed" }, "deleteBlog": { "title": "Delete the blog {{blogName}}?", "message": "Deleting this blog and all its data cannot be undone, so we want to make sure.", "typeNameOfBlog": "Type the name of your blog below to delete it.", "alsoDelete": "Also permanently delete the following", "blogSubscriptionForm": "Blog subscription form", "blogSubscriberNotificationEmails": "Blog subscriber notification emails", "blogSubscriptionEmailLists": "Blog subscription email lists", "blogSubscriptionContactProperty": "Blog subscription contact property", "blogSubscriptionEmailType": "Blog subscription type", "yesDelete": "Yes, delete" }, "amp": { "alt": "Image ALT text", "width": "Width", "height": "Height", "header": "Header", "headerFont": "Header Font", "headerFontSize": "Header Font Size (px)", "headerFontColor": "Header Font Color", "headerBackgroundColor": "Header Background Color", "body": "Body", "bodyFont": "Body Font", "bodyFontSize": "Body Font Size (px)", "bodyFontColor": "Body Font Color", "linkColor": "Link Color", "logo": "Logo", "updatedGoogleAMP": "Updated Google AMP Format" }, "validation": { "ampLogoWidth": "Exceeds max width of {{maxWidth}}px", "ampLogoHeight": "Exceeds max height of {{maxHeight}}px" }, "stagedChange": "You've changed 1 blog setting.", "stagedChanges": "You've changed {{numberOfStagedChanges}} blog settings.", "stagedChangeAMPPreview": "You've changed 1 blog setting. You will be able to preview your Google AMP changes after saving.", "stagedChangesAMPPreview": "You've changed {{numberOfStagedChanges}} blog settings. You will be able to preview your Google AMP changes after saving.", "invalidStagedChanges": "There are invalid changes to your blog settings.", "enableCorgiMode": "ENABLE CORGI MODE", "corgiMessage": { "title": "Welcome to corgi mode", "text": "To return to normal, refresh the page." }, "errors": { "create": { "default": { "message": "There was a problem creating this blog. Please try again in a few minutes." }, "BLOG_URL_EXISTS": { "default": { "message": "A blog with that root URL already exists in this account. Please use a different root URL." } }, "BLOG_NAME_MISSING": { "default": { "message": "Blog name is required." } }, "BLOG_NAME_EXISTS": { "default": { "message": "A blog named \"{{name}}\" already exists in this account." } }, "BLOG_NAME_TOO_LONG": { "default": { "message": "A blog name can’t be longer than {{maxNameLength}} characters." } }, "BLOG_SLUG_TOO_LONG": { "default": { "message": "The ending of a blog root URL can’t be longer than {{maxSlugLength}} characters." } }, "BLOG_NAME_NO_HTML": { "default": { "message": "Blog names can’t contain HTML tags." } }, "BLOG_DOMAINS_ENTERPRISE_ONLY": { "default": { "message": "This account does not have permission to set a custom blog domain" } }, "REDIRECT_EXISTS": { "default": { "message": "A URL mapping is currently redirecting {{REDIRECT_SOURCE}} to {{REDIRECT_DESTINATION}}. Consider <a href='{{URL_MAPPING_EDIT_URL}}' target='_blank'>editing</a> this URL mapping to make it more targeted, or setting it to be ignored if a page exists at the requested URL." } } }, "update": { "default": { "message": "There was a problem updating this blog. Please try again in a few minutes." }, "BLOG_URL_EXISTS": { "default": { "message": "A blog with that root URL already exists in this account. Please use a different root URL." } }, "BLOG_NAME_MISSING": { "default": { "message": "Blog name is required." } }, "BLOG_NAME_EXISTS": { "default": { "message": "A blog named \"{{name}}\" already exists in this account." } }, "BLOG_NAME_TOO_LONG": { "default": { "message": "A blog name can’t be longer than {{maxNameLength}} characters." } }, "BLOG_SLUG_TOO_LONG": { "default": { "message": "The ending of a blog root URL can’t be longer than {{maxSlugLength}} characters." } }, "BLOG_NAME_NO_HTML": { "default": { "message": "Blog names can’t contain HTML tags." } }, "POSTS_PER_FEED_OUT_OF_RANGE": { "default": { "message": "The number of posts in an RSS feed must be between {{minPosts}} and {{maxPosts}} posts." } }, "POSTS_PER_LISTING_PAGE_OUT_OF_RANGE": { "default": { "message": "The number of posts in a page must be between {{minPosts}} and {{maxPosts}}." } }, "BLOG_MISSING_ITEM_TEMPLATE": { "default": { "message": "A post template is required." } }, "BLOG_MISSING_LISTING_TEMPLATE": { "default": { "message": "A listing template is required." } }, "BLOG_DOMAINS_ENTERPRISE_ONLY": { "default": { "message": "Choosing a different blog domain isn’t available in your account." } }, "REDIRECT_EXISTS": { "default": { "message": "A URL mapping is currently redirecting {{REDIRECT_SOURCE}} to {{REDIRECT_DESTINATION}}. Consider <a href='{{URL_MAPPING_EDIT_URL}}' target='_blank'>editing</a> this URL mapping to make it more targeted, or setting it to be ignored if a page exists at the requested URL." } }, "CONTENT_GROUP_URL_CHANGE_CONFLICT": { "default": { "message": "Your root URL can't be updated because <a href='{{contentUrl}}' target='_blank'>{{contentName}}</a> and <a href='{{conflictContentUrl}}' target='_blank'>{{conflictContentName}}</a> would both have the same URL. Please change the URL of one of these pages and try again." } }, "FAILED_TO_UPDATE_SLUGS_WITH_NEW_ROOT_DATA_TRUNCATED": { "default": { "message": "Failed to update blog. There was a problem syncing the blog posts with the new blog root. Update would cause a blog post slug to exceed maximum characters of {{maxSlugLength}}" } }, "PAGE_EXISTS": { "default": { "message": "A page already exists at <a target='_blank' href='{{ PAGE_URL }}'>{{ PAGE_URL }}</a>. Please use a different root URL." } }, "BLOG_URL_MAPPING_NOT_CREATED": { "default": { "message": "Your root URL can't be updated because a URL redirect could not be created. Please try again in a few minutes, and contact support if it keeps happening." } } }, "delete": { "default": { "message": "There was a problem deleting this blog. Please try again in a few minutes." } } } }, "shared": { "buttonLabels": { "upload": "Upload", "browseImages": "Browse images" } }, "collectedForms": { "toggle": { "learnMore": "Learn More", "description": "Turn automatic collection of form data from non-HubSpot forms on and off here. No data is saved while the option is turned off. {{learnMoreLink}}", "title": "Collect data from website forms" }, "notificationEmails": { "description": "Send email notifications for collected forms submissions to:", "placeholder": "Enter an email" }, "confirmation": { "cancel": "No, keep collecting data", "confirm": "Yes, disable it", "description": "Your existing contacts will not be deleted. Once disabled, we will stop collecting new submissions on your website forms.", "title": "Are you sure you want to disable collected forms?" }, "pageTitle": "Non-HubSpot Forms" }, "forms": { "tabs": { "submissionsSettings": "Submissions Settings", "styles": "Styles", "nonHubspot": "Non-HubSpot Forms" }, "styles": { "preview": { "title": "Preview", "subHeading": "This preview will update based on the colors and fonts you choose.", "email": "Email", "firstName": "First name", "city": "City" }, "form": { "alignment": { "left": "Left", "center": "Center", "right": "Right" }, "heading": "All forms", "textSection": { "heading": "Text", "formFont": "Font family", "color": "Label color", "size": "Size" }, "buttonSection": { "heading": "Button", "color": "Color", "alignment": "Alignment", "fontColor": "Color", "newFontColor": "Font color" }, "reset": "Reset all styles" }, "subHeading_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Update the colors and fonts for HubSpot forms that you’ve embedded on external websites. These settings won't affect your pop-up forms or non-HubSpot forms that are sending data to HubSpot. ",
createElement( options,
"UILink",
{ external: true, href: props.learnMoreLink },
"Learn more" ) ); }, "fontFamily": "Form font", "fontColor": "Form font color", "buttonFontColor": "Button font color", "buttonBackgroundColor": "Button background color" }, "toggle": { "description": "By default, form submissions that don't include an email field won't create contacts. Turn this on if you'd like these submissions to create contacts.", "title": "Allow submissions without email addresses to create contacts" }, "pageTitle": "Forms" }, "email": { "pageTitle": "Email", "tabs": { "configuration": "Configuration", "doubleOptIn": "Double opt-in", "preferencesCenter": "Preferences Center", "smtp": "SMTP", "subscriptions": "Subscriptions", "tracking": "Tracking", "types": "Subscription Types", "frequency": "Send Frequency" }, "doi": { "overlay": { "text": "Enable double opt-in to edit the settings" }, "reminder": { "title": "What is a double opt-in email?", "text": "Allow your contacts to confirm that they want to receive emails from you. Your contacts will receive a double opt-in email with a link to confirm their subscription after they fill out any form on your website." }, "savingError": { "title": "Could not save double opt in information.", "text": "Sorry, your double opt in information wasn't saved. Please try again." }, "sender": { "email": "Sender", "error": { "userDeleted": "Looks like the previous user was deleted. Please choose a new user." }, "settingsLink": "Settings area", "senderDetailsSettingsLinkText": "To add new sender details, create a user in your {{settingsLink}}.", "senderDetailsPlaceholder": "Please select a sender" }, "tab": { "tooltip": "You'll need to setup email footer before you can view or edit your double opt-in email options." }, "languageSelector": { "title": "Double opt-in email language " }, "preview": { "title": "Double opt-in email preview" }, "upgrade": { "turnOff": { "button": "Send double opt-in email", "title": "Have more control over your opt-in process", "body": "Upgrade to Marketing Starter to turn off double opt-in and manage your opt-ins based on how you do business." }, "edit": { "button": "Edit", "title": "Customize your double opt-in email", "body": "Upgrade to Marketing Professional to edit your double opt-in email based on your brand and audience." } }, "subjectLine": { "label": "Subject line", "text": "Please confirm your subscription" }, "save": "Save", "types": "Subscription Types" }, "sections": { "color": "Color", "font": "Font", "fontNote": "Only applies to default email templates and custom coded templates.", "footer": "Footer", "size": "Size", "smtpTokens": "SMTP Tokens", "defaultPropertyValues": "Default values for email personalization", "subscriptionSettings": "Subscription Settings" }, "notifications": { "disableBccEmailFailure": "Sorry. Your compliance copy email setting couldn't be disabled right now. Please try again later or contact support.", "disableBccEmailSuccess": "Your compliance copy email setting was successfully disabled.", "resendBccEmailFailure": "A confirmation email couldn't be sent right now. Please try again later or contact support.", "resendBccEmailFailureMxForbidden": "BCC is not supported for emails with the domain {{domain}} hosted by {{mxGroup}}", "resendBccEmailSuccess": "A confirmation email was successfully re-sent. Please check the email's inbox shortly.", "sendBccEmailFailure": "A confirmation email couldn't be sent right now. Please try again later or contact support.", "sendBccEmailFailureMxForbidden": "BCC is not supported for emails with the domain {{domain}} hosted by {{mxGroup}}", "sendBccEmailSuccess": "A confirmation email was successfully sent. Please check the email's inbox shortly." }, "errors": { "doiConfirmationPageBlockingSave": "Please select a double opt-in confirmation page." }, "stagedChanges": { "one": "You've changed 1 email setting.", "other": "You've changed {{count}} email settings." }, "modals": { "createFooter": "Add an email footer", "createSmtpToken": "Generate a transactional token", "createdSmtpToken": "Generated token \"{{smtpTokenName}}\"", "createType": "Create subscription type", "deleteFooter": "Delete \"{{footerName}}\"?", "deleteFooterDescription": "This action can't be reverted.", "deleteSubscriptionDefinition": "Delete \"{{name}}\"?", "deleteSubscriptionDefinitionDescription": "This action can't be reverted.", "deleteSmtpToken": "Deleting token \"{{smtpTokenName}}\"", "deleteSmtpTokenDescription": "This action can't be reverted.", "unsavedChanges": "Are you sure?", "unsavedChangesDescription": "You will lose any unsaved addresses or subscription types.", "makeFooterDefault": "Making footer \"{{footerName}}\" the default", "resetSmtpTokenPassword": "Reset your token password", "resetSmtpTokenPasswordSucess": "Reset password for \"{{smtpTokenName}}\"", "updateFooter": "Edit email footer", "updateType": "Edit subscription type", "confirmBccDisableTitle": "Turn off compliance copy email?", "confirmBccDisableDescription": "The email address you entered will no longer receive copies of the emails you send.", "confirmBccDisableButton": "Turn off", "duplicateSubscriptionNameError": "This subscription name already exists.", "duplicateSubscriptionLanguageError": "This translation already exists.", "subscriptionArchiving": { "header": "Archive \"{{subscriptionName}}\"?", "description": "The subscription type \"{{subscriptionName}}\" is still used in the following emails:", "info": "This subscription will be moved to the archived filter.  You can always unarchive it later.", "confirmation": "I have reviewed these dependencies and am ready to archive", "button": "Continue" } }, "buttonLabels": { "actions": "Actions", "create": "Create", "createPending": "Creating...", "createSmtpToken": "Generate token", "createType": "Create subscription type", "cancel": "Cancel", "confirm": "Confirm", "delete": "Delete", "edit": "Edit", "finish": "Finish", "finishPending": "Finishing...", "generateToken": "Generate token", "generateTokenPending": "Generating token...", "makeDefault": "Make default", "noLabel": "No", "ok": "Ok", "resetPassword": "Reset password", "resetPasswordPending": "Resetting password...", "save": "Save", "savePending": "Saving...", "viewDetails": "View details", "yesLabel": "Yes" }, "inputLabels": { "addTranslationLink": "+ Add a translation", "addTranslationLabel": "Add a translation", "advanced": "Advanced", "back": "Back", "backgroundColor": "Background color", "bodyColor": "Body color", "bodyPadding": "Email body padding", "bodyWidth": "Email body width", "borderColor": "Border color", "borderColorOptions": "Border color options", "categorizeTooltip": "These fields aren’t required, but they're helpful if you're complying with certain data privacy laws.", "companyAddressLine1": "Address", "companyAddressLine2": "Address line 2", "companyCity": "City", "companyCountry": "Country", "companyName": "Company name", "companyPhoneNumber": "Phone number", "companyState": "State", "companyZipCode": "Zip code", "details": "Details", "default": "Default", "filterBy": "Filter by:", "footerName": "Office location name", "language": "Language", "operation": "Method of communication", "operationHelp": "The method or technology used to contact people.", "optional": "optional", "primaryAccentColor": "Primary accent color", "primaryFont": "Primary font", "primaryFontColor": "Primary font color", "primaryFontSize": "Primary font size", "preview": "Preview", "previewDetails": "This is the text your customers see on the communication preferences page", "process": "Purpose of subscription", "processHelp": "The purpose of this subscription or the department in your organization that uses it.", "secondaryAccentColor": "Secondary accent color", "secondaryFont": "Secondary font", "secondaryFontColor": "Secondary font color", "secondaryFontSize": "Secondary font size", "smtpTokenName": "Name", "smtpTokenCreateContact": "Automatically create contacts for recipients of email", "smtpPassword": "Password", "smtpPasswordWarning": "The token password can't be retrieved in the future for security reasons. Keep it somewhere safe for future use. You can also reset it later.", "smtpUsername": "Username", "typeActive": "Active", "typeDescription": "Description", "typeName": "Subscription name" }, "tableHeaders": { "createContact": "Create contact", "createdBy": "Created by", "dateCreated": "Date created", "name": "Name", "description": "Description", "tokenName": "Token name", "status": "Status", "username": "Username", "category": "Process", "channel": "Operation", "languages": "Language(s)" }, "tagLabels": { "active": "Active", "inactive": "Inactive" }, "typeFilterOptions": { "active": "Active", "all": "All", "archived": "Archived" }, "languageFilter": { "label": "Filter by language", "default": "Default" }, "borderColorOptions": { "automatic": "Set email body border color automatically", "manual": "Manually set email body color", "none": "Do not add a border around the email body" }, "footerCards": { "add": "Add a footer", "default": "default", "viewAll": "View all ({{footerCount}})", "viewLess": "View less" }, "smtp": { "learnMore": { "button": "Learn more", "description": "Send automated commerce receipts, account updates, and system messages with full engagement tracking across all of your emails.", "title": "Transactional Email add-on" }, "notice": "Transactional emails are for things like an account update, receipt, or one-time individual notification.", "noticeMore": "Please consider using another subscription type for everything else so that your recipients have the ability to manage their subscription preferences. <a target=\"_blank\" href=\"http://knowledge.hubspot.com/articles/KCS_Article/Email/How-to-use-Transactional-Email-in-HubSpot\">Learn more</a>", "noticeTitle": "Important", "resetPasswordWarning": "Resetting your token password will prevent any system using the current password from sending email.", "resetPasswordWarningTitle": "Important" }, "subscriptions": { "defaultSubsHelp": "HubSpot default subscription type", "internalTooltip": "This subscription is used by a HubSpot feature. If you deactivate it, it may be reactivated by the feature.", "SubscriptionDefinitionErrors": { "NAME_TOO_LONG": "Subscription names must be 300 characters or less", "DESCRIPTION_TOO_LONG": "Subscription descriptions must be 1500 characters or less", "PROCESS_TOO_LONG": "Subscription processes must be 100 characters or less", "OPERATION_TOO_LONG": "Subscription operations must be 100 characters or less", "TOO_MANY_SUBSCRIPTIONS": "Portals may only have {{ maxSubs }} subscription types.  You have {{ numSubs }} subscription types", "NAME_ALREADY_TAKEN": "There is already an active subscription named \"{{ subName }}\"", "RESERVED_NAME": "\"{{ subName }}\" is a name reserved for a HubSpot internal subscription.  Please choose a different name." }, "editEmail": "Edit email", "publishEmail": "Create email", "asyncSelect": { "loading": "Loading...", "search": "Search" }, "bcc": { "description": "Automatically BCC all outgoing messages where they can be reviewed for compliance later.", "modal": { "cancel": "Cancel", "email": "Recipient email", "notice": "Enabling this will result in copies of every single email sent from this portal getting copied to the designated email address. This might cause problems if you have load limits for your email service, or if the person who owns this inbox doesn't need or want to receive these emails.", "noticeTitle": "Please use this feature with care.", "save": "Save", "saving": "Saving...", "title": "Enable compliance copy email" }, "pending": "Pending Confirmation", "recipientLink": "Edit recipient", "resendLink": "Resend confirmation", "title": "Compliance copy email", "confirmationTo": "Confirmation email sent to <b>{{requestedEmail}}</b>.", "enabledOn": "Enabled on <b>{{requestedEmail}}</b>." }, "doi": { "confirmationPage": { "create": "Create a new page", "title": "Confirmation page" }, "enabledFor": { "title": "Enable options", "pagesTitle": "Pages" }, "followup": { "title": "Follow-up email", "description": "Send a follow-up email to people who confirm their subscription.", "editEmail": "Edit follow-up email", "publishEmail": "Publish follow-up email", "unpublishedEmail": "Publish a follow-up email to enable this feature.", "label": "Include follow-up email" }, "title": "Double opt-in", "toggle": { "description": "Set up an opt-in request email, confirmation page, and, optionally, a follow-up email.", "editEmail": "Edit opt-in email", "publishEmail": "Publish opt-in email", "unpublishedEmail": "Publish an opt-in email to enable this feature.", "title": "Enable double opt-in" } }, "graymail": { "description": "Improve your email sending quality and score.", "title": "Don't send to unengaged contacts" }, "pages": { "intro": "Subscription page preference pages are styled with the default style.", "confirmation": { "help": "Select a template to use on pages that visitors are taken to after setting their preferences", "text": "Subscription update confirmation page" }, "preference": { "help": "Select a template to use on your main subscription preference page", "text": "Subscription preferences page" }, "unsubscribe": { "help": "Select a template to use when the identity of your visitor is unknown", "text": "Unsubscribe backup page" }, "viewTemplateLink": "Edit Page" }, "resubscription": { "description": "Let unsubscribed contacts know how they can opt themselves back into your emails.", "editEmail": "Edit email", "publishEmail": "Publish email", "title": "Resubscription email", "unpublishedEmail": "Publish a resubscription email to enable this feature." }, "unsubscribeSurvey": { "title": "Unsubscribe Surveys", "description": "This adds a question to your unsubscribe page to ask people why they unsubscribed." }, "rss": { "format": { "title": "RSS feed date format" }, "language": { "title": "Language for dates" }, "title": "RSS email date formats" }, "groups": { "title": "Preference groups", "blurb": "Create a group and make managing your marketing emails simple. Assign addresses, subscription types, and subscription pages to teams, and add translations from one place.", "subscriptionTypes": "Subscription types ({{count}})", "addresses": "Addresses ({{count}})", "preview": "Preview", "edit": "Edit", "add": "Add", "move": "Move", "archive": "Archive", "unarchive": "Unarchive", "delete": "Delete", "makeDefault": "Make default", "actions": "Actions", "default": "Default", "disabledTooltip": "A minimum of one group is required", "alreadyDefaultTooltip": "This is already the default address for this group.", "addGroup": "Add group", "editGroup": "Edit group: {{groupName}}", "settings": "Settings", "assets": "Assets", "groupName": "Group name", "groupNameAlreadyExists": "It looks like a group with this name already exists.", "brandDomain": "Brand domain", "subscriptionTypesTitle": "Subscription types", "numberSelected": "{{total}} selected", "addressesTitle": "Addresses", "brandDomainAlreadyAssigned": "Using the same brand domain for multiple groups means that people who unsubscribe from one group will be unsubscribed from everything under this brand domain.", "brandDomainsInfo": "Set a brand domain so users can unsubscribe from that brand. If you don't set a brand domain, contacts who unsubscribe from one brand, will be opted out of all your subscription emails.", "addressesBlurb": "Add the company addresses associated with this group. When you create a marketing email, you can choose an address from the ones added here, and this will be used in your email footer.", "archiveGroup": "Archive {{groupName}}?", "archiveGroupBlurb": "By archiving this group, you'll no longer be able to use the following:", "confirmArchive": "Archive group", "addAddress": "Add address", "addSubscriptionType": "Add subscription type", "noSubscriptionTypes": "No subscription types", "noAddresses": "No addresses", "noGroups": "No groups", "cancel": "Cancel", "moveToGroup": "Move to another group", "selectGroup": "Select a destination group", "confirmMove": "Move", "defaultSubscriptionTypes": { "title": "Default subscription types ({{number}})", "helpText": "These subscription types are automatically created for your portal and tied to tools inside HubSpot.", "subscriptionTypes": "Subscription types", "modal": { "title": "Default subscription types", "done": "Done" } } } }, "unauthorized": { "title": "This area is private.", "description": "Sorry. The email settings are restricted to those with permissions to Marketing Email.", "nextStep": "Please contact your administrator about changing your role.", "link": "Back to settings home" }, "tracking": { "intro": "Measure the performance of your email sends using HubSpot tracking. You can turn off link tracking in your emails, but this will affect the accuracy of your data.", "click": { "description": "Track how many times each link in your email is clicked. You can choose to track links in HTML, plain text emails, or both. If you turn this setting off, you will no longer be able to track clicks on links in your emails.", "title": "Track clicks", "html": "Track clicks in HTML emails:", "plainText": "Track clicks in plain text emails:", "disabled": "You need to turn on tracking opens to turn on this feature." }, "domain": { "currentDomain": "Current domain", "description": "Links in your email are customized to reference your HubSpot domain. This improves your sender reputation and deliverability results.", "manageDomainsLink": "Manage domains", "noCurrentDomain": "No email domain configured", "title": "Click tracking domain" }, "identity": { "description": "Identity tracking recognizes contacts that have visited your site before and can track their pages views and site activity. If you turn this off, you won't be able to associate the activity with your contacts.", "title": "Identity tracking" }, "anonymization": { "description": "Find out how many recipients open your emails by tracking email opens. If you turn this settings off, you won't be able to see how many people opened your email or be able to track clicks in your email.", "title": "Track email opens" }, "source": { "descriptionOne": "Source tracking identifies the origin of traffic to your website by adding tags to your email links to ensure proper source attribution.", "descriptionTwo": "Use HubSpot's default source tracking to find out where your web traffic is coming from.", "radioSetting": { "addIfMissing": { "description": "HubSpot will add default tracking tags to URLs that do not include any existing UTM tags. If a URL has UTM tags, it will not be rewritten.", "text": "Add source tracking only if no existing tags in URL" }, "disabled": { "description": "No source tracking tags will be added to your URLs.", "text": "Don't add source tracking tags" }, "overwrite": { "description": "All source tracking will default to HubSpot tags. This will overwrite any existing tracking you've added.", "text": "Add source tracking tags to all URLs" } }, "title": "Source tracking", "warning": "If you don't include source tracking tags from HubSpot or if you add your own tracking tags, the sources may not accurately show where your traffic is coming from." } }, "frequency": { "instructions": "Sometimes less is more. Set a send frequency cap to make sure you don't over-email your contacts. If customers receive too many emails, they’re less likely to engage with your campaigns. Control the number of emails your contacts receive by enabling a send frequency cap.", "learnMore": "Learn more", "title": "Send frequency", "radiosLabel": "Frequency", "radios": { "everyEmail": "Recipients receive every email", "someEmail": "Recipients receive a set number of emails", "daily": "Daily", "weekly": "Weekly", "biweekly": "Every two weeks", "monthly": "Monthly" }, "helpLabel": "Only marketing emails are included in the send frequency cap.", "helpText": "Only batch, workflow, RSS, and blog emails are included in the send frequency cap.<br /><br /> Transactional, form follow-up, Service Hub, and sales emails aren't included.", "numberLabel": "Maximum number of emails per recipient", "warning": "If you use workflows to send essential automated emails, you should disable this setting for each of those emails." } }, "espSync": { "apiKeyModal": { "cancelButton": "Cancel", "helpText": "Get your {{ provider }} API key", "inputText": "API key", "title": "Enter API key", "submitButton": "Save" }, "disconnectModal": { "description": "Your contacts will no longer be synchronized with {{ provider }} if you continue.", "message": "Are you sure you want to disconnect from {{ provider }}?" }, "pageTitle": "Email Sync", "providerModal": { "title": "Connect an email provider" }, "setup": { "connectButton": "Connect email provider", "description": "Email sync settings are shared between pop-up forms and non-HubSpot forms.", "title": "Email Sync" }, "status": { "description": "Email sync settings are shared between pop-up forms and non-HubSpot forms.", "misconfigured": { "apiKeyInvalidCredentials": "Your API key is invalid. Please reconfigure your connection.", "apiKeyNoCredentials": "You must supply an API key. Please reconfigure your connection.", "oauthInvalidCredentials": "Your connection isn't working. Please reconfigure it to continue synchronizing contacts.", "oauthNoCredentials": "Your connection isn't working. Please reconfigure it to continue synchronizing contacts.", "other": "Please contact support.", "title": "There's a problem with your connection" }, "setting": { "details": "Connected to <strong>{{ provider }}</strong>", "disconnectButton": "Disconnect", "helpText": "Sync contacts to your {{ provider }} mailing list", "reconfigureButton": "Reconfigure", "title": "Email provider" }, "syncError": { "helpLink": "What does this mean?", "title": "There's an issue synchronizing with {{ provider }}" }, "title": "Email Sync", "mailchimp": { "sync": { "title": "Show Mailchimp email activities on HubSpot contact records", "description_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"See when Mailchimp emails sent, opened, clicked, and bounced on your exisiting HubSpot contact records. ",
createElement( options,
"MailchimpTooltip",
null,
"Learn More" ) ); }, "learnMoreList": { "titleWhat": "What will change in HubSpot?", "titleWhen": "When will changes happen?", "initialSync": "Allow up to 3 hours before seeing Mailchimp activities in HubSpot for the first time.", "dataInterval": "New email activity data will refresh every hour.", "newContacts": "New contacts from Mailchimp won't be automatically created in HubSpot.", "campaignInfo": "See email activity from Mailchimp campaigns sent within the past month." } }, "modal": { "title": "Turn on Mailchimp activities", "description1": "Your Mailchimp account is now connected to HubSpot. Select ‘Push to Mailchimp’ on any of your pop-up and non-HubSpot forms and new visitors who fill out those forms will automatically sync to Mailchimp.", "description2_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Turn on Mailchimp activities to see when emails are sent, opened, clicked, and bounced for your existing HubSpot contacts. ",
createElement( options,
"MailchimpTooltip",
null,
"Learn More" ),
"." ); }, "optin": "Turn on Mailchimp activities", "optout": "Not now" }, "meta": { "failureOn": "There was a problem turning on Mailchimp activities. Please try again.", "failureOff": "There was a problem turning off Mailchimp activities. Please try again." } } } }, "pages": { "modifying": "Choose a domain to edit:", "modifyingWithInheritance": "Choose a domain to edit its settings:", "allDomainsHelp": "These settings are applied to all your domains by default. To change a setting for a single domain, choose that domain above.", "knowledgeBaseSettingsAlert": { "title": "Any changes you make won't be applied to your knowledge base pages" }, "domainSelector": { "allDomains": "All domains", "allDomainsWithInheritance": "Default settings for all domains", "selectDomain": "Select a domain" }, "tooltips": { "disabledAllDomains": "Personalization can't be set per domain. Select \"all domains\" to update these settings.", "noTemplatesAccess": "You don't have permission to edit templates.", "noEmailAccess": "You don't have permission to edit emails.", "disabledForInherit": "This setting is currently based on the default for all domains. To change this setting for just this domain, click the \"override default setting\" link above. To edit the default for all domains, choose \"Default settings for all domains\" at the top of this page." }, "buttonLabels": { "branding": "Branding", "integrations": "Integrations", "personalization": "Personalization", "templates": "Templates", "seoAndCrawlers": "SEO & Crawlers", "sitemaps": "Sitemap", "systemPages": "System Pages", "navigation": "Advanced Menus", "manageDomains": "Manage domains", "editDefaults": "Edit defaults", "save": "Save", "cancel": "Cancel", "add": "Add", "remove": "Remove", "options": "Options", "show": "Show", "hide": "Hide", "applySettings": "Apply default settings", "overrideSettings": "Override default settings", "edit": "Edit", "create": "Create" }, "sectionTitles": { "companyDomain": "Company domain", "websiteImages": "Website Images", "trackingIntegrations": "Tracking integrations", "attachedStylesheets": "CSS & Stylesheets", "defaultPropertyValues": "Default values for page personalization", "setDefaultContactProperties": "Set default values for contact properties", "setDefaultOwnerProperties": "Set default values for owner properties", "setDefaultCompanyProperties": "Set default values for company properties", "jquery": "jQuery", "hsts": "HTTP Strict Transport Security (HSTS)", "hstsTooltip": "To turn on HSTS, please contact <a href=\"https://www.hubspot.com/company/contact\">support</a>.", "fileHostingDomain": "Default File Manager Hosting Domain", "canonicalUrlSettings": "Canonical URLs", "errorPages": "Errors", "passwordPrompt": "Password prompt", "searchResults": "Search results" }, "sectionSubTitles": { "contactPropertyDefaults": "Contact property defaults", "companyPropertyDefaults": "Company property defaults", "ownerPropertyDefaults": "Owner property defaults", "robotsTxt": "Learn more", "canonicalUrlPages": "Pages and blog posts", "canonicalUrlBlogListing": "Blog listing pages" }, "sectionSubTitlesTooltip": { "canonicalUrlPages": "You can edit canonical URLs on individual pages and blog posts" }, "sectionMessages": { "systemPages_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Customize the system pages for your website. ",
createElement( options,
"UILink",
{ external: true, href: props.infoLink },
"Learn more" ) ); } }, "trackingIntegrationsAlert_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"These integrations will only track users who have opted in to allow cookies. ",
createElement( options,
"UILink",
{ external: true, href: props.infoLink },
"Learn more" ) ); }, "inputLabels": { "companyName": "Company Name", "errorPage404": "404 error page", "errorPage500": "500 error page", "passwordPage": "Password prompt page", "searchResultsPage": "Search results page", "searchResultsPageUrl": "Search results page URL", "gaIntegration": "Integrate with Google Analytics", "gaTrackingId": "Enter your Google Analytics tracking ID", "adRollIntegration": "Integrate with AdRoll/RollWorks", "adRollTrackingId": "Enter your AdRoll/RollWorks advertiser ID", "adRollPixelId": "Enter your AdRoll/RollWorks pixel ID", "headerHtml": "Site header HTML", "footerHtml": "Site footer HTML", "logo": "Logo", "logoAlt": "Logo alt text", "logoHeight": "Logo height", "logoUrl": "Logo link", "logoWidth": "Logo width", "pixel": "px", "favicon": "Favicon", "robotsTxt": "Robots.txt", "defaultValue": "Default value", "jqueryMigrate": "Include jQuery migrate script", "jqueryFooterInclude": "Load HubSpot's included jQuery library from your footer", "includeJquery": "Include jQuery", "jqueryVersion": "jQuery version", "setAutoCanonicalUrlPages": "Add self-referencing canonical URLs to all pages and blog posts (Recommended)", "dontSetAutoCanonicalUrlPages": "Don’t add canonical URLs to any pages or blog posts", "setAutoCanonicalUrlBlogListing": "Set each blog listing page’s canonical URL to the first page in its series", "dontSetAutoCanonicalUrlBlogListing": "Don’t add canonical URLs to any blog listing pages (Recommended)", "driftIntegration": "Enable Drift", "hstsDuration": "Duration (max-age)", "hstsEnablePreload": "Enable preload", "hstsIncludeSubdomains": "Include subdomains", "htstsEnableHsts": "Enable HSTS", "ownerPlaceholder": "Select an owner", "inheritLabel": "Use the settings from all domains" }, "inputPlaceholders": { "defaultContactProperties": "Search contact properties", "defaultOwnerProperties": "Search owner properties", "defaultCompanyProperties": "Search company properties", "defaultFileHostingDomain": "HubSpot default CDN domain" }, "noCompanyPropertySearchMatches": "No company properties match your search.", "noContactPropertySearchMatches": "No contact properties match your search.", "inputDescriptions": { "errorPage404": "Show when a user visits an incorrect URL on your site.", "errorPage500": "Show when there is an unexpected server error on your site.", "logo": "Changing logo image here will update all logo modules in the template.", "favicon": "Choose the icon that will appear in the browser tab when people are on your page.", "robotsTxt": "Customize how search engines access your published pages. The same setting will be used across all published pages. ", "headerHtml": "Add custom code snippets to the HTML head section across all of your pages.", "footerHtml": "Add javascript code snippets right before the end of the body tag, across all of your pages.", "jqueryMigrate": "This plugin restores deprecated features and behaviors so that older code will still run properly on jQuery 1.9 and later.", "fileHostingDomain": { "message": "This will be the domain for your files hosted in {{ openLink }} File Manager {{ closeLink }}.", "link": "File Manager" }, "canonicalUrlSettings": "Customize how canonical URLs are automatically set for your pages, blog posts, and blog listing pages." }, "selectInputValues": { "hsts": { "sixWeeks": "6 weeks", "sixMonths": "6 months", "oneYear": "1 year", "twoYears": "2 years" } }, "inputValidationMessages": { "searchResultsPageUrlAllDomains": "Choose a domain at the top of this page." }, "defaultTemplates": { "errorPage404": "Default 404", "errorPage500": "Default 500", "passwordPage": "Default password page", "searchResultsPage": "Default search results", "preference": "Default subscription", "unsubscribe": "Default backup unsubscribe", "confirmation": "Default subscription update confirmation" }, "notifications": { "defaultMessage": { "success": "Success! Your web page settings were saved.", "error": "Something went wrong and your settings weren't saved. Please try again, and contact support if it keeps happening." }, "sitemaps": { "success": "Your changes have been published.", "error": "Your changes have not been updated. Please try again." }, "stylesheetControl": { "defaultMessage": "These attached stylesheets are the default stylesheets for all of your domains." }, "googleAnalytics": { "invalidTrackingCode": "Invalid tracking ID" }, "adRoll": { "invalidAdId": "Invalid advertiser ID", "invalidPixelId": "Invalid pixel ID" }, "slugConflict": { "PAGE_EXISTS": "A page already exists at {{ pageUrl }}.", "BLOG_EXISTS": "A blog already exists at {{ blogUrl }}.", "REDIRECT_EXISTS": "A URL redirect already exists at {{ redirectSource }}.", "RESERVED_NAMESPACE": "URLs that start with \"{{ reservedNamespace }}\" are reserved." }, "landingPages": { "success": "Your page has been updated", "error": "Your page has not been updated. Please try again, and contact support if it keeps happening." } }, "tooltipHeader": { "googleAnalytics": "Google Analytics", "adRoll": "AdRoll", "drift": "Drift" }, "tooltipText": { "gaIntegration": "You can find your Google Analytics tracking ID in your Google Analytics account.", "adRollIntegration": "You can find your AdRoll IDs in your AdRoll account dashboard.", "learnMore": "Learn more", "disabledRobotsTxtInput": "Built-in HubSpot domains are for testing only, and aren't crawled.", "driftIntegration": "You can enable or disable this custom integration. Please contact the makers of Drift for any additional configuration options." }, "invalidDomain": { "firstSentence": "This URL has an invalid domain ID ({{domainId}}).", "secondSentence": "Please select a valid domain." }, "dropdownText": { "folderName": "in {{folderName}}" }, "stagedChange": "You've changed 1 web page setting.", "stagedChanges": "You've changed {{numberOfStagedChanges}} web page settings.", "sitemaps": { "title": "Pages to include in your sitemap", "summary": "Sitemaps are used to manage how your HubSpot-hosted content is shown to search engines. Here's a list of pages included in your site XML file. You can add any page to your sitemap to generate a new sitemap XML file.", "summaryLink": "knowledge page", "domain": "Domain:", "viewXmlFile": "View XML file", "page": "Page", "type": "Type", "priority": "Priority", "changeFrequency": "Change Frequency", "stagedChange": "You've changed 1 setting.", "stagedChanges": "You've changed {{numberOfStagedChanges}} settings.", "addPage": "Add a page", "saveSuccess": null, "addPageModal": { "title": "Add a page", "description": "Choose a page you'd like to add to your sitemap XML file.", "placeholder": "Choose a page" }, "editPageOptionsModal": { "title": "Advanced options", "description": "These options can help search engines understand your pages better.", "frequency": { "label": "Change frequency", "placeholder": "Choose an option", "tooltip": "How often do you update this page? Choose how often search engines should crawl the page." }, "priority": { "label": "Priority", "placeholder": "Set priority", "tooltip": "Decide how important this page is, compared to your other pages. It won't affect how your pages are compared to other sites." } }, "noSitemap": { "title": "Your sitemap will appear here.", "description": "Create a page or blog post to start generating your sitemap." }, "noResults": { "title": "None of your pages or posts match that search.", "description": "Try searching for something else." }, "contentType": { "blog-post": "Blog Post", "landing-page": "Landing Page", "site_page": "Website Page", "knowledge-article": "Knowledge Article", "blog-listing-page": "Blog Listing Page" }, "frequencyOptions": { "always": "Always", "hourly": "Hourly", "daily": "Daily", "weekly": "Weekly", "monthly": "Monthly", "yearly": "Yearly", "never": "Never" }, "unauthorized": { "title": "This area is private.", "description": "Sorry. The Sitemap settings are restricted to those with permissions to Content Settings.", "nextStep": "Please contact your administrator about changing your role.", "link": "Back to settings home" }, "readOnly": { "default": "This page cannot be removed from your sitemap.", "blogListingPage": "Blog listing pages cannot be removed from your sitemap." } } }, "sdk": { "espSync": { "removeLastError": { "failure": "There was a problem dismissing the message from your email service provider. Please try again, or contact support if the problem persists.", "success": "Successfully dismissed the message from your email service provider." }, "update": { "failure": "There was a problem updating your email service provider. Please try again, or contact support if the problem persists.", "success": "Successfully updated your email service provider." } }, "marketingFreeSettings": { "update": { "failure": "There was a problem updating your marketing free settings. Please try again, or contact support if the problem persists.", "success": "Successfully updated your marketing free settings." } }, "formSettings": { "update": { "failure": "There was a problem updating your form settings. Please try again, or contact support if the problem persists.", "success": "Successfully updated your form settings." } } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "de": "static-1.16253",
    "en": "static-1.16253",
    "es": "static-1.16253",
    "fr": "static-1.16253",
    "ja": "static-1.16253",
    "pt-br": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "sales": { "buttons": { "previous": "Previous", "next": "Next", "endTour": "End tour" }, "meetings": { "new": "New", "packages": { "pro": "Pro", "starter": "Starter" }, "header": "Meetings", "tabs": { "INFO": "Preferences", "CALENDAR": "Calendar Integration", "DOMAIN": "Custom Domains" }, "error": { "namespaceCollision": "Another meetings user is using this URL. Please choose another URL.", "namespaceAllNumbers": "A meetings link can't contain only numbers." }, "namespace": { "label": "Meetings URL", "tooltip": "Your new meetings URL will only apply to future meetings and won't affect links created before." }, "defaultLink": { "label": "Default meeting link", "tooltip": "The default meeting link is used for personalization tokens and can't be deleted" }, "disconnect": { "current": "Now connected to {{ integrationType }} account" }, "cancel": { "message": "You've made changes", "description": "Save your work now to keep the changes you've made.", "confirmLabel": "Save", "rejectLabel": "Don't save" }, "freemium": { "defaultNamespace": { "title": "Choose your own URL", "text": "Upgrade to HubSpot Sales {{ priceTier }} to customize the URL associated with your booking page.", "content": { "title": "Customize your booking page URL" } } }, "buttons": { "disconnectCalendar": "Disconnect", "disconnectConfirmText": "If you disconnect your calendar from meetings, your public links for booking meetings will stop working, too. Are you sure you want to remove this integration?", "disconnectConfirm": "Disconnect calendar integration", "confirmLabel": "Disconnect calendar", "rejectLabel": "Cancel" }, "readableGoogle": "Google Calendar", "readableOffice": "Office 365 calendar", "notifications": { "saveSuccess": "Successfully saved meetings settings.", "saveError": "There was a problem saving your settings. Please try again, or contact support if the problem persists.", "integrationError": "There was a problem connecting your account. Please try again, or contact support if the problem persists." }, "authError": { "title": "Sorry. There was an issue connecting to your account.", "content": { "OFFICE365": "Please verify that you have an Office 365 account, and not a hosted exchange account instead. <a href='https://knowledge.hubspot.com/meetings-user-guide/a-quick-tour-of-meetings'>Learn more</a>.", "GOOGLE": "Please try again or contact support.", "DEFAULT": "Please try again or contact support.", "SHARED_INBOX": "This account ({{ emailAddress }}) is already connected to HubSpot as a team inbox, and can't be used for the Meetings tool." } }, "calendarIntegration": { "selectCalendarsHeader": "Use more calendars", "invalidCalendar": "{{ calendarDisplayName }} (Invalid)", "helpText": "{{ numSelected }} of {{ numAvailable }} selected", "missingCalendar": "Don't see your calendar? Your calendar must be tied to the same email address you're using with the meetings tool. {{ learnMore }}", "alertAction": "Learn More" }, "integration": { "title": { "meetings": "Meetings" }, "outroText": { "pro": "Fantastic! Meetings is included with your HubSpot Sales Professional account.", "nonPro": "Meetings is a Sales Professional feature. Before upgrading, check to see if your calendar is compatible." }, "fixIntegrationWarning": { "title": "Your accounts are disconnected.", "body": "Your meetings links won't work until you reconnect at least one calendar.", "action": "Reconnect" }, "newIntegration": { "header": "Book meetings without the hassle", "descriptionParagraphs": { "first": "Stop wasting time with endless \"What time works for you?\" back-and-forth emails.", "second": "Empower prospects and customers to book meetings on your calendar to save you time from sending unnecessary emails.", "third": { "pro": "Activate Meetings inside your HubSpot Sales account by connecting your calendar:" } }, "connectGoogleCalendarCta": "Connect your Google calendar", "connectOffice365CalendarCta": "Connect your Office 365 calendar", "connectExchangeCalendarCta": "Connect your Exchange calendar" }, "fixIntegration": { "header": "Reconnect your calendar", "descriptionParagraphs": { "first": "Don’t let another meeting go unscheduled.", "second": "Reactivate your meetings in your sales account by connecting your calendar:" }, "connectGoogleCalendarCta": "Reconnect your Google calendar", "connectOffice365CalendarCta": "Reconnect your Office 365 calendar", "connectExchangeCalendarCta": "Reconnect your Exchange calendar" }, "imageText": { "first": { "header": "Set your availability", "description": "Choose when prospects, leads, and customers can book time with you." }, "second": { "header": "Share your link", "description": "Say goodbye to endless \"What time works for you?\" email threads." }, "third": { "header": "People book time", "description": "The event is automatically added to your calendar." } }, "items": { "connectCalendar": "Connect your Google calendar", "setAvailability": "Set your availability", "getBooked": "Get meetings booked" }, "pqlCta": "Learn more about Sales Professional", "checkCalendarConnection": "Check calendar compatibility", "redirecting": "Taking you to meetings" }, "customHostedDomain": { "title": "Host meeting links from your own domain", "body": { "description": "Control your branding by using your company's domain in the meeting links you send. Select a custom domain to display meetings links using your own address instead of a HubSpot address.", "note": "<b>Note:</b> Previously sent links are still accessible from their old locations" }, "select": { "title": "Meeting domain", "example": "Example meeting link: {{ link }}", "inactive": "{{ domain }} (inactive)", "default": "{{ domain }} (default)", "custom": "{{ domain }} (custom)", "placeholder": "Select a custom domain", "error": "Sorry. There was an error loading that domain. Please choose an active domain." } } }, "quotas": { "all": "All", "filters": { "pipelines": "Pipeline:", "teams": "Team:" }, "quarterDate": "Q{{ quarter }} {{ year }}", "header": { "title": "Goals", "create": "Create", "createDisabled": "Only super admins can create goals" }, "table": { "deactivatedUser": "This user is no longer active. Delete this row to hide them from reports.", "empty": "No data to show", "basicHeader": "Monthly Goal", "numSelected": "{{ count }} selected", "addOwners": "Add another user", "total": "Total:", "average": "Average:", "owner": "User", "team": "Team", "pipeline": "Pipeline", "unknown": "Unknown" }, "empty": "Get started by creating your first goal", "panel": { "tablePrereqsNotMet": "Select a type and measurement in order to add users.", "ownerAlreadyAdded": "This user cannot be added again for the selected measurement and period.", "owners": "Users", "addQuota": "Create goal", "add": "Add", "cancel": "Cancel" }, "forms": { "applyToRemainderLabel": "apply to remainder", "amountLabel": "goal amount", "selectOwner": "Select a user", "addUser": "Add user", "clearQuota": "Clear goal", "clearLabel": "Clear all goals or this goal only", "clearAll": "Clear this goal and all future goals", "clearOne": "Clear this goal only", "valueInputErr": "Enter a value greater than zero.", "applyToRemainder": "Apply to remainder of year", "selectOwners": { "label": "Select users for this goal", "placeholder": "Search users" }, "period": { "disabled": "Monthly is the only time period currently available.", "label": "Time period", "placeholder": "Select a time period" }, "quotaType": { "label": "Measurement", "placeholder": "Select a measurement" }, "quotaTypeGroup": { "label": "Type of goal", "placeholder": "Select a type of goal", "SALES": "Sales", "SERVICES": "Services" } }, "quotaTypes": { "AVERAGE_NPS": "Average support rep CES", "AVERAGE_TICKET_RESOLUTION_TIME": "Average ticket resolution time", "AVERAGE_TICKET_RESPONSE_TIME": "Average ticket response time", "CALLS_MADE": "Calls made", "DEALS_CREATED": "Deals created", "MEETINGS_BOOKED": "Meetings booked", "REVENUE": "Revenue", "TICKETS_CLOSED": "Tickets closed" }, "units": { "AVERAGE_TICKET_RESOLUTION_TIME": { "one": "day", "other": "days" }, "AVERAGE_TICKET_RESPONSE_TIME": { "one": "hour", "other": "hours" }, "CALLS_MADE": { "one": "call", "other": "calls" }, "DEALS_CREATED": { "one": "deal", "other": "deals" }, "MEETINGS_BOOKED": { "one": "meeting", "other": "meetings" }, "TICKETS_CLOSED": { "one": "ticket", "other": "tickets" } }, "typePlaceholders": { "AVERAGE_NPS": "NPS", "AVERAGE_TICKET_RESOLUTION_TIME": "Number of days", "AVERAGE_TICKET_RESPONSE_TIME": "Number of hours", "CALLS_MADE": "Number of calls", "DEALS_CREATED": "Number of deals", "MEETINGS_BOOKED": "Number of meetings", "TICKETS_CLOSED": "Number of tickets" }, "pipelines": { "all": "All", "newbusiness": "New Business" }, "periods": { "WEEKLY": "Weekly", "MONTHLY": "Monthly", "QUARTERLY": "Quarterly", "ANNUALLY": "Annually" }, "upgrades": { "assignUser": "Upgrade this user to manage their goals", "toAdvancedGoals": { "title": "Upgrade to the new sales goals manager", "body": "Manage goals for revenue, calls made, deals created, or meetings booked for your sales team." }, "typeGroups": { "SALES": { "title": "Get access to new sales goals", "body": "Give your sales team something to strive for by assigning goals for revenue, calls made, deals created, or meetings booked." }, "SERVICES": { "title": "Get access to new service goals", "body": "Give your service team something to strive for by assigning goals for tickets closed." } } }, "errors": { "GET_QUOTAS": "There was a problem retrieving goals from the server. Please refresh to try again.", "SAVE_QUOTAS": "There was a problem saving goals. Please refresh the page and try again.", "DELETE_QUOTAS": "There was a problem deleting goals. Please refresh the page and try again.", "GET_OWNERS": "There was a problem getting users from the server. Please refresh to try again.", "GET_PIPELINES": "There was a problem getting pipelines from the server. Please refresh to try again." } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "de": "static-1.16253",
    "en": "static-1.16253",
    "es": "static-1.16253",
    "fr": "static-1.16253",
    "ja": "static-1.16253",
    "pt-br": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "reporting-data": { "export": { "defaultExportName": "My Export", "fields": { "name": "Name" } }, "missing": { "unknown": { "page": "Unknown page", "type": "Unknown type ({ type })", "owner": "Unknown owner ({{ id }})", "team": "Unknown team ({{ id }})" }, "unassigned": "Unassigned", "value": "(No value)", "empty-topic": "Empty core topic", "subtopic": "No subtopic", "untitled": "Untitled ({{ id }})" }, "durations": { "seconds": { "one": "{{ count }} second", "other": "{{ count }} seconds" }, "minutes": { "one": "{{ count }} minute", "other": "{{ count }} minutes" }, "hours": { "one": "{{ count }} hour", "other": "{{ count }} hours" }, "days": { "one": "{{ count }} day", "other": "{{ count }} days" } }, "dataTypes": { "ANALYTICS_ALL_PAGES": "Pages", "ANALYTICS_BLOG_POSTS": "Blog posts", "ANALYTICS_BOTS_CHATS": "Chatflows", "ANALYTICS_BOTS_MODULES": "Chatflow modules", "ANALYTICS_CAMPAIGNS": "Campaigns", "ANALYTICS_CONTENT_SEARCH": "Content searches", "ANALYTICS_CTAS": "Calls-to-action", "ANALYTICS_DEVICE_TYPES": "Device types", "ANALYTICS_EVENT_COMPLETIONS": "Events", "ANALYTICS_EVENTS": "Events", "ANALYTICS_FORMS": "Forms", "ANALYTICS_FUNNEL": "Analytics funnel", "ANALYTICS_GEOLOCATION": "Countries", "ANALYTICS_KNOWLEDGE_ARTICLES": "Knowledge articles", "ANALYTICS_LANDING_PAGES": "Landing pages", "ANALYTICS_PAGES": "Pages", "ANALYTICS_PATHS": "Pages", "ANALYTICS_SALES_DOCUMENTS": "Documents", "ANALYTICS_SALES_TEMPLATES": "Templates", "ANALYTICS_SEQUENCE_ENROLLMENT_ACTIVITIES": "Sequences", "ANALYTICS_SESSIONS": "Sessions", "ANALYTICS_SOCIAL": "Social", "ANALYTICS_SOURCES": "Sources", "ANALYTICS_STANDARD_PAGES": "Website pages", "ANALYTICS_TOPICS": "Topic clusters", "ANALYTICS_UTM_CAMPAIGNS": "UTM campaigns", "ANALYTICS_UTM_CONTENTS": "UTM Contents", "ANALYTICS_UTM_MEDIUMS": "UTM Mediums", "ANALYTICS_UTM_SOURCES": "UTM Sources", "ANALYTICS_UTM_TERMS": "UTM Terms", "ANALYTICS": "Sessions", "ATTRIBUTION_TOUCH_POINTS": "Interactions", "ATTRIBUTION": "Attribution", "BLOG_POSTS": "Blog posts", "BLOG": "Blog", "CALLS": "Calls", "COMPANIES": "Companies", "CONTACTS": "Contacts", "CONVERSATIONS": "Conversations", "CONVERSION": "Conversions", "CROSS_OBJECT": "Associations", "DEALS": "Deals", "EMAIL": "Emails", "ENGAGEMENT_EMAILS": "Emails", "ENGAGEMENT": "Activities", "ENGAGEMENTS": "Activities", "EXPERIMENTAL_REVENUE": "Recurring revenue", "FACEBOOK_MESSENGER": "Audience", "FEEDBACK": "Feedback", "FEEDBACK_SUBMISSIONS": "Feedback submissions", "KNOWLEDGE_ARTICLES": "Knowledge articles", "LANDING_PAGES": "Landing pages", "LEGACY_CAMPAIGNS": "Campaigns", "LINE_ITEMS": "Products", "LISTS": "Contacts", "MEETINGS": "Meetings", "NOTES": "Notes", "PERSONA": "Personas", "PRODUCTS": "Products", "QUOTAS": "Quotas", "SEQUENCES": "Sequences", "SOCIAL_POSTS": "Social posts", "SOCIAL": "Social interactions", "TASKS": "Tasks", "TEMPLATES": "Templates", "TICKETS": "Tickets", "UNIFIED_ADS_CAMPAIGNS": "Ad campaigns", "UNIFIED_ADS_NETWORKS": "Ad networks", "UNIFIED_FEEDBACK_TRENDS": "Feedback", "WEB_ANALYTICS": "Sessions", "WORKFLOWS": "Workflows" }, "propertyLabel": { "SUM": "{{ propertyLabel }}", "AVG": "Average {{ propertyLabel }}", "MIN": "Minimum {{ propertyLabel }}", "MAX": "Maximum {{ propertyLabel }}", "COUNT": "{{ propertyLabel }}", "NEW": "New {{ propertyLabel }}", "DISTINCT_APPROX": "Count of {{ propertyLabel }}", "PERCENTILES": "{{ propertyLabel }}", "VALUE": "{{ propertyLabel }}" }, "guids": { "NO_BREAKDOWN": "Property not set", "NO_DETAIL_GUID": "Unknown campaign", "EMPTY_LIST_GUID": "Empty list", "UNKNOWN": "Unknown", "UNKNOWN_URL": "Unknown URL", "UNKNOWN_CAMPAIGN_GUID": "Unknown campaign", "UNKNOWN_COUNTRY_GUID": "Country unknown", "UNKNOWN_KEYWORD_GUID": "Content network (AdSense or other)", "UNKNOWN_REFERRER_GUID": "Unknown referrer", "UNKNOWN_GEO_GUID": "Unknown location", "SSL_REMOVED_KEYWORDS": "Unknown keywords (SSL)", "LYCOS_IMAGE_KEYWORD_PLACEHOLDER": "Unknown keywords (image preview)", "PPC_GCLID_BUCKET": "Auto-tagged PPC", "GMAIL_INTEGRATION": "Gmail integration", "BCC_TO_CRM": "BCC to CRM", "EMAIL_INTEGRATION": "Email integration" }, "compare": { "priorPeriod": "Previous period", "priorYear": "Last year" }, "groups": { "analytics": { "analyticsCommon": "Analytics Properties" }, "attribution": { "attributionInfo": "Attribution Properties" }, "blog": { "blogInfo": "Blog", "blogPostInfo": "Blog posts" }, "campaigns": { "campaignInfo": "Campaigns", "assetTypes": "Asset Types" }, "contacts": { "contactscripted": "Calculated Contact Information" }, "conversations": { "conversationInfo": "Conversation" }, "conversion": { "conversionInfo": "Conversion" }, "cta": { "ctaInfo": "CTA" }, "deals": { "dealscripted": "Calculated Deal Information", "dealstages": "Deal Stage Properties" }, "documents": { "documentInfo": "Document" }, "engagement": { "betEngagementInfo": "BET Engagement Properties", "callInfo": "Call", "engagementInfo": "Engagement", "engagementEmailInfo": "Email", "meetingInfo": "Meeting", "noteInfo": "Note", "taskInfo": "Task" }, "email": { "emailInfo": "Email" }, "facebookMessenger": { "facebookMessengerInfo": "Facebook Messenger" }, "feedback": { "feedbackInfo": "Feedback", "npsInfo": "NPS", "npsSurveyInfo": "NPS Survey", "npsEmailInfo": "NPS Email" }, "legacyCampaigns": { "legacyCampaignsInfo": "Campaigns" }, "knowledgeArticles": { "knowledgeArticleInfo": "Knowledge articles" }, "lists": { "listInfo": "List" }, "pages": { "pageInfo": "Page", "analyticsPages": "Page Analytics" }, "people": { "pageInfo": "People" }, "sequences": { "sequenceInfo": "Sequence" }, "socialPosts": { "socialPostInfo": "Social Posts" }, "sources": { "sources": "Sources", "sourceInfo": "Source Information" }, "templates": { "templateInfo": "Template" }, "topics": { "topicInfo": "Topic" }, "recurring-revenue": { "group": "Recurring Revenue Properties" }, "unified": { "group": "Unified Analytics Properties" } }, "properties": { "common": { "id": "ID", "objectId": "{{ object }} ID", "namespacedProperty": "{{ propertyLabel }} ({{ dataTypeLabel }})", "count": "Count of {{ object }}", "total": "Total", "created": "Create date", "updated": "Last updated", "body": "Body", "conversion": "Conversion", "stepwiseConversion": "Next step conversion", "cumulativeConversion": "Cumulative conversion", "buckets": { "included": "True", "excluded": "False" }, "associatedCompanies": "Associated Companies", "associatedContacts": "Associated Contacts", "associatedDeals": "Associated Deals", "inboundDbImport": "Import" }, "attributionTouchPoints": { "hs_u_amount": "Amount (U Model)", "hs_content_type": "Content type" }, "attribution": { "referrer": "Referrer", "url": "URL", "source": "Source", "contactsAssisted": "Contacts assisted", "percentOfContacts": "% of contacts", "normalizedScore": "Score / 100" }, "blog": { "author": "Author", "blogPost": "Blog post", "created": "Create date", "ctaClickRate": "Click-through rate", "ctaClicks": "CTA clicks", "date": "View date", "publishDate": "Publish date", "subscribers": "Subscribers", "updated": "Last updated", "viewDate": "View date", "views": "Views", "subscriberCountDate": "Subscription date", "subscriberType": "Subscriber", "subscriberTypes": { "email": "Email subscriber", "rss": "RSS subscriber" } }, "call": { "status": "Call status", "callStatus": { "completed": "Completed", "noAnswer": "No answer", "queued": "Queued", "failed": "Failed", "canceled": "Canceled", "busy": "Busy", "connecting": "Connecting", "callingCrmUser": "Calling CRM user", "ringing": "Ringing", "inProgress": "In progress" }, "duration": "Call duration", "disposition": "Call outcome", "dispositionTypes": { "busy": "Busy", "no_answer": "No answer", "wrong_number": "Wrong number", "left_live_message": "Left live message", "left_voicemail": "Left voicemail", "connected": "Connected" }, "body": "Call notes" }, "contacts": { "contact": "Contact", "listMembership": "List membership", "deletedList": "Deleted List({{ listId }})", "formSubmission": "Form submission", "hs_analytics_num_visits": "Number of sessions", "hs_analytics_first_visit_timestamp": "Time of first session", "hs_analytics_last_visit_timestamp": "Time of last session", "BUCKET_customer": "Customer", "BUCKET_sources": "Sources", "BUCKET_createdate_enteredCount": "Created", "buckets": { "UNKNOWN": "Unknown", "OFFLINE": "Offline", "ONLINE": "Online" } }, "companies": { "company": "Company" }, "tickets": { "ticket": "Ticket" }, "conversations": { "fullUrl": "Conversation website URL", "conversationSource": "Conversation source type", "visitorStartTime": "Date visitor started conversation", "agentJoinTime": "Date agent joined conversation", "visitorEndTime": "Date visitor ended conversation", "online": "Online", "isBot": "Conversation by bot", "visitorWaitTimeMilliseconds": "Time visitor waited for conversation", "sessionDurationMilliseconds": "Conversation duration", "numVisitorMessages": "Number of visitor messages", "numAgentMessages": "Number of agent messages", "conversationSources": { "liveChat": "Live chat", "facebookMessenger": "Facebook Messenger" }, "threadId": "Conversation thread id", "sessionClosedAt": "Conversation session closed at", "agentResponseTimeMilliseconds": "Conversation session agent response time" }, "conversion": { "visitTime": "Visit date", "pageUrl": "URL", "pageDomain": "Domain", "visitSource": "Source", "pageContentType": "Page type", "analyticsPageId": "Page", "pageAuthor": "Author", "pageBlogId": "Blog post", "country": "Country", "region": "Region", "city": "City", "persona": "Persona", "conversionTime": "Conversion date", "referrerVisitTime": "Referrer visit date", "referrerUrl": "Referring URL", "referrerDomain": "Referring domain", "referrerVisitSource": "Referring source", "referrerContentType": "Referring page type", "referrerAnalyticsPageId": "Referring page", "referrerAuthor": "Referring author", "referrerBlogAuthorId": "Referring blog author", "referrerBlogId": "Referring blog post", "firstVisit": "First visit", "firstVisitInLeadSession": "First visit in lead session", "lastVisitInLeadSession": "Last visit in lead session", "firstVisitInCreateSession": "First visit in create session", "lastVisitInCreateSession": "Last visit in create session", "firstVisitInCloseSession": "First visit in close session", "lastVisitInCloseSession": "Last visit in close session", "pageContentTypes": { "landingPage": "Landing page", "standardPage": "Website page", "blogPost": "Blog post", "listingPage": "Listing page" }, "page": "Page", "author": "Author" }, "cta": { "cta": "Calls-to-action", "ctaViews": "Views", "date": "Date", "placement": "Placement" }, "deals": { "deal": "Deal", "amount": "Amount", "created": "Create date", "closedAmount": "Closed amount", "projectedAmount": "Forecast amount", "amount_in_home_currency": "Amount in company currency", "projectedAmountInHomeCurrency": "Forecast amount in company currency", "closedAmountInHomeCurrency": "Closed amount in company currency", "dealStage": "Deal stage", "associations": "Association", "enteredStage": "Entered Stage Date - {{ stageLabel }}", "hasEnteredStage": "Entered Stage - {{ stageLabel }}", "timeInStage": "Time in Stage - {{ stageLabel }}", "timeInAllStages": "Time in Stage - All stages", "dealstageProbability": "Deal Stage Probability", "BUCKET_createdate_enteredCount": "Created", "BUCKET_dealProgress": "Deal Status", "days_to_close": "Days to Close", "closeDate": "Close date", "num_notes": "Number of sales activities", "num_contacted_notes": "Number of times contacted", "timeInStageDescriptions": "Measured in milliseconds", "dealprogress": { "won": "Won", "open": "Open", "lost": "Lost" }, "stage": { "create": "All created deals" } }, "line-items": { "product": "Product" }, "email": { "bounce": "Bounce", "bounceratio": "Bounce rate", "campaign": "Campaign", "emailSends": "Emails", "click": "Clicks", "clickratio": "Click rate", "clickthroughratio": "Click-through rate", "contactslost": "Contacts lost", "contactslostratio": "Contacts lost rate", "count": "Emails", "created": "Create date", "date": "Date", "delivered": "Delivered", "deliveredratio": "Delivered rate", "dropped": "Dropped", "email": "Email", "emailCampaign": "Campaign", "hardbounced": "Hard bounced", "hardbounceratio": "Hard bounce rate", "name": "Email", "notsent": "Not sent", "notsentratio": "Not sent rate", "open": "Opened", "openratio": "Open rate", "pending": "Pending", "pendingratio": "Pending rate", "publishDate": "Publish date", "selected": "Selected", "sent": "Sent", "softbounced": "Soft bounced", "softbounceratio": "Soft bounce rate", "spamreport": "Marked spam", "suppressed": "Suppressed", "spamreportratio": "Spam report rate", "state": "State", "unsubscribed": "Unsubscribed", "unsubscribedratio": "Unsubscribed rate", "updated": "Update date", "deviceType": "Device", "deviceTypes": { "computer": "Desktop", "mobile": "Mobile", "unknown": "Unknown" } }, "engagement": { "instance": "Activity", "id": "ID", "timestamp": "Activity date", "owner": "Activity assigned to", "createdBy": "Activity created by", "associations": "Associated with", "details": "Details", "type": "Activity type", "modifiedBy": "Modified by", "team": "Hubspot Team", "engagementType": { "email": "Email sent to contact", "incomingEmail": "Email reply from contact", "forwardedEmail": "Forwarded email", "call": "Call", "meeting": "Meeting", "task": "Task", "note": "Note", "fbMessage": "Facebook Message", "conversationSession": "Conversation Session", "feedbackSubmission": "Feedback Submission" }, "source": "Source", "activityType": "Call and meeting type", "activityTypes": { "CALL": "Call", "IMA": "IMA", "DEMO": "Demo", "DISCOVERY": "Discovery", "GOAL_SETTING": "Goal setting", "PREQUALIFICATION_CALL": "Prequalification call", "ACCOUNT_ASSIST": "Account assist", "AGENCY_SERVICES": "Define agency services", "BILLING_ISSUE": "Billing or contract issue", "BUILD_LEAD_LIST": "Building a lead list", "BUSINESS_STRATEGY": "Business strategy", "CANCELLATION": "Cancellation/Downgrade", "CLIENT_DELIVERY": "Client delivery", "CONSULTING": "Consulting", "CULTURE": "Hiring/HR/Culture", "DEAL_REVIEW": "Deal review", "DEVELOPING_SALES_PLAN": "Developing sales plan", "ESCALATION": "Escalation", "IMPLEMENTATION": "Implementation", "INTERNAL_TRANSITION": "Internal transition", "KICK_OFF": "Kick-off", "PBE_REVIEW": "PBE review", "PRICING_PACKAGING": "Pricing & packaging", "PROACTIVE_PROSPECTING": "Proactive prospecting", "QSR_DELIVERED": "QSR delivered", "QUARTERLY_REVIEW": "Quarterly business review", "RESELL_DISCUSSION": "Resell & retainers discussion", "SALES_COACHING": "Sales coaching", "SELLING_OPPORTUNITY": "Selling opportunity", "SE_DISCOVERY": "Discovery", "SMALL_GROUP_COACHING": "Small group coaching", "DEAL_SPECIFIC_COACHING": "Deal specific coaching", "FULL_DEMO": "Full demo", "IN_PERSON": "In person", "OFFLINE_SOLUTION_RESEARCH": "Offline solution research", "PARTIAL_DEMO": "Partial demo", "POST_SALE_SERVICES_SUPPORT": "Post sale services support", "QUESTIONNAIRE_REVIEW_CALL": "Questionnaire review call", "TECH_CONSULT": "Tech consult", "SALES_NEW_BUSINESS_CALL": "New business", "SALES_INSTALL_BASE_CALL": "Install base", "SUPPORT_BILLING": "Billing", "SUPPORT_CANCELLATION_DOWNGRADE": "Cancellation/Downgrade", "SUPPORT_TECHNICAL_SUPPORT": "Technical support", "SUPPORT_RENEWAL": "Renewal", "SUPPORT_ACCOUNT_MANAGEMENT": "Account management", "OTHER_TYPE": "Other" }, "unknownVisitorConversation": "Unknown Visitor Conversation", "productName": "Product name", "productNames": { "PRODUCT_ADD_ONS": "Add-ons", "PRODUCT_CRM": "CRM", "PRODUCT_MARKETING_FREE": "Marketing Hub Free", "PRODUCT_SALES_FREE": "Sales Hub Free", "PRODUCT_GROWTH_STACK": "Growth Platform", "PRODUCT_MARKETING_PAID": "Marketing Hub Basic/Pro/Enterprise", "PRODUCT_MARKETING_STARTER": "Marketing Hub Starter", "PRODUCT_SALES_PRO": "Sales Hub Professional", "PRODUCT_SALES_STARTER": "Sales Hub Starter", "PRODUCT_SALES_HUB_ENTERPRISE": "Sales Hub Enterprise", "PRODUCT_SERVICE_HUB": "Service Hub Free", "PRODUCT_SERVICE_PRO": "Service Hub Professional", "PRODUCT_SERVICE_HUB_STARTER": "Service Hub Starter", "PRODUCT_SERVICE_HUB_ENTERPRISE": "Service Hub Enterprise", "PRODUCT_CMS": "CMS", "PRODUCT_UNKNOWN": "Unknown" }, "followUpAction": "Follow-up action", "followUpActions": { "FOLLOW_UP_PASSED_TO_SALES": "Passed on to sales", "FOLLOW_UP_INTERNAL_TRANSFER": "Internal transfer/connection", "FOLLOW_UP_SENT_RESOURCES": "Sent resources", "FOLLOW_UP_NO_FOLLOW_UP": "No follow up" } }, "engagementEmail": { "subject": "Email subject", "html": "Email body", "text": "Text", "trackerKey": "Tracker key", "messageId": "Message ID", "threadId": "Thread ID", "status": "Email send status", "sentVia": "Sent via", "attachedVideoId": "Attached video ID", "attachedVideoOpened": "Attached video opened", "attachedVideoWatched": "Attached video watched" }, "events": { "event": "Event" }, "facebookMessenger": { "count": "Audience" }, "feedback": { "score": "Score", "customerType": "Customer type", "promoters": "Promoters 9-10", "passives": "Passives 7-8", "detractors": "Detractors 0-6", "highEffort": "Difficult 1-3", "mediumEffort": "Neutral 4-5", "lowEffort": "Easy 6-7", "unhappy": "Unhappy", "neutral": "Neutral", "happy": "Happy", "helpful": "Helpful", "unhelpful": "Unhelpful", "rating": "The number rating of the feedback submission", "formType": "Feedback survey type", "formGuid": "The unique ID of the form", "followUp": "The comment provided with the feedback submission", "formChannel": "Feedback channel", "numViews": "Surveyed", "numSubmissions": "Responses", "numSent": "Sent", "numDelivered": "Delivered", "numContactsLost": "Contacts Lost", "numOpen": "Opened", "responseGroup": "Feedback sentiment", "formTypes": { "nps": "NPS", "ces": "CES", "csat": "CSAT", "knowledge": "Knowledge" }, "formChannels": { "email": "Email", "web": "Web" } }, "legacy-campaigns": { "count": "Count", "campaign": "Campaign", "assetId": "Asset", "assetType": "Asset type", "blogPosts": "Blog posts", "socialMessages": "Social messages", "ctas": "Calls-to-action", "emails": "Emails", "landingPages": "Landing pages", "landingPage": "Landing page", "otherSources": "Other sources", "paidCampaigns": "Paid campaign", "sitePages": "Site pages", "workflows": "Workflows", "metrics": { "count": "Count", "visits": "Visits", "contacts": "Contacts", "customers": "Customers", "sent": "Sent", "open": "Open", "ctaViews": "CTA views", "ctaClicks": "CTA clicks", "ctaConversionRate": "CTA rate", "views": "Views", "facebookClicks": "Facebook clicks", "twitterClicks": "Twitter clicks", "linkedinClicks": "LinkedIn clicks", "startedWorkflow": "Started workflow", "joinedGoalList": "Joined goal list", "workflowConversionRate": "Conversion rate" } }, "meetings": { "description": "Meeting description", "title": "Meeting name", "source": "Meeting source", "startTime": "Meeting start time" }, "notes": { "body": "Note body" }, "pages": { "pageId": "Page", "viewDate": "View date", "leads": "Leads", "opportunities": "Opportunities", "deviceType": "Device breakdown", "deviceTypes": { "mobile": "Mobile", "desktop": "Desktop", "others": "Others" }, "viewType": "Engagement type", "viewTypes": { "standardViews": "Standard", "ampViews": "AMP" }, "ampViews": "AMP views", "viewsToSubmissionsRate": "Views to Submissions rate", "viewsToContactsRate": "Views to Contacts rate", "viewsToCustomersRate": "Views to Customers rate", "submissionsPerPageview": "View to submission rate", "contactsPerPageview": "View to contact rate", "customersPerPageview": "View to customer rate", "name": "Name", "createdAt": "Creation date", "publishStatusId": "Publish status", "publishedAt": "Publish date", "contentGroupId": "Content group", "publishStatus": { "deleted": "Deleted", "draft": "Draft", "published": "Published", "scheduled": "Scheduled" }, "domain": "Domain", "tagIds": "Tags", "contentType": "Content Type", "contentTypes": { "standardPages": "Standard Pages", "landingPages": "Landing Pages", "blogPosts": "Blog Posts", "knowledgeArticles": "Knowledge Articles" }, "language": "Language", "contentTypeCode": "Content Type", "contentTypeCodes": { "standardPage": "Standard Page", "landingPage": "Landing Page", "listingPage": "Listing Page", "blogPost": "Blog Post", "knowledgeArticle": "Knowledge Article" }, "url": "Url" }, "paths": { "ctaClicks": "CTA clicks", "ctaRate": "CTA %", "ctaViews": "CTA views", "date": "Date", "path": "Page", "rawViews": "Views", "entrances": "Entrances", "exits": "Exits", "timePerPageview": "Time on page", "pageBounceRate": "Bounce rate", "exitsPerPageview": "Exit rate" }, "people": { "email": "Email", "firstname": "First name", "hsAnalyticsFirstTimestamp": "Timestamp", "isContact": "Is contact", "name": "Name", "lastname": "Last name", "lifecyclestage": "Lifecycle stage", "noContactRecord": "No contact record", "source": "Source", "sourceDrilldown1": "Source drilldown 1", "sourceDrilldown2": "Source drilldown 2", "dealName": "Deal" }, "quotas": { "owner": "Owner", "AVERAGE_RESPONSE_TIME": { "WEEKLY": "Weekly Average Response Time Goal", "MONTHLY": "Response Time Goal", "QUARTERLY": "Quarterly Average Response Time Goal", "ANNUALLY": "Annual Average Response Time Goal" }, "AVERAGE_RESOLUTION_TIME": { "WEEKLY": "Weekly Average Resolution Time Goal", "MONTHLY": "Resolution Time Goal", "QUARTERLY": "Quarterly Average Resolution Time Goal", "ANNUALLY": "Annual Average Resolution Time Goal" }, "CALLS_MADE": { "WEEKLY": "Weekly Calls Made Goal", "MONTHLY": "Calls Made Goal", "QUARTERLY": "Quarterly Calls Made Goal", "ANNUALLY": "Annual Calls Made Goal" }, "DEALS_CREATED": { "WEEKLY": "Weekly Deals Created Goal", "MONTHLY": "Deals Created Goal", "QUARTERLY": "Quarterly Deals Created Goal", "ANNUALLY": "Annual Deals Created Goal" }, "AVERAGE_NPS": { "WEEKLY": "Weekly Average Nps Goal", "MONTHLY": "NPS Goal", "QUARTERLY": "Quarterly Average Nps Goal", "ANNUALLY": "Annual Average Nps Goal" }, "REVENUE": { "WEEKLY": "Weekly Revenue Goal", "MONTHLY": "Revenue Goal", "QUARTERLY": "Quarterly Revenue Goal", "ANNUALLY": "Annual Revenue Goal" }, "TICKETS_CLOSED": { "WEEKLY": "Weekly Tickets Closed Goal", "MONTHLY": "Tickets Closed Goal", "QUARTERLY": "Quarterly Tickets Closed Goal", "ANNUALLY": "Annual Tickets Closed Goal" }, "MEETINGS_BOOKED": { "WEEKLY": "Weekly Meetings Booked Goal", "MONTHLY": "Meetings Booked Goal", "QUARTERLY": "Quarterly Meetings Booked Goal", "ANNUALLY": "Annual Meetings Booked Goal" } }, "recurring-revenue": { "date": "Date", "recurringRevenue": "Recurring revenue", "lostRecurringRevenue": "Lost recurring revenue", "newRecurringRevenue": "New recurring revenue", "existingRecurringRevenue": "Existing recurring revenue" }, "sequences": { "activityDate": "Activity date", "completionRate": "Completion rate", "errorRate": "Error rate", "meetingsRate": "Meetings rate", "replyCounts": "Email {{ version }}", "replyRate": "Replies per send", "sequenceId": "Sequence name", "totalEnrolled": "Total enrolled", "totalReplies": "Total replies", "unenrollRate": "Unenroll rate", "currentlyEnrolled": "Currently enrolled", "replied": "Replied", "finished": "Finished", "errored": "Errored", "manuallyUnenrolled": "Manually unenrolled", "meetingScheduled": "Meeting scheduled" }, "sessions": { "ampViews": "Amp views", "bounceRate": "Bounce rate", "campaign": "Campaign", "contacts": "New contacts", "contactToCustomerRate": "Contact to customer rate", "created": "Create date", "ctaClicks": "CTA clicks", "ctaRate": "CTA %", "ctaViews": "CTA views", "customers": "Customers", "direct": "Direct traffic", "directTraffic": "Direct traffic", "email": "Email marketing", "emailAddress": "Email", "emailCampaign": "Email campaign", "entrances": "Entrances", "entranceUrl": "Entrance URL", "exits": "Exits", "exitsPerPageview": "Exit rate", "first_conversion_date": "First conversion date", "first_conversion_event_name": "First conversion event name", "influencedContacts": "Influenced contacts", "influencedDeals": "Closed deals", "influencedRevenue": "Influenced revenue", "integrationsPlatform": "Integrations platform", "keyword": "Keyword", "landingPage": "Landing page", "lastTouchContacts": "New contacts (last touch)", "leads": "Leads", "lifecyclestage": "Lifecycle Stage", "name": "Name", "newVisitorSessionRate": "New session %", "offline": "Offline sources", "organic": "Organic search", "other": "Other campaigns", "page": "Page", "pageBounceRate": "Bounce rate", "pageviewsPerSession": "Page views / session", "paid-social": "Paid social", "paid": "Paid search", "rawViews": "Views", "recent_conversion_date": "Recent conversion date", "recent_conversion_event_name": "Recent conversion event name", "referrals": "Referrals", "referrer": "Referrer", "searchEngine": "Search engine", "sessionDate": "Session date", "sessionToContactRate": "Session to contact rate", "site": "Site", "social": "Social media", "source": "Source", "sourceMedium": "Source/medium", "standardViews": "Standard views", "submissions": "Total submissions", "subscribers": "Subscribers", "term": "Term", "timePerPageview": "Time on page", "timePerSession": "Session length", "topic": "Topic", "topicCluster": "Topic cluster", "url": "URL", "utmCampaign": "UTM campaign", "vid": "Vid", "visitors": "New visitor sessions", "visits": "Sessions" }, "sitePages": { "contacts": "Contacts", "contentType": "Content Type", "date": "Date", "deletedAt": "Deleted at", "name": "Name", "publishedAt": "Published at", "rawViews": "Views", "referrer": "Referrer", "sitePage": "Site page", "state": "State", "title": "Title", "url": "URL", "views": "Views" }, "topics": { "attachedContent": "Page", "bounceRate": "Bounce rate", "contacts": "New contacts", "contactToCustomerRate": "Contact to customer rate", "customers": "Customers", "filterId": "Analytics view", "leads": "Leads", "newVisitorSessionRate": "New session %", "pageviewsPerSession": "Page views / session", "rawViews": "Views", "sessionDate": "Session date", "sessionToContactRate": "Session to contact rate", "source": "Source of traffic", "subscribers": "Subscribers", "timePerPageview": "Time on page", "timePerSession": "Session length", "topic": "Topic", "topicCluster": "Topic cluster", "visitors": "New visitor sessions", "visits": "Sessions" }, "documents": { "count": "Documents", "meanDuration": "Visit time", "numShares": "Shares", "numUniqueVisitors": "Unique visitors", "numViews": "Total visits", "title": "Title", "createdAt": "Create date", "updatedAt": "Last updated", "deckId": "Deck", "folderId": "Folder", "ownerId": "Owner" }, "socialPosts": { "count": "Published Posts", "id": "Post", "key": "Post", "publishedAt": "Publish date", "network": "Network", "accountType": "Network", "channelType": "Network", "channelId": "Account", "foreignId": "Network Post ID", "mediaType": "Post type", "broadcastGuid": "Post", "campaignGuid": "Campaign", "remoteContentId": "Content ID", "remoteContentType": "Content type", "body": "Message", "stats": { "likes": "Likes", "dislikes": "Dislikes", "comments": "Comments", "shares": "Shares", "videoViews": "Views", "interactions": "Interactions", "impressions": "Impressions", "clicks": "Clicks", "videoMinutesWatched": "Watch time", "videoAverageViewPercentage": "% Time viewed", "videoAverageViewDurationSeconds": "Seconds viewed" } }, "tasks": { "taskStatus": { "label": "Task status", "options": { "COMPLETED": "Completed", "IN_PROGRESS": "In-progress", "NOT_STARTED": "Not started", "WAITING": "Waiting", "DEFERRED": "Deferred" } }, "taskSubject": { "label": "Task title" }, "taskBody": { "label": "Task notes" }, "taskType": { "label": "Task type", "options": { "EMAIL": "Email", "CALL": "Call", "TODO": "To-do" } } }, "templates": { "activityDate": "Activity date", "owner": "Owner", "sends": "Sends", "opens": "Opens", "clicks": "Clicks", "replies": "Replies", "openRate": "Open rate", "clickRate": "Click rate", "replyRate": "Replies per open", "template": "Template" }, "lists": { "measuredAt": "Measured", "source": "Source", "country": "Country", "lifecyclestage": "Lifecycle stage", "events": "Events", "visitedWebsite": "Visited your website", "clickedEmail": "Clicked in an email", "openedEmail": "Opened an email", "clickedSocial": "Clicked on social link", "convertedForm": "Converted on a form" }, "unified": { "options": { "sources": { "direct": "Direct traffic", "email": "Email marketing", "offline": "Offline sources", "organic": "Organic search", "social": "Social media", "paid": "Paid search", "referrals": "Referrals", "paid-social": "Paid social", "other": "Other campaigns" }, "content-type-codes": { "standard-page": "Standard page", "landing-page": "Landing page", "listing-page": "Listing page", "blog-post": "Blog post", "knowledge-article": "Knowledge article" }, "publish-status": { "deleted": "Deleted", "draft": "Draft", "published": "Published", "scheduled": "Scheduled" }, "social-accounts": { "facebook": "Facebook", "twitter": "Twitter", "instagram": "Instagram", "linkedin": "LinkedIn", "youtube": "YouTube" }, "social-channels": { "twitter": "Twitter", "facebookpage": "Facebook Page", "instagram": "Instagram", "linkedinstatus": "LinkedIn Profile", "linkedincompanypage": "LinkedIn Company Page", "youtube": "YouTube" } }, "people": { "default": "Name", "visits": "Visit", "submissions": "Submission", "leads": "Lead", "customers": "Customer", "contacts": "Contact", "last-touch-contacts": "Last touch contact", "lastTouchContacts": "Last touch contact", "subscribers": "Subscriber", "marketing-qualified-leads": "Marketing qualified lead", "sales-qualified-leads": "Sales qualified lead", "opportunities": "Opportunities", "others": "Other", "evangelists": "Evangelist", "contacts-influenced": "Contact influenced", "influenced-contacts": "Influenced contact", "influencedContacts": "Influenced contact" }, "person": { "vid": "Vid", "isContact": "Contact?", "deleted": "Deleted?", "email": "Email", "lifecyclestage": "Lifecycle stage", "firstname": "First name", "lastname": "Last name", "hs_analytics_source": "Source", "hs_analytics_source_data_1": "Source drilldown 1", "hs_analytics_source_data_2": "Source drilldown 2", "hs_analytics_first_timestamp": "First activity date", "first_conversion_event_name": "First conversion event name", "first_conversion_date": "First converson date", "recent_conversion_event_name": "Recent conversion event name", "recent_conversion_date": "Recent converson date", "guids": "GUIDs", "people": "People" } }, "bots-chats": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "bot": "Chatflow", "completions": "Completions", "starts": "Started", "abandons": "Abandoned" }, "bots-modules": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "bot": "Chatflow", "action": "Action", "completions": "Successfully Completed", "starts": "Started", "failures": "Action error" }, "content-search": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "term": "Term", "searches": "Searches", "autocompleteSearches": "Auto-complete searches", "searchResultsFounds": "Search results found", "noSearchResultsFounds": "No search results found", "searchConversions": "Search conversions", "searchAutocompleteConversions": "Search auto-complete conversions", "totalSearches": "Total searches", "totalSearchConversions": "Total search conversions", "searchConversionsPerSearch": "Search conversions per search", "hasResults": "Results found", "searchConversionSessionsPerSearchSession": "% Found answer", "subdomain": "Subdomain", "noResults": "No results", "contentType": "Content type" }, "event-completions": { "sessionDate": "Completion date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "completions": "Completions", "NAME": "Name", "CREATED_TIMESTAMP": "Create date", "IS_SOFT_DELETED": "Deleted", "WAITLISTED": "Waitlisted", "TAGS": "Tags" }, "sales-email": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "sequence": "Sequence", "opens": "Opens", "sends": "Sends", "replies": "Replies", "clicks": "Clicks", "openToClickRate": "Click rate", "openToReplyRate": "Replies per open" }, "sales-templates": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "template": "Template", "user": "User", "opens": "Opens", "sends": "Sends", "replies": "Replies", "clicks": "Clicks", "sendToOpenRate": "Send to open rate", "openToClickRate": "Open to click rate", "openToReplyRate": "Open to reply rate", "rootUser": "All users", "CREATED_BY": "Created by", "CREATED_TIMESTAMP": "Create date", "FOLDER_ID": "Folder", "IS_SOFT_DELETED": "Is deleted", "NAME": "Name", "UPDATED_TIMESTAMP": "Last updated" }, "targeted-content-definitions": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "definition": "Definition", "criteria": "Criteria", "rawViews": "Views", "submissions": "Submissions", "leads": "Leads", "customers": "Customers", "contacts": "Contacts", "opportunities": "Opportunities", "entrances": "Entrances", "exits": "Exits", "pageBounces": "Page bounces", "pageTime": "Time on page", "timePerPageview": "Time on page", "pageBounceRate": "Bounce rate", "exitsPerPageview": "Exit rate", "contactToCustomerRate": "Contact to customer rate", "submissionsPerPageview": "View to submission rate", "contactsPerPageview": "View to contact rate", "customersPerPageview": "View to customer rate", "pageId": "Page" }, "targeted-content": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "type": "Type", "types": { "targeted": "Smart", "default": "Default" }, "rawViews": "Views", "submissions": "Submissions", "leads": "Leads", "customers": "Customers", "contacts": "Contacts", "criteria": "Criteria", "definition": "Definition", "opportunities": "Opportunities", "entrances": "Entrances", "exits": "Exits", "pageBounces": "Page bounces", "pageTime": "Time on page", "timePerPageview": "Time on page", "pageBounceRate": "Bounce rate", "exitsPerPageview": "Exit rate", "contactToCustomerRate": "Contact to customer rate", "submissionsPerPageview": "View to submission rate", "contactsPerPageview": "View to contact rate", "customersPerPageview": "View to customer rate", "pageId": "Page" }, "utm-campaigns": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "campaign": "Campaign", "rawViews": "Views", "visits": "Sessions", "leads": "Leads", "customers": "Customers", "visitors": "New visitor sessions", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "bounces": "Bounces", "time": "Time", "pageviewsPerSession": "Page views / session", "bounceRate": "Bounce rate", "timePerSession": "Session length", "newVisitorSessionRate": "New session %", "sessionToContactRate": "Session to contact rate", "contactToCustomerRate": "Contact to customer rate", "source": "Source", "filterId": "Analytics view" }, "utm-contents": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "content": "Content", "rawViews": "Views", "visits": "Sessions", "leads": "Leads", "customers": "Customers", "visitors": "New visitor sessions", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "bounces": "Bounces", "time": "Time", "pageviewsPerSession": "Page views / session", "bounceRate": "Bounce rate", "timePerSession": "Session length", "newVisitorSessionRate": "New session %", "sessionToContactRate": "Session to contact rate", "contactToCustomerRate": "Contact to customer rate", "medium": "Medium", "source": "Source", "term": "Term", "filterId": "Analytics view" }, "utm-mediums": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "medium": "Medium", "rawViews": "Views", "visits": "Sessions", "leads": "Leads", "customers": "Customers", "visitors": "New visitor sessions", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "bounces": "Bounces", "time": "Time", "pageviewsPerSession": "Page views / session", "bounceRate": "Bounce rate", "timePerSession": "Session length", "newVisitorSessionRate": "New session %", "sessionToContactRate": "Session to contact rate", "contactToCustomerRate": "Contact to customer rate", "source": "Source", "filterId": "Analytics view" }, "utm-sources": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "source": "Source", "rawViews": "Views", "visits": "Sessions", "leads": "Leads", "customers": "Customers", "visitors": "New visitor sessions", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "bounces": "Bounces", "time": "Time", "pageviewsPerSession": "Page views / session", "bounceRate": "Bounce rate", "timePerSession": "Session length", "newVisitorSessionRate": "New session %", "sessionToContactRate": "Session to contact rate", "contactToCustomerRate": "Contact to customer rate", "filterId": "Analytics view" }, "utm-terms": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "term": "Term", "rawViews": "Views", "visits": "Sessions", "leads": "Leads", "customers": "Customers", "visitors": "New visitor sessions", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "bounces": "Bounces", "time": "Time", "pageviewsPerSession": "Pageviews per session", "bounceRate": "Bounce rate", "timePerSession": "Session length", "newVisitorSessionRate": "New session %", "sessionToContactRate": "Session to contact rate", "contactToCustomerRate": "Contact to customer rate", "source": "Source", "filterId": "Analytics view" }, "videos-viewership": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "views": "Views", "pageId": "Page", "playerId": "Player", "videoId": "Video" }, "videos": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "withoutPlayerUuid": "Without player", "page": "Page", "player": "Player", "video": "Video", "views": "Views" }, "landing-pages": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "contentGroupId": "Content group", "scaleByPercent": "Scale by percent", "landingPage": "Landing page", "rawViews": "Views", "submissions": "Total submissions", "leads": "Leads", "customers": "Customers", "ctaViews": "CTA views", "ctaClicks": "CTA clicks", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "entrances": "Entrances", "exits": "Exits", "pageBounces": "Bounces", "pageTime": "Time on page", "timePerPageview": "Time per pageview", "pageBounceRate": "Bounce rate", "exitsPerPageview": "Exits per pageview", "contactToCustomerRate": "Contact to customer rate", "ctaRate": "CTA rate", "submissionsPerPageview": "View to submission rate", "contactsPerPageview": "View to contact rate", "customersPerPageview": "View to customer rate", "NAME": "Title", "CREATED_TIMESTAMP": "Create date", "PUBLISH_STATUS_ID": "Publish status", "PUBLISHED_TIMESTAMP": "Publish date", "DOMAIN_ID": "Domain", "LANGUAGE": "Language", "CONTENT_TYPE_CODE": "Content type", "URL": "URL", "HTML_TITLE": "Page title" }, "standard-pages": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "contentGroupId": "Content group", "scaleByPercent": "Scale by percent", "standardPage": "Standard page", "rawViews": "Views", "submissions": "Total submissions", "leads": "Leads", "customers": "Customers", "ctaViews": "CTA views", "ctaClicks": "CTA clicks", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "entrances": "Entrances", "exits": "Exits", "pageBounces": "Bounces", "pageTime": "Time on page", "timePerPageview": "Time per pageview", "pageBounceRate": "Bounce rate", "exitsPerPageview": "Exits per pageview", "contactToCustomerRate": "Contact to customer rate", "ctaRate": "CTA rate", "submissionsPerPageview": "View to submission rate", "contactsPerPageview": "View to contact rate", "customersPerPageview": "View to customer rate", "NAME": "Title", "CREATED_TIMESTAMP": "Create date", "PUBLISH_STATUS_ID": "Publish status", "PUBLISHED_TIMESTAMP": "Publish date", "DOMAIN_ID": "Domain", "LANGUAGE": "Language", "CONTENT_TYPE_CODE": "Content type", "URL": "URL", "HTML_TITLE": "Page title" }, "blog-posts": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "contentGroupId": "Content group", "blogPost": "Blog post", "rawViews": "Views", "submissions": "Total submissions", "leads": "Leads", "customers": "Customers", "ctaViews": "CTA views", "ctaClicks": "CTA clicks", "contacts": "New contacts", "opportunities": "Opportunities", "ampViews": "AMP views", "entrances": "Entrances", "exits": "Exits", "pageBounces": "Bounces", "pageTime": "Time on page", "timePerPageview": "Time per pageview", "pageBounceRate": "Bounce rate", "exitsPerPageview": "Exits per pageview", "contactToCustomerRate": "Contact to customer rate", "ctaRate": "CTA rate", "submissionsPerPageview": "View to submission rate", "contactsPerPageview": "View to contact rate", "customersPerPageview": "View to customer rate", "NAME": "Title", "CREATED_TIMESTAMP": "Create date", "PUBLISH_STATUS_ID": "Publish status", "PUBLISHED_TIMESTAMP": "Publish date", "BLOG_AUTHOR_ID": "Blog author", "CONTENT_GROUP_ID": "Blog", "DOMAIN_ID": "Domain", "LANGUAGE": "Language", "CONTENT_TYPE_CODE": "Content type", "URL": "URL", "TAG_IDS": "Tags", "authorName": "Author", "created": "Create date", "ctaClickRate": "Click-through rate", "pageViews": "Page Views", "publishDate": "Publish date", "subscribers": "Subscribers", "title": "Blog post", "updated": "Last updated", "blogAuthorId": "Blog Author" }, "knowledge-articles": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "contentGroupId": "Content group", "knowledgeArticle": "Knowledge article", "rawViews": "Views", "entrances": "Entrances", "exits": "Exits", "pageBounces": "Bounces", "pageTime": "Time on page", "timePerPageview": "Time per pageview", "pageBounceRate": "Bounce rate", "exitsPerPageview": "Exits per pageview", "NAME": "Title", "CREATED_TIMESTAMP": "Create date", "PUBLISH_STATUS_ID": "Publish status", "PUBLISHED_TIMESTAMP": "Publish date", "DOMAIN_ID": "Domain", "LANGUAGE": "Language", "CONTENT_TYPE_CODE": "Content type", "URL": "URL", "averageTimeOnPage": "Avg. Time on Article", "helpfulFeedback": "Helpful rating", "helpfulFeedbackPercentage": "% Helpful", "lastUpdated": " Last Updated", "name": "Article", "totalFeedback": "Total Feedback Submitted", "unhelpfulFeedback": "Unhelpful rating", "unhelpfulFeedbackPercentage": "% Unhelpful" }, "sources": { "sessionDate": "Session date", "breakdown": "Breakdown", "filters": "Inclusions", "excludes": "Exclusions", "source": "Source", "rawViews": "Views", "visits": "Sessions", "leads": "Leads", "customers": "Customers", "visitors": "New visitor sessions", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "marketingQualifiedLeads": "Marketing qualified leads", "bounces": "Bounces", "time": "Time", "pageviewsPerSession": "Page views / session", "bounceRate": "Bounce rate", "timePerSession": "Session length", "contactToCustomerRate": "Contact to customer rate", "contactsPerPageview": "Contact conversion rate", "customersPerPageview": "Customer conversion rate", "sessionToContactRate": "Session to contact rate", "keyword": "Keyword", "searchEngine": "Search engine", "entranceUrl": "Entrance URL", "referrer": "Referrer", "referUrl": "Url", "emailCampaign": "UTM campaign", "emailId": "Email (UTM content)", "site": "Site", "campaign": "Campaign", "sourceMedium": "UTM Source/UTM Medium", "paidTerm": "UTM Term", "integrationsPlatform": "Integrations platform", "subdomain": "Subdomain", "filterId": "Analytics view", "newVisitorSessionRate": "New session %", "returningVisits": "Returning visitor sessions", "others": "Other", "offlineSource": "Offline Source", "devicetype": "Device type", "deviceTypes": { "DESKTOP": "Desktop", "MOBILE": "Mobile", "OTHERS": "Other" } }, "social-channels": { "sessionDate": "Session date", "breakdown": "Account", "filters": "Inclusions", "excludes": "Exclusions", "audienceGained": "Audience gained", "audienceLost": "Audience lost", "audienceTotal": "Audience size", "breakdownType": "Breakdown type", "channelKeys": "Account", "breakdownTypes": { "channelType": "Network", "channelKey": "Account" }, "comments": "Comments", "dislikes": "Dislikes", "likes": "Likes", "shares": "Shares", "videoAverageViewDurationSeconds": "Average view time", "videoAverageViewPercentage": "Average view percentage", "videoMinutesWatched": "Time watched", "videoViews": "Video views" }, "event-properties": { "sessionDate": "Session date", "breakdown": "Event property", "d1": "Event value", "filters": "Inclusions", "excludes": "Exclusions", "completions": "Completions" }, "all-pages": { "sessionDate": "Session date", "breakdown": "Page", "filters": "Inclusions", "excludes": "Exclusions", "contentType": "Content type", "contentGroupId": "Content group", "blogPost": "Blog post", "rawViews": "Views", "submissions": "Total submissions", "leads": "Leads", "customers": "Customers", "ctaViews": "CTA views", "ctaClicks": "CTA clicks", "contacts": "Contacts", "opportunities": "Opportunities", "ampViews": "AMP views", "entrances": "Entrances", "exits": "Exits", "pageBounces": "Bounces", "pageTime": "Time on page", "timePerPageview": "Time per pageview", "pageBounceRate": "Bounce rate", "exitsPerPageview": "Exits per pageview", "contactToCustomerRate": "Contact to customer rate", "ctaRate": "CTA rate", "submissionsPerPageview": "View to submission rate", "contactsPerPageview": "View to contact rate", "customersPerPageview": "View to customer rate", "subscribers": "Subscribers", "BLOG_AUTHOR_ID": "Blog author", "CONTENT_GROUP_ID": "Blog", "CONTENT_TYPE_CODE": "Content type", "CREATED_TIMESTAMP": "Create date", "DOMAIN_ID": "Domain", "HTML_TITLE": "Page title", "LANGUAGE": "Language", "NAME": "Title", "PUBLISH_STATUS_ID": "Publish status", "PUBLISHED_TIMESTAMP": "Publish date", "TAG_IDS": "Tags", "URL": "Url" }, "social-engagement": { "sessionDate": "Session date", "breakdown": "Account", "filters": "Inclusions", "excludes": "Exclusions", "clicks": "Clicks" }, "sequence-enrollment-activities": { "sessionDate": "Session date", "breakdown": "Sequence", "filters": "Inclusions", "excludes": "Exclusions", "clicks": "Clicks", "clicksPerEnroll": "Clicks per enroll", "completions": "Completions", "completionsPerEnroll": "Completions per enroll", "enrolls": "Enrolls", "executedSequenceSteps": "Sends", "executing": "Executing", "failures": "Failures", "failuresPerEnroll": "Failures per enroll", "manuals": "Manuals", "manualsPerEnroll": "Manuals per enroll", "meetingsBooked": "Meetings booked", "meetingsBookedPerEnroll": "Meetings booked per enroll", "opens": "Opens", "opensPerEnroll": "Opens per enroll", "openToClickRate": "Open to click rate", "openToReplyRate": "Open to reply rate", "replies": "Replies", "repliesPerEnroll": "Replies per enroll", "sends": "Sends", "unenrolls": "Unenrolls", "unenrollsPerEnroll": "Unenrolls per enroll", "unsubscribes": "Unsubscribes", "unsubscribesPerEnroll": "Unsubscribes per enroll", "NAME": "Name", "CREATED_TIMESTAMP": "Create date", "IS_SOFT_DELETED": "Deleted", "FOLDER_ID": "Folder", "CREATED_BY": "Created by", "UPDATED_TIMESTAMP": "Update date" }, "sequence-step-activities": { "sessionDate": "Session date", "breakdown": "Sequence", "filters": "Inclusions", "excludes": "Exclusions", "opens": "Opens", "sends": "Sends", "replies": "Replies", "clicks": "Clicks", "failures": "Failures", "meetingsBooked": "Meetings booked", "manuals": "Manuals", "executedSequenceSteps": "Executed sequence steps", "openToClickRate": "Open to click rate", "openToReplyRate": "Open to reply rate", "NAME": "Name", "CREATED_TIMESTAMP": "Create date", "IS_SOFT_DELETED": "Deleted", "CREATED_BY": "Created by", "UPDATED_TIMESTAMP": "Update date" }, "sequence-enrollment-states": { "sessionDate": "Session date", "breakdown": "Sequence", "filters": "Inclusions", "excludes": "Exclusions", "completions": "Completions", "meetingsBooked": "Meetings booked", "executing": "Executing", "unenrolls": "Unenrolls", "manuals": "Manuals", "enrolls": "Enrolls", "unenrollsPerEnroll": "Unenrolls per enroll", "meetingsBookedPerEnroll": "Meetings booked per enroll" }, "sales-documents": { "sessionDate": "Session date", "breakdown": "Document", "filters": "Inclusions", "excludes": "Exclusions", "completions": "Completions", "views": "Views", "visits": "Unique Visitors", "shares": "Shares", "duration": "Duration", "durationSeconds": "Duration", "enrolls": "Enrolls", "durationPerCompletion": "Average time spent viewing", "durationSecondsPerCompletion": "Average time spent viewing", "NAME": "Name", "CREATED_TIMESTAMP": "Create date", "IS_SOFT_DELETED": "Deleted", "CREATED_BY": "Created by", "UPDATED_TIMESTAMP": "Update date" }, "unified-ads-networks": { "sessionDate": "Session date", "breakdown": "Network", "filters": "Inclusions", "excludes": "Exclusions", "attributionView": "Attribution view", "impressions": "Impressions", "clicks": "Clicks", "engagements": "Engagements", "cost": "Cost", "newContacts": "New contacts", "leads": "Leads", "marketingQualifiedLeads": "Marketing qualified leads", "salesQualifiedLeads": "Sales qualified leads", "opportunities": "Opportunities", "customers": "Customers", "revenue": "Revenue", "costPerClick": "Cost per click", "clickThroughRate": "Click-through rate", "roi": "ROI", "clickToContactRate": "Click to contact rate", "costPerNewContact": "Cost per new contact", "costPerCustomer": "Cost per customer", "costPerDeal": "Cost per deal", "adWordsAccountIds": "AdWords accounts", "facebookAccountIds": "Facebook accounts", "linkedInAccountIds": "LinkedIn accounts", "status": "Status", "statuses": { "ENABLED": "Active", "PAUSED": "Paused", "REMOVED": "Deleted" }, "networks": { "LINKEDIN": "LinkedIn", "FACEBOOK": "Facebook", "ADWORDS": "Google Ads" } }, "unified-ads-accounts": { "sessionDate": "Session date", "breakdown": "Account", "filters": "Inclusions", "excludes": "Exclusions", "attributionView": "Attribution view", "adWordsAccountIds": "AdWords accounts", "facebookAccountIds": "Facebook accounts", "linkedInAccountIds": "LinkedIn accounts", "impressions": "Impressions", "clicks": "Clicks", "engagements": "Engagements", "cost": "Cost", "newContacts": "New contacts", "leads": "Leads", "marketingQualifiedLeads": "Marketing qualified leads", "salesQualifiedLeads": "Sales qualified leads", "opportunities": "Opportunities", "customers": "Customers", "revenue": "Revenue", "costPerClick": "Cost per click", "clickThroughRate": "Click-through rate", "roi": "ROI", "clickToContactRate": "Click to contact rate", "costPerNewContact": "Cost per new contact", "costPerCustomer": "Cost per customer", "costPerDeal": "Cost per deal" }, "unified-ads-campaigns": { "sessionDate": "Session date", "breakdown": "Campaign", "filters": "Inclusions", "excludes": "Exclusions", "attributionView": "Attribution view", "adWordsAccountIds": "AdWords accounts", "facebookAccountIds": "Facebook accounts", "linkedInAccountIds": "LinkedIn accounts", "impressions": "Impressions", "clicks": "Clicks", "engagements": "Engagements", "cost": "Cost", "newContacts": "New contacts", "leads": "Leads", "marketingQualifiedLeads": "Marketing qualified leads", "salesQualifiedLeads": "Sales qualified leads", "opportunities": "Opportunities", "customers": "Customers", "contacts": "Contacts", "revenue": "Revenue", "costPerClick": "Cost per click", "clickThroughRate": "Click-through rate", "roi": "ROI", "clickToContactRate": "Click to contact rate", "costPerNewContact": "Cost per new contact", "costPerCustomer": "Cost per customer", "costPerDeal": "Cost per deal", "costPerContact": "Cost per contact", "network": "Network", "networks": { "LINKEDIN": "LinkedIn", "FACEBOOK": "Facebook", "ADWORDS": "Google Ads" }, "status": "Status", "statuses": { "ENABLED": "Active", "PAUSED": "Paused", "REMOVED": "Deleted" }, "STATUS": "Status", "ACCOUNT_ID": "Account", "TYPE": "Type", "ID": "ID", "NETWORK": "Network", "NAME": "Campaign" }, "forms": { "IS_SOFT_DELETED": "Deleted", "NAME": "Name", "TYPE_ID": "Form type", "variants": { "a": "Variation A", "b": "Variation B", "c": "Variation C", "d": "Variation D" }, "sessionDate": "Session date", "breakdown": "Form", "variant": "Version", "filters": "Inclusions", "excludes": "Exclusions", "submissions": "Submissions", "completions": "Completions", "formViews": "Views", "installs": "Installs", "visibles": "Form views", "interactions": "Interactions", "conversionRate": "Conversion rate", "clickThroughRate": "Click-through rate", "formConversionRate": "Form conversion rate", "count": "Count", "funnelStage": "Form event", "funnel": { "stepwiseConversion": "Conversion", "stages": { "formViews": "Form loaded", "visibles": "Visible on screen", "interactions": "Interacted with", "submissions": "Submitted" } }, "nonContactSubmissions": "Submissions from new contacts", "contactSubmissions": "Submissions from existing contacts", "submissionsPerFormView": "Conversion rate", "formTypes": { "hubspot": "Regular", "flow": "Pop-up", "captured": "Non-Hubspot", "leadAd": "Lead ad", "blogComment": "Blog Comment", "meeting": "Meeting", "feedback": "Feedback", "ticket": "Ticket", "document": "Document", "video": "Video" } }, "forms-sources": { "breakdown": "Source", "formId": "Form", "completions": "Completions", "formViews": "Views", "installs": "Installs", "sessionDate": "Session date", "submissions": "Submissions", "submissionsPerFormView": "Conversion rate", "visibles": "Form views" }, "forms-urls": { "breakdown": "Page url", "formId": "Form", "completions": "Completions", "formViews": "Views", "installs": "Installs", "sessionDate": "Session date", "submissions": "Submissions", "submissionsPerFormView": "Conversion rate", "visibles": "Form views" }, "unified-feedback-trends": { "sessionDate": "Session date", "breakdown": "Survey", "filters": "Inclusions", "excludes": "Exclusions", "surveyType": "Survey type", "surveyTypes": { "CES": "Customer Support (CES)", "CSAT": "Customer Satisfaction (CSAT)", "NPS": "Customer Loyalty (NPS)" }, "detractorsCount": "Detractors", "detractorsPercentage": "Detractors %", "passivesCount": "Passives", "passivesPercentage": "Passives %", "promotersCount": "Promoters", "promotersPercentage": "Promoters %", "score": "Score", "npsDetractorsCount": "Detractors 0-6", "npsPassivesCount": "Passives 7-8", "npsPromotersCount": "Promoters 9-10", "cesDetractorsCount": "Difficult 1-3", "cesPassivesCount": "Neutral 4-5", "cesPromotersCount": "Easy 6-7", "csatDetractorsCount": "Unhappy", "csatPassivesCount": "Neutral", "csatPromotersCount": "Happy" }, "unified-feedback-web": { "sessionDate": "Session date", "breakdown": "Survey", "filters": "Inclusions", "excludes": "Exclusions", "surveyType": "Survey type", "surveyId": "Survey", "submissions": "Responses", "followUp": "Responses with comments", "views": "Surveyed" }, "unified-feedback-email": { "sessionDate": "Session date", "breakdown": "Survey", "filters": "Inclusions", "excludes": "Exclusions", "surveyType": "Survey type", "surveyId": "Survey", "submissions": "Responses", "followUp": "Responses with comments", "delivered": "Delivered", "open": "Opened", "sent": "Sent" }, "cta-placements": { "sessionDate": "Date", "breakdown": "Call-to-action", "filters": "Inclusions", "excludes": "Exclusions", "ctaClicks": "Clicks", "ctaViews": "Views", "submissions": "Submissions", "variant": "Variant" }, "social": { "sessionDate": "Session date", "breakdown": "Channel", "filters": "Inclusions", "excludes": "Exclusions", "visits": "Sessions", "leads": "Leads", "customers": "Customers", "visitors": "New visitor sessions", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "newVisitorSessionRate": "New session %", "sessionToContactRate": "Session to contact rate", "contactToCustomerRate": "Contact to customer rate", "channelKey": "Account" }, "campaigns": { "sessionDate": "Session date", "breakdown": "Campaign", "source": "Source", "asset": "Asset", "filters": "Inclusions", "excludes": "Exclusions", "rawViews": "Views", "visits": "Sessions", "submissions": "Submissions", "ctaViews": "CTA views", "ctaClicks": "CTA clicks", "contacts": "New contacts (first touch)", "others": "Other", "formViews": "Form views", "mobile": "Mobile", "desktop": "Desktop", "organicSearch": "Organic search", "emailMarketing": "Email marketing", "paidSearch": "Paid search", "paidSocial": "Paid social", "socialMedia": "Social media", "directTraffic": "Direct traffic", "referrals": "Referrals", "otherCampaigns": "Other campaigns", "lastTouchContacts": "New contacts (last touch)", "ampViews": "AMP views", "influencedContacts": "Influenced contacts", "influencedDeals": "Closed deals", "influencedRevenue": "Influenced revenue", "pageviewsPerSession": "Page views / session", "sessionToContactRate": "Session to contact rate", "ctaRate": "CTA rate", "submissionsPerPageview": "View to submission rate", "contactsPerPageview": "View to contact rate", "NAME": "Name", "CREATED_TIMESTAMP": "Create date", "IS_SOFT_DELETED": "Deleted", "STARTED_AT_TIMESTAMP": "Start date", "ENDED_AT_TIMESTAMP": "End date", "CREATED_BY": "Created by", "ENABLED": "Enabled", "keyword": "Keyword", "landingPage": "Landing page", "cta": "Calls-to-action", "blogPost": "Blog post", "sitePage": "Site page", "utm": "UTM campaign", "offline": "Offline sources", "assetType": "Asset type", "broadcast": "Social message", "campaign": "Campaign", "date": "Date", "otherDevices": "Other devices", "otherSource": "Other source", "paidSource": "Paid source", "workflow": "Workflow" }, "unified-search-analytics-queries": { "sessionDate": "Session date", "breakdown": "Query", "filters": "Inclusions", "excludes": "Exclusions", "site": "Website", "clicks": "Clicks", "clickthroughRate": "Clickthrough rate", "impressions": "Impressions", "position": "Position", "page": "Page" }, "unified-search-analytics-pages": { "sessionDate": "Session date", "breakdown": "Page", "filters": "Inclusions", "excludes": "Exclusions", "clicks": "Clicks", "clickthroughRate": "Clickthrough rate", "impressions": "Impressions", "position": "Position" }, "geolocation": { "sessionDate": "Session date", "breakdown": "Breakdown", "country": "Country", "filters": "Inclusions", "excludes": "Exclusions", "visits": "Sessions", "visitors": "New visitor sessions", "newVisitorSessionRate": "% New session", "filterId": "Analytics view" }, "device-types": { "breakdown": "Device type", "sessionDate": "Session date", "standardViews": "Standard views", "pageviewsMinusExits": "Page views (ignoring exits)", "leadsPerView": "Leads per view", "evangelists": "Evangelists", "bounces": "Bounces", "others": "Others", "newVisitorSessionRate": "% new session", "rawViews": "Views", "visits": "Sessions", "leads": "Leads", "customers": "Customers", "visitors": "New visitor sessions", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "marketingQualifiedLeads": "Marketing qualified leads", "time": "Time", "pageviewsPerSession": "Page views / session", "bounceRate": "Bounce rate", "timePerSession": "Session length", "contactToCustomerRate": "Contact to customer rate", "contactsPerPageview": "Contact conversion rate", "customersPerPageview": "Customer conversion rate", "sessionToContactRate": "Session to contact rate", "mobileSessionRate": "Mobile session rate", "deviceTypes": { "DESKTOP": "Desktop", "MOBILE": "Mobile", "OTHERS": "Other" } }, "all-pages-sources": { "sessionDate": "Session date", "breakdown": "Breakdown", "source": "Source", "rawViews": "Views", "visits": "Sessions", "leads": "Leads", "customers": "Customers", "visitors": "New visitor sessions", "contacts": "New contacts", "subscribers": "Subscribers", "opportunities": "Opportunities", "marketingQualifiedLeads": "Marketing qualified leads", "bounces": "Bounces", "time": "Time", "pageviewsPerSession": "Page views / session", "bounceRate": "Bounce rate", "timePerSession": "Session length", "contactToCustomerRate": "Contact to customer rate", "contactsPerPageview": "Contact conversion rate", "customersPerPageview": "Customer conversion rate", "sessionToContactRate": "Session to contact rate", "keyword": "Keyword", "searchEngine": "Search engine", "entranceUrl": "Entrance URL", "referrer": "Referrer", "referUrl": "Url", "emailCampaign": "Email campaign", "emailId": "Email marketing", "site": "Site", "campaign": "Campaign", "sourceMedium": "Source/Medium", "paidTerm": "Term", "integrationsPlatform": "Integrations platform", "subdomain": "Subdomain", "filterId": "Analytics view", "newVisitorSessionRate": "New session %", "others": "Other", "offlineSource": "Offline Source", "ampViews": "AMP views", "entrances": "Entrances", "exits": "Exits", "pageBounces": "Bounces", "pageTime": "Time on page", "timePerPageview": "Time per pageview", "pageBounceRate": "Bounce rate", "exitsPerPageview": "Exits per pageview", "submissionsPerPageview": "View to submission rate", "submissions": "Total submissions" }, "unified-analytics-sessions": { "breakdown": "Breakdown", "mobile": "Mobile sessions", "desktop": "Desktop sessions", "other": "Other sessions", "sessions": "Sessions", "new-visitors": "New visitor sessions", "time-per-session": "Session length", "views-per-session-dec": "Page views per session", "bounce-percent-dec": "Bounce rate", "interactions-per-session-dec": "Interactions per session" } }, "references": { "activity": { "untitled": "Untitled activity ({{id}})", "unknown": "Unknown activity ({{id}})" }, "campaign": { "deleted": "{{ name }} (Deleted)" }, "company": { "unnamed": "Unnamed company ({{id}})", "unknown": "Unknown company ({{id}})" }, "contact": { "unknown": "Unknown contact ({{id}})" }, "deal": { "unknown": "Unknown deal ({{id}})" }, "cta": { "version": "Version {{ version }}", "deletedCta": "Deleted CTA {{ version }}", "default": "Default CTA", "variation": "Variation {{ version }}", "smartRule": "Smart rule {{ version }}" }, "line-item": { "unknown": "Unknown product ({{id}})" }, "email": { "preview": "HubSpot Marketing Email Preview" }, "ticket": { "unknown": "Unknown ticket ({{id}})" }, "feedback-submission": { "unknown": "Unknown feedback submission ({{id}})" } }, "lifecyclestage": { "enteredStage": { "create": "Entered Stage - All created contacts", "subscriber": "Entered Stage - Subscriber", "lead": "Entered Stage - Lead", "marketingqualifiedlead": "Entered Stage - Marketing qualified lead", "salesqualifiedlead": "Entered Stage - Sales qualified lead", "opportunity": "Entered Stage - Opportunity", "evangelist": "Entered Stage - Evangelist", "customer": "Entered Stage - Customer", "other": "Entered Stage - Other" }, "create": "All created contacts", "subscriber": "Subscriber", "lead": "Lead", "marketingqualifiedlead": "Marketing qualified lead", "salesqualifiedlead": "Sales qualified lead", "opportunity": "Opportunity", "evangelist": "Evangelist", "customer": "Customer", "other": "Other" }, "search-engines": { "unknown": "Unknown", "google": "Google", "google-images": "Google Images", "yahoo": "Yahoo", "msn": "MSN", "aol": "AOL", "ask": "Ask", "bing": "Bing", "yandex": "Yandex", "baidu": "Baidu", "lycos": "Lycos", "duckduckgo": "DuckDuckGo" }, "offlineSources": { "import": "Import", "api": "API", "form": "Analytics", "analytics": "Analytics", "migration": "Migration", "salesforce": "Salesforce", "integration": "Integration", "contactsWeb": "Web contacts", "walIncremental": "WAL incremental", "task": "Task", "email": "Email", "workflows": "Workflow", "calculated": "Calculated", "social": "Social", "batchUpdate": "Batch update", "signals": "Signals", "biden": "Biden", "default": "Default", "companies": "Companies", "deals": "Deals", "assists": "Assists", "presentations": "Presentations", "tally": "Tally", "sidekick": "Sidekick", "crmUI": "CRM user interface", "mergeContacts": "Merge contacts", "portalUserAssociator": "Portal user associator", "integrationsPlatform": "Integrations platform", "inboxConnection": "Inbox connection", "forwardToCrm": "Forward to CRM", "engagements": "Engagements", "sales": "Sales", "heisenberg": "Heisenberg", "leadin": "Leadin", "academy": "Academy", "salesMessages": "Sales messages", "avatarsService": "Avatars service", "mergeCompanies": "Merge companies", "sequences": "Sequences", "companyFamilies": "Company families", "mobileIOS": "iOS mobile app", "mobileAndroid": "Android mobile app", "contacts": "Contacts", "associations": "Associations", "extension": "HubSpot extension", "success": "Success", "bot": "Chatflow", "integrationsSync": "Integration sync pipeline", "automationPlatform": "Automation platform", "conversations": "Conversations", "contentMembership": "Content membership", "quotes": "Quotes", "betAssignment": "BET assignment", "quotas": "Quotas", "betCrmConnector": "BET CRM connector", "meetings": "Meetings", "mergeObjects": "Merge objects", "bccToCrm": "BCC to CRM", "emailIntegration": "Email integration", "gmailIntegration": "Gmail integration" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "reporting-data": {
    "en": "static-1.9792"
  }
};
  result.translationsAvailable = {
  "reporting-data": {
    "de": "static-1.9792",
    "en": "static-1.9792",
    "es": "static-1.9792",
    "fr": "static-1.9792",
    "ja": "static-1.9792",
    "nl": "static-1.9792",
    "pt-br": "static-1.9792"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:reporting-data:en', {version: 'static-1.9792'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "recordProperties": { "_no_value_": "(No value)", "about_us": "About us", "account_id": "Account ID", "accounting": "Accounting", "active": "Active", "activity_assigned_to": "Activity assigned to", "activity_created_by": "Activity created by", "activity_date": "Activity date", "address": "Address", "airlines_aviation": "Airlines/Aviation", "alternative_dispute_resolution": "Alternative Dispute Resolution", "alternative_medicine": "Alternative Medicine", "amount": "Amount", "amount_after_conversion_in_the_home_currency": "Amount after conversion in the home currency", "amount_in_company_currency": "Amount in company currency", "amount_in_home_currency": "Amount in company currency", "animation": "Animation", "annually": "Annually", "annual_revenue": "Annual revenue", "analytics_history": "Analytics history", "apparel___fashion": "Apparel & Fashion", "appointment_scheduled": "Appointment scheduled", "approval_not_needed": "Approval not needed", "approved": "Approved", "architecture___planning": "Architecture & Planning", "arts_and_crafts": "Arts and Crafts", "associated_company": "Associated company", "associated_company_id": "Associated company ID", "associated_contacts": "Associated contacts", "associated_deals": "Associated deals", "attached_video_name": "Attached video name", "attached_video_opened": "Attached video opened", "attached_video_watched": "Attached video watched", "attempted_to_contact": "Attempted to contact", "automotive": "Automotive", "average_pageviews": "Average page views", "average_ticket_resolution_time": "Average ticket resolution time", "average_ticket_response_time": "Average ticket response time", "average_support_nps": "Average support NPS", "aviation___aerospace": "Aviation & Aerospace", "bad_timing": "Bad timing", "banking": "Banking", "became_a_customer_date": "Became a customer date", "became_a_lead_date": "Became a lead date", "became_a_marketing_qualified_lead_date": "Became a marketing qualified lead date", "became_a_sales_qualified_lead_date": "Became a sales qualified lead date", "became_a_subscriber_date": "Became a subscriber date", "became_an_evangelist_date": "Became an evangelist date", "became_an_opportunity_date": "Became an opportunity date", "became_an_other_lifecycle_date": "Became an other lifecycle date", "became_another_lifecycle_date": "Became another lifecycle date", "biotechnology": "Biotechnology", "birthdays": "Birthday", "broadcast_clicks": "Broadcast clicks", "broadcast_media": "Broadcast Media", "building_materials": "Building Materials", "business_supplies_and_equipment": "Business Supplies and Equipment", "busy": "Busy", "buying_role": "Buying Role", "call": "Call", "call_duration": "Call duration (ms)", "call_outcome": "Call outcome", "calls_made": "Calls made", "campaign_ids": "Campaign IDs", "campaign_of_last_booking_in_meetings_tool": "Campaign of last booking in meetings tool", "capital_markets": "Capital Markets", "category": "Category", "checkboxes": "Checkboxes", "chemicals": "Chemicals", "city": "City", "civic___social_organization": "Civic & Social Organization", "civil_engineering": "Civil Engineering", "close_date": "Close date", "closed": "Closed", "closed_lost": "Closed lost", "closed_lost_reason": "Closed lost reason", "closed_won": "Closed won", "closed_won_reason": "Closed won reason", "comments_to_buyer": "Comments to buyer", "commercial_real_estate": "Commercial Real Estate", "company": "Company", "company_city": "Company city", "company_country": "Company country", "company_domain_name": "Company domain name", "company_id": "Company ID", "company_information": "Company information", "company_name": "Company name", "company_owner": "Company owner", "company_phone": "Company phone", "company_size": "Company size", "company_state": "Company state", "company_street_address_1": "Company address 1", "company_street_address_2": "Company address 2", "company_zip": "Company zip", "completed": "Completed", "computer___network_security": "Computer & Network Security", "computer_games": "Computer Games", "computer_hardware": "Computer Hardware", "computer_networking": "Computer Networking", "computer_software": "Computer Software", "connected": "Connected", "construction": "Construction", "consumer_electronics": "Consumer Electronics", "consumer_goods": "Consumer Goods", "consumer_services": "Consumer Services", "contact_id": "Contact ID", "contact_information": "Contact information", "contact_owner": "Contact owner", "contact_priority": "Contact priority", "contract_sent": "Contract sent", "conversion_information": "Conversion information", "cosmetics": "Cosmetics", "cost_of_goods_sold": "Cost of goods sold", "country": "Country", "country_region": "Country/Region", "create_date": "Create date", "cta": "CTA", "currency": "Currency", "currency_exchange_rate": "Currency exchange rate", "current_generator_s_": "Current generator's?", "currently_in_sequence": "Now in Sequence", "currently_in_workflow": "Now in Workflow", "custom_email_address": "Custom email address", "customer": "Customer", "daily": "Daily", "dairy": "Dairy", "date": "Date", "date_of_birth": "Date of birth", "date_of_last_meeting_booked_in_meetings_tool": "Date of last meeting booked in meetings tool", "days_to_close": "Days to close", "deal_currency_code": "Deal currency code", "deal_description": "Deal Description", "deal_id": "Deal ID", "deal_information": "Deal information", "deal_name": "Deal name", "deal_owner": "Deal owner", "deal_stage": "Deal stage", "deal_stage_probability": "Deal stage probability", "deal_type": "Deal type", "deals_created": "Deals created", "decision_maker_bought_in": "Decision Maker Bought-In", "default_hubspot_blog_email_subscription": "Default HubSpot blog email subscription", "defense___space": "Defense & Space", "deferred": "Deferred", "degree": "Degree", "description": "Description", "design": "Design", "direct_traffic": "Direct traffic", "discount_amount": "Discount Amount", "discount_percentage": "Discount Percentage", "domain": "Domain", "domain_to_which_registration_email_was_sent": "Domain to which registration email was sent", "domains": "Domains", "draft": "Draft", "dropdown": "Dropdown", "e_learning": "E-Learning", "education_management": "Education Management", "electrical_electronic_manufacturing": "Electrical/Electronic Manufacturing", "email": "Email", "email_subscription": "Email subscription", "email_address_quarantined": "Email address quarantined", "email_address_quarantined_reason": "Email address quarantined reason", "email_confirmation_status": "Email confirmation status", "email_confirmed": "Email Confirmed", "email_domain": "Email Domain", "email_information": "Email information", "email_marketing": "Email marketing", "email_property": "Email property", "email_received_from_contact": "Email received from contact", "email_sent_to_contact": "Email sent to contact", "emails_bounced": "Emails bounced", "emails_clicked": "Emails clicked", "emails_delivered": "Emails delivered", "emails_opened": "Emails opened", "employees": "Employees", "end_date": "End date", "entertainment": "Entertainment", "enum": "Enum", "environmental_services": "Environmental Services", "esign_date": "ESign date", "esign_enabled": "ESign enabled", "esign_number_of_signers_required": "ESign number of signers required", "esign_completed_signatures": "ESign completed signatures", "evangelist": "Evangelist", "event_revenue": "Event Revenue", "events_services": "Events Services", "executive_office": "Executive Office", "expiration_date": "Expiration date", "facebook_clicks": "Facebook clicks", "facebook_company_page": "Facebook company page", "facebook_fans": "Facebook fans", "facebook_lead_ad_properties": "Facebook Lead Ad Properties", "facilities_services": "Facilities Services", "farming": "Farming", "fax_number": "Fax number", "feature_request_tracked": "Feature request tracked", "feedback": "Feedback", "feedback_channel": "Feedback channel", "feedback_comment": "Feedback comment", "feedback_form_type": "Feedback form type", "feedback_rating": "Feedback rating", "feedback_sentiment": "Feedback sentiment", "feedback_survey_id": "Feedback survey ID", "feedback_survey_type": "Feedback survey type", "field_of_study": "Field of study", "file_upload": "File upload", "financial_services": "Financial Services", "fine_art": "Fine Art", "first_agent_response_date": "First agent response date", "first_agent_email_response_date": "First agent email response date", "first_contact_create_date": "First contact create date", "first_conversion": "First conversion", "first_conversion_date": "First conversion date", "first_deal_created_date": "First deal created date", "first_marketing_email_click_date": "First marketing email click date", "first_marketing_email_open_date": "First marketing email open date", "first_marketing_email_send_date": "First marketing email send date", "first_name": "First name", "first_page_seen": "First page seen", "first_referring_site": "First referring site", "first_seen": "First seen", "first_touch_converting_campaign": "First touch converting campaign", "fishery": "Fishery", "follow_up_action": "Follow up action", "follower_count": "Follower count", "followers": "Followers", "following": "Following", "food___beverages": "Food & Beverages", "food_production": "Food Production", "form_submission": "Form submission", "freely_given_consent_from_contact": "Freely given consent from contact", "friends_count": "Friends count", "from_greenhouse": "From Greenhouse", "full_name": "Full name", "fund_raising": "Fund-Raising", "furniture": "Furniture", "gambling___casinos": "Gambling & Casinos", "gender": "Gender", "glass__ceramics___concrete": "Glass, Ceramics & Concrete", "google_plus_clicks": "Google Plus clicks", "google_plus_page": "Google plus page", "government_administration": "Government Administration", "government_relations": "Government Relations", "graduation_date": "Graduation date", "graphic_design": "Graphic Design", "health__wellness_and_fitness": "Health, Wellness and Fitness", "higher_education": "Higher Education", "home_currency_code": "Home currency code", "hospital___health_care": "Hospital & Health Care", "hospitality": "Hospitality", "hs_created_by_user_id": "Created by user ID", "hs_createdate": "Object create date/time", "hs_facebook_ad_clicked": "Clicked Facebook ad", "hs_google_click_id": "Google ad click ID", "hs_lastmodifieddate": "Object last modified date/time", "hs_object_id": "Object ID", "hs_timestamp": "Activity date", "hs_updated_by_user_id": "Updated by user ID", "note_body": "Note body", "hubspot_owner": "HubSpot owner", "hubspot_score": "HubSpot score", "hubspot_team": "HubSpot team", "hubspot_twitter_id": "HubSpot twitter ID", "human_resources": "Human Resources", "id": "ID", "ideal_customer_profile_tier": "Ideal Customer Profile Tier", "import": "Import", "import_and_export": "Import and Export", "in_progress": "In progress", "inactive": "Inactive", "individual___family_services": "Individual & Family Services", "industrial_automation": "Industrial Automation", "industry": "Industry", "information_services": "Information Services", "information_technology_and_services": "Information Technology and Services", "instant": "Instant", "insurance": "Insurance", "international_affairs": "International Affairs", "international_trade_and_development": "International Trade and Development", "internet": "Internet", "internet_service_provider": "Internet service provider", "investment_banking": "Investment Banking", "investment_management": "Investment Management", "ip_address": "IP address", "ip_city": "IP city", "ip_country": "IP country", "ip_country_code": "IP country code", "ip_state_code_region_code": "IP state/region code", "ip_state_region": "IP state/region", "ip_timezone": "IP time zone", "is_public": "Is public", "issue_fixed": "Issue fixed", "job_function": "Job function", "job_title": "Job title", "judiciary": "Judiciary", "klout_score": "Klout score", "languages": "Languages", "last_activity_date": "Last activity date", "last_ces_survey_comment": "Last CES survey comment", "last_ces_survey_date": "Last CES survey date", "last_ces_survey_rating": "Last CES survey rating", "last_contacted": "Last contacted", "last_contacted_date": "Last contacted date", "last_customer_reply_date": "Last customer reply date", "last_email_activity": "Last email activity", "last_marketing_email_click_date": "Last marketing email click date", "last_marketing_email_name": "Last marketing email name", "last_marketing_email_open_date": "Last marketing email open date", "last_marketing_email_send_date": "Last marketing email send date", "last_meeting_booked": "Last meeting booked", "last_meeting_booked_campaign": "Last meeting booked campaign", "last_meeting_booked_medium": "Last meeting booked medium", "last_meeting_booked_source": "Last meeting booked source", "last_meetings_tool_submission": "Last meetings tool submission", "last_meetings_tool_submission_campaign": "Last meetings tool submission campaign", "last_meetings_tool_submission_medium": "Last meetings tool submission medium", "last_meetings_tool_submission_source": "Last meetings tool submission source", "last_modified_date": "Last modified date", "last_name": "Last name", "last_nps_survey_comment": "Last NPS survey comment", "last_nps_survey_date": "Last NPS survey date", "last_nps_survey_rating": "Last NPS survey rating", "last_page_seen": "Last page seen", "last_referring_site": "Last referring site", "last_sales_activity_date": "Last Sales Activity Date", "last_salesforce_sync_time": "Last Salesforce sync time", "last_seen": "Last seen", "last_touch_converting_campaign": "Last touch converting campaign", "law_enforcement": "Law Enforcement", "law_practice": "Law Practice", "lead": "Lead", "lead_id": "Lead ID", "lead_rating": "Lead rating", "lead_source": "Lead source", "lead_status": "Lead status", "left_live_message": "Left live message", "left_voicemail": "Left voicemail", "legal_basis_for_processing_contact_s_data": "Legal basis for processing contact's data.", "legal_services": "Legal Services", "legislative_office": "Legislative Office", "legitimate_interest___existing_customer": "Legitimate interest – existing customer", "legitimate_interest___other": "Legitimate interest - other", "legitimate_interest___prospect_lead": "Legitimate interest – prospect/lead", "leisure__travel___tourism": "Leisure, Travel & Tourism", "level": "Level", "libraries": "Libraries", "lifecycle_stage": "Lifecycle stage", "likelihood_to_close": "Likelihood to close", "linkedin_bio": "LinkedIn bio", "linkedin_clicks": "LinkedIn clicks", "linkedin_company_page": "LinkedIn company page", "linkedin_connections": "LinkedIn connections", "list_membership": "List membership", "location": "Location", "logistics_and_supply_chain": "Logistics and Supply Chain", "luxury_goods___jewelry": "Luxury Goods & Jewelry", "machinery": "Machinery", "management_consulting": "Management Consulting", "marital_status": "Marital status", "maritime": "Maritime", "market_research": "Market Research", "marketing_and_advertising": "Marketing and Advertising", "marketing_email_confirmation_status": "Marketing email confirmation status", "marketing_emails_bounced": "Marketing emails bounced", "marketing_emails_clicked": "Marketing emails clicked", "marketing_emails_delivered": "Marketing emails delivered", "marketing_emails_opened": "Marketing emails opened", "marketing_qualified_lead": "Marketing qualified lead", "max_employees": "Max employees", "max_revenue": "Max revenue", "mechanical_or_industrial_engineering": "Mechanical or Industrial Engineering", "media_production": "Media Production", "medical_devices": "Medical Devices", "medical_practice": "Medical Practice", "medium_of_last_booking_in_meetings_tool": "Medium of last booking in meetings tool", "meetings_booked": "Meetings booked", "meetings_link": "Meetings link", "membership_notes": "Membership notes", "membership_status": "Membership status", "mental_health_care": "Mental Health Care", "message": "Message", "military": "Military", "military_status": "Military status", "min_employees": "Min employees", "min_revenue": "Min revenue", "mining___metals": "Mining & Metals", "mobile_phone_number": "Mobile phone number", "monthly": "Monthly", "most_recent_social_click": "Most recent social click", "motion_pictures_and_film": "Motion Pictures and Film", "museums_and_institutions": "Museums and Institutions", "music": "Music", "name": "Name", "nanotechnology": "Nanotechnology", "new": "New", "newspapers": "Newspapers", "next_activity_date": "Next activity date", "no_answer": "No answer", "non_profit_organization_management": "Nonprofit Organization Management", "none": "None", "not_applicable": "Not applicable", "not_started": "Not started", "notes": "Notes", "notes_last_updated": "Notes last updated", "number_of_child_companies": "Number of child companies", "number_of_companies": "Number of companies", "number_of_contacts": "Number of contacts", "number_of_employees": "Number of employees", "number_of_event_completions": "Number of event completions", "number_of_form_submissions": "Number of form submissions", "number_of_locations": "Number of locations", "number_of_notes": "Number of notes", "number_of_pageviews": "Number of page views", "number_of_sales_activities": "Number of sales activities", "number_of_times_contacted": "Number of times contacted", "number_of_unique_forms_submitted": "Number of unique forms submitted", "number_of_visitors": "Number of visitors", "number_of_visits": "Number of sessions", "number_of_sessions": "Number of sessions", "object_id": "Object ID", "offline": "Offline", "offline_sources": "Offline Sources", "oil___energy": "Oil & Energy", "online_media": "Online Media", "open": "Open", "open_deal": "Open deal", "opportunity": "Opportunity", "opportunity_stage": "Opportunity stage", "opted_out_of_all_email": "Opted out of all email", "opted_out_of_email__blog_fr_subscription": "Opted out of email: Blog FR Subscription", "opted_out_of_email__customer_service_communication": "Opted out of email: Customer Service Communication", "opted_out_of_email__default_hubspot_blog_subscription": "Opted out of email: Default HubSpot blog subscription", "opted_out_of_email__hubspot_support": "Opted out of email: HubSpot support", "opted_out_of_email__marketing_information": "Opted out of email marketing information", "opted_out_of_email__one_to_one": "Opted out of email: One to one", "organic_search": "Organic search", "original_source": "Original Source", "original_source_data_1": "Original source data 1", "original_source_data_2": "Original source data 2", "original_source_drill_down_1": "Original source drill-down 1", "original_source_drill_down_2": "Original source drill-down 2", "original_source_type": "Original source type", "original_value": "The internal value for this property is {{ originalValue }}. Use this internal value when creating a list or saved filter.", "other": "Other", "other_campaigns": "Other campaigns", "other_money_property": "Other money property", "outsourcing_offshoring": "Outsourcing/Offshoring", "owner_assigned_date": "Owner assigned date", "owner_email": "Owner email", "owner_id": "Owner ID", "owner_name": "Owner name", "package_freight_delivery": "Package/Freight Delivery", "packaging_and_containers": "Packaging and Containers", "paid_search": "Paid search", "paid_social": "Paid social", "paper___forest_products": "Paper & Forest Products", "parent_company": "Parent company", "payment_date": "Payment date", "payment_enabled": "Payment enabled", "pending_approval": "Pending approval", "performance_of_a_contract": "Performance of a contract", "performing_arts": "Performing Arts", "persona": "Persona", "pharmaceuticals": "Pharmaceuticals", "philanthropy": "Philanthropy", "phone_number": "Phone number", "photography": "Photography", "pipeline": "Pipeline", "plastics": "Plastics", "political_organization": "Political Organization", "postal_code": "Postal code", "predictive_close_probability": "Predictive close probability", "predictive_contact_priority": "Predictive contact priority", "predictive_lead_score": "Predictive Lead Score", "preferred_language": "Preferred language", "presentation_scheduled": "Presentation scheduled", "primary": "Primary", "primary_secondary_education": "Primary/Secondary Education", "printing": "Printing", "priority": "Priority", "product_description": "Product description", "product_id": "Product ID", "product_interest": "Product interest", "product_name": "Product name", "product_price": "Product price", "product_source_application_id": "Product source application ID", "professional_training___coaching": "Professional Training & Coaching", "program_development": "Program Development", "public": "Public", "public_policy": "Public Policy", "public_relations_and_communications": "Public Relations and Communications", "public_safety": "Public Safety", "publishing": "Publishing", "qualified_to_buy": "Qualified to buy", "quantity": "Quantity", "quarterly": "Quarterly", "queue_membership_ids": "Queue Memberships", "quote_amount": "Quote amount", "quote_approval_feedback": "Quote approval feedback", "quote_approval_status": "Quote approval status", "quote_approver": "Quote approver", "quote_number": "Quote number", "quote_owner": "Quote owner", "quote_pdf_download_link": "Quote PDF download link", "quote_title": "Quote title", "quote_template": "Quote template", "railroad_manufacture": "Railroad Manufacture", "ranching": "Ranching", "rating": "Rating", "real_estate": "Real Estate", "recent_conversion": "Recent conversion", "recent_conversion_date": "Recent conversion date", "recent_deal_amount": "Recent deal amount", "recent_deal_close_date": "Recent deal close date", "recent_document_revisit_date": "Recent document revisit date", "recent_sales_email_clicked_date": "Recent sales emails clicked date", "recent_sales_email_opened_date": "Recent sales email open date", "recent_sales_email_replied_date": "Recent sales email replied date", "recreational_facilities_and_services": "Recreational Facilities and Services", "recurring_billing_frequency": "Recurring billing frequency", "referrals": "Referrals", "refund_applied": "Refund applied", "registered_at": "Registered at", "rejected": "Rejected", "relationship_status": "Relationship status", "religious_institutions": "Religious Institutions", "renewables___environment": "Renewables & Environment", "research": "Research", "resolution": "Resolution", "response": "Response", "response_group": "Feedback response group", "restaurants": "Restaurants", "retail": "Retail", "revenue": "Revenue", "sales_qualified_lead": "Sales qualified lead", "salesforce_contact_id": "Salesforce contact ID", "salesforce_information": "Salesforce information", "salesforce_opportunity_stage": "Salesforce opportunity stage", "salesforce_owner_email": "Salesforce owner email", "salesforce_owner_id": "Salesforce owner ID", "salesforce_owner_name": "Salesforce owner name", "salesforce_url": "Salesforce URL", "salutation": "Salutation", "school": "School", "security_and_investigations": "Security and Investigations", "select_an_outcome": "Select an outcome", "semiconductors": "Semiconductors", "seniority": "Seniority", "sender_company_image_url": "Sender company image URL", "sends_since_last_engagement": "Sends since last engagement", "sent_knowledge_document_link": "Sent knowledge document link", "shipbuilding": "Shipbuilding", "sic_code": "SIC code", "signature": "Signature", "signature_required": "Signature required", "social_media": "Social media", "social_media_information": "Social media information", "source": "Source", "source_data_1": "Source Data 1", "source_data_2": "Source Data 2", "source_of_last_booking_in_meetings_tool": "Source of last booking in meetings tool", "sporting_goods": "Sporting Goods", "sports": "Sports", "staffing_and_recruiting": "Staffing and Recruiting", "start_date": "Start Date", "state_region": "State/Region", "status": "Status", "status_count": "Status count", "street_address": "Street address", "street_address_2": "Street address 2", "submission_url": "Submission URL", "subscriber": "Subscriber", "supermarkets": "Supermarkets", "survey_id": "Survey Id", "survey_type": "Survey type", "suspicious_form_activity": "Suspicious Form Activity", "sync_amount": "Sync amount", "target_account": "Target Account", "target_account_beta": "Target Account Beta", "task_owner": "Task owner", "tax": "Tax", "telecommunications": "Telecommunications", "template_1___original": "Template 1 - Original", "template_2___basic": "Template 2 - Basic", "template_3___modern": "Template 3 - Modern", "term": "Term", "terms": "Terms", "textiles": "Textiles", "think_tanks": "Think Tanks", "ticket_owner": "Ticket owner", "ticket_id": "Ticket ID", "ticket_information": "Ticket information", "ticket_name": "Ticket name", "ticket_status": "Ticket status", "ticket_description": "Ticket description", "tickets_closed": "Tickets closed", "time_first_seen": "Time first seen", "time_last_seen": "Time last seen", "time_registration_email_was_sent": "Time registration email was sent", "time_of_first_session": "Time of first session", "time_of_first_visit": "Time of first session", "time_of_last_session": "Time of last session", "time_of_last_visit": "Time of last session", "time_to_close": "Time to close", "time_to_first_agent_email_reply": "Time to first agent email reply", "time_zone": "Time zone", "tobacco": "Tobacco", "to_do": "To-do", "total_money_raised": "Total money raised", "total_revenue": "Total revenue", "translation_and_localization": "Translation and Localization", "transportation_trucking_railroad": "Transportation/Trucking/Railroad", "tweets": "Tweets", "twitter_bio": "Twitter bio", "twitter_clicks": "Twitter clicks", "twitter_followers": "Twitter followers", "twitter_handle": "Twitter handle", "twitter_profile": "Twitter Profile", "twitter_profile_photo": "Twitter profile photo", "twitter_username": "Twitter username", "type": "Type", "unqualified": "Unqualified", "unsubscribed_from_all_email": "Unsubscribed from all email", "utilities": "Utilities", "venture_capital___private_equity": "Venture Capital & Private Equity", "veterinary": "Veterinary", "view_on_twitter": "View on Twitter", "waiting": "Waiting", "waiting_on_contact": "Waiting on contact", "waiting_on_us": "Waiting on us", "warehousing": "Warehousing", "web_analytics_history": "Web analytics history", "web_conference_meeting_id": "Web conference meeting ID", "web_technologies": "Web technologies", "website": "Website", "website_url": "Website URL", "weekly": "Weekly", "wholesale": "Wholesale", "wine_and_spirits": "Wine and Spirits", "wireless": "Wireless", "work_email": "Work email", "writing_and_editing": "Writing and Editing", "wrong_number": "Wrong number", "year_founded": "Year founded", "favorite": "Favorite" }, "bidenProperties": { "name": "Name", "domain": "Domain", "address": "Street address", "city": "City", "public": "Public", "address1": "Street address 1", "address2": "Street address 2", "state": "State/Region", "zipcode": "Postal code", "countrycode": "Country", "twitterusername": "Twitter handle", "twitterurl": "Twitter URL", "overview": "Overview", "shortdescription": "Short description", "longdescription": "Long description", "joblistingurl": "Job listing URL", "logourl": "Logo URL", "squareimageurl": "Square image URL", "facebookpageurl": "Facebook company page", "favorite": "Favorite", "linkedinbio": "LinkedIn bio", "linkedinurl": "LinkedIn company page", "latitude": "Latitude", "longitude": "Longitude", "dnsresolves": "DNS resolves", "industrycode": "Industry", "phonenumber": "Phone number", "timezone": "Time zone", "foundedyear": "Year founded", "nonprofit": "Is nonprofit", "totalmoneyraised": "Total money raised", "minrevenue": "Min revenue", "maxrevenue": "Max revenue", "minemployees": "Min employees", "maxemployees": "Max employees", "relatedcompanies": "Related companies", "industries": "Industries", "technologies": "Technologies", "blogurl": "Blog URL", "crunchbaseurl": "CrunchBase URL", "parkeddomain": "Parked domain", "approximatelocation": "Location", "unsafeforbrowsing": "Is Unsafe for Browsing", "organization": "Organization", "sourcedata1": "Source data 1", "sourcedata2": "Source data 2", "firsttimestamp": "First seen", "lasttimestamp": "Last seen", "numvids": "Number of visitors", "numvidslastday": "Number of visitors today", "numvidslastweek": "Number of visitors in the last week", "numvidslastmonth": "Number of visitors in the last month", "numvidslastyear": "Number of visitors in the last year", "numpageviews": "Number of page views", "numpageviewslastday": "Number of page views today", "numpageviewslastweek": "Number of page views in the last week", "numpageviewslastmonth": "Number of page views in the last month", "numpageviewslastyear": "Number of page views in the last year", "originalsource": "Source", "isp": "Internet service provider" }, "attributionProperties": { "hs_analytics_source_data_1": "Source data 1", "hs_analytics_source_data_2": "Source data 2", "hs_analytics_source": "Source", "hs_asset_title": "Content title", "hs_asset_type": "Content type", "hs_asset_url": "Content URL", "hs_attribution_type": "Attribution type", "hs_campaign_guid": "HubSpot campaign", "hs_campaign_name": "HubSpot campaign", "hs_campaign": "Campaign", "hs_canonical_url": "Canonical URL", "hs_contact_id": "Contact name", "hs_contact_ids": "Contact names", "hs_deal_amount": "Deal amount", "hs_deal_close_date": "Deal close date", "hs_deal_create_date": "Deal create date", "hs_deal_dealtype": "Deal type", "hs_deal_id": "Deal", "hs_deal_name": "Deal", "hs_deal_owner": "Deal owner", "hs_deal_pipeline": "Deal pipeline", "hs_email_campaign_group_id": "Email campaign group", "hs_email_campaign_id": "Email campaign", "hs_first_touch_amount": "First interaction", "hs_first_touch_percentage": "First interaction", "hs_full_path_amount": "Full-path", "hs_full_path_percentage": "Full-path", "hs_last_touch_amount": "Last interaction", "hs_last_touch_percentage": "Last interaction", "hs_linear_amount": "Linear", "hs_linear_percentage": "Linear", "hs_processed_timestamp": "Processed date", "hs_referrer_url": "Referrer URL", "hs_time_decay_amount": "Time-decay", "hs_time_decay_percentage": "Time-decay", "hs_touchpoint_positions": "Interaction result", "hs_touchpoint_source": "Interaction source", "hs_touchpoint_timestamp": "Interaction date", "hs_touchpoint_type": "Interaction type", "hs_touchpoint_url": "Interaction URL", "hs_u_amount": "U-shaped", "hs_u_percentage": "U-shaped", "hs_w_amount": "W-shaped", "hs_w_percentage": "W-shaped", "ad_click": "Ad click", "ad": "Ads", "blog_post": "Blog post", "call": "Call", "contact_import": "Contact import", "conversation": "Conversation", "cta_click": "CTA click", "deal_closed_won": "Deal closed won", "deal_create": "Deal created", "email_click": "Marketing email click", "external_page": "External page", "first_interaction": "First interaction", "form_submission": "Form submission", "integrations": "Integration", "knowledge_article": "Knowledge article", "landing_page": "Landing page", "last_interaction": "Last interaction", "lead_create": "Lead created", "lead_creation": "Contact import", "listing_page": "Listing page", "marketing_email": "Marketing email", "meeting": "Meeting", "middle": "Middle", "misc_hubspot_page": "Misc. HubSpot page", "other": "Other lead creation", "page_view": "Page view", "sales_email_reply": "Sales email reply", "sales_email": "Sales email", "sales": "Sales", "social_post_click": "Social post click", "social_post": "Social post", "submission": "Form submission", "visit": "Page view", "website_page": "Website page", "direct_traffic": "Direct traffic", "email_marketing": "Email marketing", "offline": "Offline Sources", "offline_sources": "Offline Sources", "organic_search": "Organic search", "other_campaigns": "Other campaigns", "paid_search": "Paid search", "paid_social": "Paid social", "referrals": "Referrals", "social_media": "Social media", "very_high": "Very High", "high": "High", "medium": "Medium", "low": "Low", "disqualified": "Disqualified" } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "property-translator": {
    "en": "static-1.561"
  }
};
  result.translationsAvailable = {
  "property-translator": {
    "cs": "static-1.561",
    "da": "static-1.561",
    "de": "static-1.561",
    "el": "static-1.561",
    "en": "static-1.561",
    "es-mx": "static-1.561",
    "es": "static-1.561",
    "fi": "static-1.561",
    "fr": "static-1.561",
    "it": "static-1.561",
    "ja": "static-1.561",
    "ko": "static-1.561",
    "nl": "static-1.561",
    "no": "static-1.561",
    "pl": "static-1.561",
    "pt-br": "static-1.561",
    "sv": "static-1.561",
    "zh-cn": "static-1.561",
    "zh-hk": "static-1.561"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:property-translator:en', {version: 'static-1.561'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "customerDataContent": { "noRecipients": { "disabledTooltip": "You must choose a recipient" }, "GDPR": { "buttons": { "legalBasis": "You must give a legal basis." } }, "MeetingsGetStarted": { "cta": { "header": "Book meetings without the hassle", "text": "Say goodbye to the endless back and forth of scheduling meetings with your own dedicated link. Your schedule, your way.", "button": "Get started" } }, "MeetingsSelect": { "manageLinks": "Manage meetings links", "menuLabel": "Meetings", "placeholderName": "{{ minutes }} minute meeting" }, "quotesPQL": { "title": "Create and send Quotes", "text": "Let your products shine. Use quotes to look professional, continue the conversation, and win those deals." }, "QuotesSelect": { "menuLabel": "Quotes", "header": "Quote links by deal for {{ name }}", "expiredQuote": "{{ quoteTitle }} (expired)", "generatedOn": "Created on {{ date }}", "noQuoteGenerated": "No published quote", "helpText": "How do I create quotes?", "createQuote": "Create quote", "emptyState": { "CONTACT": "This contact isn't associated with any published quotes.", "COMPANY": "This company isn't associated with any published quotes.", "DEAL": "This deal has no published quotes." } }, "SalesContentMenu": { "buttons": { "templates": "Templates", "sequences": "Sequences", "documents": "Documents" } }, "salesToolPlugins": { "DOCUMENT": { "help": "created by {{ name }}" }, "TEMPLATES": { "help": "created by {{ name }}" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "customer-data-content": {
    "en": "static-1.3700"
  }
};
  result.translationsAvailable = {
  "customer-data-content": {
    "de": "static-1.3700",
    "en": "static-1.3700",
    "es": "static-1.3700",
    "fr": "static-1.3700",
    "ja": "static-1.3700",
    "nl": "static-1.3700",
    "pt-br": "static-1.3700"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:customer-data-content:en', {version: 'static-1.3700'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "customerDataObjects": { "DealStageIdSelect": { "allClosedWon": "All closed won" }, "OwnerIdSelect": { "all": "All owners", "me": "Me", "meDescription": "This value is dynamically applied to the current user", "none": "No owner" }, "OwnerName": { "deactivated": "Deactivated User ({{ name }})", "unnamed": "Unnamed" }, "TicketStageIdSelect": { "allClosed": "All closed" }, "objectNames": { "CONTACT": { "one": "contact", "other": "contacts" }, "COMPANY": { "one": "company", "other": "companies" }, "DEAL": { "one": "deal", "other": "deals" }, "TICKET": { "one": "ticket", "other": "tickets" }, "unknownNumber": { "CONTACT": "contacts", "COMPANY": "companies", "DEAL": "deals", "TICKET": "tickets" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "customer-data-objects": {
    "en": "static-1.562"
  }
};
  result.translationsAvailable = {
  "customer-data-objects": {
    "de": "static-1.562",
    "en": "static-1.562",
    "es": "static-1.562",
    "fr": "static-1.562",
    "ja": "static-1.562",
    "nl": "static-1.562",
    "pt-br": "static-1.562"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:customer-data-objects:en', {version: 'static-1.562'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "customerDataObjectsUiComponents": { "Association": { "noResults": "No results found", "searchBy": "Search {{ type }}", "searching": "Searching...", "start": "Type to search...", "associationFailedError": { "generic": "There was an error updating this record's associations.", "associationLimitExceeded": { "COMPANY_TO_CONTACT": "The associations couldn't be updated, you can only associate up to {{ associationLimit }} contacts with a company.", "DEAL_TO_CONTACT": "The associations couldn't be updated, you can only associate up to {{ associationLimit }} contacts with a deal.", "TICKET_TO_CONTACT": "The associations couldn't be updated, you can only associate up to {{ associationLimit }} contacts with a ticket.", "CONTACT_TO_DEAL": "The associations couldn't be updated, you can only associate up to {{ associationLimit }} deals with a contact.", "COMPANY_TO_DEAL": "The associations couldn't be updated, you can only associate up to {{ associationLimit }} deals with a company.", "TICKET_TO_DEAL": "The associations couldn't be updated, you can only associate up to {{ associationLimit }} deals with a ticket.", "CONTACT_TO_TICKET": "The associations couldn't be updated, you can only associate up to {{ associationLimit }} tickets with a contact.", "COMPANY_TO_TICKET": "The associations couldn't be updated, you can only associate up to {{ associationLimit }} tickets with a company.", "DEAL_TO_TICKET": "The associations couldn't be updated, you can only associate up to {{ associationLimit }} tickets with a deal.", "generic": "The associations couldn't be updated, the limit of {{ associationLimit }} associations of this type per record has been reached." } } }, "Associations": { "preview": "Preview" }, "ChangePipelineDialog": { "save": "Save", "title": { "DEAL": "Change deal pipeline", "TICKET": "Change ticket pipeline" } }, "ContactChicklet": { "titleAtCompany": "{{title}} at {{company}}" }, "DealChicklet": { "closeDate": "<b>Close date:</b> {{ value }}", "editableStage": "<b>Stage:</b> ", "stage": "<b>Stage:</b> {{ value }}", "title": "{{currencyAmount}} {{ dealName }}" }, "FeedbackChicklet": { "label": "Last response:", "title": { "CES": "Customer Support Survey (CES)", "CSAT": "Customer Satisfaction Survey (CSAT)", "KNOWLEDGE": "Knowlegde Article Feedback", "NPS": "Customer Loyalty Survey (NPS)" }, "response": "Response: {{ response }}", "responseQuotes": "\"{{ response }}\"", "dateLabel": "Date:", "rating": { "label": "Rating:", "CES": { "DETRACTOR": "Difficult ({{ rating }}/7)", "PASSIVE": "Neutral ({{ rating }}/7)", "PROMOTER": "Easy ({{ rating }}/7)" }, "CSAT": { "DETRACTOR": "Unhappy", "PASSIVE": "Neutral", "PROMOTER": "Happy" }, "NPS": { "DETRACTOR": "Detractor ({{ rating }}/10)", "PASSIVE": "Passive ({{ rating }}/10)", "PROMOTER": "Promoter ({{ rating }}/10)" }, "KNOWLEDGE": { "HELPFUL": "Helpful", "UNHELPFUL": "Unhelpful" } }, "association": { "TICKET": { "timeToClose": "Time to close:" } } }, "DealStageIdSelect": { "allClosedWon": "All closed won" }, "ObjectTypes": { "CONTACT": "contacts", "COMPANY": "companies", "DEAL": "deals", "TASK": "tasks", "VISIT": "visits" }, "Permissions": { "emptyStateExplanation": "(You're only allowed to view items that you own or are assigned to.)", "learnMore": "Learn more about permissions", "exportDisabled": "Sorry. You're not authorized to export contacts.", "importDisabled": "Sorry. You're not authorized to import {{ objectTypeLabel }}.", "importExportDisabled": "Sorry. You're not authorized to do that.", "deleteDisabled": "Sorry. You're not authorized to delete this {{ objectTypeLabel }}.", "mergeDisabled": "Sorry. You're not authorized to merge this {{ objectTypeLabel }}.", "sendOptInEmailDisabled": "Sorry. You're not authorized to opt this contact in.", "optOutOfEmailDisabled": "Sorry. You're not authorized to opt this contact out.", "closeAsCustomerDisabled": "Sorry. You're not authorized to close this contact.", "editPropertiesDisabled": "Sorry. You're not authorized to edit properties.", "editDefaultPropertiesDisabled": "Sorry. You're not authorized to edit portal defaults.", "editDealStagesDisabled": "Sorry. You're not authorized to edit deal stages.", "editTicketStagesDisabled": "Sorry. You're not authorized to edit ticket stages.", "editTicketFeedbackDisabled": { "noClosedState": "Support surveys can not be turned on. A ticket pipeline requires a closed state. Please edit your ticket stage properties.", "noPipelines": "A pipeline is required to enable support surveys. Please edit your survey recipients." }, "enableLeadScoreDisabled": "Sorry. You don't have permission to turn on Predictive Lead Scoring.", "deletePropertyDisabled": "Sorry. You're not authorized to bulk delete.", "restoreObjectsDisabled": { "CONTACT": "You don't have permission to restore contacts.", "COMPANY": "You don't have permission to restore companies.", "DEAL": "You don't have permission to restore deals.", "TICKET": "You don't have permission to restore tickets." }, "editDisabled": "Sorry. You don't have permission to edit {{ objectTypeLabel }}.", "createDisabled": "Sorry. You don't have permission to create {{ objectTypeLabel }}.", "editUnownedDisabled": "Sorry. You don't have permission to edit all of these {{ objectTypeLabel }}.", "notOwnedDisabled": "Sorry. You don't have permission to edit this {{ objectTypeLabel }} because you don't own it.", "enableRecordingDisabled": "You don't have permission to change this setting.", "createContactModal": "Sorry. You don't have permission to view this contact.", "createCompanyModal": "Sorry. You don't have permission to view this company.", "billing": "Sorry. You don't have permission to manage Pro billing. Only team admin can edit these settings.", "editPipelines": "Sorry. You don't have permission to edit deal pipelines and deal stages.", "pipelines": { "DEAL": "Sorry. You don't have permission to edit deal pipelines and deal stages.", "TICKET": "Sorry. You don't have permission to edit ticket pipelines and ticket stages." }, "viewAttachmentDisabled": "Sorry. You don't have permission to view this attachment.", "activityTypes": "Changes to call & meeting types can only be made by account admins.", "communicationPermissionDisabled": "You don’t have access to communication tools because of your user permissions.", "floatingCommunicatorPermissionDisabled": "You don't have access to communication tools. Talk to your account admin about changing your permissions.", "betCannotCreateDeal": "You can't create a deal for a contact that is owned by a queue.", "betCannotCreateDealBanishedDomain": "You can't create a deal because the domain is banished.", "generic": { "unknown": "Sorry. You don't have permission to do that.", "setting": "Sorry. You don't have permission to edit this setting." }, "duplicatesCenterNoPermissions": { "CONTACT": "You don't have permission to manage duplicate contacts.", "COMPANY": "You don't have permission to manage duplicate companies." } }, "TicketChicklet": { "closeDate": "Closed on {{ date }}", "dueDate": "Due {{ date }}", "noStatus": "Status: Unavailable", "timeOpen": "Open {{ lengthOfTime }}", "priority": { "LOW": "Low", "MEDIUM": "Medium", "HIGH": "High", "Unassigned": "Unassigned priority" }, "editableStatus": "Status:", "status": "<b>Stage:</b> {{ value }}", "owner": "Owner:", "ownerReadOnly": "Owner: {{ ownerName }}", "ownerPlaceholder": "Select owner" }, "Tooltips": { "removeAssociation": "Remove association" } }, "invalidValue": "Invalid value", "componentErrorAlert": { "title": "There was a problem displaying this page.", "message_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Please ",
createElement( options,
"Link",
props,
"refresh" ),
" the page. If this message reappears wait a few minutes before trying again." ); } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "customer-data-objects-ui-components": {
    "en": "static-1.2524"
  }
};
  result.translationsAvailable = {
  "customer-data-objects-ui-components": {
    "de": "static-1.2524",
    "en": "static-1.2524",
    "es": "static-1.2524",
    "fr": "static-1.2524",
    "ja": "static-1.2524",
    "nl": "static-1.2524",
    "pt-br": "static-1.2524"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:customer-data-objects-ui-components:en', {version: 'static-1.2524'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "customerDataPropertyUtils": { "PropertyDisplay": { "associatedcompanyid": "Associated company", "associatedcontactid": "Associated contact", "engagementType": "Type", "formSubmissions": "Form submission", "inbounddbImport": "Import", "listMemberships": "List membership", "taskBody": "Body", "taskCreatedBy": "Created by", "taskDueDate": "Due date", "taskOwner": "Assigned to", "taskRelatesTo": "Associated with", "taskReminder": "Reminder", "taskStatus": "Status", "taskSubject": "Title", "taskType": "Task type" }, "PropertyOptionDisplay": { "CALL": "Call", "COMPLETED": "Completed", "DEFERRED": "Deferred", "EMAIL": "Email", "IN_PROGRESS": "In progress", "MEETING": "Meeting", "NOTE": "Note", "NOT_STARTED": "Not started", "TASK": "Task", "WAITING": "Waiting" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "customer-data-property-utils": {
    "en": "static-1.570"
  }
};
  result.translationsAvailable = {
  "customer-data-property-utils": {
    "de": "static-1.570",
    "en": "static-1.570",
    "es": "static-1.570",
    "fr": "static-1.570",
    "ja": "static-1.570",
    "nl": "static-1.570",
    "pt-br": "static-1.570"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:customer-data-property-utils:en', {version: 'static-1.570'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "customerDataProperties": { "AddOptionRow": { "addOption": "Add an option" }, "CustomOptionsModal": { "apply": "Apply", "cancel": "Cancel", "delimiterDescription": "Use a comma, semi-colon, or any custom text to separate labels from values (for example, \"label 1, value 1\" or \"label 2; value 2\")", "delimiterLabel": "Add delimiter (optional)", "delimiterPlaceholder": "Add a delimiter", "keepOptions": "Add to the current options", "label": "Place your options on their own line", "placeholder": "Cat\nDog\nFish", "replaceOptions": "Replace the current options", "title": "Paste in property options" }, "DeleteSecondaryEmailPrompt": { "buttonText": "Delete", "emailTitle": "Are you sure you want to delete the email {{ email }}?", "emailMessage": "Deleting this email address can't be undone." }, "PersonaSearchableSelectInput": { "noPersona": "No persona" }, "PropertyDefaultsByFieldType": { "affirmative": "Yes", "negative": "No" }, "PropertyDomain": { "error": { "invalidDomain": "{{ domain }} is not a valid domain." } }, "PropertyEditForm": { "noOptions": "Enumeration properties must have at least one option.", "labelConflict": "You already have a property called \"{{ propertyLabel }}\" ({{ propertyName}}).", "tooltip": { "hubspotProperty": "This field is provided by HubSpot and can't be edited or deleted.", "noPermission": "You're not authorized to edit this field. Please talk to your manager or account administrator about changing your permissions." } }, "PropertyFieldTypes": { "booleancheckbox": "Single checkbox", "calculation": "Calculation", "calculation_equation": "Equation", "calculation_rollup": "Rollup", "calculation_score": "Score", "checkbox": "Multiple checkboxes", "date": "Date picker", "file": "File", "number": "Number", "radio": "Radio select", "select": "Dropdown select", "OWNER": "HubSpot user", "text": "Single-line text", "textarea": "Multi-line text" }, "PropertyFieldTypesDisabled": { "isInUse": "This property is in use and cannot be changed into this type ({{ fieldType }}).", "isCreated": "Properties cannot be changed into this property ({{ fieldType }}). Create a new property instead.", "default": "This property field type cannot be changed." }, "PropertyForm": { "disabledDisplayHintTooltip": "You can only choose one of currency or unformatted at a time.", "disabledDisplayHintTooltipWithPercentage": "You can only choose one of currency, percent, or unformatted at a time.", "noOptions": "Enumeration properties must have at least one option.", "currency": { "description": "Format your property as a currency.", "label": "Currency" }, "numberDisplay": { "description": "Remove formatting from your property.", "label": "Unformatted number" }, "percentageDisplay": { "description": "Format your property as a percentage.", "label": "Percentage number" }, "searchable": { "description": "Allow users to search for any info added to this field.", "label": "Add to search" }, "descriptionLabel": "Description", "fieldTypeLabel": "Field type", "fieldTypeDisabled": "{{ propertyType }} property types can't be changed.", "groupLabel": "Group", "searchLimit": "You’ve already added search to three custom properties. To add search to this property, you need to remove search from another.", "labelConflict": "Sorry, you already have a property called \"{{ propertyName }}\". Please select a different label.", "labelLabel": "Label", "nameConflict": "A property named \"{{ propertyName }}\" already exists.", "nameHelp": "This unique identifier is used when syncing with our integration partners. It can't be edited.", "nameInfo": "Internal names can only have lowercase letters a-z, numbers 0-9, and underscores. They must start with a letter.", "nameLabel": "Internal name", "optional": "Optional", "showInForms": { "description": "Use in forms, pop-up forms, and bots.", "label": "Show in forms" } }, "PropertyGroupNameSelect": { "defaultEmptyLabel": "Loading...", "defaultPlaceholder": "Select a property group" }, "PropertyInput": { "selectPlaceholder": "Select an option", "errorMessageNonUniqueEmail": "This email address already belongs to a contact in your database. <a href='https://knowledge.hubspot.com/articles/kcs_article/contacts/why-cant-i-save-a-new-email-address-for-my-contact' target='_blank'>Learn more.</a>", "errorMessageInvalidEmail": "This is not a valid email address.", "delete": "Delete", "makePrimary": "Make primary", "owner": { "deactivatedOwner": "(Deactivated owner)", "SalesforceOwner": "(Salesforce)" } }, "PropertyInputMultiDomain": { "primaryDomain": "Primary domain", "secondaryDomain": { "one": "Merged domain", "other": "Merged domains" } }, "PropertyInputMultipleEmail": { "addEmail": "Add email address", "commaSeparatorKey": ", ", "label": "Email address", "primaryEmailTag": "Primary", "permissionsAlert": { "editContact": "Your permissions don't allow you to edit a contact." }, "genericError": "This email property update couldn't be saved" }, "PropertyInputText": { "error": { "nameContainsDoubleQuote": "A contact name can't contain a double quote (\") character" } }, "PropertyInputRelativeDate": { "at": "at", "custom": "Custom Date", "preset": { "today": "Today", "tomorrow": "Tomorrow", "oneBusinessDay": "In 1 business day ({{ day }})", "twoBusinessDays": "In 2 business days ({{ day }})", "threeBusinessDays": "In 3 business days ({{ day }})", "oneWeek": "In 1 week ({{ day }})", "twoWeeks": "In 2 weeks ({{ day }})", "oneMonth": "In 1 month ({{ day }})", "threeMonths": "In 3 months ({{ day }})", "sixMonths": "In 6 months ({{ day }})" } }, "PropertyInputTaskReminder": { "at": "at", "custom": "Custom", "sendReminder": "Send reminder", "preset": { "sameTime": "At task due time", "halfHourBefore": "30 minutes before", "hourBefore": "1 hour before", "dayBefore": "1 day before", "weekBefore": "1 week before" } }, "PropertyOptionPresets": { "acceptability": { "acceptable": "Acceptable", "label": "Acceptability", "neutral": "Neutral", "noAnswer": "Not applicable", "not": "Unacceptable", "somewhat": "Somewhat acceptable", "verynot": "Totally unacceptable" }, "age": { "label": "Age", "noAnswer": "Prefer not to answer", "over65": "65 or above", "under18": "Under 18" }, "country": { "label": "Country" }, "day": { "Friday": "Friday", "Monday": "Monday", "Saturday": "Saturday", "Sunday": "Sunday", "Thursday": "Thursday", "Tuesday": "Tuesday", "Wednesday": "Wednesday", "label": "Days of the week" }, "difficulty": { "label": "Difficulty", "neutral": "Neutral", "noAnswer": "Not applicable", "not": "Easy", "somewhat": "Difficult", "very": "Very difficult", "verynot": "Very easy" }, "education": { "associate": "Associate degree", "bachelor": "Bachelor's degree", "grad": "Graduate or professional degree", "highSchool": "High school graduate or equivalent", "label": "Education", "someCollege": "Some college", "someHighSchool": "Some high school", "tradeSchool": "Trade or vocational degree" }, "employment": { "disabled": "Disabled", "full": "Full time", "homemaker": "Homemaker", "label": "Employment", "part": "Part time", "retired": "Retired", "self": "Self employed", "student": "Student", "unemployed": "Unemployed" }, "ethnicity": { "africanAmerican": "African American", "asian": "Asian", "caucasian": "Caucasian", "hispanic": "Hispanic", "label": "Ethnicity", "nativeAmerican": "Native American", "other": "Other" }, "gender": { "Female": "Female", "Male": "Male", "Neither": "Neither", "PreferNot": "I prefer not to say", "label": "Gender" }, "importance": { "important": "Important", "label": "Importance", "neutral": "Neutral", "noAnswer": "Not applicable", "not": "Not at all important", "somewhat": "Somewhat important", "very": "Very important" }, "marital": { "divorced": "Divorced", "label": "Marital status", "married": "Married", "noAnswer": "Prefer not to answer", "single": "Single" }, "month": { "April": "April", "August": "August", "December": "December", "February": "February", "January": "January", "July": "July", "June": "June", "March": "March", "May": "May", "November": "November", "October": "October", "September": "September", "label": "Month of the year" }, "priority": { "LOW": "Low", "MEDIUM": "Medium", "HIGH": "High", "NONE": "None" }, "queueMembership": { "NONE": "None" }, "satisfaction": { "label": "Satisfaction", "neutral": "Neutral", "noAnswer": "Not applicable", "not": "Unsatisfied", "somewhat": "Satisfied", "very": "Very satisfied", "verynot": "Very unsatisfied" }, "state": { "label": "State (United States)" }, "timezone": { "label": "Timezone" }, "year": { "label": "Year" } }, "PropertyOptionsEditInput": { "disabledCheckBox": "Some of these property options can't be edited because they're read-only. Please use the checkboxes next to each property below.", "internalValue": "Internal value", "label": "Label", "merge": "Merge", "noBlankMerge": "Property options can't be merged when one of the selected options is blank. Please delete the blank property instead.", "objectCount": { "COMPANY": "Companies with this value", "CONTACT": "Contacts with this value", "DEAL": "Deals with this value", "TICKET": "Tickets with this value" }, "paginator": { "perPage": "{{ count }} per page", "showAll": "Show all {{ optionCount }} options" }, "remove": "Remove", "selectAllOptions": "Toggle selection for all rows", "selected": "{{ count }} selected", "showInForms": "Show in forms", "title": { "booleancheckbox": "Single checkbox options", "checkbox": "Checkbox options", "radio": "Radio select options", "select": "Dropdown options", "text": "Dropdown options", "number": "Score options" } }, "PropertyOptionsEditItem": { "toggleRow": "Toggle row" }, "PropertyOptionsInput": { "addOption": "Add an option", "clearOptions": "Clear all", "duplicateLabel": "An option named {{ label }} already exists.", "emptyLabel": "A blank option already exists." }, "PropertyOptionsItem": { "optionNumber": "Option {{ number }}", "placeholder": "Enter Label", "valuePlaceholder": "Enter Value" }, "PropertyOptionsPresetsButton": { "back": "Back", "buttonLabel": "Load options...", "cancel": "Cancel", "chooseOptions": "Choose options", "chooseProperty": "Choose property", "copyFromProperty": "Copy from property", "pasteOptions": "Paste in your own options", "propertyCopyTitle": "Property to copy options from", "title": "Load options" }, "SaveBar": { "cancel": "Cancel", "info": "You've changed {{ changes }}", "save": "Save", "viewRecord": "View record" }, "alertUpdatePropertiesError": "Sorry, there was an issue saving your change. Please try again.", "StageChangeDialog": { "completedProperties": "Previously completed properties" }, "dealStageChangeModal": { "title": "Move deal", "message": { "one": "Before you can move <b>{{ name }}</b> to <b>{{ stage }}</b> you will need to update this property", "other": "Before you can move <b>{{ name }}</b> to <b>{{ stage }}</b> you will need to update these properties" } }, "ticketStageChangeModal": { "title": "Move ticket", "message": "Before you can move <b>{{ name }}</b> to <b>{{ stage }}</b> you may need to update properties." }, "dealClosedModal": { "syncMessage": "The associated contacts and company will become customers automatically." }, "CalculatedPropertyFormBuilder": { "calculatedPropertType": { "label": "Calculated property type", "options": { "EQUATION": "Custom equation", "MIN": "Min", "MAX": "Max", "COUNT": "Count", "SUM": "Sum", "AVERAGE": "Average" }, "help": { "MIN": "The lowest value of this property for your object type.", "MAX": "The highest value of this property for your object type.", "COUNT": "A count of object type records with a value in the property you choose.", "SUM": "The sum of the values in this property.", "AVERAGE": "The average of the values in this property." } }, "tabs": { "CONDITION_TAB": "Condition", "FORMULA_TAB": "Formula" }, "formula": { "custom": { "addToEquation": "Add to equation", "collapse": "Collapse", "deleteItemHelp": "Delete this item", "expand": "Expand" }, "rollup": { "chooseType": "Choose the associated record type", "chooseProperty": "Choose the associated record property" } }, "condition": { "description": "If this condition is true, we will calculate this property.", "createButton": "Create condition", "deleteButton": "Delete condition", "dropdown": { "placeholder": "Choose a Property", "search": "Search for a property" } } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "customer-data-properties": {
    "en": "static-1.3897"
  }
};
  result.translationsAvailable = {
  "customer-data-properties": {
    "de": "static-1.3897",
    "en": "static-1.3897",
    "es": "static-1.3897",
    "fr": "static-1.3897",
    "ja": "static-1.3897",
    "nl": "static-1.3897",
    "pt-br": "static-1.3897"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:customer-data-properties:en', {version: 'static-1.3897'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "customerDataUiUtilities": { "BaseDialog": { "save": "Save", "cancel": "Cancel" }, "DeleteDialog": { "rejectLabel": "Cancel", "confirmApplyToAll": { "CONTACT": "Yes I want to delete all contacts", "COMPANY": "Yes I want to delete all companies", "DEAL": "Yes I want to delete all deals", "TICKET": "Yes I want to delete all tickets" } }, "ListEditor": { "nextItemLabel": "Next item" }, "NavigationConfirmation": { "abandonChanges": { "leave": "Leave this page", "stay": "Stay on this page", "title": "Are you sure you want to leave this page?" } }, "PermissionTooltip": { "cta": "Please talk to your manager or account administrator about changing your permissions." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "customer-data-ui-utilities": {
    "en": "static-1.2165"
  }
};
  result.translationsAvailable = {
  "customer-data-ui-utilities": {
    "cs": "static-1.2165",
    "da": "static-1.2165",
    "de": "static-1.2165",
    "en": "static-1.2165",
    "es-mx": "static-1.2165",
    "es": "static-1.2165",
    "fi": "static-1.2165",
    "fr": "static-1.2165",
    "it": "static-1.2165",
    "ja": "static-1.2165",
    "nl": "static-1.2165",
    "no": "static-1.2165",
    "pl": "static-1.2165",
    "pt-br": "static-1.2165",
    "sv": "static-1.2165",
    "zh-cn": "static-1.2165",
    "zh-hk": "static-1.2165"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:customer-data-ui-utilities:en', {version: 'static-1.2165'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "crm_components": { "Associations": { "noResults": "No results found", "searchBy": "Search {{ type }}", "searching": "Searching", "start": "Type to search", "preview": "Preview" }, "AssociationDialog": { "DEAL": { "checkboxLabel": "Select {{ name }}", "confirmLabel": "Done", "createButtonLabel": "Create a deal", "createMessage": "Can't find the deal you're looking for?", "name": "{{ name }}", "noResults": "No deals found.", "placeholder": "Search by name", "results": "RESULTS", "selected": "Selected", "selectedMicroCopy": "This is where deals you’ve selected to associate with {{ objectName }} will go.", "title": "Associate deals with {{ objectName }}", "helperText": "Deals already added to a company won’t show in results" }, "TICKET": { "checkboxLabel": "Select {{ name }}", "confirmLabel": "Done", "createButtonLabel": "Create a ticket", "createMessage": "Can't find the ticket you're looking for?", "header": "Find Ticket", "name": "{{ name }}", "noResults": "No tickets found.", "placeholder": "Search by name", "results": "RESULTS", "selected": "Selected", "selectedMicroCopy": "This is where tickets you’ve selected to associate with {{ objectName }} will go.", "title": "Associate tickets with {{ objectName }}", "helperText": "Tickets already added to a company won’t show in results" } }, "Attachment": { "fileSize": { "bytes": "{{ size }} bytes", "kb": "{{ size }} KB", "mb": "{{ size }} MB" }, "viewDisabled": "Sorry. You don't have permission to view this attachment." }, "Communicator": { "floatingCommunicator": { "activity": "Activity", "task": "Task", "schedule": "Schedule", "note": "Note", "email": "Email", "call": "Call", "tooltips": { "close": "Close" } }, "Note": { "cancelLabel": "Discard", "placeholder": "Start typing to leave a note", "saveLabel": "Save note" }, "Email": { "address": "{{ name }} <small>({{ address }})</small>", "integrateEmail": { "gmail": "Connect Gmail", "imap": "Connect Other (IMAP)", "knowledgePrompt": { "connectInbox": "Learn more" }, "outlook365": "Connect Office 365", "title": { "connectInbox": "Keep track of your email activity in your CRM", "default": "Connect with your email" }, "tooltips": { "chooseAnotherAddress": "Choose another email address" }, "usage": { "connectAccountInbox": "The from address you've selected isn't connected to HubSpot. You must connect {{ emailAddress }} before you can use it to send emails from your CRM.", "connectInbox": "Connect your email account to HubSpot to begin sending emails from your CRM. All your email conversations will appear in the timeline below.", "enable": "The connection for {{ emailAddress }} is currently disabled. You must enable it before you can use it to send emails from your CRM.", "reconnect": "Sorry. {{ emailAddress }} is no longer connected to HubSpot CRM. Please reconnect now so that this email thread can be recorded." }, "useAddress": "Send this email from {{ emailAddress }} instead", "visitSettings": { "connectAccountInbox": "Connect {{ emailAddress }}", "enable": "Enable the connection for {{ emailAddress }}" } }, "interaction": { "cancel": "Cancel", "editorPlaceholder": "Type something brilliant…", "problem": { "deliverability": { "title": "An email sent to this address has bounced in the past.", "description": "Please choose a different address or send it using your personal email account." }, "noEmailAddress": { "title": "We don't have an email address for the contact you'd like to email.", "description": "Please configure an email address for this contact." }, "loading": { "title": "Sorry. Something went wrong.", "description": "Emailing isn't available right now.<br /><br /><i>HubSpot is seeing the following error: {{ codes }}</i>" }, "invalidUser": { "title": "Sorry. Something went wrong.", "description": "Emailing isn't available right now. HubSpot can't locate the primary email account for user {{ emailAddress }}." } }, "send": "Send" }, "recipients": { "bcc": "Bcc", "cc": "Cc", "choose": "Choose a recipient", "to": "To" }, "sender": { "from": "From", "notIntegrated": "This email isn't integrated with HubSpot. Go to your settings to sync your email." }, "subject": { "label": "Subject", "placeholder": "Add a subject" }, "tooltips": { "noContacts": "This email won't show up in the timeline because there is no contact addressed.", "mandatoryFields": "Emails require a subject and a body", "invalidAttachments": "Attachments have errors", "isTracked": "HubSpot tracks opens and clicks on emails sent through the CRM", "noRecipient": "No recipient selected", "trackingTitle": "Email tracking" }, "verifyEmail": { "description": "Your email address must be verified before you can send an email.", "error": "There was an issue sending the confirmation email. Please try again in a moment.", "resend": "Resend confirmation email", "resent": "Confirmation email sent. Please check your inbox.", "title": "Please verify your email." } } }, "TicketStageIdSelect": { "allClosed": "All closed" }, "DeleteDialog": { "rejectLabel": "Cancel", "confirmApplyToAll": { "CONTACT": "Yes I want to delete all contacts", "COMPANY": "Yes I want to delete all companies", "DEAL": "Yes I want to delete all deals", "TICKET": "Yes I want to delete all tickets" } }, "GDPR": { "alerts": { "addSubscription": "{{ label }} added.", "removeSubscription": "{{ label }} removed." }, "buttons": { "save": "Save", "cancel": "Cancel", "disabled": "All fields are required.", "legalBasis": "You must give a legal basis." }, "inputs": { "email": { "placeholder": "Select email address", "label": "Email address" }, "explanation": { "label": "Explanation for communication consent", "placeholder": "Explain why you are legally allowed to communicate with this contact." }, "lawfulBasisSelectForProcessingDate": { "label": "Add legal basis for processing contact's data" }, "lawfulBasisSelectForAddingSubscription": { "label": "Legal basis for communicating with contact" }, "subscriptionTypeSelect": { "label": "Communication subscription type" } }, "dialogs": { "notApplicable": { "title": { "one": "Mark this contact as not applicable?", "other": "Mark these contacts as not applicable?" }, "body": { "one": "Please confirm privacy laws and regulations don't need to be applied for this contact.", "other": "Please confirm privacy laws and regulations don't need to be applied for these contacts." }, "note": { "one": "<b>Note:</b> You'll still be able to add communication subscriptions to this contact.", "other": "<b>Note:</b> You'll still be able to add communication subscriptions to these contacts." }, "confirmLabel": { "one": "Contact not applicable", "other": "Contacts not applicable" } }, "legalBasis": { "title": "Give legal basis" }, "addSubscription": { "back": "Back to subscriptions", "historyBack": "Back to history", "title": "Communication subscription", "subTitle": "Subscriptions will be edited for the primary email address for the contact. This will not change unsubscribes the recipient has explicitly requested.", "table": { "add": "Add another subscription", "subscriptionType": "Communication subscription type", "email": "Email address", "delete": "Unsubscribe" } }, "subscription": { "title": "Communication subscriptions" } }, "errors": { "SINGLE_SUBSCRIPTION_RESUB_ERROR": "{{ label }} couldn't be added to {{ email }} as they have unsubscribed from it", "PORTAL_WIDE_RESUB_ERROR": "{{ label }} couldn't be added to {{ email }} as they have unsubscribed from the account" } }, "GDPRDeleteDialog": { "permissions": { "cantDelete": "You do not have permission to GDPR delete this contact. Please talk to your manager or account administrator about changing your permissions." }, "normalDeleteLabel_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Delete this contact with the ability to restore it for up to 90 days. ",
createElement( options,
"Link",
{ href: "https://knowledge.hubspot.com/articles/kcs_article/contacts/restore-deleted-contacts-companies-deals-or-tickets", external: true, use: "on-bright" },
"Learn more" ) ); }, "gdprDeleteLabel_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Permanently delete this contact and all its associated content to follow privacy laws and regulations. ",
createElement( options,
"Link",
{ href: "https://knowledge.hubspot.com/articles/kcs_article/contacts/how-do-i-perform-a-gdpr-compliant-delete-in-hubspot", external: true, use: "on-bright" },
"Learn more" ) ); } }, "GenericInboxForm": { "emailLabel": "Email address" }, "GenericModal": { "saveChangesButton": "Save changes", "searchPropertiesPlaceholder": "Search properties", "browseByCategory": "Browse by category", "noProperty": "Looks like that property doesn't exist.", "createPropertyText": "Don't see the property you're looking for? ", "addPropertyLink": "Create a property", "deleteTypeButton": { "contacts": "Delete contacts", "companies": "Delete companies", "deals": "Delete deals", "tasks": "Delete tasks", "visits": "Delete visits", "prospects": "Delete prospects", "engagement": "Delete engagements", "campaign": "Delete campaigns", "onboarding": "Delete onboarding", "lists": "Delete lists", "products": "Delete products", "page": "Delete page" }, "cancelActionButton": "Cancel", "saveActionButton": "Save", "saveChangesCancel": "Cancel", "addButtonLabel": "Create", "addAndNewButtonLabel": "Create and add another", "categoryType": { "contact": "Contact", "company": "Company", "task": "Task", "deal": "Deal", "products": "Products" }, "provideCategoryType": "Please provide {{ categoryType }}.", "unableToCreate": { "invalidProp": { "CONTACT": "The contact couldn't be created because of an invalid property value.", "COMPANY": "The company couldn't be created because of an invalid property value.", "TASK": "The task couldn't be created because of an invalid property value.", "TICKET": "The ticket couldn't be created because of an invalid property value.", "DEAL": "The deal couldn't be created because of an invalid property value." }, "genericError": { "CONTACT": "The contact couldn't be created.", "COMPANY": "The company couldn't be created.", "TASK": "The task couldn't be created.", "TICKET": "The ticket couldn't be created.", "DEAL": "The deal couldn't be created." }, "associationLimitExceeded": { "COMPANY_TO_CONTACT": "The contact couldn't be created. You can only associate up to {{ associationLimit }} contacts with a company." }, "detailedError": { "INVALID_EMAIL": "Invalid Email Address" }, "gdprError": "This email address is blacklisted and can't be used to create a contact." }, "dealTitleStub": "{{ subject }} - New Deal", "similarCompanies": "Similar existing companies", "quantity": "Quantity", "addProduct": "Add product" }, "InteractionWithNavigationConfirmation": { "abandonChanges": { "prompt": "You haven't saved your {{ objectType }} yet. If you leave now, your changes will be lost." } }, "ObjectTypes": { "CONTACT": "contacts", "COMPANY": "companies", "DEAL": "deals", "TASK": "tasks", "VISIT": "visits" }, "OnboardingTriggerBanners": { "confirm": "Start the tour", "reject": "Dismiss" }, "OwnerIdSelect": { "all": "All owners", "me": "Me", "none": "No owner" }, "PropertyFieldTypeSelect": { "placeholder": "Select a field type..." }, "PropertyForm": { "noOptions": "Enumeration properties must have at least one option.", "currency": { "description": "Enable this option if you would like the property to be formatted as currency", "label": "Currency" }, "numberDisplay": { "description": "Enable this option if you would like the property to not be formatted.", "label": "Unformatted number" }, "searchable": { "description": "Allow users to search for any info added to this field.", "label": "Add to search" }, "descriptionLabel": "Description", "fieldTypeLabel": "Field type", "groupLabel": "Group", "searchLimit": "You’ve already added search to three custom properties. To add search to this property, you need to remove search from another.", "labelConflict": "Sorry, you already have a property called \"{{ propertyName }}\". Please select a different label.", "labelLabel": "Label", "nameConflict": "A property named \"{{ propertyName }}\" already exists.", "nameHelp": "This unique identifier is used when syncing with our integration partners. It can't be edited.", "nameInfo": "Property names must contain only lowercase letters, numbers, and underscores. They must start with a letter.", "nameLabel": "Internal name", "optional": "Optional", "showInForms": { "description": "Use in forms, lead flows, and bots.", "label": "Show in forms" } }, "PropertyGroupNameSelect": { "defaultEmptyLabel": "Loading...", "defaultPlaceholder": "Select a property group" }, "PropertyInput": { "selectPlaceholder": "Select an option", "errorMessageNonUniqueEmail": "This email address already belongs to a contact in your database. <a href='https://knowledge.hubspot.com/articles/kcs_article/contacts/why-cant-i-save-a-new-email-address-for-my-contact' target='_blank'>Learn more.</a>", "errorMessageInvalidEmail": "This isn't a valid email address.", "delete": "Delete", "makePrimary": "Make primary" }, "PropertyListEditor": { "success": "Your properties have been saved.", "error": "There was a problem saving your selection", "dealStageSuccess": "Your update deal stage properties have been saved.", "disabledReason": { "CONTACT": "An email address or name is always required to create a contact", "COMPANY": "A company name is always required to create a company", "DEAL": "A deal name, pipeline, and deal stage are always required to create a deal", "TICKET": "A ticket name and status are always required to create a ticket." }, "defaultRequiredProperties": { "CONTACT": "Contacts will need either an email address or name to be created.", "COMPANY": "Companies will need either a name or domain to be created.", "DEAL": "Deals need a deal name, pipeline, and deal stage to be created.", "TICKET": "Tickets need a ticket name and status to be created." }, "title": { "dealstage": "Update deal stage properties", "ticketStage": "Update ticket stage properties", "creator": { "CONTACT": "Contact creator properties", "COMPANY": "Company creator properties", "DEAL": "Deal creator properties", "TICKET": "Ticket creator properties" }, "columns": "Choose which columns you see", "recordProperties": { "CONTACT": "Contact Record Properties", "COMPANY": "Company Record Properties", "DEAL": "Deal Record Properties", "TICKET": "Ticket Record Properties" } }, "selectAll": "Select all properties", "selected": { "COLUMN_SETTINGS": { "one": "Selected column", "other": "Selected columns ({{ count }})" }, "FAVORITE_PROPERTIES": { "one": "Selected property", "other": "Selected properties ({{ count }})" }, "CREATOR_PROPERTIES": { "one": "Selected property", "other": "Selected properties ({{ count }})", "required": "Required" }, "DEAL_STAGE_PROPERTIES": { "one": "Selected property", "other": "Selected properties ({{ count }})", "required": "Required" }, "TICKET_STAGE_PROPERTIES": { "one": "Selected property", "other": "Selected properties ({{ count }})", "required": "Required" } }, "removeAll": { "COLUMN_SETTINGS": "Remove all columns", "FAVORITE_PROPERTIES": "Remove all properties", "CREATOR_PROPERTIES": "Remove all properties", "DEAL_STAGE_PROPERTIES": "Remove all properties", "TICKET_STAGE_PROPERTIES": "Remove all properties" }, "previewLink": { "DEAL_STAGE_PROPERTIES": "Preview popup", "TICKET_STAGE_PROPERTIES": "Preview popup" }, "propertyTypeHeader": { "CONTACT": "Contacts", "COMPANY": "Companies", "DEAL": "Deals", "ADVANCED": "Advanced" }, "propertyTypeCategoryPrefix": { "CONTACT": "Contacts: {{ groupLabel }}", "COMPANY": "Companies: {{ groupLabel }}", "DEAL": "Deals: {{ groupLabel }}", "ADVANCED": "Advanced properties" } }, "SalesProPQL": { "pro": "Professional", "activityTypes": { "title": "Align activities across your sales teams", "subTitle": "Custom call and meeting types offer organization on how your team logs sales activities. Gain access to reporting that shows how effective each type is in your sales process." }, "multiplePipelines": { "button": "Add another pipeline", "title": "Add your own custom deal pipelines into your CRM.", "subTitle": "Empower your sales team and organize your sales process with the ability to create multiple deal pipelines." }, "requiredFields": { "tooltip": "Unlock required fields by upgrading to Sales Professional.", "message": "Need to keep your team aligned?", "button": "Set fields as required.", "title": "Streamline your team's creation process", "subTitleCreate": "Capture consistent data for new contacts, companies, and deals by customizing which fields are required.", "subTitleStages": "Capture consistent data for deals by customizing which fields are required when you move a deal to a new stage" }, "table": { "subscriptionType": "Communication subscription type", "emailAddress": "Email Address", "add": "Add another subscription" } }, "ServiceProPQL": { "pro": "Professional", "multiplePipelines": { "tooltip": "Unlock multiple pipelines by upgrading to Service Professional.", "button": "Add another pipeline", "title": "Add your own custom ticket pipelines into your CRM.", "subTitle": "Empower your support team and organize your support process with the ability to create multiple ticket pipelines." }, "requiredFields": { "tooltip": "Unlock required fields by upgrading to Service Professional.", "message": "Need to keep your team aligned?", "button": "Set fields as required.", "title": "Streamline your team's creation process", "subTitleCreate": "Set up which fields are required when creating new contacts, companies, and tickets. This will help you capture consistent info.", "subTitleStages": "Capture consistent data for tickets by customizing which fields are required when you move a ticket to a new stage" } }, "ShowMore": { "showMore": "Load more.", "remainingCount": "...and {{ count }} more. {{ showMoreButton }}" }, "restoreObjectsButton": { "restoreObjectsDisabled": { "CONTACT": "You don't have permission to restore contacts. Talk to your administrator to restore contacts.", "COMPANY": "You don't have permission to restore companies. Talk to your administrator to restore companies.", "DEAL": "You don't have permission to restore deals. Talk to your administrator to restore deals.", "TICKET": "You don't have permission to restore tickets. Talk to your administrator to restore tickets." } }, "previewDealStagePropertiesDialog": { "DEAL": { "title": "Move deal (preview)", "saveAndMove": "Save and move deal", "message": "Before you move this deal, you'll need to update these properties" }, "TICKET": { "title": "Move ticket (preview)", "saveAndMove": "Save and move ticket", "message": "Before you move this ticket, you'll need to update these properties" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "crm_components": {
    "en": "static-3.7556"
  }
};
  result.translationsAvailable = {
  "crm_components": {
    "de": "static-3.7556",
    "en": "static-3.7556",
    "es": "static-3.7556",
    "fr": "static-3.7556",
    "ja": "static-3.7556",
    "nl": "static-3.7556",
    "pt-br": "static-3.7556"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:crm_components:en', {version: 'static-3.7556'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "analyticsAndTracking": { "pageTitle": "Reports & Analytics Tracking", "saved": { "disabledReason": "Fix errors before saving", "success": "Successfully saved Reports & Analytics Tracking settings.", "error": { "deletingDomain": { "message": "An error occurred while deleting a domain. Please try again, or contact support if the problem persists.", "withWarning": "An error occurred while deleting a domain: {{ message }}" }, "creatingDomain": { "message": "An error occurred while adding a domain. Please try again, or contact support if the problem persists.", "withWarning": "An error occurred while adding a domain: {{ message }}" }, "deletingView": { "message": "An error occurred while deleting a view. Please try again, or contact support if the problem persists.", "withWarning": "An error occurred while deleting a view: {{ message }}" }, "restoringView": { "message": "An error occurred while restoring a view. Please try again, or contact support if the problem persists.", "withWarning": "An error occurred while restoring a view: {{ message }}" }, "creatingView": { "message": "An error occurred while creating your view. Please try again, or contact support if the problem persists.", "withWarning": "An error occurred while creating your view: {{ message }}" }, "updatingView": { "message": "An error occurred while updating your view. Please try again, or contact support if the problem persists.", "withWarning": "An error occurred while updating your view: {{ message }}" }, "settings": { "message": "An error occurred while saving Reports & Analytics Tracking settings. Please try again, or contact support if the problem persists.", "withWarning": "An error occurred while saving Reports & Analytics Tracking settings: {{ message }}" }, "SUBDOMAIN_CONTAINS_FQDN": "The provided website subdomain appears to be a full domain.", "URL_PATH_CONTAINS_FULL_URL": "The provided URL path and query match appears to be a full URL", "URL_PATH_CONTAINS_FQDN": "The provided URL path and query match appears to be or start with a domain." } }, "tabs": { "trackingCode": "Tracking code", "domainsAndIp": "Advanced Tracking", "analyticsViews": "Analytics views", "cookiePolicy": "Cookie Policy", "newTag": "New" }, "settingConfirmations": { "domain": { "message": "Update your target domain?", "description": "This will update any analytics views you've created using the domain filter.", "confirm": "Yes", "reject": "No" } }, "tracking": { "title": "Tracking code installation", "description": "Copy and paste this tracking code into every page of your site, just before the </body> tag.", "embed": { "label": "Embed code", "copy": "Copy", "showAdvancedTrackingCode": "Show full tracking code", "showBasicTrackingCode": "Show condensed tracking code", "email": { "title": "Email to my web developer", "button": "Send instructions", "placeholder": "email@example.com", "sending": "Sending instructions...", "success": "Successfully sent instructions to {{ email }}.", "error": "Failed to send email. Please try again.", "validate": "Please enter a valid email address.", "disabled": "Email is only supported for condensed tracking code" } }, "help": { "title": "Need help?", "instructions": "Detailed instructions for installing tracking code can be found <a href=\"{{ url }}\">here</a>.", "tips": "Tips for validating your tracking code installation can be found <a href=\"{{ url }}\">here</a>.", "customizeJavascript": "Customize javascript", "installBookmarklet": { "bookmarklet": "Install event bookmarklet", "extension": "Install event chrome extension" } }, "modal": { "title": "Send tracking code", "email": "Email address", "invalid": "Invalid email address", "send": "Send", "placeholder": "email@example.com", "success": "Successfully sent tracking code", "error": "There was a problem emailing your tracking code. Please try again, or contact support if the problem persists." } }, "privacy": { "title": "Privacy Policy", "label": "Privacy Policy Types", "types": { "noRequest": "Do not notify visitors that your site uses cookies.", "notify": "Notify visitors that your site uses cookies.", "requestConsent": "Tell visitors that your site uses cookies and require opt-in.", "noCookies": "Do not use cookies at all." }, "consent": { "testMode": { "label": "Turn this on to publish your cookie banner on your website", "help": "To preview your policy banner before publishing to your website, turn this off and add <code>?_hsPrivacyTest</code> to your website URL." }, "privacyMode": { "title": "Privacy mode", "help": "Choose Test Mode to preview your chosen privacy policy type as your visitors will see it. Add ?_hsPrivacyTest to a URL on your site to view the preview (e.g. www.example.com/?_hsPrivacyTest).", "test": "Test Mode", "production": "Production Mode" }, "privacyPolicyWording": { "title": "Privacy policy banner text", "help": "<em>Suggested text</em>: This website stores cookies on your computer. These cookies are used to improve your website experience and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our Privacy Policy.", "default": "This website stores cookies on your computer. These cookies are used to improve your website experience and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our Privacy Policy." }, "privacyAcceptWording": { "title": "Privacy policy accept button text", "help": "Customize your 'accept' button text. <em>Suggested text</em>: Accept", "default": "Accept" }, "privacyDismissWording": { "title": "Privacy policy decline button text", "help": "Customize your 'decline' button text. <em>Suggested text</em>: Decline", "default": "Decline", "optionalText": "Hide decline button" }, "privacyDisclaimerWording": { "title": "Privacy policy disclaimer text", "help": "Customize your 'disclaimer' text. <em>Suggested text</em>: We won't track your information when you visit our site. But in order to comply with your preferences, we'll have to use just one tiny cookie so that you're not asked to make this choice again.", "default": "We won't track your information when you visit our site. But in order to comply with your preferences, we'll have to use just one tiny cookie so that you're not asked to make this choice again." } } }, "cookiePolicy": { "cookieSettingsHeader": "Cookie settings", "useCookiesOption": { "label": "Use cookies", "description": "Using tracking cookies allows you to track visits and clicks on your website." }, "notifyVisitorsOption": { "label": "Notify visitors that your site uses cookies", "description": "Display a notification to your visitors to show that your site uses cookies." }, "notificationSettingsHeader": "Cookie policy", "notificationSettingsIntro": "These settings apply to all external pages with the HubSpot tracking code, and to all HubSpot hosted pages. These settings can’t control any cookies placed by other scripts.", "notificationSettingsDescription": "Under the General Data Protection Regulation (GDPR) or other private regulations, visitors to your website must consent to being tracked. This means that you must display a notice telling visitors that you use cookie tracking, and offer them the choice to opt in to being tracked.", "requireOptIn": { "label": "Require opt-in", "description": "Require visitors to opt into cookie tracking. This may be required if you do business in the European Union." }, "notificationSettingsTable": { "allPages": "All URLs", "policyHeading": "Policy label", "pagesHeading": "URLs", "publishedHeading": "Published", "useCookiesHeading": "Use cookies", "notifyHeading": "Notify visitors", "requireOptInHeading": "Require opt-in", "editButton": "Edit", "deleteButton": "Delete", "viewButton": "View", "defaultNotificationName": "Default cookie notification", "addPolicyButton": "Add policy", "cookiesDisabled": "Cookies disabled", "notificationDisabled": "Cookies enabled, no notification", "notifyVisitors": "Cookies enabled, notify visitors", "requireOptIn": "Cookies enabled, require opt-in" }, "bannerStylesHeader": "Cookie notification style", "accentColorLabel": "Accent color", "customColorLabel": "or select a custom color", "bannerStyle": { "optInButton": "Check out new styles", "optInDescription": "Customize the colors and style of the cookie policy banner that appears at the top of your website.", "optInTitle": "Give your website banner a fresh look", "optOutLink": "Go back to old styles" }, "bannerTypeLabel": "Notification type", "mobileBottom": "Banner position defaults to top on mobile", "bannerType": { "bottomBanner": "Bottom banner", "topBanner": "Top banner", "bottomLeftBanner": "Bottom left banner" }, "bannerPreviewNotice": "This preview is based on the default policy notification", "previewNotification": { "button": "Preview", "help": "All matching policies will show, even if they’re not published. Changes may take up to 5 minutes to be applied.", "label": "Preview notification", "placeholder": "Enter a URL to preview" }, "notificationPanel": { "clearText": "Clear", "defaultPolicyLabel": "Default policy", "notificationSettingsHeader": "Cookie policy settings", "policyLabelLabel": "Policy label", "showOnPagesLabel": "Set a domain, URL path, or both. A page will match first on both, then URL path, then domain.", "defaultDescription": "These default settings will take effect on any URLs that do not match a more specific policy", "domainOption": { "any": "any domain", "label": "Domain", "help": "Include “www.” if this is included when your site loads in a web browser.", "error": "This should not include wildcards (*), protocol (http://), or path. e.g. example.com, not http://www.example.com or www.example.com/page" }, "pathOption": { "label": "URL Path", "any": "any path", "help": "Set a subdirectory for a more targeted banner.", "error": "This can not include a ? or #. e.g. /blog/en/, not /page?q=123 or blog.example.com/de/" }, "notificationTextLabel": "Notification terms text", "acceptLabel": "Accept button label", "dismissLabel": "Decline button label", "disclaimerTextHelp": "only shown when opt-in is required", "disclaimerTextLabel": "Disclaimer text", "applyButton": "Apply", "notificationNotConfigured": "When the setting to notify visitors is turned on, you must choose notification terms text to apply changes.", "targetingNotConfigured": "Cookie policy overrides must target either a domain, a path, or both. To target any page, update your default policy.", "cancelButton": "Cancel", "newPolicyDefaults": { "policyLabel": "New cookie policy", "privacyPolicyWording": "<p>This website stores cookies on your computer. These cookies are used to improve your website and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our Privacy Policy.</p><p>We won't track your information when you visit our site. But in order to comply with your preferences, we'll have to use just one tiny cookie so that you're not asked to make this choice again.</p>", "privacyAcceptWording": "Accept", "privacyDismissWording": "Decline" }, "notificationTextSelection": { "description": "Choose from the default options or write your own. You may want to review these terms with a lawyer.", "addButton": "Add copy", "placeholder": "Choose a language", "orDivider": "or", "startFromScratch": "Start from scratch" } }, "deleteModal": { "title": "Are you sure you want to delete this override?", "titleWithLabel": "Are you sure you want to delete \"{{ label }}\"?", "description": "", "descriptionWithLabel": "", "confirm": "Delete", "cancel": "Cancel" }, "revokeCookieConsent": { "title": "Check consent status & revoke consent", "description": "You may want to check the consent status or give users the choice to remove their cookies and their tracking cookie consent. To offer this choice, use the <code>addPrivacyConsentListener</code> and <code>revokeCookieConsent</code> methods provided in your HubSpot analytics code.", "learnMore": "Learn more" } }, "domains": { "target": { "title": "Target domain", "label": "Domain", "help": "This is the domain that is used in the Links, Pages, and Competitors apps.", "errors": { "empty": "Domain cannot be empty.", "invalid": "Invalid domain." } }, "additional": { "table": { "domain": "DOMAIN", "type": "TYPE" }, "title": "Additional site domains", "description": "We'll count the domains listed here as part of your site. This will allow us to handle cross-domain traffic properly if you have multiple domains.", "types": { "hosted": "Hosted", "external": "External" }, "remove": "remove", "add": "Add domain", "modal": { "title": "Add an external domain", "domain": "Domain", "add": "Add", "cancel": "Cancel", "invalid": "Invalid domain", "present": "This domain is already present" } }, "crossDomainLinking": { "title": "Automatic cross-domain linking", "description": "Modify links on your sites to enable link-tracking between domains." }, "limitTrackingDomains": { "title": "Limit tracking to these domains", "description": "Only allow tracking on the domains listed here." }, "limitCookiesToSubdomains": { "title": "Limit cookies to subdomains", "description": "Limit the HubSpot tracking cookie to the subdomain placing it. As opposed to the entire root domain. This means something like blog.yourcompany.com would be the referrer in the sources tool. And not yourcompany.com." }, "botFiltering": { "title": "Bot filtering", "description": "Filter all activity from known internet bots." }, "analyticsWeek": { "title": "Begin week on Monday for analytics reports", "description": "Turn this on to set Monday as the beginning of the week for analytics reports like sources and sessions. Turn this off to set the beginning of your week for analytics reports to Sunday. Your CRM reports on contacts and deals will continue to start its reporting week on Monday." } }, "subdomains": { "title": "Sources views" }, "views": { "title": "Custom analytics views", "createDate": "Created date", "updatedDate": "Last modified", "description": "Use analytics views to filter your data based on website domain, IP address, or country. A view will only capture data collected after it’s created or edited", "newView": "Add another view", "viewLimitReached": "You can't have more than {{ limit }} views", "editView": "Edit", "viewView": "View", "deleteView": "Delete", "editModal": { "invalidWarning": "This view has a combination of filters that's no longer supported. Remove the filters and create new ones.", "invalidTileText": "This combination of filters is no longer supported. Remove these filters to save changes.", "addFilter": "Add filter", "and": "and", "title": { "new": "Create analytics view", "edit": "Edit analytics view" }, "description": "This view will be applied only to analytics activity going forward.", "defaultViewTitle": "New analytics view", "viewTitleLabel": "Name", "save": "Save", "cancel": "Cancel", "back": "Back", "apply": "Apply Filter", "noFilters": "You need at least one filter to create a view", "noTitle": "Please enter a name for your new view", "cantEdit": "You do not have permission to edit this filter", "propertiesTitle": "View filters", "fqdn": { "subdomain": "Subdomain", "subdomainDescription": "A subdomain is the first part of a domain name. So in www.inbound.com, the subdomain is \"www\".", "subdomainMatch": { "any": "match any subdomain", "none": "exclude all subdomains", "specify": "match only a specific subdomain" }, "anySubdomain": "any subdomain", "noSubdomain": "no subdomain", "targetDomain": "Target domain", "targetDomainDescription": "You are only able to filter for subdomains of your target domain.", "brand": "Brand domain", "brandDescription": "A brand domain is the part of the domain between the subdomain and the top-level domain. So in www.inbound.com, the brand domain is \"inbound\".", "brandMatch": { "any": "match any tracked brand domain", "specify": "match only a specific brand domain", "placeholder": "Select a brand domain" }, "suffix": "Top-level domain", "suffixDescription": "The top-level domain is the end of the domain that comes after the brand domain. In www.inbound.com, the top-level domain is \"com\" and in www.inbound.co.uk it's \"co.uk\".", "suffixMatch": { "any": "match any top-level domain", "specify": "match only a specific top-level domain" } }, "legacyProperties": { "saveButton": "This view can’t be edited. The filters used to create this view are no longer available.", "warningMessage": "This view can’t be edited. The filters used to create this view are no longer available." }, "warnings": { "empty": "Filters may not be empty.", "subdomain": { "path": "Subdomains don’t include any <code>/</code> characters. Make sure you’re not entering an entire website URL.", "protocol": "Subdomains don’t include the protocols that come before them in the URL. Make sure you remove any http or https.", "tld": "Make sure you’re only entering the subdomain and not an entire website URL. For example, use <code>blog</code> rather than <code>blog.example.com</code>.", "subdomain": { "title": "Make sure you’re only entering the subdomain and not an entire website URL. For example, use <code>blog</code> rather than <code>blog.example.com</code>.", "body": "<code>{{ suffixFound }}</code> looks like the suffix of a full URL instead of a subdomain. If you want to continue anyway, click <code>apply</code>." } }, "urlPath": { "protocol": "Paths don’t include the protocols that come before them in the URL. Make sure you remove any http or https.", "tld": "Make sure you’re only entering the path and not an entire website URL. For example, use <code>/en/</code> rather than <code>example.com/en/</code>." } }, "urlPathAndQuery": { "CONTAINS": { "help": "This filter will match anywhere in the path that starts after the domain (e.g. www.example.com)." }, "NOT_CONTAINS": { "help": "This filter will match anywhere in the path that starts after the domain (e.g. www.example.com)." }, "STARTS_WITH": { "help": "Do not include the protocol (e.g. http:// or https://) or the domain (e.g. www.example.com). To filter by domain, try adding a domain filter." }, "NOT_STARTS_WITH": { "help": "Do not include the protocol (e.g. http:// or https://) or the domain (e.g. www.example.com). To filter by domain, try adding a domain filter." }, "startLabel": "Path start", "containsLabel": "Path contains" }, "operators": { "CONTAINS": "contains", "ENDS_WITH": "ends with", "FQDN_BRAND_MATCH": "is", "FQDN_MATCH": "matches", "FQDN_SUBDOMAIN_MATCH": "is", "FQDN_SUFFIX_MATCH": "is", "IS_ANY_OF": "is any of", "IS_NOT_ANY_OF": "is not any of", "IS_NOT": "does not equal", "IS": "equals", "KNOWN": "is known", "NOT_CONTAINS": "does not contain", "NOT_ENDS_WITH": "does not end with", "NOT_KNOWN": "is not known", "NOT_STARTS_WITH": "does not start with", "STARTS_WITH": "starts with" }, "properties": { "URL": { "name": "Page URL", "description": "Looks at the full URL of the page being viewed." }, "COUNTRY": { "name": "Country", "description": "Looks at the country of the visitor based on their IP address." }, "DOMAIN": { "name": "Website domain", "description": "Looks at the domain of the page being viewed." }, "FQDN": { "name": "Website domain", "description": "" }, "FQDN_SUFFIX": { "name": "Top-level domain", "description": "The top-level domain is the end of the domain that comes after the brand domain. In www.inbound.com, the top-level domain is \"com\" and in www.inbound.co.uk it's \"co.uk\"." }, "FQDN_BRAND": { "name": "Brand domain", "description": "A brand domain is the part of the domain between the subdomain and the top-level domain. So in www.inbound.com, the brand domain is \"inbound\"." }, "FQDN_SUBDOMAIN": { "name": "Subdomain", "description": "A subdomain is the first part of a domain name. So in www.inbound.com, the subdomain is \"www\"." }, "URL_PATH_AND_QUERY": { "name": "URL path" }, "URL_PATH_AND_QUERY_STARTS": { "name": "URL path starts", "description": "This filter will start after the domain (e.g., www.example.com or blog.example.fr). Try /blog or /en." }, "URL_PATH_AND_QUERY_CONTAINS": { "name": "URL path contains", "description": "This filter will start after the domain (e.g., www.example.com or blog.example.fr). Try /blog or /en." }, "viewGroup": "Analytics View", "tooltip": "A {{ property }} filter has already been applied to this view." } }, "deleteModal": { "title": "Delete \"{{ filterName }}\"?", "description": "You’re about to delete {{ filterName }}. Your view can be recovered and will continue collecting data for 30 days. After 30 days, this view will be permanently deleted.", "confirm": "Delete", "cancel": "Cancel" }, "permanentlyDeleteModal": { "title": "Permanetly delete \"{{ filterName }}\"?", "description": "You’re about to permanently delete {{ filterName }}. Once deleted, it can't be recovered.", "confirm": "Delete", "cancel": "Cancel" } }, "deletedViews": { "header": "Recently deleted views", "description": "Views will be permanently deleted after 30 days", "title": "Name", "expiresOn": "Expires on", "restoreView": "Restore", "permanentDelete": "Delete permanently" }, "operators": { "labels": { "Contains": "contains", "NotContains": "does not contain", "StartsWith": "starts with", "NotStartsWith": "does not start with", "EndsWith": "ends with", "NotEndsWith": "does not end with", "TrueEquals": "equals", "TrueNotEquals": "does not equal" }, "conjunction": { "Contains": "{{ label }} contains {{ value }}", "NotContains": "{{ label }} does not contain {{ value }}", "StartsWith": "{{ label }} starts with {{ value }}", "NotStartsWith": "{{ label }} does not start with {{ value }}", "EndsWith": "{{ label }} ends with {{ value }}", "NotEndsWith": "{{ label }} does not end with {{ value }}", "TrueEquals": "{{ label }} equals {{ value }}", "TrueNotEquals": "{{ label }} does not equal {{ value }}" } }, "excludeTraffic": { "title": "Exclude Traffic", "yourIp": "Your IP Address", "ip": { "label": "IP Addresses to Exclude:", "help": "Use commas to separate different IP addresses. For example: 63.139.127.5, 63.139.127.23<br><br>Use dashes to represent entire ranges of IP addresses. For example: 63.139.127.0 - 63.139.127.255", "error": { "INVALID_IP": "Invalid IP address: {{ ip }}. <a href=\"http://knowledge.hubspot.com/articles/kcs_article/reports/error-ip-addresses-must-contain-four-sets-of-numbers-each-of-which-must-be-equal-to-or-less-than-255\" target=\"_blank\">Learn more.</a>", "INVALID_PREFIX_LENGTH": "Invalid prefix length of {{ prefixLength }} for address {{ ip }}.", "PREFIX_LENGTH_OUT_OF_RANGE": "The prefix length {{ prefixLength }} is out of range for address {{ ip }}", "RANGE_START_IS_IPV4_BUT_END_IS_IPV6": "The range start of {{ startIp }} - {{ endIp }} is IPv4 but the range end is IPv6. IP ranges should be the same format.", "RANGE_START_IS_IPV6_BUT_END_IS_IPV4": "The range start of {{ startIp }} - {{ endIp }} is IPv6 but the range end is IPv4. IP ranges should be the same format.", "RANGE_DOES_NOT_CONTAIN_2_IPS": "The range {{ range}} only contains one IP address. IP ranges should go from a low value to a high value. For example, 63.139.127.0 - 63.139.127.255.", "START_IP_IS_HIGHER_THAN_END_IP": "The range start of {{ startIp }} - {{ endIp }} is higher than the range end. IP ranges should go from a low value to a high value. For example, 63.139.127.0 - 63.139.127.255", "TOO_MANY_IP_RANGES": "Range error: too many IP ranges." } }, "yourIpUnavailable": "Can't be determined. Refresh the page to retrieve this value.", "referrer": { "label": "From these referrers:", "help": "Use commas to separate different referrer domains or referrer IP addresses. For example, adding hubspot.com will filter out referral traffic from any hubspot.com URL and adding 127.0.0.1 will filter out referral traffic from any 127.0.0.1 URL (i.e 127.0.0.1/home).<br><br>Check out this <a href=\"https://knowledge.hubspot.com/articles/kcs_article/reports/how-do-i-block-referring-domains-from-my-website-analytics\">help article</a> for more information about referrer filtering.", "errors": { "invalidDomain": "Invalid referrer domain \"{{ domain }}\"" } } }, "wordpress": { "header": "WordPress installation", "download": "Download the zip file for WordPress", "portalId": "Your Hub id", "tooltip": "WordPress will ask you for your Hub ID when connecting your account to the web app." }, "customJavascript": { "pageTitle": "Custom JavaScript", "backSettingsText": "Back to settings", "addButtonText": "Add custom JavaScript", "empty": { "heading": "Add scripts to your tracking code", "body": "Add custom JavaScript to your tracking code to log extra events. New events can also be defined using the events tool." }, "table": { "nameHeaderText": "Name", "createdHeaderText": "Create date", "editText": "Edit", "deleteText": "Delete", "noNamePlaceholder": "Unnamed custom JavaScript {{scriptId}}" }, "addModal": { "header": "Add custom JavaScript", "javascriptNameLabel": "Name", "javascriptCodeLabel": "Custom JavaScript", "javascriptNamePlaceholder": "Name your JavaScript", "saveButton": "Save", "cancelButton": "Cancel", "javascriptNameTooLong": "JavaScript names can not be more than 12 characters", "validatingCodePlaceholder": "Validating code", "invalidCodeMessage": "JavaScript parse error.", "errorValidatingCode": "We're having trouble validating your code" }, "createSuccessAlert": { "title": "JavaScript added.", "message": "The JavaScript was added." }, "createFailedAlert": { "title": "JavaScript addition failed.", "message": "The JavaScript could not be added." }, "editSuccessAlert": { "title": "JavaScript updated.", "message": "The JavaScript was updated." }, "editFailedAlert": { "title": "JavaScript update failed.", "message": "The JavaScript could not be updated." }, "deleteModal": { "title": "Delete {{scriptName}}?", "description": "This code will no longer be run as part of your HubSpot tracking script. This action can't be undone.", "confirmLabel": "Delete", "rejectLabel": "Cancel" }, "deleteSuccessAlert": { "title": "JavaScript removed.", "message": "The JavaScript was removed." }, "deleteFailedAlert": { "title": "JavaScript removal failed.", "message": "The JavaScript could not be removed." } } }, "filterSidebar": { "addFilter": "Add filter" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "de": "static-1.16253",
    "en": "static-1.16253",
    "es": "static-1.16253",
    "fr": "static-1.16253",
    "ja": "static-1.16253",
    "pt-br": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "settingsui": { "tabTitle": "Settings", "title": "Settings", "notifications": { "error": "Error", "success": "Success" }, "save": "Save", "cancel": "Cancel", "delete": "Delete", "pendingChanges": { "one": "You've changed {{ count }} setting.", "other": "You've changed {{ count }} settings." }, "firstNameLastName": "{{ firstName }} {{ lastName }}" } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "settings-ui-app": {
    "en": "static-1.16253"
  }
};
  result.translationsAvailable = {
  "settings-ui-app": {
    "de": "static-1.16253",
    "en": "static-1.16253",
    "es": "static-1.16253",
    "fr": "static-1.16253",
    "ja": "static-1.16253",
    "pt-br": "static-1.16253"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:settings-ui-app:en', {version: 'static-1.16253'}); }
})();


/*!
 * Javascript Cookie v1.5.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	var jQuery;
	if (typeof define === 'function' && define.amd) {
		// AMD (Register as an anonymous module)
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// Node/CommonJS
		try {
			jQuery = require('jquery');
		} catch(e) {}
		module.exports = factory(jQuery);
	} else {
		// Browser globals
		var _OldCookies = window.Cookies;
		var api = window.Cookies = factory(window.jQuery);
		api.noConflict = function() {
			window.Cookies = _OldCookies;
			return api;
		};
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return api.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return api.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(api.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return api.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = api.raw ? s : parseCookieValue(s);
		return isFunction(converter) ? converter(value) : value;
	}

	function extend() {
		var key, options;
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			options = arguments[ i ];
			for (key in options) {
				result[key] = options[key];
			}
		}
		return result;
	}

	function isFunction(obj) {
		return Object.prototype.toString.call(obj) === '[object Function]';
	}

	var api = function (key, value, options) {

		// Write

		if (arguments.length > 1 && !isFunction(value)) {
			options = extend(api.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {},
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()".
			cookies = document.cookie ? document.cookie.split('; ') : [],
			i = 0,
			l = cookies.length;

		for (; i < l; i++) {
			var parts = cookies[i].split('='),
				name = decode(parts.shift()),
				cookie = parts.join('=');

			if (key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	api.get = api.set = api;
	api.defaults = {};

	api.remove = function (key, options) {
		// Must not alter options, thus extending a fresh object...
		api(key, '', extend(options, { expires: -1 }));
		return !api(key);
	};

	if ( $ ) {
		$.cookie = api;
		$.removeCookie = api.remove;
	}

	return api;
}));


if (window.performance && typeof window.performance.mark === 'function') {
  window.performance.mark('mark_i18n_load_start');
}


// I18n.js
// =======
//
// This small library provides the Rails I18n API on the Javascript.
// You don't actually have to use Rails (or even Ruby) to use I18n.js.
// Just make sure you export all translations in an object like this:
//
//     I18n.translations.en = {
//       hello: "Hello World"
//     };
//
// See tests for specific formatting like numbers and dates.
//
// Orignally pulled from https://raw.github.com/fnando/i18n-js/rewrite/app/assets/javascripts/i18n.js
// v3.0.0.rc11 (commit ab4bc2a).
//
// All custom HubSpot modifications are surrounded by comments and have been
// made while the file was in this repo.
//
;(function(I18n){
  "use strict";

  // Just cache the Array#slice function.
  var slice = Array.prototype.slice;

  // Apply number padding.
  var padding = function(number) {
    return ("0" + number.toString()).substr(-2);
  };

  // Set default days/months translations.
  var DATE = {
      day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    , abbr_day_names: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    , month_names: [null, "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    , abbr_month_names: [null, "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    , meridian: ["AM", "PM"]
  };

  // Set default number format.
  var NUMBER_FORMAT = {
      precision: 3
    , separator: "."
    , delimiter: ","

    // HACK, HubSpot customizations to default number format
    // (more info at https://git.hubteam.com/HubSpot/I18n/commit/32fdaf1abad25b3b937a2947a83d788603636841 and https://git.hubteam.com/HubSpot/I18n/commit/7cff88e13955e56cf0f373480f3b04e7fc8b0512)
    // It would be much nicer if we could change these defaults without having to touch i18n.js (similar to existingOptions?)

    // , strip_insignificant_zeros: false
    , strip_insignificant_zeros: true
    // END HACK
  };

  // Set default currency format.
  var CURRENCY_FORMAT = {
      unit: "$"
    , precision: 2
    , format: "%u%n"
    , sign_first: true
    , delimiter: ","
    , separator: "."
  };

  // Set default percentage format.
  var PERCENTAGE_FORMAT = {
      unit: "%"
    , precision: 3
    , format: "%n%u"
    , separator: "."
    , delimiter: ""
  };

  // Set default size units.
  var SIZE_UNITS = [null, "kb", "mb", "gb", "tb"];

  // Other default options
  var DEFAULT_OPTIONS = {
    // Set default locale. This locale will be used when fallback is enabled and
    // the translation doesn't exist in a particular locale.
      defaultLocale: "en"
    // Set the current locale to `en`.
    , locale: "en"
    // Set the translation key separator.
    , defaultSeparator: "."
    // Set the placeholder format. Accepts `{placeholder}}` and `%{placeholder}`.}

    // HACK, HubSpot accepts whitespace: `{{ placeholder }}` or `{{placeholder}}` are equivalent
    // , placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm
    , placeholder: /(?:\{\{)\s?(\S*?)\s?(?:\}\})/gm

    // Set if engine should fallback to the default locale when a translation
    // is missing.
    , fallbacks: false
    // Set the default translation object.
    , translations: {}
    // Set missing translation behavior. 'message' will display a message
    // that the translation is missing, 'guess' will try to guess the string
    , missingBehaviour: 'message'
    // if you use missingBehaviour with 'message', but want to know that the
    // string is actually missing for testing purposes, you can prefix the
    // guessed string by setting the value here. By default, no prefix!
    , missingTranslationPrefix: ''
  };

  I18n.reset = function() {
    // Set default locale. This locale will be used when fallback is enabled and
    // the translation doesn't exist in a particular locale.
    this.defaultLocale = DEFAULT_OPTIONS.defaultLocale;

    // Set the current locale to `en`.
    this.locale = DEFAULT_OPTIONS.locale;

    // Set the translation key separator.
    this.defaultSeparator = DEFAULT_OPTIONS.defaultSeparator;

    // Set the placeholder format. Accepts `{{placeholder}}` and `%{placeholder}`.
    this.placeholder = DEFAULT_OPTIONS.placeholder;

    // Set if engine should fallback to the default locale when a translation
    // is missing.
    this.fallbacks = DEFAULT_OPTIONS.fallbacks;

    // Set the default translation object.
    this.translations = DEFAULT_OPTIONS.translations;

    // Set the default missing behaviour
    this.missingBehaviour = DEFAULT_OPTIONS.missingBehaviour;

    // Set the default missing string prefix for guess behaviour
    this.missingTranslationPrefix = DEFAULT_OPTIONS.missingTranslationPrefix;

  };

  // Much like `reset`, but only assign options if not already assigned
  I18n.initializeOptions = function() {
    if (typeof(this.defaultLocale) === "undefined" && this.defaultLocale !== null)
      this.defaultLocale = DEFAULT_OPTIONS.defaultLocale;

    if (typeof(this.locale) === "undefined" && this.locale !== null)
      this.locale = DEFAULT_OPTIONS.locale;

    if (typeof(this.defaultSeparator) === "undefined" && this.defaultSeparator !== null)
      this.defaultSeparator = DEFAULT_OPTIONS.defaultSeparator;

    if (typeof(this.placeholder) === "undefined" && this.placeholder !== null)
      this.placeholder = DEFAULT_OPTIONS.placeholder;

    if (typeof(this.fallbacks) === "undefined" && this.fallbacks !== null)
      this.fallbacks = DEFAULT_OPTIONS.fallbacks;

    if (typeof(this.translations) === "undefined" && this.translations !== null)
      this.translations = DEFAULT_OPTIONS.translations;
  };
  I18n.initializeOptions();

  // Return a list of all locales that must be tried before returning the
   // missing translation message. By default, this will consider the inline option,
   // current locale and fallback locale.
   //
   //     I18n.locales.get("de-DE");
   //     // ["de-DE", "de", "en"]
   //
   // You can define custom rules for any locale. Just make sure you return a array
   // containing all locales.
   //
   //     // Default the Wookie locale to English.
   //     I18n.locales["wk"] = function(locale) {
   //       return ["en"];
   //     };
   //
   I18n.locales = {};

   // Retrieve locales based on inline locale, current locale or default to
   // I18n's detection.
   I18n.locales.get = function(locale) {
     var result = this[locale] || this[I18n.locale] || this["default"];

     if (typeof(result) === "function") {
       result = result(locale);
     }

     if (result instanceof Array === false) {
       result = [result];
     }

     return result;
   };

   // The default locale list.
   I18n.locales["default"] = function(locale) {
     var locales = []
       , list = []
       , countryCode
       , count
     ;

     // Handle the inline locale option that can be provided to
     // the `I18n.t` options.
     if (locale) {
       locales.push(locale);
     }

     // Add the current locale to the list.
     if (!locale && I18n.locale) {
       locales.push(I18n.locale);
     }

     // Add the default locale if fallback strategy is enabled.
     if (I18n.fallbacks && I18n.defaultLocale) {
       locales.push(I18n.defaultLocale);
     }

     // Compute each locale with its country code.
     // So this will return an array containing both
     // `de-DE` and `de` locales.
     locales.forEach(function(locale){
       countryCode = locale.split("-")[0];

       if (!~list.indexOf(locale)) {
         list.push(locale);
       }

      // HubSpot Hack: Fall back lowercase locales (pt-BR to pt-br) I18n/473
      if (!~list.indexOf(locale.toLowerCase())) {
        list.push(locale.toLowerCase());
      }
      // End Hack

       if (I18n.fallbacks && countryCode && countryCode !== locale && !~list.indexOf(countryCode)) {
         list.push(countryCode);
       }
     });

     // No locales set? English it is.
     if (!locales.length) {
       locales.push("en");
     }

     return list;
   };

  // Hold pluralization rules.
  I18n.pluralization = {};

  // Return the pluralizer for a specific locale.
  // If no specify locale is found, then I18n's default will be used.
  I18n.pluralization.get = function(locale) {
    return this[locale] || this[I18n.locale] || this["default"];
  };

  // The default pluralizer rule.
  // It detects the `zero`, `one`, and `other` scopes.
  I18n.pluralization["default"] = function(count) {
    switch (count) {
      case 0: return ["zero", "other"];

      // HACK, HubSpot customization, more info at https://git.hubteam.com/HubSpot/I18n/commit/c1debccf2409a358b5456830c472ae78ece5e634#commitcomment-8149
      // case 1: return ["one"];
      case 1: return ["one", "other"];
      // END HACK

      default: return ["other"];
    }
  };

  // Return current locale. If no locale has been set, then
  // the current locale will be the default locale.
  I18n.currentLocale = function() {
    return this.locale || this.defaultLocale;
  };

  // Check if value is different than undefined and null;
  I18n.isSet = function(value) {
    return value !== undefined && value !== null;
  };

  // Find and process the translation using the provided scope and options.
  // This is used internally by some functions and should not be used as an
  // public API.
  I18n.lookup = function(scope, options) {
    options = this.prepareOptions(options);

    var locales = this.locales.get(options.locale).slice()
      , requestedLocale = locales[0]
      , locale
      , scopes
      , translations
    ;

    // HACK, Handle invalid Norwegian keys
    if (locales.indexOf('noNO') >= 0) {
      locales.unshift('no-no');
    } else if (locales.indexOf('no-no') >= 0) {
      locales.unshift('noNO');
    }
    // END HACK

    scope = this.getFullScope(scope, options);

    while (locales.length) {
      locale = locales.shift();
      scopes = scope.split(this.defaultSeparator);
      translations = this.translations[locale];

      if (!translations) {
        continue;
      }

      while (scopes.length) {
        translations = translations[scopes.shift()];

        if (translations === undefined || translations === null) {
          break;
        }
      }

      if (translations !== undefined && translations !== null) {
        return translations;
      }
    }

    if (this.isSet(options.defaultValue)) {
      return options.defaultValue;
    }
  };

  // Rails changed the way the meridian is stored.
  // It started with `date.meridian` returning an array,
  // then it switched to `time.am` and `time.pm`.
  // This function abstracts this difference and returns
  // the correct meridian or the default value when none is provided.
  I18n.meridian = function() {
    var time = this.lookup("time");
    var date = this.lookup("date");

    if (time && time.am && time.pm) {
      return [time.am, time.pm];
    } else if (date && date.meridian) {
      return date.meridian;
    } else {
      return DATE.meridian;
    }
  };

  // Merge serveral hash options, checking if value is set before
  // overwriting any value. The precedence is from left to right.
  //
  //     I18n.prepareOptions({name: "John Doe"}, {name: "Mary Doe", role: "user"});
  //     #=> {name: "John Doe", role: "user"}
  //
  I18n.prepareOptions = function() {
    var args = slice.call(arguments)
      , options = {}
      , subject
    ;

    while (args.length) {
      subject = args.shift();

      if (typeof(subject) != "object") {
        continue;
      }

      for (var attr in subject) {
        if (!subject.hasOwnProperty(attr)) {
          continue;
        }

        if (this.isSet(options[attr])) {
          continue;
        }

        options[attr] = subject[attr];
      }
    }

    return options;
  };

  // HACK, HubSpot fix

  // Steal Underscore's isObject implementation to deal with node not correctly respecting
  // `x instanceof Object` across different requires.
  var isObject = function(obj) {
    return obj === Object(obj);
  };

  // END HACK

  // Translate the given scope with the provided options.
  I18n.translate = function(scope, options) {
    options = this.prepareOptions(options);
    var translation = this.lookup(scope, options);

    // HACK: If the translation in this locale is a non-pluralization object, try
    // falling back on the default locale. Otherwise we'd just render "[object Object]"!
    // See HubSpot/I18n#209
    if (isObject(translation) && !this.isSet(options.count)) {
      translation = this.lookup(scope, I18n.prepareOptions({locale: this.defaultLocale}, options));
    }
    // END HACK

    if (translation === undefined || translation === null) {
      return this.missingTranslation(scope, options);
    }

    // HACK: Format count param if the translation is not an object
    if (!isObject(translation) && typeof options.count === 'number') {
      options.count = I18n.formatNumber(options.count);
    }
    // END HACK

    if (typeof(translation) === "string") {
      translation = this.interpolate(translation, options);
    // HACK, HubSpot fix
    // } else if (translation instanceof Object && this.isSet(options.count)) {
    } else if (isObject(translation) && this.isSet(options.count)) {
    // END HACK
      translation = this.pluralize(options.count, translation, options);
      // HACK: Fall back on default locale if pluralization failed
      if (translation === undefined && options.locale !== this.defaultLocale) {
        return I18n.translate(scope, I18n.prepareOptions({locale: this.defaultLocale}, options));
      }
      // END HACK
    }

    return translation;
  };

  // This function interpolates the all variables in the given message.
  I18n.interpolate = function(message, options) {
    options = this.prepareOptions(options);
    var matches = message.match(this.placeholder)
      , placeholder
      , value
      , name
      , regex
    ;

    if (!matches) {
      return message;
    }

    var value;

    while (matches.length) {
      placeholder = matches.shift();
      name = placeholder.replace(this.placeholder, "$1");

      if (this.isSet(options[name])) {
        value = options[name].toString().replace(/\$/gm, "_#$#_");
      } else if (name in options) {
        // HACK: Pass options through to nullPlaceholder/missingPlaceholder
        // value = this.nullPlaceholder(placeholder, message);
        value = this.nullPlaceholder(placeholder, message, options);
      } else {
        // value = this.missingPlaceholder(placeholder, message);
        value = this.missingPlaceholder(placeholder, message, options);
      }

      regex = new RegExp(placeholder.replace(/\{/gm, "\\{").replace(/\}/gm, "\\}"));
      message = message.replace(regex, value);
    }

    return message.replace(/_#\$#_/g, "$");
  };

  // Pluralize the given scope using the `count` value.
  // The pluralized translation may have other placeholders,
  // which will be retrieved from `options`.
  I18n.pluralize = function(count, scope, options) {
    options = this.prepareOptions(options);
    var translations, pluralizer, keys, key, message;

    // HACK, HubSpot fix
    // if (scope instanceof Object) {
    if (isObject(scope)) {
      translations = scope;
    // END HACK
    } else {
      translations = this.lookup(scope, options);
    }

    if (!translations) {
      return this.missingTranslation(scope, options);
    }

    pluralizer = this.pluralization.get(options.locale);
    keys = pluralizer(count);

    while (keys.length) {
      key = keys.shift();

      if (this.isSet(translations[key])) {
        message = translations[key];
        break;
      }
    }

    // HACK, if no translation keys matched then return instead of throwing an error (#303)
    if (typeof message !== 'string') {
      return undefined;
    }
    // END HACK

    // HACK, format count to a localized string instead of just casting it
    // options.count = String(count);
    if (typeof options.count === 'number') {
      options.count = I18n.formatNumber(count);
    }
    // END HACK

    return this.interpolate(message, options);
  };

  // Return a missing translation message for the given parameters.
  I18n.missingTranslation = function(scope, options) {
    //guess intended string
    if(this.missingBehaviour == 'guess'){
      //get only the last portion of the scope
      var s = scope.split('.').slice(-1)[0];
      //replace underscore with space && camelcase with space and lowercase letter
      return (this.missingTranslationPrefix.length > 0 ? this.missingTranslationPrefix : '') +
          s.replace('_',' ').replace(/([a-z])([A-Z])/g,
          function(match, p1, p2) {return p1 + ' ' + p2.toLowerCase()} );
    }

    var fullScope           = this.getFullScope(scope, options);
    var fullScopeWithLocale = [this.currentLocale(), fullScope].join(this.defaultSeparator);

    return '[missing “' + fullScopeWithLocale + '” translation]';
  };

  // Return a missing placeholder message for given parameters
  I18n.missingPlaceholder = function(placeholder, message) {
    return "[missing " + placeholder + " value]";
  };

  I18n.nullPlaceholder = function() {
    return I18n.missingPlaceholder.apply(I18n, arguments);
  };

  // Format number using localization rules.
  // The options will be retrieved from the `number.format` scope.
  // If this isn't present, then the following options will be used:
  //
  // - `precision`: `3`
  // - `separator`: `"."`
  // - `delimiter`: `","`
  // - `strip_insignificant_zeros`: `true`     // HACK, HubSpot customization to make this default to true instead of false (more info at https://git.hubteam.com/HubSpot/I18n/commit/32fdaf1abad25b3b937a2947a83d788603636841 and https://git.hubteam.com/HubSpot/I18n/commit/7cff88e13955e56cf0f373480f3b04e7fc8b0512)
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toNumber = function(number, options) {
    options = this.prepareOptions(
        options
      , this.lookup("number.format")
      , NUMBER_FORMAT
    );

    var negative = number < 0
      , string = Math.abs(number).toFixed(options.precision).toString()
      , parts = string.split(".")
      , precision
      , buffer = []
      , formattedNumber
      , format = options.format || "%n"
      , sign = negative ? "-" : ""
    ;

    number = parts[0];
    precision = parts[1];

    while (number.length > 0) {
      buffer.unshift(number.substr(Math.max(0, number.length - 3), 3));
      number = number.substr(0, number.length -3);
    }

    formattedNumber = buffer.join(options.delimiter);

    if (options.strip_insignificant_zeros && precision) {
      precision = precision.replace(/0+$/, "");
    }

    if (options.precision > 0 && precision) {
      formattedNumber += options.separator + precision;
    }

    if (options.sign_first) {
      format = "%s" + format;
    }
    else {
      format = format.replace("%n", "%s%n");
    }

    formattedNumber = format
      .replace("%u", options.unit)
      .replace("%n", formattedNumber)
      .replace("%s", sign)
    ;

    return formattedNumber;
  };

  // Format currency with localization rules.
  // The options will be retrieved from the `number.currency.format` and
  // `number.format` scopes, in that order.
  //
  // Any missing option will be retrieved from the `I18n.toNumber` defaults and
  // the following options:
  //
  // - `unit`: `"$"`
  // - `precision`: `2`
  // - `format`: `"%u%n"`
  // - `delimiter`: `","`
  // - `separator`: `"."`
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toCurrency = function(number, options) {
    var customLocale = (options || {}).locale;
    options = this.prepareOptions(
        options
      , this.lookup("number.currency.format", { locale: customLocale })
      , this.lookup("number.format", { locale: customLocale })
      , CURRENCY_FORMAT
    );

    return this.toNumber(number, options);
  };

  // Localize several values.
  // You can provide the following scopes: `currency`, `number`, or `percentage`.
  // If you provide a scope that matches the `/^(date|time)/` regular expression
  // then the `value` will be converted by using the `I18n.toTime` function.
  //
  // It will default to the value's `toString` function.
  //
  I18n.localize = function(scope, value, options) {
    options || (options = {});

    switch (scope) {
      case "currency":
        return this.toCurrency(value);
      case "number":
        scope = this.lookup("number.format");
        return this.toNumber(value, scope);
      case "percentage":
        return this.toPercentage(value);
      default:
        var localizedValue;

        if (scope.match(/^(date|time)/)) {
          localizedValue = this.toTime(scope, value);
        } else {
          localizedValue = value.toString();
        }

        return this.interpolate(localizedValue, options);
    }
  };


  // Parse a given `date` string into a JavaScript Date object.
  // This function is time zone aware.
  //
  // The following string formats are recognized:
  //
  //    yyyy-mm-dd
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ssZ
  //    yyyy-mm-dd[ T]hh:mm::ss+0000
  //    yyyy-mm-dd[ T]hh:mm::ss+00:00
  //    yyyy-mm-dd[ T]hh:mm::ss.123Z
  //
  I18n.parseDate = function(date) {
    var matches, convertedDate, fraction;
    // we have a date, so just return it.
    if (typeof(date) == "object") {
      return date;
    };

    matches = date.toString().match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})([\.,]\d{1,3})?)?(Z|\+00:?00)?/);

    if (matches) {
      for (var i = 1; i <= 6; i++) {
        matches[i] = parseInt(matches[i], 10) || 0;
      }

      // month starts on 0
      matches[2] -= 1;

      fraction = matches[7] ? 1000 * ("0" + matches[7]) : null;

      if (matches[8]) {
        convertedDate = new Date(Date.UTC(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction));
      } else {
        convertedDate = new Date(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction);
      }
    } else if (typeof(date) == "number") {
      // UNIX timestamp
      convertedDate = new Date();
      convertedDate.setTime(date);
    } else if (date.match(/([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/)) {
      // This format `Wed Jul 20 13:03:39 +0000 2011` is parsed by
      // webkit/firefox, but not by IE, so we must parse it manually.
      convertedDate = new Date();
      convertedDate.setTime(Date.parse([
        RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$6, RegExp.$4, RegExp.$5
      ].join(" ")));
    } else if (date.match(/\d+ \d+:\d+:\d+ [+-]\d+ \d+/)) {
      // a valid javascript format with timezone info
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    } else {
      // an arbitrary javascript string
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    }

    return convertedDate;
  };


  // Formats time according to the directives in the given format string.
  // The directives begins with a percent (%) character. Any text not listed as a
  // directive will be passed through to the output string.
  //
  // The accepted formats are:
  //
  //     %a  - The abbreviated weekday name (Sun)
  //     %A  - The full weekday name (Sunday)
  //     %b  - The abbreviated month name (Jan)
  //     %B  - The full month name (January)
  //     %c  - The preferred local date and time representation
  //     %d  - Day of the month (01..31)
  //     %-d - Day of the month (1..31)
  //     %H  - Hour of the day, 24-hour clock (00..23)
  //     %-H - Hour of the day, 24-hour clock (0..23)
  //     %I  - Hour of the day, 12-hour clock (01..12)
  //     %-I - Hour of the day, 12-hour clock (1..12)
  //     %m  - Month of the year (01..12)
  //     %-m - Month of the year (1..12)
  //     %M  - Minute of the hour (00..59)
  //     %-M - Minute of the hour (0..59)
  //     %p  - Meridian indicator (AM  or  PM)
  //     %S  - Second of the minute (00..60)
  //     %-S - Second of the minute (0..60)
  //     %w  - Day of the week (Sunday is 0, 0..6)
  //     %y  - Year without a century (00..99)
  //     %-y - Year without a century (0..99)
  //     %Y  - Year with century
  //     %z  - Timezone offset (+0545)
  //
  I18n.strftime = function(date, format) {
    var options = this.lookup("date")
      , meridianOptions = I18n.meridian()
    ;

    if (!options) {
      options = {};
    }

    options = this.prepareOptions(options, DATE);

    var weekDay = date.getDay()
      , day = date.getDate()
      , year = date.getFullYear()
      , month = date.getMonth() + 1
      , hour = date.getHours()
      , hour12 = hour
      , meridian = hour > 11 ? 1 : 0
      , secs = date.getSeconds()
      , mins = date.getMinutes()
      , offset = date.getTimezoneOffset()
      , absOffsetHours = Math.floor(Math.abs(offset / 60))
      , absOffsetMinutes = Math.abs(offset) - (absOffsetHours * 60)
      , timezoneoffset = (offset > 0 ? "-" : "+") +
          (absOffsetHours.toString().length < 2 ? "0" + absOffsetHours : absOffsetHours) +
          (absOffsetMinutes.toString().length < 2 ? "0" + absOffsetMinutes : absOffsetMinutes)
    ;

    if (hour12 > 12) {
      hour12 = hour12 - 12;
    } else if (hour12 === 0) {
      hour12 = 12;
    }

    format = format.replace("%a", options.abbr_day_names[weekDay]);
    format = format.replace("%A", options.day_names[weekDay]);
    format = format.replace("%b", options.abbr_month_names[month]);
    format = format.replace("%B", options.month_names[month]);
    format = format.replace("%d", padding(day));
    format = format.replace("%e", day);
    format = format.replace("%-d", day);
    format = format.replace("%H", padding(hour));
    format = format.replace("%-H", hour);
    format = format.replace("%I", padding(hour12));
    format = format.replace("%-I", hour12);
    format = format.replace("%m", padding(month));
    format = format.replace("%-m", month);
    format = format.replace("%M", padding(mins));
    format = format.replace("%-M", mins);
    format = format.replace("%p", meridianOptions[meridian]);
    format = format.replace("%S", padding(secs));
    format = format.replace("%-S", secs);
    format = format.replace("%w", weekDay);
    format = format.replace("%y", padding(year));
    format = format.replace("%-y", padding(year).replace(/^0+/, ""));
    format = format.replace("%Y", year);
    format = format.replace("%z", timezoneoffset);

    return format;
  };

  // Convert the given dateString into a formatted date.
  I18n.toTime = function(scope, dateString) {
    var date = this.parseDate(dateString)
      , format = this.lookup(scope)
    ;

    if (date.toString().match(/invalid/i)) {
      return date.toString();
    }

    if (!format) {
      return date.toString();
    }

    return this.strftime(date, format);
  };

  // Convert a number into a formatted percentage value.
  I18n.toPercentage = function(number, options) {
    options = this.prepareOptions(
        options
      , this.lookup("number.percentage.format")
      , this.lookup("number.format")
      , PERCENTAGE_FORMAT
    );

    return this.toNumber(number, options);
  };

  // Convert a number into a readable size representation.
  I18n.toHumanSize = function(number, options) {
    var kb = 1024
      , size = number
      , iterations = 0
      , unit
      , precision
    ;

    while (size >= kb && iterations < 4) {
      size = size / kb;
      iterations += 1;
    }

    if (iterations === 0) {
      unit = this.t("number.human.storage_units.units.byte", {count: size});
      precision = 0;
    } else {
      unit = this.t("number.human.storage_units.units." + SIZE_UNITS[iterations]);
      precision = (size - Math.floor(size) === 0) ? 0 : 1;
    }

    options = this.prepareOptions(
        options
      , {unit: unit, precision: precision, format: "%n%u", delimiter: ""}
    );

    return this.toNumber(size, options);
  };

  I18n.getFullScope = function(scope, options) {
    options = this.prepareOptions(options);

    // Deal with the scope as an array.
    if (scope.constructor === Array) {
      scope = scope.join(this.defaultSeparator);
    }

    // Deal with the scope option provided through the second argument.
    //
    //    I18n.t('hello', {scope: 'greetings'});
    //
    if (options.scope) {
      scope = [options.scope, scope].join(this.defaultSeparator);
    }

    return scope;
  }

  // Set aliases, so we can save some typing.
  I18n.t = I18n.translate;
  I18n.l = I18n.localize;
  I18n.p = I18n.pluralize;

  // HACK, export default formats for use in our methods
  I18n.NUMBER_FORMAT = NUMBER_FORMAT;
  I18n.CURRENCY_FORMAT = CURRENCY_FORMAT;
  I18n.PERCENTAGE_FORMAT = PERCENTAGE_FORMAT;

// HACK, HubSpot customization so that the config can be set before the library is loaded.
// (more info at https://git.hubteam.com/HubSpot/I18n/commit/4187783fba78f9249817e16487bc0c28fa3f0557)
// })(typeof(exports) === "undefined" ? (this.I18n = {}) : exports);
})(typeof(exports) === "undefined" ? (this.I18n = this.I18n || {}) : exports);
// END HACK


(function () {
var slice = [].slice;

I18n.debugLog = function() {
  var args, enabled;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (typeof document === "undefined" || document === null) {
    return;
  }
  enabled = this.I18N_DEBUG_LOG || window.I18N_DEBUG;
  try {
    enabled || (enabled = localStorage.I18N_DEBUG_LOG === "true" || localStorage.I18N_DEBUG === "true");
  } catch (undefined) {}
  if (enabled !== true) {
    return;
  }
  args.unshift('I18n:');
  if (window.parent !== window) {
    args.unshift('(IFRAME)');
  }
  return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log.apply(console, args) : void 0 : void 0;
};

I18n.onAnyTrigger = function() {
  var args, eventName;
  eventName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  return I18n.debugLog.apply(I18n, ["triggered " + eventName].concat(slice.call(args)));
};
}());

(function(I18n) {
  // SafeString type to be used to mark I18n params as _not_ needing escaping.
  // (concept borrowed from http://handlebarsjs.com/#html-escaping)
  function SafeString(string) {
    // Work even if called without `new`
    if (!(this instanceof SafeString)) {
      return new SafeString(string);
    } else {
      this.string = string;
    }
  }

  SafeString.prototype.toString = SafeString.prototype.toHTML = function() {
    return '' + this.string;
  };

  I18n.SafeString = SafeString;
})(I18n);


(function () {
I18n.whenDOMContentLoaded = function(callback) {
  var ref;
  if ((ref = document.readyState) === 'interactive' || ref === 'complete') {
    setTimeout(callback, 1);
  } else {
    document.addEventListener('DOMContentLoaded', callback, false);
  }
};
}());

// Stolen (and cleaned up/tweaked) from the Intl.NumberFormat Spec:
// http://www.ecma-international.org/ecma-402/1.0/#ToRawFixed
(function(I18n) {
  var arrJoin = Array.prototype.join;

  function toRawFixed(
    x,
    minIntegerDigits,
    minFractionDigits,
    maxFractionDigits
  ) {
    var idx,
      result = Number.prototype.toFixed.call(x, maxFractionDigits),
      intDigits = result.split('.')[0].length,
      cut = maxFractionDigits - minFractionDigits,
      exp = (idx = result.indexOf('e')) > -1 ? result.slice(idx + 1) : 0;

    if (exp) {
      result = result.slice(0, idx).replace('.', '');
      result +=
        arrJoin.call(Array(exp - (result.length - 1) + 1), '0') +
        '.' +
        arrJoin.call(Array(maxFractionDigits + 1), '0');

      intDigits = result.length;
    }

    // Repeat while cut > 0 and the last character of result is "0":
    while (cut > 0 && result.slice(-1) === '0') {
      result = result.slice(0, -1);
      cut--;
    }

    // If the last character of result is ".", then remove it
    if (result.slice(-1) === '.') result = result.slice(0, -1);

    // If int < minIntegerDigits, then pad front with zeros
    if (intDigits < minIntegerDigits)
      var padding = arrJoin.call(Array(minIntegerDigits - intDigits + 1), '0');

    return (padding ? padding : '') + result;
  }

  I18n.util = I18n.util || {};
  I18n.util.toRawFixed = toRawFixed;
})(I18n);


// Stolen (and cleaned up/tweaked) from the Intl.NumberFormat Spec:
// http://www.ecma-international.org/ecma-402/1.0/#ToRawPrecision
(function(I18n) {
  var arrJoin = Array.prototype.join;

  // A function to deal with the inaccuracy of calculating log10 in pre-ES6
  // JavaScript environments. Math.log(num) / Math.LN10 was responsible for
  // causing issue #62.
  function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') {
      return Math.floor(Math.log10(n));
    }

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
  }

  function toRawPrecision(x, minPrecision, maxPrecision) {
    var result,
      numDigits,
      isNegative = x < 0;

    // Deal with negative values later
    x = Math.abs(x);

    // If 0, pad out to maxPrecision 0 characters
    if (x === 0) {
      result = arrJoin.call(Array(maxPrecision + 1), '0');
      numDigits = 1;
    } else {
      // Positive values mean # of int digits and negative values mean # of fractional digits
      numDigits = log10Floor(Math.abs(x)) + 1;

      // Easier to get to result from here
      var factor = Math.round(
        Math.exp(Math.abs(numDigits - maxPrecision) * Math.LN10)
      );

      // b. Let result be the String consisting of the digits of the decimal
      //  representation of n (in order, with no leading zeroes)
      result = String(
        Math.round(numDigits - maxPrecision < 0 ? x * factor : x / factor)
      );
    }

    // If numDigits ≥ maxPrecision, then pad the end of the number with zeros
    if (numDigits > maxPrecision) {
      result = result + arrJoin.call(Array(numDigits - maxPrecision + 1), '0');
      return isNegative ? '-' + result : result;

      // If numDigits = maxPrecision, then don't need to do anything
    } else if (numDigits === maxPrecision) {
      return isNegative ? '-' + result : result;

      // If numDigits > 0, then format as a decimal number with maxPrecision total digits
    } else if (numDigits > 0) {
      //var cutPoint = isNegative ? numDigits : numDigits + 1;
      result = result.slice(0, numDigits) + '.' + result.slice(numDigits);

      // If numDigits <= 0, then pad 0 zeros in front of decimal as needed
    } else if (numDigits <= 0) {
      result = '0.' + arrJoin.call(Array(-numDigits + 1), '0') + result;
    }

    // If result contains the character ".", and maxPrecision > minPrecision, then
    if (result.indexOf('.') >= 0 && maxPrecision > minPrecision) {
      var cut = maxPrecision - minPrecision;

      // Repeat while cut > 0 and the last character of result is "0":
      while (cut > 0 && result.charAt(result.length - 1) === '0') {
        result = result.slice(0, -1);
        cut--;
      }

      // If the last character of result is ".", then remove it
      if (result.charAt(result.length - 1) === '.')
        result = result.slice(0, -1);
    }

    return isNegative ? '-' + result : result;
  }

  I18n.util = I18n.util || {};
  I18n.util.log10Floor = log10Floor;
  I18n.util.toRawPrecision = toRawPrecision;
})(I18n);


//! moment.js

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');

    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


(function () {
if (typeof document !== "undefined" && document !== null) {
  hubspot.define('hubspot.carmen.client', ['hubspot.PortalIdParser', 'enviro'], function(PortalIdParser, Env) {
    var handleResponse, loadFromEarlyRequesterOrCarmen, makeRequestViaCarmenService, pendingCBs, portalId, setPortalIdIfNotAvailable, tags, triggerCallbacks;
    portalId = PortalIdParser.get({
      preserveGlobalId: true
    });
    tags = [];
    pendingCBs = [];
    makeRequestViaCarmenService = function(cb) {
      var callback, suffix, tag, url;
      if (cb != null) {
        pendingCBs.push(cb);
      }
      suffix = '';
      if (Env.getShort('carmen.api') === 'qa') {
        suffix = 'qa';
      }
      callback = 'hubspot.carmen.client.handleResponse';
      url = "https://app.hubspot" + suffix + ".com/carmen/locale.js?portalId=" + portalId + "&callback=" + callback;
      tag = document.createElement('script');
      tag.src = url;
      tags.push(tag);
      return document.querySelector('head').appendChild(tag);
    };
    triggerCallbacks = function(data) {
      var cb, i, len;
      for (i = 0, len = pendingCBs.length; i < len; i++) {
        cb = pendingCBs[i];
        cb(data);
      }
      return pendingCBs = [];
    };
    handleResponse = function(data) {
      var i, len, tag;
      for (i = 0, len = tags.length; i < len; i++) {
        tag = tags[i];
        tag.parentNode.removeChild(tag);
      }
      tags = [];
      return triggerCallbacks(data);
    };
    loadFromEarlyRequesterOrCarmen = function(cb, onError, loadLocaleFallback) {
      var earlyAuthRequest, ref;
      if (cb != null) {
        pendingCBs.push(cb);
      }
      earlyAuthRequest = (ref = window.earlyRequester) != null ? ref.getRequestStateByName('api-verify') : void 0;
      if (earlyAuthRequest != null) {
        earlyAuthRequest.whenFinished((function(_this) {
          return function(apiVerifyData) {
            var langEnabled, locale, ref1, ref2, ref3, ref4, timezone;
            timezone = apiVerifyData != null ? (ref1 = apiVerifyData.portal) != null ? (ref2 = ref1.timezone) != null ? ref2.id : void 0 : void 0 : void 0;
            locale = apiVerifyData != null ? (ref3 = apiVerifyData.user) != null ? ref3.locale : void 0 : void 0;
            langEnabled = apiVerifyData != null ? (ref4 = apiVerifyData.user) != null ? ref4.lang_enabled : void 0 : void 0;
            if ((timezone != null) && (locale != null)) {
              return triggerCallbacks({
                timezone: timezone,
                locale: locale,
                langEnabled: langEnabled
              });
            } else {
              return (typeof loadLocaleFallback === "function" ? loadLocaleFallback().then(handleResponse) : void 0) || makeRequestViaCarmenService();
            }
          };
        })(this));
        return earlyAuthRequest.onError((function(_this) {
          return function(xhr, statusCode, error) {
            return (typeof loadLocaleFallback === "function" ? loadLocaleFallback().then(handleResponse) : void 0) || makeRequestViaCarmenService();
          };
        })(this));
      } else {
        return (typeof loadLocaleFallback === "function" ? loadLocaleFallback().then(handleResponse) : void 0) || makeRequestViaCarmenService();
      }
    };
    setPortalIdIfNotAvailable = function(pid) {
      if (!portalId) {
        return portalId = pid;
      }
    };
    return {
      load: loadFromEarlyRequesterOrCarmen,
      handleResponse: handleResponse,
      setPortalIdIfNotAvailable: setPortalIdIfNotAvailable
    };
  });
}
}());

(function () {
var Evented, k, ref, v,
  slice = [].slice;

Evented = (function() {
  function Evented() {}

  Evented.prototype.on = function(event, handler, ctx, once) {
    var base, e, j, len, ref, results;
    if (once == null) {
      once = false;
    }
    if (event.indexOf(' ') !== -1) {
      ref = event.split(' ');
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        e = ref[j];
        results.push(this.on(e, handler, ctx, once));
      }
      return results;
    } else {
      if (this.bindings == null) {
        this.bindings = {};
      }
      if ((base = this.bindings)[event] == null) {
        base[event] = [];
      }
      return this.bindings[event].push({
        handler: handler,
        ctx: ctx,
        once: once
      });
    }
  };

  Evented.prototype.once = function(event, handler, ctx) {
    return this.on(event, handler, ctx, true);
  };

  Evented.prototype.off = function(event, handler) {
    var i, ref, results;
    if (((ref = this.bindings) != null ? ref[event] : void 0) == null) {
      return;
    }
    if (handler == null) {
      return delete this.bindings[event];
    } else {
      i = 0;
      results = [];
      while (i < this.bindings[event].length) {
        if (this.bindings[event][i].handler === handler) {
          results.push(this.bindings[event].splice(i, 1));
        } else {
          results.push(i++);
        }
      }
      return results;
    }
  };

  Evented.prototype.when = function(event, handler, ctx) {
    var e, j, len, ref, ref1;
    if (event.indexOf(' ') !== -1) {
      ref = event.split(' ');
      for (j = 0, len = ref.length; j < len; j++) {
        e = ref[j];
        this.when(e, handler, ctx);
      }
      return;
    }
    if ((ref1 = this.fired) != null ? ref1[event] : void 0) {
      return handler.call(ctx != null ? ctx : this);
    } else {
      return this.once(event, handler, ctx);
    }
  };

  Evented.prototype.trigger = function() {
    var args, ctx, event, handler, i, once, ref, ref1, results;
    event = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    if (this.fired == null) {
      this.fired = {};
    }
    this.fired[event] = true;
    if (typeof this.onAnyTrigger === "function") {
      this.onAnyTrigger.apply(this, [event].concat(slice.call(args)));
    }
    if ((ref = this.bindings) != null ? ref[event] : void 0) {
      i = 0;
      results = [];
      while (i < this.bindings[event].length) {
        ref1 = this.bindings[event][i], handler = ref1.handler, ctx = ref1.ctx, once = ref1.once;
        if (once) {
          this.bindings[event].splice(i, 1);
        } else {
          i++;
        }
        results.push(handler.apply(ctx != null ? ctx : this, args));
      }
      return results;
    }
  };

  return Evented;

})();

if ((typeof window !== "undefined" && window !== null) && !window.isServer) {
  ref = Evented.prototype;
  for (k in ref) {
    v = ref[k];
    window.I18n[k] = v;
  }
}
}());

(function () {
var init, ref;

init = function(moment) {
  I18n.moment = moment;
  if (typeof I18n.trigger === "function") {
    I18n.trigger('moment:init');
  }
  I18n.fallbacks = true;
  if (I18n.translationsLoaded == null) {
    I18n.translationsLoaded = {};
  }
  if (I18n.moment.locale != null) {
    return I18n.moment.locale(I18n.locale);
  } else {
    return I18n.moment.lang(I18n.locale);
  }
};

if (typeof define !== "undefined" && define !== null ? define.amd : void 0) {
  define(['moment'], init);
} else if (typeof window !== "undefined" && window !== null) {
  init(window.moment);
} else if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
  init(require('moment'));
}

if (I18n.translations == null) {
  I18n.translations = {};
}

if (typeof window !== "undefined" && window !== null ? (ref = window.I18n) != null ? ref.loaded : void 0 : void 0) {
  console.error("I18n/init.js brought in more than once");
}

I18n.loaded = true;
}());

(function () {
hubspot.defineEager('hubspot.i18n.pre', [], I18n);

I18n.when('timezone:ready', function() {
  var ref;
  if (((ref = hubspot.i18n) != null ? ref.timezone : void 0) == null) {
    return hubspot.defineEager('hubspot.i18n.timezone', [], I18n);
  }
});

I18n.when('locale:ready', function() {
  var ref;
  if (((ref = hubspot.i18n) != null ? ref.locale : void 0) == null) {
    return hubspot.defineEager('hubspot.i18n.locale', [], I18n);
  }
});

I18n.when('ready', function() {
  var ref;
  if (((ref = hubspot.i18n) != null ? ref.info : void 0) == null) {
    return hubspot.defineEager('hubspot.i18n.info', [], I18n);
  }
});

I18n.when('timeout', function() {
  var ref, ref1;
  if (((ref = hubspot.i18n) != null ? ref.locale : void 0) == null) {
    hubspot.defineEager('hubspot.i18n.locale', [], I18n);
  }
  if (((ref1 = hubspot.i18n) != null ? ref1.timezone : void 0) == null) {
    return hubspot.defineEager('hubspot.i18n.timezone', [], I18n);
  }
});
}());

(function () {
var Promise;

Promise = (function() {
  function Promise() {
    this.cbs = [];
  }

  Promise.prototype.then = function(yep, nope) {
    switch (this.state) {
      case 'resolved':
        return typeof yep === "function" ? yep(this.value) : void 0;
      case 'rejected':
        return typeof nope === "function" ? nope(this.value) : void 0;
      default:
        return this.cbs.push([yep, nope]);
    }
  };

  Promise.prototype.resolve = function(value) {
    this.value = value;
    this.state = 'resolved';
    return this._run();
  };

  Promise.prototype.reject = function(value) {
    this.value = value;
    this.state = 'rejected';
    return this._run();
  };

  Promise.prototype._run = function() {
    var cbs, i, len, ref;
    if (this.cbs == null) {
      return;
    }
    ref = this.cbs;
    for (i = 0, len = ref.length; i < len; i++) {
      cbs = ref[i];
      this.then.apply(this, cbs);
    }
    return this.cbs = null;
  };

  Promise.prototype.done = Promise.prototype.then;

  return Promise;

})();

I18n.Locale = new Promise;

I18n.when('locale:ready', function() {
  return I18n.Locale.resolve(I18n);
});

I18n.Timezone = new Promise;

I18n.when('timezone:ready', function() {
  return I18n.Timezone.resolve(I18n);
});

I18n.Info = new Promise;

I18n.when('ready', function() {
  var i18nDuration, i18nLangLocale, ref, ref1;
  I18n.Info.resolve(I18n);
  try {
    window.performance.mark('mark_i18n_load_successful');
    window.performance.measure('measure_i18n_load_time', 'mark_i18n_load_start', 'mark_i18n_load_successful');
    if (i18nDuration = window.performance.getEntriesByName('measure_i18n_load_time')[0].duration) {
      if ((ref = window.newrelic) != null) {
        ref.setCustomAttribute('i18nTime', i18nDuration);
      }
    }
    i18nLangLocale = I18n.locale !== 'en-us' && !I18n.langEnabled && !I18n.publicPage ? 'en-us' : I18n.locale;
    return (ref1 = window.newrelic) != null ? ref1.setCustomAttribute('i18nLangLocale', i18nLangLocale) : void 0;
  } catch (undefined) {}
});

I18n.Promise = Promise;
}());

hns('I18n.countries', {});

hns('I18n.translations.cs', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": " ",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "B",
            "few": "B",
            "other": "B"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.da', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.de', {
  "number": {
    "format": {
      "precision": 3,
      "separator": ",",
      "delimiter": ".",
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "precision": 0
      }
    },
    "currency": {
      "format": {
        "strip_insignificant_zeros": false,
        "unit": "€",
        "precision": 2,
        "format": "%n %u",
        "delimiter": ".",
        "separator": ","
      }
    },
    "human": {
      "storage_units": {
        "units": {
          "byte": " Byte",
          "kb": "kb",
          "mb": "mb",
          "gb": "gb",
          "tb": "tb"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " und ",
          "lastWordConnector": " und "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " oder ",
          "lastWordConnector": " oder "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 Tausend",
            "other": "0 Tausend"
          },
          "10000": {
            "one": "00 Tausend",
            "other": "00 Tausend"
          },
          "100000": {
            "one": "000 Tausend",
            "other": "000 Tausend"
          },
          "1000000": {
            "one": "0 Million",
            "other": "0 Millionen"
          },
          "10000000": {
            "one": "00 Millionen",
            "other": "00 Millionen"
          },
          "100000000": {
            "one": "000 Millionen",
            "other": "000 Millionen"
          },
          "1000000000": {
            "one": "0 Milliarde",
            "other": "0 Milliarden"
          },
          "10000000000": {
            "one": "00 Milliarden",
            "other": "00 Milliarden"
          },
          "100000000000": {
            "one": "000 Milliarden",
            "other": "000 Milliarden"
          },
          "1000000000000": {
            "one": "0 Billion",
            "other": "0 Billionen"
          },
          "10000000000000": {
            "one": "00 Billionen",
            "other": "00 Billionen"
          },
          "100000000000000": {
            "one": "000 Billionen",
            "other": "000 Billionen"
          }
        },
        "short": {
          "1000": {
            "one": "0 Tsd.",
            "other": "0 Tsd."
          },
          "10000": {
            "one": "00 Tsd.",
            "other": "00 Tsd."
          },
          "100000": {
            "one": "000 Tsd.",
            "other": "000 Tsd."
          },
          "1000000": {
            "one": "0 Mio",
            "other": "0 Mio"
          },
          "10000000": {
            "one": "00 Mio",
            "other": "00 Mio"
          },
          "100000000": {
            "one": "000 Mio",
            "other": "000 Mio"
          },
          "1000000000": {
            "one": "0 Mrd",
            "other": "0 Mrd"
          },
          "10000000000": {
            "one": "00 Mrd",
            "other": "00 Mrd"
          },
          "100000000000": {
            "one": "000 Mrd",
            "other": "000 Mrd"
          },
          "1000000000000": {
            "one": "0 Bio.",
            "other": "0 Bio."
          },
          "10000000000000": {
            "one": "00 Bio.",
            "other": "00 Bio."
          },
          "100000000000000": {
            "one": "000 Bio.",
            "other": "000 Bio."
          }
        }
      }
    }
  }
});

hns('I18n.translations.el', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.en-au', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-ca', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-gb', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "£"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-ie', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-in', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "₹"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-nz', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-us', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en', {
  "number": {
    "format": {
      "precision": 3,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "currency": {
      "format": {
        "precision": 2,
        "strip_insignificant_zeros": false
      }
    },
    "human": {
      "storage_units": {
        "units": {
          "byte": {
            "one": " byte",
            "other": " bytes"
          },
          "kb": "kb",
          "mb": "mb",
          "gb": "gb",
          "tb": "tb"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 thousand",
            "other": "0 thousand"
          },
          "10000": {
            "one": "00 thousand",
            "other": "00 thousand"
          },
          "100000": {
            "one": "000 thousand",
            "other": "000 thousand"
          },
          "1000000": {
            "one": "0 million",
            "other": "0 million"
          },
          "10000000": {
            "one": "00 million",
            "other": "00 million"
          },
          "100000000": {
            "one": "000 million",
            "other": "000 million"
          },
          "1000000000": {
            "one": "0 billion",
            "other": "0 billion"
          },
          "10000000000": {
            "one": "00 billion",
            "other": "00 billion"
          },
          "100000000000": {
            "one": "000 billion",
            "other": "000 billion"
          },
          "1000000000000": {
            "one": "0 trillion",
            "other": "0 trillion"
          },
          "10000000000000": {
            "one": "00 trillion",
            "other": "00 trillion"
          },
          "100000000000000": {
            "one": "000 trillion",
            "other": "000 trillion"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0M",
            "other": "0M"
          },
          "10000000": {
            "one": "00M",
            "other": "00M"
          },
          "100000000": {
            "one": "000M",
            "other": "000M"
          },
          "1000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000": {
            "one": "000B",
            "other": "000B"
          },
          "1000000000000": {
            "one": "0T",
            "other": "0T"
          },
          "10000000000000": {
            "one": "00T",
            "other": "00T"
          },
          "100000000000000": {
            "one": "000T",
            "other": "000T"
          }
        }
      }
    }
  }
});

hns('I18n.translations.es-ar', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": true,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " y ",
          "lastWordConnector": " y "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": ", o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 millón",
            "other": "0 millones"
          },
          "10000000": {
            "one": "00 millones",
            "other": "00 millones"
          },
          "100000000": {
            "one": "000 millones",
            "other": "000 millones"
          },
          "1000000000": {
            "one": "0 mil millones",
            "other": "0 mil millones"
          },
          "10000000000": {
            "one": "00 mil millones",
            "other": "00 mil millones"
          },
          "100000000000": {
            "one": "000 mil millones",
            "other": "000 mil millones"
          },
          "1000000000000": {
            "one": "0 billón",
            "other": "0 billones"
          },
          "10000000000000": {
            "one": "00 billones",
            "other": "00 billones"
          },
          "100000000000000": {
            "one": "000 billones",
            "other": "000 billones"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0MM",
            "other": "0MM"
          },
          "10000000": {
            "one": "00MM",
            "other": "00MM"
          },
          "100000000": {
            "one": "000MM",
            "other": "000MM"
          },
          "1000000000": {
            "one": "0000MM",
            "other": "0000MM"
          },
          "10000000000": {
            "one": "00MRD",
            "other": "00MRD"
          },
          "100000000000": {
            "one": "000MRD",
            "other": "000MRD"
          },
          "1000000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000000": {
            "one": "000B",
            "other": "000B"
          }
        }
      }
    }
  }
});

hns('I18n.translations.es-mx', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " y ",
          "lastWordConnector": " y "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": ", o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 millón",
            "other": "0 millones"
          },
          "10000000": {
            "one": "00 millones",
            "other": "00 millones"
          },
          "100000000": {
            "one": "000 millones",
            "other": "000 millones"
          },
          "1000000000": {
            "one": "0 mil millones",
            "other": "0 mil millones"
          },
          "10000000000": {
            "one": "00 mil millones",
            "other": "00 mil millones"
          },
          "100000000000": {
            "one": "000 mil millones",
            "other": "000 mil millones"
          },
          "1000000000000": {
            "one": "0 billón",
            "other": "0 billones"
          },
          "10000000000000": {
            "one": "00 billones",
            "other": "00 billones"
          },
          "100000000000000": {
            "one": "000 billones",
            "other": "000 billones"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0M",
            "other": "0M"
          },
          "10000000": {
            "one": "00M",
            "other": "00M"
          },
          "100000000": {
            "one": "000M",
            "other": "000M"
          },
          "1000000000": {
            "one": "0000M",
            "other": "0000M"
          },
          "10000000000": {
            "one": "00MRD",
            "other": "00MRD"
          },
          "100000000000": {
            "one": "000MRD",
            "other": "000MRD"
          },
          "1000000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000000": {
            "one": "000B",
            "other": "000B"
          }
        }
      }
    }
  }
});

hns('I18n.translations.es', {
  "number": {
    "format": {
      "precision": 3,
      "separator": ",",
      "delimiter": ".",
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "precision": 0
      }
    },
    "currency": {
      "format": {
        "strip_insignificant_zeros": false,
        "unit": "$",
        "precision": 2,
        "format": "%n %u",
        "delimiter": ".",
        "separator": ","
      }
    },
    "human": {
      "storage_units": {
        "units": {
          "byte": " Byte",
          "kb": "kb",
          "mb": "mb",
          "gb": "gb",
          "tb": "tb"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " y ",
          "lastWordConnector": ", y "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": ", o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 millón",
            "other": "0 millones"
          },
          "10000000": {
            "one": "00 millones",
            "other": "00 millones"
          },
          "100000000": {
            "one": "000 millones",
            "other": "000 millones"
          },
          "1000000000": {
            "one": "0 mil millones",
            "other": "0 mil millones"
          },
          "10000000000": {
            "one": "00 mil millones",
            "other": "00 mil millones"
          },
          "100000000000": {
            "one": "000 mil millones",
            "other": "000 mil millones"
          },
          "1000000000000": {
            "one": "0 billón",
            "other": "0 billones"
          },
          "10000000000000": {
            "one": "00 billones",
            "other": "00 billones"
          },
          "100000000000000": {
            "one": "000 billones",
            "other": "000 billones"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0M",
            "other": "0M"
          },
          "10000000": {
            "one": "00M",
            "other": "00M"
          },
          "100000000": {
            "one": "000M",
            "other": "000M"
          },
          "1000000000": {
            "one": "0000M",
            "other": "0000M"
          },
          "10000000000": {
            "one": "00MRD",
            "other": "00MRD"
          },
          "100000000000": {
            "one": "000MRD",
            "other": "000MRD"
          },
          "1000000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000000": {
            "one": "000B",
            "other": "000B"
          }
        }
      }
    }
  }
});

hns('I18n.translations.fi', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "tavu",
            "other": "tavua"
          },
          "gb": "GB",
          "kb": "kB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ja ",
          "lastWordConnector": " ja "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " tai ",
          "lastWordConnector": " tai "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 tuhat",
            "other": "0 tuhatta"
          },
          "10000": {
            "one": "00 tuhatta",
            "other": "00 tuhatta"
          },
          "100000": {
            "one": "000 tuhatta",
            "other": "000 tuhatta"
          },
          "1000000": {
            "one": "0 miljoona",
            "other": "0 miljoonaa"
          },
          "10000000": {
            "one": "00 miljoonaa",
            "other": "00 miljoonaa"
          },
          "100000000": {
            "one": "000 miljoonaa",
            "other": "000 miljoonaa"
          },
          "1000000000": {
            "one": "0 miljardi",
            "other": "0 miljardia"
          },
          "10000000000": {
            "one": "00 miljardia",
            "other": "00 miljardia"
          },
          "100000000000": {
            "one": "000 miljardia",
            "other": "000 miljardia"
          },
          "1000000000000": {
            "one": "0 biljoona",
            "other": "0 biljoonaa"
          },
          "10000000000000": {
            "one": "00 biljoonaa",
            "other": "00 biljoonaa"
          },
          "100000000000000": {
            "one": "000 biljoonaa",
            "other": "000 biljoonaa"
          }
        },
        "short": {
          "1000": {
            "one": "0 t.",
            "other": "0 t."
          },
          "10000": {
            "one": "00 t.",
            "other": "00 t."
          },
          "100000": {
            "one": "000 t.",
            "other": "000 t."
          },
          "1000000": {
            "one": "0 milj.",
            "other": "0 milj."
          },
          "10000000": {
            "one": "00 milj.",
            "other": "00 milj."
          },
          "100000000": {
            "one": "000 milj.",
            "other": "000 milj."
          },
          "1000000000": {
            "one": "0 mrd.",
            "other": "0 mrd."
          },
          "10000000000": {
            "one": "00 mrd.",
            "other": "00 mrd."
          },
          "100000000000": {
            "one": "000 mrd.",
            "other": "000 mrd."
          },
          "1000000000000": {
            "one": "0 bilj.",
            "other": "0 bilj."
          },
          "10000000000000": {
            "one": "00 bilj.",
            "other": "00 bilj."
          },
          "100000000000000": {
            "one": "000 bilj.",
            "other": "000 bilj."
          }
        }
      }
    }
  }
});

hns('I18n.translations.fr', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "octet",
            "other": "octets"
          },
          "gb": "Go",
          "kb": "ko",
          "mb": "Mo",
          "tb": "To"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " et ",
          "lastWordConnector": " et "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ou ",
          "lastWordConnector": " ou "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 millier",
            "other": "0 mille"
          },
          "10000": {
            "one": "00 millier",
            "other": "00 mille"
          },
          "100000": {
            "one": "000 millier",
            "other": "000 mille"
          },
          "1000000": {
            "one": "0 million",
            "other": "0 millions"
          },
          "10000000": {
            "one": "00 million",
            "other": "00 millions"
          },
          "100000000": {
            "one": "000 million",
            "other": "000 millions"
          },
          "1000000000": {
            "one": "0 milliard",
            "other": "0 milliards"
          },
          "10000000000": {
            "one": "00 milliard",
            "other": "00 milliards"
          },
          "100000000000": {
            "one": "000 milliards",
            "other": "000 milliards"
          },
          "1000000000000": {
            "one": "0 billion",
            "other": "0 billions"
          },
          "10000000000000": {
            "one": "00 billions",
            "other": "00 billions"
          },
          "100000000000000": {
            "one": "000 billions",
            "other": "000 billions"
          }
        },
        "short": {
          "1000": {
            "one": "0 k",
            "other": "0 k"
          },
          "10000": {
            "one": "00 k",
            "other": "00 k"
          },
          "100000": {
            "one": "000 k",
            "other": "000 k"
          },
          "1000000": {
            "one": "0 M",
            "other": "0 M"
          },
          "10000000": {
            "one": "00 M",
            "other": "00 M"
          },
          "100000000": {
            "one": "000 M",
            "other": "000 M"
          },
          "1000000000": {
            "one": "0 Md",
            "other": "0 Md"
          },
          "10000000000": {
            "one": "00 Md",
            "other": "00 Md"
          },
          "100000000000": {
            "one": "000 Md",
            "other": "000 Md"
          },
          "1000000000000": {
            "one": "0 Bn",
            "other": "0 Bn"
          },
          "10000000000000": {
            "one": "00 Bn",
            "other": "00 Bn"
          },
          "100000000000000": {
            "one": "000 Bn",
            "other": "000 Bn"
          }
        }
      }
    }
  }
});

hns('I18n.translations.it', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " e ",
          "lastWordConnector": " e "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": " o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 migliaio",
            "other": "0 migliaia"
          },
          "10000": {
            "one": "00 migliaia",
            "other": "00 migliaia"
          },
          "100000": {
            "one": "000 migliaia",
            "other": "000 migliaia"
          },
          "1000000": {
            "one": "0 milione",
            "other": "0 milioni"
          },
          "10000000": {
            "one": "00 milioni",
            "other": "00 milioni"
          },
          "100000000": {
            "one": "000 milioni",
            "other": "000 milioni"
          },
          "1000000000": {
            "one": "0 miliardo",
            "other": "0 miliardi"
          },
          "10000000000": {
            "one": "00 miliardi",
            "other": "00 miliardi"
          },
          "100000000000": {
            "one": "000 miliardi",
            "other": "000 miliardi"
          },
          "1000000000000": {
            "one": "0 migliaio di miliardi",
            "other": "0 migliaia di miliardi"
          },
          "10000000000000": {
            "one": "00 migliaia di miliardi",
            "other": "00 migliaia di miliardi"
          },
          "100000000000000": {
            "one": "000 migliaia di miliardi",
            "other": "000 migliaia di miliardi"
          }
        },
        "short": {
          "1000": {
            "one": "0",
            "other": "0"
          },
          "10000": {
            "one": "0",
            "other": "0"
          },
          "100000": {
            "one": "0",
            "other": "0"
          },
          "1000000": {
            "one": "0 Mln",
            "other": "0 Mln"
          },
          "10000000": {
            "one": "00 Mln",
            "other": "00 Mln"
          },
          "100000000": {
            "one": "000 Mln",
            "other": "000 Mln"
          },
          "1000000000": {
            "one": "0 Mld",
            "other": "0 Mld"
          },
          "10000000000": {
            "one": "00 Mld",
            "other": "00 Mld"
          },
          "100000000000": {
            "one": "000 Mld",
            "other": "000 Mld"
          },
          "1000000000000": {
            "one": "0 Bln",
            "other": "0 Bln"
          },
          "10000000000000": {
            "one": "00 Bln",
            "other": "00 Bln"
          },
          "100000000000000": {
            "one": "000 Bln",
            "other": "000 Bln"
          }
        }
      }
    }
  }
});

hns('I18n.translations.ja', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 0,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "¥"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "バイト",
          "gb": "ギガバイト",
          "kb": "キロバイト",
          "mb": "メガバイト",
          "tb": "テラバイト"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": "と",
          "twoWordsConnector": "と",
          "lastWordConnector": "と"
        },
        "exclusive": {
          "wordsConnector": "または",
          "twoWordsConnector": "または",
          "lastWordConnector": "または"
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0億"
          },
          "1000000000": {
            "other": "00億"
          },
          "10000000000": {
            "other": "000億"
          },
          "100000000000": {
            "other": "0000億"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        },
        "short": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0億"
          },
          "1000000000": {
            "other": "00億"
          },
          "10000000000": {
            "other": "000億"
          },
          "100000000000": {
            "other": "0000億"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        }
      }
    }
  }
});

hns('I18n.translations.ko', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 0,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "바이트",
          "gb": "기가바이트",
          "kb": "킬로바이트",
          "mb": "메가바이트",
          "tb": "테라바이트"
        }
      }
    }
  }
});

hns('I18n.translations.nl', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " en ",
          "lastWordConnector": " en "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " of ",
          "lastWordConnector": ", of "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 duizend",
            "other": "0 duizend"
          },
          "10000": {
            "one": "00 duizend",
            "other": "00 duizend"
          },
          "100000": {
            "one": "000 duizend",
            "other": "000 duizend"
          },
          "1000000": {
            "one": "0 miljoen",
            "other": "0 miljoen"
          },
          "10000000": {
            "one": "00 miljoen",
            "other": "00 miljoen"
          },
          "100000000": {
            "one": "000 miljoen",
            "other": "000 miljoen"
          },
          "1000000000": {
            "one": "0 miljard",
            "other": "0 miljard"
          },
          "10000000000": {
            "one": "00 miljard",
            "other": "00 miljard"
          },
          "100000000000": {
            "one": "000 miljard",
            "other": "000 miljard"
          },
          "1000000000000": {
            "one": "0 biljoen",
            "other": "0 biljoen"
          },
          "10000000000000": {
            "one": "00 biljoen",
            "other": "00 biljoen"
          },
          "100000000000000": {
            "one": "000 biljoen",
            "other": "000 biljoen"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0 mln.",
            "other": "0 mln."
          },
          "10000000": {
            "one": "00 mln.",
            "other": "00 mln."
          },
          "100000000": {
            "one": "000 mln.",
            "other": "000 mln."
          },
          "1000000000": {
            "one": "0 mld.",
            "other": "0 mld."
          },
          "10000000000": {
            "one": "00 mld.",
            "other": "00 mld."
          },
          "100000000000": {
            "one": "000 mld.",
            "other": "000 mld."
          },
          "1000000000000": {
            "one": "0 bln.",
            "other": "0 bln."
          },
          "10000000000000": {
            "one": "00 bln.",
            "other": "00 bln."
          },
          "100000000000000": {
            "one": "000 bln.",
            "other": "000 bln."
          }
        }
      }
    }
  }
});

hns('I18n.translations.no-no', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "kB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.pl', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": true
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": " ",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "bajt",
            "few": "bajty",
            "many": "bajtów",
            "other": "bajty"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.pt-br', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "R$"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " e ",
          "lastWordConnector": " e "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ou ",
          "lastWordConnector": ", ou "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 milhão",
            "other": "0 milhões"
          },
          "10000000": {
            "one": "00 milhão",
            "other": "00 milhões"
          },
          "100000000": {
            "one": "000 milhão",
            "other": "000 milhões"
          },
          "1000000000": {
            "one": "0 bilhão",
            "other": "0 bilhões"
          },
          "10000000000": {
            "one": "00 bilhão",
            "other": "00 bilhões"
          },
          "100000000000": {
            "one": "000 bilhão",
            "other": "000 bilhões"
          },
          "1000000000000": {
            "one": "0 trilhão",
            "other": "0 trilhões"
          },
          "10000000000000": {
            "one": "00 trilhão",
            "other": "00 trilhões"
          },
          "100000000000000": {
            "one": "000 trilhão",
            "other": "000 trilhões"
          }
        },
        "short": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 mi",
            "other": "0 mi"
          },
          "10000000": {
            "one": "00 mi",
            "other": "00 mi"
          },
          "100000000": {
            "one": "000 mi",
            "other": "000 mi"
          },
          "1000000000": {
            "one": "0 bi",
            "other": "0 bi"
          },
          "10000000000": {
            "one": "00 bi",
            "other": "00 bi"
          },
          "100000000000": {
            "one": "000 bi",
            "other": "000 bi"
          },
          "1000000000000": {
            "one": "0 tri",
            "other": "0 tri"
          },
          "10000000000000": {
            "one": "00 tri",
            "other": "00 tri"
          },
          "100000000000000": {
            "one": "000 tri",
            "other": "000 tri"
          }
        }
      }
    }
  }
});

hns('I18n.translations.sv', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "kr"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " och ",
          "lastWordConnector": " och "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " eller ",
          "lastWordConnector": ", eller "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 tusen",
            "other": "0 tusen"
          },
          "10000": {
            "one": "00 tusen",
            "other": "00 tusen"
          },
          "100000": {
            "one": "000 tusen",
            "other": "000 tusen"
          },
          "1000000": {
            "one": "0 miljon",
            "other": "0 miljoner"
          },
          "10000000": {
            "one": "00 miljon",
            "other": "00 miljoner"
          },
          "100000000": {
            "one": "000 miljoner",
            "other": "000 miljoner"
          },
          "1000000000": {
            "one": "0 miljard",
            "other": "0 miljarder"
          },
          "10000000000": {
            "one": "00 miljarder",
            "other": "00 miljarder"
          },
          "100000000000": {
            "one": "000 miljarder",
            "other": "000 miljarder"
          },
          "1000000000000": {
            "one": "0 biljon",
            "other": "0 biljoner"
          },
          "10000000000000": {
            "one": "00 biljoner",
            "other": "00 biljoner"
          },
          "100000000000000": {
            "one": "000 biljoner",
            "other": "000 biljoner"
          }
        },
        "short": {
          "1000": {
            "one": "0 tn",
            "other": "0 tn"
          },
          "10000": {
            "one": "00 tn",
            "other": "00 tn"
          },
          "100000": {
            "one": "000 tn",
            "other": "000 tn"
          },
          "1000000": {
            "one": "0 mn",
            "other": "0 mn"
          },
          "10000000": {
            "one": "00 mn",
            "other": "00 mn"
          },
          "100000000": {
            "one": "000 mn",
            "other": "000 mn"
          },
          "1000000000": {
            "one": "0 md",
            "other": "0 md"
          },
          "10000000000": {
            "one": "00 md",
            "other": "00 md"
          },
          "100000000000": {
            "one": "000 md",
            "other": "000 md"
          },
          "1000000000000": {
            "one": "0 bn",
            "other": "0 bn"
          },
          "10000000000000": {
            "one": "00 bn",
            "other": "00 bn"
          },
          "100000000000000": {
            "one": "000 bn",
            "other": "000 bn"
          }
        }
      }
    }
  }
});

hns('I18n.translations.zh-cn', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u %n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "CN¥"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": "、 ",
          "twoWordsConnector": "和",
          "lastWordConnector": "和"
        },
        "exclusive": {
          "wordsConnector": "、 ",
          "twoWordsConnector": "或",
          "lastWordConnector": "或"
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0亿"
          },
          "1000000000": {
            "other": "00亿"
          },
          "10000000000": {
            "other": "000亿"
          },
          "100000000000": {
            "other": "0000亿"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        },
        "short": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0亿"
          },
          "1000000000": {
            "other": "00亿"
          },
          "10000000000": {
            "other": "000亿"
          },
          "100000000000": {
            "other": "0000亿"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        }
      }
    }
  }
});

hns('I18n.translations.zh-hk', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u %n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "HK$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": "、",
          "twoWordsConnector": "和",
          "lastWordConnector": "和"
        },
        "exclusive": {
          "wordsConnector": "、 ",
          "twoWordsConnector": "或",
          "lastWordConnector": "或"
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "other": "0 千"
          },
          "10000": {
            "other": "0萬"
          },
          "100000": {
            "other": "00萬"
          },
          "1000000": {
            "other": "000萬"
          },
          "10000000": {
            "other": "0000萬"
          },
          "100000000": {
            "other": "0億"
          },
          "1000000000": {
            "other": "00億"
          },
          "10000000000": {
            "other": "000億"
          },
          "100000000000": {
            "other": "0000億"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        },
        "short": {
          "1000": {
            "other": "0K"
          },
          "10000": {
            "other": "00K"
          },
          "100000": {
            "other": "000K"
          },
          "1000000": {
            "other": "0M"
          },
          "10000000": {
            "other": "00M"
          },
          "100000000": {
            "other": "000M"
          },
          "1000000000": {
            "other": "0B"
          },
          "10000000000": {
            "other": "00B"
          },
          "100000000000": {
            "other": "000B"
          },
          "1000000000000": {
            "other": "0T"
          },
          "10000000000000": {
            "other": "00T"
          },
          "100000000000000": {
            "other": "000T"
          }
        }
      }
    }
  }
});




hns('I18n.baseLocales', {
  "en": {
    "language": "en",
    "beta": false,
    "defaultLocale": "en-us",
    "availableLocale": [
      "en-us",
      "en-ca",
      "en-gb",
      "en-ie",
      "en-au",
      "en-nz",
      "en-in",
      "es-ar",
      "es-mx",
      "es",
      "pt-br",
      "de",
      "fr",
      "it",
      "fi",
      "sv",
      "nl",
      "ja",
      "zh-cn",
      "zh-hk"
    ]
  },
  "es": {
    "language": "es",
    "beta": false,
    "defaultLocale": "es-ar",
    "availableLocale": [
      "es",
      "es-ar",
      "es-mx"
    ]
  },
  "de": {
    "language": "de",
    "beta": false,
    "defaultLocale": "de",
    "availableLocale": [
      "de"
    ]
  },
  "ja": {
    "language": "ja",
    "beta": false,
    "defaultLocale": "ja",
    "availableLocale": [
      "ja"
    ]
  },
  "fr": {
    "language": "fr",
    "beta": false,
    "defaultLocale": "fr",
    "availableLocale": [
      "fr"
    ]
  },
  "pt-br": {
    "language": "pt",
    "beta": true,
    "defaultLocale": "pt-br",
    "availableLocale": [
      "pt-br"
    ]
  }
});

hns('I18n.publicLocales', {
  "es-mx": {
    "language": "es-mx",
    "beta": true,
    "defaultLocale": "es-mx",
    "availableLocale": [
      "es-mx"
    ]
  },
  "cs": {
    "language": "cs",
    "beta": true,
    "defaultLocale": "cs",
    "availableLocale": [
      "cs"
    ]
  },
  "da": {
    "language": "da",
    "beta": true,
    "defaultLocale": "da",
    "availableLocale": [
      "da"
    ]
  },
  "el": {
    "language": "el",
    "beta": true,
    "defaultLocale": "el",
    "availableLocale": [
      "el"
    ]
  },
  "fi": {
    "language": "fi",
    "beta": true,
    "defaultLocale": "fi",
    "availableLocale": [
      "fi"
    ]
  },
  "it": {
    "language": "it",
    "beta": true,
    "defaultLocale": "it",
    "availableLocale": [
      "it"
    ]
  },
  "ko": {
    "language": "ko",
    "beta": true,
    "defaultLocale": "ko",
    "availableLocale": [
      "ko"
    ]
  },
  "nl": {
    "language": "nl",
    "beta": true,
    "defaultLocale": "nl",
    "availableLocale": [
      "nl-be",
      "nl"
    ]
  },
  "no-no": {
    "language": "no-no",
    "beta": true,
    "defaultLocale": "no-no",
    "availableLocale": [
      "no-no"
    ]
  },
  "pl": {
    "language": "pl",
    "beta": true,
    "defaultLocale": "pl",
    "availableLocale": [
      "pl"
    ]
  },
  "sv": {
    "language": "sv",
    "beta": true,
    "defaultLocale": "sv",
    "availableLocale": [
      "sv-fi",
      "sv"
    ]
  },
  "zh-cn": {
    "language": "zh-cn",
    "beta": true,
    "defaultLocale": "zh-cn",
    "availableLocale": [
      "zh-cn"
    ]
  },
  "zh-hk": {
    "language": "zh-hk",
    "beta": true,
    "defaultLocale": "zh-hk",
    "availableLocale": [
      "zh-hk"
    ]
  }
});

hns('I18n.currencySymbols', {
  "USD": {
    "symbol": "$",
    "name": "US Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USD",
    "name_plural": "US dollars"
  },
  "CAD": {
    "symbol": "CA$",
    "name": "Canadian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CAD",
    "name_plural": "Canadian dollars"
  },
  "EUR": {
    "symbol": "€",
    "name": "Euro",
    "symbol_native": "€",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EUR",
    "name_plural": "euros"
  },
  "AED": {
    "symbol": "AED",
    "name": "United Arab Emirates Dirham",
    "symbol_native": "د.إ.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AED",
    "name_plural": "UAE dirhams"
  },
  "AFN": {
    "symbol": "Af",
    "name": "Afghan Afghani",
    "symbol_native": "؋",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AFN",
    "name_plural": "Afghan Afghanis"
  },
  "ALL": {
    "symbol": "ALL",
    "name": "Albanian Lek",
    "symbol_native": "Lek",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ALL",
    "name_plural": "Albanian lekë"
  },
  "AMD": {
    "symbol": "AMD",
    "name": "Armenian Dram",
    "symbol_native": "դր.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AMD",
    "name_plural": "Armenian drams"
  },
  "AOA": {
    "symbol": "Kz",
    "name": "Angolan kwanza",
    "symbol_native": "Kz",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AOA",
    "name_plural": "Angolan kwanzas"
  },
  "ARS": {
    "symbol": "AR$",
    "name": "Argentine Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ARS",
    "name_plural": "Argentine pesos"
  },
  "AUD": {
    "symbol": "AU$",
    "name": "Australian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AUD",
    "name_plural": "Australian dollars"
  },
  "AZN": {
    "symbol": "man.",
    "name": "Azerbaijani Manat",
    "symbol_native": "ман.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AZN",
    "name_plural": "Azerbaijani manats"
  },
  "BAM": {
    "symbol": "KM",
    "name": "Bosnia-Herzegovina Convertible Mark",
    "symbol_native": "KM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BAM",
    "name_plural": "Bosnia-Herzegovina convertible marks"
  },
  "BDT": {
    "symbol": "Tk",
    "name": "Bangladeshi Taka",
    "symbol_native": "৳",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BDT",
    "name_plural": "Bangladeshi takas"
  },
  "BGN": {
    "symbol": "BGN",
    "name": "Bulgarian Lev",
    "symbol_native": "лв.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BGN",
    "name_plural": "Bulgarian leva"
  },
  "BHD": {
    "symbol": "BD",
    "name": "Bahraini Dinar",
    "symbol_native": "د.ب.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "BHD",
    "name_plural": "Bahraini dinars"
  },
  "BIF": {
    "symbol": "FBu",
    "name": "Burundian Franc",
    "symbol_native": "FBu",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BIF",
    "name_plural": "Burundian francs"
  },
  "BND": {
    "symbol": "BN$",
    "name": "Brunei Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BND",
    "name_plural": "Brunei dollars"
  },
  "BOB": {
    "symbol": "Bs",
    "name": "Bolivian Boliviano",
    "symbol_native": "Bs",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOB",
    "name_plural": "Bolivian bolivianos"
  },
  "BRL": {
    "symbol": "R$",
    "name": "Brazilian Real",
    "symbol_native": "R$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BRL",
    "name_plural": "Brazilian reals"
  },
  "BWP": {
    "symbol": "BWP",
    "name": "Botswanan Pula",
    "symbol_native": "P",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BWP",
    "name_plural": "Botswanan pulas"
  },
  "BYR": {
    "symbol": "BYR",
    "name": "Belarusian Ruble",
    "symbol_native": "BYR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BYR",
    "name_plural": "Belarusian rubles"
  },
  "BZD": {
    "symbol": "BZ$",
    "name": "Belize Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BZD",
    "name_plural": "Belize dollars"
  },
  "CDF": {
    "symbol": "CDF",
    "name": "Congolese Franc",
    "symbol_native": "FrCD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CDF",
    "name_plural": "Congolese francs"
  },
  "CHF": {
    "symbol": "CHF",
    "name": "Swiss Franc",
    "symbol_native": "CHF",
    "decimal_digits": 2,
    "rounding": 0.05,
    "code": "CHF",
    "name_plural": "Swiss francs"
  },
  "CLF": {
    "symbol": "UF",
    "name": "Unidad de Fomento",
    "symbol_native": "UF",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CLF",
    "name_plural": "Unidades de Fomento"
  },
  "CLP": {
    "symbol": "CL$",
    "name": "Chilean Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CLP",
    "name_plural": "Chilean pesos"
  },
  "CNY": {
    "symbol": "CN¥",
    "name": "Chinese Yuan",
    "symbol_native": "CN¥",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CNY",
    "name_plural": "Chinese yuan"
  },
  "COP": {
    "symbol": "COP",
    "name": "Colombian Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "COP",
    "name_plural": "Colombian pesos"
  },
  "CRC": {
    "symbol": "₡",
    "name": "Costa Rican Colón",
    "symbol_native": "₡",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CRC",
    "name_plural": "Costa Rican colóns"
  },
  "CVE": {
    "symbol": "CV$",
    "name": "Cape Verdean Escudo",
    "symbol_native": "CV$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CVE",
    "name_plural": "Cape Verdean escudos"
  },
  "CZK": {
    "symbol": "Kč",
    "name": "Czech Republic Koruna",
    "symbol_native": "Kč",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CZK",
    "name_plural": "Czech Republic korunas"
  },
  "DJF": {
    "symbol": "Fdj",
    "name": "Djiboutian Franc",
    "symbol_native": "Fdj",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "DJF",
    "name_plural": "Djiboutian francs"
  },
  "DKK": {
    "symbol": "kr.",
    "name": "Danish Krone",
    "symbol_native": "kr.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DKK",
    "name_plural": "Danish kroner"
  },
  "DOP": {
    "symbol": "RD$",
    "name": "Dominican Peso",
    "symbol_native": "RD$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DOP",
    "name_plural": "Dominican pesos"
  },
  "DZD": {
    "symbol": "DA",
    "name": "Algerian Dinar",
    "symbol_native": "د.ج.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DZD",
    "name_plural": "Algerian dinars"
  },
  "EEK": {
    "symbol": "Ekr",
    "name": "Estonian Kroon",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EEK",
    "name_plural": "Estonian kroons"
  },
  "EGP": {
    "symbol": "EGP",
    "name": "Egyptian Pound",
    "symbol_native": "ج.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EGP",
    "name_plural": "Egyptian pounds"
  },
  "ERN": {
    "symbol": "Nfk",
    "name": "Eritrean Nakfa",
    "symbol_native": "Nfk",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ERN",
    "name_plural": "Eritrean nakfas"
  },
  "ETB": {
    "symbol": "Br",
    "name": "Ethiopian Birr",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ETB",
    "name_plural": "Ethiopian birrs"
  },
  "GBP": {
    "symbol": "£",
    "name": "British Pound Sterling",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GBP",
    "name_plural": "British pounds sterling"
  },
  "GEL": {
    "symbol": "GEL",
    "name": "Georgian Lari",
    "symbol_native": "GEL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GEL",
    "name_plural": "Georgian laris"
  },
  "GHS": {
    "symbol": "GH₵",
    "name": "Ghanaian Cedi",
    "symbol_native": "GH₵",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GHS",
    "name_plural": "Ghanaian cedis"
  },
  "GNF": {
    "symbol": "FG",
    "name": "Guinean Franc",
    "symbol_native": "FG",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "GNF",
    "name_plural": "Guinean francs"
  },
  "GTQ": {
    "symbol": "GTQ",
    "name": "Guatemalan Quetzal",
    "symbol_native": "Q",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GTQ",
    "name_plural": "Guatemalan quetzals"
  },
  "HKD": {
    "symbol": "HK$",
    "name": "Hong Kong Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HKD",
    "name_plural": "Hong Kong dollars"
  },
  "HNL": {
    "symbol": "HNL",
    "name": "Honduran Lempira",
    "symbol_native": "L",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HNL",
    "name_plural": "Honduran lempiras"
  },
  "HRK": {
    "symbol": "kn",
    "name": "Croatian Kuna",
    "symbol_native": "kn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HRK",
    "name_plural": "Croatian kunas"
  },
  "HUF": {
    "symbol": "Ft",
    "name": "Hungarian Forint",
    "symbol_native": "Ft",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "HUF",
    "name_plural": "Hungarian forints"
  },
  "IDR": {
    "symbol": "Rp",
    "name": "Indonesian Rupiah",
    "symbol_native": "Rp",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IDR",
    "name_plural": "Indonesian rupiahs"
  },
  "ILS": {
    "symbol": "₪",
    "name": "Israeli New Shekel",
    "symbol_native": "₪",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ILS",
    "name_plural": "Israeli new shekels"
  },
  "INR": {
    "symbol": "Rs",
    "name": "Indian Rupee",
    "symbol_native": "₹",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "INR",
    "name_plural": "Indian rupees"
  },
  "IQD": {
    "symbol": "IQD",
    "name": "Iraqi Dinar",
    "symbol_native": "د.ع.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IQD",
    "name_plural": "Iraqi dinars"
  },
  "IRR": {
    "symbol": "IRR",
    "name": "Iranian Rial",
    "symbol_native": "﷼",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IRR",
    "name_plural": "Iranian rials"
  },
  "ISK": {
    "symbol": "Ikr",
    "name": "Icelandic Króna",
    "symbol_native": "kr",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ISK",
    "name_plural": "Icelandic krónur"
  },
  "JMD": {
    "symbol": "J$",
    "name": "Jamaican Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "JMD",
    "name_plural": "Jamaican dollars"
  },
  "JOD": {
    "symbol": "JD",
    "name": "Jordanian Dinar",
    "symbol_native": "د.أ.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "JOD",
    "name_plural": "Jordanian dinars"
  },
  "JPY": {
    "symbol": "¥",
    "name": "Japanese Yen",
    "symbol_native": "￥",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "JPY",
    "name_plural": "Japanese yen"
  },
  "KES": {
    "symbol": "Ksh",
    "name": "Kenyan Shilling",
    "symbol_native": "Ksh",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KES",
    "name_plural": "Kenyan shillings"
  },
  "KHR": {
    "symbol": "KHR",
    "name": "Cambodian Riel",
    "symbol_native": "៛",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KHR",
    "name_plural": "Cambodian riels"
  },
  "KMF": {
    "symbol": "CF",
    "name": "Comorian Franc",
    "symbol_native": "FC",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KMF",
    "name_plural": "Comorian francs"
  },
  "KRW": {
    "symbol": "₩",
    "name": "South Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KRW",
    "name_plural": "South Korean won"
  },
  "KWD": {
    "symbol": "KD",
    "name": "Kuwaiti Dinar",
    "symbol_native": "د.ك.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "KWD",
    "name_plural": "Kuwaiti dinars"
  },
  "KZT": {
    "symbol": "KZT",
    "name": "Kazakhstani Tenge",
    "symbol_native": "тңг.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KZT",
    "name_plural": "Kazakhstani tenges"
  },
  "LBP": {
    "symbol": "LB£",
    "name": "Lebanese Pound",
    "symbol_native": "ل.ل.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "LBP",
    "name_plural": "Lebanese pounds"
  },
  "LKR": {
    "symbol": "SLRs",
    "name": "Sri Lankan Rupee",
    "symbol_native": "SL Re",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LKR",
    "name_plural": "Sri Lankan rupees"
  },
  "LTL": {
    "symbol": "Lt",
    "name": "Lithuanian Litas",
    "symbol_native": "Lt",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LTL",
    "name_plural": "Lithuanian litai"
  },
  "LVL": {
    "symbol": "Ls",
    "name": "Latvian Lats",
    "symbol_native": "Ls",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LVL",
    "name_plural": "Latvian lati"
  },
  "LYD": {
    "symbol": "L$",
    "name": "Libyan Dinar",
    "symbol_native": "د.ل.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "LYD",
    "name_plural": "Libyan dinars"
  },
  "MAD": {
    "symbol": "MAD",
    "name": "Moroccan Dirham",
    "symbol_native": "د.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MAD",
    "name_plural": "Moroccan dirhams"
  },
  "MDL": {
    "symbol": "MDL",
    "name": "Moldovan Leu",
    "symbol_native": "MDL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MDL",
    "name_plural": "Moldovan lei"
  },
  "MGA": {
    "symbol": "MGA",
    "name": "Malagasy Ariary",
    "symbol_native": "MGA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MGA",
    "name_plural": "Malagasy Ariaries"
  },
  "MKD": {
    "symbol": "MKD",
    "name": "Macedonian Denar",
    "symbol_native": "MKD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MKD",
    "name_plural": "Macedonian denari"
  },
  "MMK": {
    "symbol": "MMK",
    "name": "Myanma Kyat",
    "symbol_native": "K",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MMK",
    "name_plural": "Myanma kyats"
  },
  "MNT": {
    "symbol": "MNT",
    "name": "Mongolian Tughrik",
    "symbol_native": "₮",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MNT",
    "name_plural": "Mongolian tögrög"
  },
  "MOP": {
    "symbol": "MOP$",
    "name": "Macanese Pataca",
    "symbol_native": "MOP$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MOP",
    "name_plural": "Macanese patacas"
  },
  "MRO": {
    "symbol": "UM",
    "name": "Mauritanian ouguiya",
    "symbol_native": "UM",
    "decimal_digits": 1,
    "rounding": 0,
    "code": "MRO",
    "name_plural": "Mauritanian ouguiya"
  },
  "MUR": {
    "symbol": "MURs",
    "name": "Mauritian Rupee",
    "symbol_native": "MURs",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MUR",
    "name_plural": "Mauritian rupees"
  },
  "MXN": {
    "symbol": "MX$",
    "name": "Mexican Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXN",
    "name_plural": "Mexican pesos"
  },
  "MYR": {
    "symbol": "RM",
    "name": "Malaysian Ringgit",
    "symbol_native": "RM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MYR",
    "name_plural": "Malaysian ringgits"
  },
  "MZN": {
    "symbol": "MTn",
    "name": "Mozambican Metical",
    "symbol_native": "MTn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MZN",
    "name_plural": "Mozambican meticals"
  },
  "NAD": {
    "symbol": "N$",
    "name": "Namibian Dollar",
    "symbol_native": "N$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NAD",
    "name_plural": "Namibian dollars"
  },
  "NGN": {
    "symbol": "₦",
    "name": "Nigerian Naira",
    "symbol_native": "₦",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NGN",
    "name_plural": "Nigerian nairas"
  },
  "NIO": {
    "symbol": "C$",
    "name": "Nicaraguan Córdoba",
    "symbol_native": "C$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NIO",
    "name_plural": "Nicaraguan córdobas"
  },
  "NOK": {
    "symbol": "kr",
    "name": "Norwegian Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NOK",
    "name_plural": "Norwegian kroner"
  },
  "NPR": {
    "symbol": "NPRs",
    "name": "Nepalese Rupee",
    "symbol_native": "नेरू",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NPR",
    "name_plural": "Nepalese rupees"
  },
  "NZD": {
    "symbol": "NZ$",
    "name": "New Zealand Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NZD",
    "name_plural": "New Zealand dollars"
  },
  "OMR": {
    "symbol": "OMR",
    "name": "Omani Rial",
    "symbol_native": "ر.ع.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "OMR",
    "name_plural": "Omani rials"
  },
  "PAB": {
    "symbol": "B/.",
    "name": "Panamanian Balboa",
    "symbol_native": "B/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PAB",
    "name_plural": "Panamanian balboas"
  },
  "PEN": {
    "symbol": "S/.",
    "name": "Peruvian Nuevo Sol",
    "symbol_native": "S/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PEN",
    "name_plural": "Peruvian nuevos soles"
  },
  "PGK": {
    "symbol": "K",
    "name": "Papua New Guinean kina",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PGK",
    "name_plural": "Papua New Guinean kina"
  },
  "PHP": {
    "symbol": "₱",
    "name": "Philippine Peso",
    "symbol_native": "₱",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PHP",
    "name_plural": "Philippine pesos"
  },
  "PKR": {
    "symbol": "PKRs",
    "name": "Pakistani Rupee",
    "symbol_native": "₨",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PKR",
    "name_plural": "Pakistani rupees"
  },
  "PLN": {
    "symbol": "zł",
    "name": "Polish Zloty",
    "symbol_native": "zł",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PLN",
    "name_plural": "Polish zlotys"
  },
  "PYG": {
    "symbol": "₲",
    "name": "Paraguayan Guarani",
    "symbol_native": "₲",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PYG",
    "name_plural": "Paraguayan guaranis"
  },
  "QAR": {
    "symbol": "QR",
    "name": "Qatari Rial",
    "symbol_native": "ر.ق.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "QAR",
    "name_plural": "Qatari rials"
  },
  "RON": {
    "symbol": "RON",
    "name": "Romanian Leu",
    "symbol_native": "RON",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RON",
    "name_plural": "Romanian lei"
  },
  "RSD": {
    "symbol": "din.",
    "name": "Serbian Dinar",
    "symbol_native": "дин.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RSD",
    "name_plural": "Serbian dinars"
  },
  "RUB": {
    "symbol": "RUB",
    "name": "Russian Ruble",
    "symbol_native": "руб.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RUB",
    "name_plural": "Russian rubles"
  },
  "RWF": {
    "symbol": "RWF",
    "name": "Rwandan Franc",
    "symbol_native": "FR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RWF",
    "name_plural": "Rwandan francs"
  },
  "SAR": {
    "symbol": "SR",
    "name": "Saudi Riyal",
    "symbol_native": "ر.س.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SAR",
    "name_plural": "Saudi riyals"
  },
  "SDG": {
    "symbol": "SDG",
    "name": "Sudanese Pound",
    "symbol_native": "SDG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SDG",
    "name_plural": "Sudanese pounds"
  },
  "SEK": {
    "symbol": "SEK",
    "name": "Swedish Krona",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SEK",
    "name_plural": "Swedish kronor"
  },
  "SGD": {
    "symbol": "S$",
    "name": "Singapore Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SGD",
    "name_plural": "Singapore dollars"
  },
  "SOS": {
    "symbol": "Ssh",
    "name": "Somali Shilling",
    "symbol_native": "Ssh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SOS",
    "name_plural": "Somali shillings"
  },
  "SRD": {
    "symbol": "SR$",
    "name": "Surinamese Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SRD",
    "name_plural": "Surinamese dollars"
  },
  "SYP": {
    "symbol": "SY£",
    "name": "Syrian Pound",
    "symbol_native": "ل.س.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SYP",
    "name_plural": "Syrian pounds"
  },
  "THB": {
    "symbol": "฿",
    "name": "Thai Baht",
    "symbol_native": "฿",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "THB",
    "name_plural": "Thai baht"
  },
  "TND": {
    "symbol": "DT",
    "name": "Tunisian Dinar",
    "symbol_native": "د.ت.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "TND",
    "name_plural": "Tunisian dinars"
  },
  "TOP": {
    "symbol": "T$",
    "name": "Tongan Paʻanga",
    "symbol_native": "T$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TOP",
    "name_plural": "Tongan paʻanga"
  },
  "TRY": {
    "symbol": "TL",
    "name": "Turkish Lira",
    "symbol_native": "TL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TRY",
    "name_plural": "Turkish Lira"
  },
  "TTD": {
    "symbol": "TT$",
    "name": "Trinidad and Tobago Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TTD",
    "name_plural": "Trinidad and Tobago dollars"
  },
  "TWD": {
    "symbol": "NT$",
    "name": "New Taiwan Dollar",
    "symbol_native": "NT$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TWD",
    "name_plural": "New Taiwan dollars"
  },
  "TZS": {
    "symbol": "TSh",
    "name": "Tanzanian Shilling",
    "symbol_native": "TSh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "TZS",
    "name_plural": "Tanzanian shillings"
  },
  "UAH": {
    "symbol": "₴",
    "name": "Ukrainian Hryvnia",
    "symbol_native": "₴",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UAH",
    "name_plural": "Ukrainian hryvnias"
  },
  "UGX": {
    "symbol": "USh",
    "name": "Ugandan Shilling",
    "symbol_native": "USh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UGX",
    "name_plural": "Ugandan shillings"
  },
  "UYU": {
    "symbol": "$U",
    "name": "Uruguayan Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYU",
    "name_plural": "Uruguayan pesos"
  },
  "UZS": {
    "symbol": "UZS",
    "name": "Uzbekistan Som",
    "symbol_native": "UZS",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UZS",
    "name_plural": "Uzbekistan som"
  },
  "VEF": {
    "symbol": "Bs.S.",
    "name": "Venezuelan Bolívar",
    "symbol_native": "Bs.S.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VEF",
    "name_plural": "Venezuelan bolívars"
  },
  "VND": {
    "symbol": "₫",
    "name": "Vietnamese Dong",
    "symbol_native": "₫",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "VND",
    "name_plural": "Vietnamese dong"
  },
  "XAF": {
    "symbol": "FCFA",
    "name": "CFA Franc BEAC",
    "symbol_native": "FCFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XAF",
    "name_plural": "CFA francs BEAC"
  },
  "XOF": {
    "symbol": "CFA",
    "name": "CFA Franc BCEAO",
    "symbol_native": "CFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XOF",
    "name_plural": "CFA francs BCEAO"
  },
  "YER": {
    "symbol": "YR",
    "name": "Yemeni Rial",
    "symbol_native": "ر.ي.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "YER",
    "name_plural": "Yemeni rials"
  },
  "ZAR": {
    "symbol": "R",
    "name": "South African Rand",
    "symbol_native": "R",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZAR",
    "name_plural": "South African rand"
  },
  "ZMK": {
    "symbol": "ZK",
    "name": "Zambian Kwacha",
    "symbol_native": "ZK",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ZMK",
    "name_plural": "Zambian kwachas"
  },
  "ANG": {
    "symbol": "NAƒ",
    "name": "Netherlands Antillean Guilder",
    "symbol_native": "ƒ",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ANG",
    "name_plural": "Netherlands Antillean guilders"
  },
  "AWG": {
    "symbol": "Afl.",
    "name": "Aruban Florin",
    "symbol_native": "Afl.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AWG",
    "name_plural": "Aruban florin"
  },
  "BBD": {
    "symbol": "Bds$",
    "name": "Barbadian Dollar",
    "symbol_native": "Bds$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BBD",
    "name_plural": "Barbadian dollars"
  },
  "BMD": {
    "symbol": "BD$",
    "name": "Bermudian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BMD",
    "name_plural": "Bermudian dollars"
  },
  "BOV": {
    "symbol": "Bolivian Mvdol",
    "name": "Bolivian Mvdol",
    "symbol_native": "Bolivian Mvdol",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOV",
    "name_plural": "Bolivian Mvdol"
  },
  "BSD": {
    "symbol": "B$",
    "name": "Bahamian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BSD",
    "name_plural": "Bahamian dollars"
  },
  "BTN": {
    "symbol": "Nu.",
    "name": "Bhutanese Ngultrum",
    "symbol_native": "Nu.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BTN",
    "name_plural": "Bhutanese ngultrum"
  },
  "BYN": {
    "symbol": "Br",
    "name": "Belarusian Ruble",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BYN",
    "name_plural": "Belarusian rubles"
  },
  "CHE": {
    "symbol": "CHE",
    "name": "WIR Euro",
    "symbol_native": "CHE",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CHE",
    "name_plural": "WIR Euro"
  },
  "CHW": {
    "symbol": "CHW",
    "name": "WIR Franc",
    "symbol_native": "CHW",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CHW",
    "name_plural": "WIR Franc"
  },
  "COU": {
    "symbol": "COU",
    "name": "Unidad de Valor Real",
    "symbol_native": "COU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "COU",
    "name_plural": "Unidad de Valor Real"
  },
  "CUC": {
    "symbol": "CUC$",
    "name": "Cuban Convertible Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CUC",
    "name_plural": "Cuban convertible pesos"
  },
  "CUP": {
    "symbol": "$",
    "name": "Cuban Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CUP",
    "name_plural": "Cuban pesos"
  },
  "FJD": {
    "symbol": "FJ$",
    "name": "Fiji Dollar",
    "symbol_native": "FJ$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "FJD",
    "name_plural": "Fiji dollars"
  },
  "FKP": {
    "symbol": "£",
    "name": "Falkland Islands Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "FKP",
    "name_plural": "Falkland Islands pounds"
  },
  "GIP": {
    "symbol": "£",
    "name": "Gibraltar Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GIP",
    "name_plural": "Gibraltar pounds"
  },
  "GMD": {
    "symbol": "D",
    "name": "Gambian Dalasi",
    "symbol_native": "D",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GMD",
    "name_plural": "Gambian dalasi"
  },
  "GYD": {
    "symbol": "G$",
    "name": "Guyanese Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GYD",
    "name_plural": "Guyanese dollars"
  },
  "HTG": {
    "symbol": "G",
    "name": "Haitian Gourde",
    "symbol_native": "G",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HTG",
    "name_plural": "Haitian gourdes"
  },
  "KGS": {
    "symbol": "C",
    "name": "Kyrgyzstani Som",
    "symbol_native": "C",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KGS",
    "name_plural": "Kyrgyzstani som"
  },
  "KPW": {
    "symbol": "₩",
    "name": "North Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KPW",
    "name_plural": "North Korean won"
  },
  "KYD": {
    "symbol": "CI$",
    "name": "Cayman Islands Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KYD",
    "name_plural": "Cayman Islands dollars"
  },
  "LAK": {
    "symbol": "₭",
    "name": "Lao Kip",
    "symbol_native": "₭",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LAK",
    "name_plural": "Lao kip"
  },
  "LRD": {
    "symbol": "L$",
    "name": "Liberian Dollar",
    "symbol_native": "L$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LRD",
    "name_plural": "Liberian dollars"
  },
  "LSL": {
    "symbol": "M",
    "name": "Lesotho Loti",
    "symbol_native": "M",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LSL",
    "name_plural": "Lesotho maloti"
  },
  "MRU": {
    "symbol": "UM",
    "name": "Mauritanian Ouguiya",
    "symbol_native": "UM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MRU",
    "name_plural": "Mauritanian ouguiya"
  },
  "MVR": {
    "symbol": "Rf",
    "name": "Maldivian Rufiyaa",
    "symbol_native": "Rf",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MVR",
    "name_plural": "Maldivian rufiyaa"
  },
  "MWK": {
    "symbol": "K",
    "name": "Malawian Kwacha",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MWK",
    "name_plural": "Malawian kwacha"
  },
  "MXV": {
    "symbol": "MXV",
    "name": "Mexican Unidad de Inversión",
    "symbol_native": "MXV",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXV",
    "name_plural": "Mexican unidad de inversión"
  },
  "SBD": {
    "symbol": "SI$",
    "name": "Solomon Islands Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SBD",
    "name_plural": "Solomon Islands dollars"
  },
  "SCR": {
    "symbol": "SR",
    "name": "Seychellois Rupee",
    "symbol_native": "SR",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SCR",
    "name_plural": "Seychellois rupees"
  },
  "SHP": {
    "symbol": "£",
    "name": "Saint Helena Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SHP",
    "name_plural": "Saint Helena pounds"
  },
  "SLL": {
    "symbol": "Le",
    "name": "Sierra Leonean Leone",
    "symbol_native": "Le",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SLL",
    "name_plural": "Sierra Leonean leones"
  },
  "SSP": {
    "symbol": "SSP",
    "name": "South Sudanese Pound",
    "symbol_native": "SSP",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SSP",
    "name_plural": "South Sudanese pounds"
  },
  "STN": {
    "symbol": "Db",
    "name": "São Tomé and Príncipe Dobra",
    "symbol_native": "Db",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "STN",
    "name_plural": "São Tomé and Príncipe dobras"
  },
  "SVC": {
    "symbol": "₡",
    "name": "Salvadoran Colón",
    "symbol_native": "₡",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SVC",
    "name_plural": "Salvadoran colones"
  },
  "SZL": {
    "symbol": "E",
    "name": "Swazi Lilangeni",
    "symbol_native": "E",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SZL",
    "name_plural": "Swazi emalangeni"
  },
  "TJS": {
    "symbol": "TJS",
    "name": "Tajikistani Somoni",
    "symbol_native": "TJS",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TJS",
    "name_plural": "Tajikistani somoni"
  },
  "TMT": {
    "symbol": "T",
    "name": "Turkmenistan Manat",
    "symbol_native": "T",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TMT",
    "name_plural": "Turkmenistan manat"
  },
  "USN": {
    "symbol": "$",
    "name": "US dollar (Next day)",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USN",
    "name_plural": "US dollar (next day)"
  },
  "UYI": {
    "symbol": "UYI",
    "name": "Uruguay Peso en Unidades Indexadas",
    "symbol_native": "UYI",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYI",
    "name_plural": "Uruguay Peso en Unidades Indexadas"
  },
  "VUV": {
    "symbol": "VT",
    "name": "Vanuatu Vatu",
    "symbol_native": "VT",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VUV",
    "name_plural": "Vanuatu vatu"
  },
  "WST": {
    "symbol": "WS$",
    "name": "Samoan Tālā",
    "symbol_native": "WS$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "WST",
    "name_plural": "Samoan tālā"
  },
  "XAG": {
    "symbol": "XAG",
    "name": "Silver",
    "symbol_native": "XAG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XAG",
    "name_plural": "Silver"
  },
  "XAU": {
    "symbol": "XAU",
    "name": "Gold",
    "symbol_native": "XAU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XAU",
    "name_plural": "Gold"
  },
  "XBA": {
    "symbol": "XBA",
    "name": "Bond Markets Unit European Composite Unit (EURCO)",
    "symbol_native": "XBA",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBA",
    "name_plural": "Bond Markets Unit European Composite Unit (EURCO)"
  },
  "XBB": {
    "symbol": "XBB",
    "name": "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
    "symbol_native": "XBB",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBB",
    "name_plural": "Bond Markets Unit European Monetary Unit (E.M.U.-6)"
  },
  "XBC": {
    "symbol": "XBC",
    "name": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)9",
    "symbol_native": "XBC",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBC",
    "name_plural": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)"
  },
  "XBD": {
    "symbol": "XBD",
    "name": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
    "symbol_native": "XBD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBD",
    "name_plural": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)"
  },
  "XCD": {
    "symbol": "$",
    "name": "East Caribbean Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XCD",
    "name_plural": "East Caribbean Dollar"
  },
  "XDR": {
    "symbol": "SDR",
    "name": "SDR (Special Drawing Right)",
    "symbol_native": "SDR",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XDR",
    "name_plural": "SDR (Special Drawing Right)"
  },
  "XPD": {
    "symbol": "XPD",
    "name": "Palladium",
    "symbol_native": "XPD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPD",
    "name_plural": "Palladium"
  },
  "XPF": {
    "symbol": "CFP",
    "name": "CFP Franc",
    "symbol_native": "CFP",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPF",
    "name_plural": "CFP franc"
  },
  "XPT": {
    "symbol": "XPT",
    "name": "Platinum",
    "symbol_native": "XPT",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPT",
    "name_plural": "Platinum"
  },
  "XSU": {
    "symbol": "XSU",
    "name": "SUCRE",
    "symbol_native": "XSU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XSU",
    "name_plural": "SUCRE"
  },
  "XUA": {
    "symbol": "XUA",
    "name": "ADB Unit of Account",
    "symbol_native": "XUA",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XUA",
    "name_plural": "ADB Unit of Account"
  },
  "ZMW": {
    "symbol": "K",
    "name": "Zambian Kwacha",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZMW",
    "name_plural": "Zambian kwacha"
  },
  "ZWL": {
    "symbol": "Z$",
    "name": "Zimbabwe Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZWL",
    "name_plural": "Zimbabwe dollar"
  }
});

(function () {
var ABBREVIATE_DEFAULTS, ABBR_DIGIT_MAX, ABBR_NUMBER_MAX, ABBR_NUMBER_MIN, CONNECTOR_DEFAULTS, I18n, NUMERAL_OR_SIGN_OR_E, getAbbreviationKey, htmlCharPattern, htmlEscape, htmlEscapeMap, htmlReplaceRegexp, htmlReplacement, htmlTestRegexp, interleave, missingNotificationWrapper, originalMissingTranslation, originalMissingValue, parseAbbreviatePattern, zeroAsOnePlural,
  slice = [].slice;

I18n = typeof exports !== "undefined" && exports !== null ? exports : this.I18n;

I18n.baseI18nT = I18n.t;

I18n.text = I18n.t = function() {
  var args, includesOptions, key, lastOption, modifiedOpts, optName, optValue, originalOpts, tooEarlyError;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  lastOption = args[args.length - 1];
  includesOptions = typeof lastOption !== 'string';
  originalOpts = includesOptions && lastOption ? args[args.length - 1] : {};
  key = includesOptions ? args.slice(0, args.length - 1).join('.') : args.join('.');
  modifiedOpts = {};
  for (optName in originalOpts) {
    optValue = originalOpts[optName];
    if (optValue != null) {
      modifiedOpts[optName] = I18n.formatParam(optName, optValue);
    }
  }
  if (!modifiedOpts.locale && I18n.lang !== 'en' && !I18n.langEnabled && !I18n.publicPage) {
    I18n.debugLog("Forcing translation in English, lang is not enabled");
    modifiedOpts.locale = 'en';
  }
  modifiedOpts.__scope = key;
  if (I18n.fired && !I18n.fired.ready) {
    tooEarlyError = new Error("I18n.text called before ready with key '" + key + "' - See go/i18n-help for more info");
    setTimeout(function() {
      throw tooEarlyError;
    }, 0);
  }
  return I18n.baseI18nT(key, modifiedOpts);
};

I18n.html = function(key, opts) {
  var gap;
  if (opts == null) {
    opts = {};
  }
  gap = '';
  if (opts.useGap === true || opts.noGap === false) {
    gap = ' ';
  }
  return gap + "<i18n-string data-key='" + key + "' data-locale-at-render='" + I18n.locale + "'>" + (I18n.text(key, opts)) + "</i18n-string>" + gap;
};

I18n.formatNumber = function(val, opts) {
  if (opts == null) {
    opts = {};
  }
  if (opts.abbreviate) {
    opts = I18n.prepareOptions(opts, ABBREVIATE_DEFAULTS);
    if (typeof opts.abbreviate === 'string') {
      opts.type = opts.abbreviate;
    }
    return I18n.abbreviateNumber(val, opts);
  }
  return I18n.toNumber(val, opts);
};

I18n.formatPercentage = function(val, opts) {
  if (opts == null) {
    opts = {};
  }
  return I18n.toPercentage(val, opts);
};

ABBREVIATE_DEFAULTS = {
  type: 'short',
  precision: 0
};

I18n.formatCurrency = function(val, opts) {
  var currencyData, signedNumber;
  if (opts == null) {
    opts = {};
  }
  if (!I18n.currencySymbols['USD']) {
    console.error('It looks like currency data is not available. Are you using the new I18n loader and forgot to import currencies? See go/new-i18n');
  }
  if (opts.currencyCode) {
    currencyData = I18n.currencySymbols[opts.currencyCode];
    if (currencyData) {
      if (opts.unit == null) {
        opts.unit = currencyData.symbol;
      }
      if (opts.precision == null) {
        opts.precision = currencyData.decimal_digits;
      }
    }
  }
  if (!opts.unit && !opts.useCurrencyCode) {
    console.warn('I18n: Missing or invalid currencyCode in call to formatCurrency. See https://git.hubteam.com/HubSpot/I18n/issues/59');
  }
  if (opts.abbreviate) {
    opts = I18n.prepareOptions(opts, ABBREVIATE_DEFAULTS);
    if (typeof opts.abbreviate === 'string') {
      opts.type = opts.abbreviate;
    }
    signedNumber = val >= 0 ? 2 : -2;
    return I18n.toCurrency(signedNumber, opts).replace("2", I18n.abbreviateNumber(Math.abs(val), opts));
  } else {
    return I18n.toCurrency(val, opts);
  }
};

I18n.formatSize = I18n.toHumanSize;

NUMERAL_OR_SIGN_OR_E = /\d|\+|\-|e/i;

I18n.parseNumber = function(string, options) {
  var buffer, char, j, len;
  options = I18n.prepareOptions(options, I18n.lookup("number.format", {
    locale: (options || {}).locale
  }), I18n.NUMBER_FORMAT);
  if (typeof string === 'number') {
    return string;
  } else if (typeof string !== 'string') {
    return NaN;
  }
  string = string.replace(/\s/g, '');
  buffer = '';
  for (j = 0, len = string.length; j < len; j++) {
    char = string[j];
    if (char.match(NUMERAL_OR_SIGN_OR_E)) {
      buffer += char;
    } else if (char === options.separator) {
      buffer += '.';
    } else if (char === options.delimiter) {
      continue;
    } else {
      return NaN;
    }
  }
  return parseFloat(buffer);
};

missingNotificationWrapper = function(originalFunction, eventName, sendSentries, originalArgs, sentryOptions) {
  var message, sentryMessage;
  if (sentryOptions == null) {
    sentryOptions = {};
  }
  message = originalFunction.apply(I18n, originalArgs);
  if (sendSentries) {
    sentryMessage = sentryOptions.message || message;
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage("I18n: " + sentryMessage, {
        extra: {
          currentLocale: I18n.currentLocale(),
          translationKey: sentryOptions.translationKey,
          placeholderName: sentryOptions.placeholderName
        }
      });
    }
  }
  if (typeof I18n.trigger === "function") {
    I18n.trigger(eventName, message);
  }
  return message;
};

I18n.sendSentryOnMissingTranslations = true;

originalMissingTranslation = I18n.missingTranslation;

I18n.missingTranslation = function(scope) {
  var sentryOptions;
  console.warn('I18n: Missing translation (' + this.currentLocale() + '): ' + scope);
  sentryOptions = {
    translationKey: scope
  };
  return htmlEscape(missingNotificationWrapper(originalMissingTranslation, 'missingTranslation', I18n.sendSentryOnMissingTranslations, arguments, sentryOptions));
};

I18n.sendSentryOnMissingValues = true;

originalMissingValue = I18n.missingPlaceholder;

I18n.missingPlaceholder = function(placeholder, message, options) {
  var missingPlaceholderMessage, sentryOptions;
  missingPlaceholderMessage = 'I18n: Missing placeholder (' + this.currentLocale() + '): ' + placeholder + ' in "' + options.__scope + '"';
  sentryOptions = {
    message: missingPlaceholderMessage,
    translationKey: options.__scope,
    placeholderName: placeholder
  };
  console.warn(missingPlaceholderMessage);
  return missingNotificationWrapper(originalMissingValue, 'missingPlaceholder', I18n.sendSentryOnMissingValues, arguments, sentryOptions);
};

if (I18n.lang == null) {
  Object.defineProperty(I18n, 'lang', {
    get: function() {
      return I18n.locale.split('-')[0];
    }
  });
}

CONNECTOR_DEFAULTS = {
  inclusive: {
    wordsConnector: "|, ",
    twoWordsConnector: "| and ",
    lastWordConnector: "|, and "
  },
  exclusive: {
    wordsConnector: "|, ",
    twoWordsConnector: "| or ",
    lastWordConnector: "|, or "
  }
};

interleave = function(between, items) {
  var lastIndex;
  lastIndex = items.length - 1;
  return items.reduce(function(acc, item, index) {
    acc.push(item);
    if (index !== lastIndex) {
      acc.push(between);
    }
    return acc;
  }, []);
};

I18n.formatListArray = function(list, options) {
  var connectorType, excessKey, excessString, exclusive, lastWordConnector, length, limit, locale, ref, ref1, ref2, ref3, ref4, ref5, result, rootKey, twoWordsConnector, wordsConnector;
  if (options == null) {
    options = {};
  }
  wordsConnector = options.wordsConnector, twoWordsConnector = options.twoWordsConnector, lastWordConnector = options.lastWordConnector, locale = options.locale, limit = options.limit, excessKey = options.excessKey, exclusive = options.exclusive;
  if ((limit != null) && limit <= 2) {
    throw new Error("The formatList limit must be 3 or larger");
  }
  if ((limit != null) && (excessKey == null)) {
    throw new Error("When using a limit in formatList, you must pass excessKey (that is a external, plurlized string reference)");
  }
  if (Array.isArray != null) {
    if (!Array.isArray(list)) {
      throw new Error("The first argument to I18n.formatList must be an array");
    }
  } else {
    if (!(list instanceof Array)) {
      throw new Error("The first argument to I18n.formatList must be an array");
    }
  }
  rootKey = 'number.human.array';
  connectorType = 'inclusive';
  if (exclusive === true) {
    connectorType = 'exclusive';
  }
  wordsConnector = (ref = (ref1 = options.wordsConnector) != null ? ref1 : I18n.text(rootKey + "." + connectorType + ".wordsConnector", {
    locale: options.locale
  })) != null ? ref : CONNECTOR_DEFAULTS[connectorType].wordsConnector;
  twoWordsConnector = (ref2 = (ref3 = options.twoWordsConnector) != null ? ref3 : I18n.text(rootKey + "." + connectorType + ".twoWordsConnector", {
    locale: options.locale
  })) != null ? ref2 : CONNECTOR_DEFAULTS[connectorType].twoWordsConnector;
  lastWordConnector = (ref4 = (ref5 = options.lastWordConnector) != null ? ref5 : I18n.text(rootKey + "." + connectorType + ".lastWordConnector", {
    locale: options.locale
  })) != null ? ref4 : CONNECTOR_DEFAULTS[connectorType].lastWordConnector;
  length = list.length;
  if (length === 0) {
    return [];
  } else if (length === 1) {
    return [list[0]];
  } else if (length === 2) {
    return [list[0], twoWordsConnector, list[1]];
  } else if ((limit == null) || limit >= length) {
    result = interleave(wordsConnector, list.slice(0, -1));
    result.push(lastWordConnector);
    result.push(list[list.length - 1]);
    return result;
  } else {
    excessString = I18n.text(excessKey, {
      count: list.length - limit,
      locale: options.locale
    });
    result = interleave(wordsConnector, list.slice(0, limit));
    result.push(lastWordConnector);
    result.push(excessString);
    return result;
  }
};

I18n.formatList = function(list, options) {
  if (options == null) {
    options = {};
  }
  return I18n.formatListArray(list, options).join('');
};

ABBR_DIGIT_MAX = 15;

ABBR_NUMBER_MAX = Math.pow(10, ABBR_DIGIT_MAX);

ABBR_NUMBER_MIN = 1000;

I18n.advancedFormatNumber = function(number, opts) {
  var absNumber, buffer, decPart, delimiter, formattedNumber, intPart, locale, localizedNumber, maxFractionDigits, maxSignificantDigits, maxThreshold, minFractionDigits, minIntegerDigits, minSignificantDigits, minThreshold, negative, numDigitsToTruncateTo, parts, separator, stripInsignificantZeros, truncateFactor;
  if (opts == null) {
    opts = {};
  }
  opts = this.prepareOptions(opts, I18n.lookup("number.format", {
    locale: opts.locale
  }), {
    separator: '.',
    delimiter: ','
  });
  locale = opts.locale, separator = opts.separator, delimiter = opts.delimiter, numDigitsToTruncateTo = opts.numDigitsToTruncateTo, maxThreshold = opts.maxThreshold, minThreshold = opts.minThreshold, minIntegerDigits = opts.minIntegerDigits, maxSignificantDigits = opts.maxSignificantDigits, minSignificantDigits = opts.minSignificantDigits, maxFractionDigits = opts.maxFractionDigits, minFractionDigits = opts.minFractionDigits, stripInsignificantZeros = opts.stripInsignificantZeros;
  negative = number < 0;
  if (minThreshold == null) {
    minThreshold = Number.NEGATIVE_INFINITY;
  }
  if (maxThreshold == null) {
    maxThreshold = Number.POSITIVE_INFINITY;
  }
  if ((minFractionDigits != null) || (minSignificantDigits != null) || (maxFractionDigits != null) || (maxSignificantDigits != null)) {
    if (stripInsignificantZeros == null) {
      stripInsignificantZeros = false;
    }
  } else {
    if (stripInsignificantZeros == null) {
      stripInsignificantZeros = true;
    }
  }
  if (minIntegerDigits == null) {
    minIntegerDigits = Math.max(numDigitsToTruncateTo != null ? numDigitsToTruncateTo : 0, 1);
  }
  if ((minSignificantDigits != null) || (maxSignificantDigits != null)) {
    if (maxSignificantDigits == null) {
      maxSignificantDigits = ABBR_DIGIT_MAX;
    }
    if (minSignificantDigits == null) {
      minSignificantDigits = 1;
    }
  }
  if (minFractionDigits == null) {
    minFractionDigits = 0;
  }
  if (maxFractionDigits == null) {
    maxFractionDigits = Math.max(minFractionDigits, 0);
  }
  absNumber = Math.abs(number);
  if ((numDigitsToTruncateTo != null) && (minThreshold <= absNumber && absNumber < maxThreshold)) {
    truncateFactor = Math.max(0, I18n.util.log10Floor(absNumber) + 1 - numDigitsToTruncateTo);
    absNumber = absNumber / Math.pow(10, truncateFactor);
  }
  if ((minSignificantDigits != null) && (maxSignificantDigits != null)) {
    formattedNumber = I18n.util.toRawPrecision(absNumber, minSignificantDigits, maxSignificantDigits);
  } else {
    formattedNumber = I18n.util.toRawFixed(absNumber, minIntegerDigits, minFractionDigits, maxFractionDigits);
  }
  parts = formattedNumber.split(".");
  intPart = parts[0];
  decPart = parts[1];
  buffer = [];
  while (intPart.length > 0) {
    buffer.unshift(intPart.substr(Math.max(0, intPart.length - 3), 3));
    intPart = intPart.substr(0, intPart.length - 3);
  }
  localizedNumber = buffer.join(delimiter);
  if (stripInsignificantZeros && decPart) {
    decPart = decPart.replace(/0+$/, "");
  }
  if (decPart) {
    localizedNumber += separator + decPart;
  }
  if (negative) {
    localizedNumber = "-" + localizedNumber;
  }
  return localizedNumber;
};

getAbbreviationKey = function(number) {
  var i, zeroes;
  number = Math.abs(number);
  zeroes = ((function() {
    var j, ref, results;
    results = [];
    for (i = j = 0, ref = Math.floor(number).toString().length - 1; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
      results.push("0");
    }
    return results;
  })()).join("");
  return "1" + zeroes;
};

parseAbbreviatePattern = function(pattern) {
  var __, digitString, match, numDigits, prefix, suffix;
  if (match = pattern.match(/^([^0]*)(0+)(.*)$/)) {
    __ = match[0], prefix = match[1], digitString = match[2], suffix = match[3];
    numDigits = digitString.length;
    return {
      prefix: prefix,
      digitString: digitString,
      numDigits: numDigits,
      suffix: suffix
    };
  } else {
    throw new Error("Invalid abbreviation pattern: " + pattern);
  }
};

I18n.abbreviateNumber = function(val, opts) {
  var abbrFormat, abbrPattern, delimiter, formattedTruncatedNumber, key, locale, maxFractionDigits, maxSignificantDigits, minFractionDigits, minIntegerDigits, minSignificantDigits, pluralKey, pluralKeys, pluralizer, samplePattern, samplePatternString, sampleTruncatedNumber, separator, stripInsignificantZeros, type;
  if (opts == null) {
    opts = {};
  }
  type = opts.type, locale = opts.locale, separator = opts.separator, delimiter = opts.delimiter, stripInsignificantZeros = opts.stripInsignificantZeros, minIntegerDigits = opts.minIntegerDigits, maxSignificantDigits = opts.maxSignificantDigits, minSignificantDigits = opts.minSignificantDigits, maxFractionDigits = opts.maxFractionDigits, minFractionDigits = opts.minFractionDigits;
  if (type == null) {
    type = 'short';
  }
  key = getAbbreviationKey(val);
  abbrPattern = I18n.lookup("number.human.abbreviated." + type + "." + key, opts);
  if ((abbrPattern != null) && typeof abbrPattern === "object") {
    samplePatternString = abbrPattern[Object.keys(abbrPattern)[0]];
    samplePattern = parseAbbreviatePattern(samplePatternString);
    sampleTruncatedNumber = I18n.advancedFormatNumber(val, {
      numDigitsToTruncateTo: samplePattern.numDigits,
      minThreshold: ABBR_NUMBER_MIN,
      maxThreshold: ABBR_NUMBER_MAX
    });
    pluralizer = I18n.pluralization.get(locale);
    pluralKeys = pluralizer(Math.abs(sampleTruncatedNumber));
    while (pluralKeys.length) {
      pluralKey = pluralKeys.shift();
      if (abbrPattern[pluralKey] != null) {
        abbrPattern = abbrPattern[pluralKey];
        break;
      }
    }
  }
  if ((abbrPattern === '0' || abbrPattern === 0) || (abbrPattern == null)) {
    return I18n.advancedFormatNumber(val, {
      locale: locale,
      numDigitsToTruncateTo: 30,
      minThreshold: ABBR_NUMBER_MIN,
      maxThreshold: ABBR_NUMBER_MAX,
      minIntegerDigits: minIntegerDigits != null ? minIntegerDigits : 1,
      minSignificantDigits: minSignificantDigits,
      maxSignificantDigits: maxSignificantDigits,
      minFractionDigits: minFractionDigits,
      maxFractionDigits: maxFractionDigits,
      separator: separator,
      delimiter: delimiter,
      stripInsignificantZeros: stripInsignificantZeros
    });
  } else {
    abbrFormat = parseAbbreviatePattern(abbrPattern);
    formattedTruncatedNumber = I18n.advancedFormatNumber(val, {
      locale: locale,
      numDigitsToTruncateTo: abbrFormat.numDigits,
      minThreshold: ABBR_NUMBER_MIN,
      maxThreshold: ABBR_NUMBER_MAX,
      minIntegerDigits: minIntegerDigits,
      minSignificantDigits: minSignificantDigits,
      maxSignificantDigits: maxSignificantDigits,
      minFractionDigits: minFractionDigits,
      maxFractionDigits: maxFractionDigits,
      separator: separator,
      delimiter: delimiter,
      stripInsignificantZeros: stripInsignificantZeros
    });
    return "" + abbrFormat.prefix + formattedTruncatedNumber + abbrFormat.suffix;
  }
};

I18n.interpolateToArray = function(key, options, escapeFunction) {
  var escapedOptValue, i, match, modifiedOpts, optName, prefix, rawOptValue, ref, remainingMessage, result;
  modifiedOpts = I18n.prepareOptions(options);
  modifiedOpts.__scope = key;
  result = [];
  if (!options.locale && !I18n.langEnabled && !I18n.publicPage) {
    I18n.debugLog("Forcing translation in English, lang is not enabled");
    modifiedOpts.locale = 'en';
  }
  remainingMessage = I18n.lookup(key, modifiedOpts);
  if (!(remainingMessage != null)) {
    return [I18n.missingTranslation(key)];
  }
  if (remainingMessage === Object(remainingMessage) && this.isSet(options.count)) {
    if (options.count === 0 && remainingMessage.zero) {
      remainingMessage = remainingMessage.zero;
    } else if (options.count === 1 && remainingMessage.one) {
      remainingMessage = remainingMessage.one;
    } else {
      remainingMessage = remainingMessage.other;
    }
  }
  i = 0;
  while ((match = I18n.placeholder.exec(remainingMessage))) {
    prefix = remainingMessage.substring(0, match.index);
    if (prefix !== '') {
      result.push(escapeFunction("text-chunk", prefix, i++));
    }
    optName = match[1];
    rawOptValue = (ref = modifiedOpts[optName]) != null ? ref : I18n.missingPlaceholder(optName, remainingMessage, modifiedOpts);
    escapedOptValue = escapeFunction(optName, rawOptValue, i++);
    if (escapedOptValue !== '') {
      result.push(escapedOptValue);
    }
    remainingMessage = remainingMessage.substring(match.index + match[0].length);
    I18n.placeholder.lastIndex = 0;
  }
  if (remainingMessage !== '') {
    result.push(escapeFunction("text-chunk", remainingMessage, i++));
  }
  return result;
};

I18n.formatParam = function(optName, optValue) {
  if (typeof optValue === 'number') {
    if (optValue !== optValue) {
      return null;
    }
    if (optName === 'count') {
      return Number(optValue);
    }
    if (optName.toLowerCase() === 'portalid') {
      console.warn('The use of params named "portalId" in externalized strings is deprecated. You should wrap it, like so "I18n.t(key, { portalId: I18n.SafeString(portalId) })", to prevent it from being automatically formatted. See HubSpot/I18n#109');
      return String(optValue);
    } else {
      return I18n.formatNumber(optValue);
    }
  } else if (optValue instanceof I18n.SafeString) {
    return optValue.toString();
  } else if (optValue != null) {
    return htmlEscape(String(optValue));
  } else {
    return optValue;
  }
};

htmlEscapeMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};

htmlCharPattern = '(?:&|<|>|"|\'|`)';

htmlTestRegexp = RegExp(htmlCharPattern);

htmlReplaceRegexp = RegExp(htmlCharPattern, 'g');

htmlReplacement = function(match) {
  return htmlEscapeMap[match];
};

htmlEscape = function(string) {
  if (htmlTestRegexp.test(string)) {
    return string.replace(htmlReplaceRegexp, htmlReplacement);
  } else {
    return string;
  }
};

zeroAsOnePlural = function(count) {
  var validCount;
  validCount = count === 0 ? 1 : count;
  return I18n.pluralization["default"](validCount);
};

I18n.pluralization.fr = zeroAsOnePlural;
}());

(function () {
var DATE_STRING_ZONE_ABBR_REGEX, INTL_STRING_ZONE_ABBR_REGEX, origZoneAbbr, userZoneAbbr,
  slice = [].slice;

INTL_STRING_ZONE_ABBR_REGEX = /\s+(\S+)$/;

DATE_STRING_ZONE_ABBR_REGEX = /[A-Z]{2}\S+/;

I18n.moment.fn.portalTz = function() {
  var args, moment;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (args.length === 0) {
    moment = I18n.moment.fn.tz.call(this, I18n.timezone);
  } else {
    throw new Error("You cannot pass any parameters to portalTz when called on a moment instance. Did you mean to call `I18n.moment.portalTz(...)` instead?");
  }
  return moment;
};

I18n.moment.portalTz = function() {
  var args, moment, ref;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (args.length > 0) {
    moment = (ref = I18n.moment.tz).call.apply(ref, [this].concat(slice.call(args), [I18n.timezone]));
  } else {
    moment = I18n.moment.utc().tz(I18n.timezone);
  }
  return moment;
};

I18n.moment.userTz = function() {
  var args, moment, ref;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (args.length > 0) {
    moment = (ref = I18n.moment).call.apply(ref, [this].concat(slice.call(args)));
  } else {
    moment = I18n.moment();
  }
  moment.zoneAbbr = userZoneAbbr;
  return moment;
};

origZoneAbbr = I18n.moment.fn.zoneAbbr;

I18n.moment.fn.zoneAbbr = function() {
  if (this._z === void 0) {
    console.warn('I18n: Time zone abbreviations are not available on moments created with I18n.moment(). Switch to I18n.moment.userTz(), I18n.moment.portalTz(), or I18n.moment.utc(), as appropriate: https://git.hubteam.com/HubSpot/I18n/blob/master/docs/dates.md');
  }
  return origZoneAbbr.call(this);
};

userZoneAbbr = function() {
  var date, match;
  date = this.toDate();
  I18n.intlTimeZoneFormatter || (I18n.intlTimeZoneFormatter = typeof Intl !== "undefined" && Intl !== null ? typeof Intl.DateTimeFormat === "function" ? Intl.DateTimeFormat('en', {
    timeZoneName: 'short'
  }) : void 0 : void 0);
  if (I18n.intlTimeZoneFormatter) {
    match = I18n.intlTimeZoneFormatter.format(date).match(INTL_STRING_ZONE_ABBR_REGEX);
    if (match && match[1]) {
      return match[1];
    }
  }
  match = date.toString().match(DATE_STRING_ZONE_ABBR_REGEX);
  if (match) {
    return match[0];
  }
  return '';
};
}());

"use strict";
'use es6';
'babel noModule';

(function () {
  I18n.formatDuration = function (duration) {
    var minutes = Math.floor(duration.asMinutes());
    var hours = Math.floor(duration.asHours());

    if (minutes < 60) {
      return I18n.text('i18n.duration.minutes', {
        minutes: minutes
      });
    }

    if (minutes % 60 === 0) {
      return I18n.text('i18n.duration.hours', {
        hours: hours
      });
    }

    return I18n.text('i18n.duration.hoursAndMinutes', {
      hours: hours,
      minutes: minutes % 60
    });
  };
})();

"use strict";
'use es6';
'babel noModule'; // Copied from I18n/js/components/formatName to work around current import/export limitations

(function () {
  var CJK_HIRAGANA_REGEX = new RegExp(/[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]|[\u3040-\u309F]|[\u3005]|[\u3031-\u3032]/);
  var KATAKANA_REGEX = new RegExp(/[\u30A0-\u30FF]/);
  var KATAKANA_SEPARATOR = '・'; // Formats a first and last name depending on the character set.

  I18n.formatName = function (_ref) {
    var firstName = _ref.firstName,
        lastName = _ref.lastName;
    var first = firstName && firstName.trim();
    var last = lastName && lastName.trim();

    if (!first && !last) {
      return '';
    } else if (first && !last) {
      return first;
    } else if (!first && last) {
      return last;
    } else if (CJK_HIRAGANA_REGEX.test(last) && (CJK_HIRAGANA_REGEX.test(first) || KATAKANA_REGEX.test(first))) {
      return last + " " + first;
    } else if (KATAKANA_REGEX.test(first) && KATAKANA_REGEX.test(last)) {
      return "" + first + KATAKANA_SEPARATOR + last;
    }

    return first + " " + last;
  };
})();

"use strict";
'use es6';
'babel noModule';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function () {
  var _this = this;

  I18n.partial = function () {
    var _I18n$partial;

    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }

    var result = function result() {
      var _I18n;

      for (var _len2 = arguments.length, nextKeys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nextKeys[_key2] = arguments[_key2];
      }

      var allKeys = [].concat(keys, nextKeys);
      return (_I18n = I18n).text.apply(_I18n, _toConsumableArray(allKeys));
    };

    result.partial = (_I18n$partial = I18n.partial).bind.apply(_I18n$partial, [_this].concat(keys));
    return result;
  };
})();

(function () {
var slice = [].slice;

I18n.when('locale:loaded locale:failed locale:noop', function() {
  return I18n.trigger('locale:ready');
});

I18n.when('timezone:loaded timezone:failed timezone:noop', function() {
  return I18n.trigger('timezone:ready');
});

I18n.waitFor = function() {
  var deps, pro;
  deps = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  pro = new I18n.Promise;
  I18n.when('locale:ready', function() {
    return I18n.loadLocale(I18n.locale, function() {
      return I18n.when('timezone:ready', function() {
        return pro.resolve();
      });
    }, deps);
  });
  return pro;
};

I18n.loadedProjects = function() {
  var project, results;
  results = [];
  for (project in I18n.translationsLoaded) {
    results.push(project);
  }
  return results;
};

I18n.whenDOMContentLoaded(function() {
  var keys;
  keys = I18n.loadedProjects();
  return I18n.when('locale:ready', function() {
    return I18n.loadLocale(I18n.locale, function() {
      return I18n.when('timezone:ready', function() {
        return I18n.trigger('ready');
      });
    }, null, I18n.langEnabled);
  });
}, false);

I18n.whenDOMContentLoaded(function() {
  var timeout;
  timeout = setTimeout(function() {
    console.error("I18n locale / timezone loading timed out");
    I18n.trigger('timeout');
    return I18n.trigger('ready');
  }, 2500);
  return I18n.when('ready', function() {
    return clearTimeout(timeout);
  });
}, false);
}());

(function () {
var pending;

I18n.buildStaticPath = function(project, path) {
  var message, ref, ref1, versionForProject;
  if ((typeof hubspot !== "undefined" && hubspot !== null ? (ref = hubspot.bender) != null ? ref.staticDomainPrefix : void 0 : void 0) == null) {
    message = "I18n error: it doesn't seem like the bender mixin has been included on the page";
    console.error(message);
    if (typeof Raven !== "undefined" && Raven !== null) {
      if (typeof Raven.captureMessage === "function") {
        Raven.captureMessage(message);
      }
    }
  } else if (!(typeof I18n !== "undefined" && I18n !== null ? (ref1 = I18n.translationsAvailable[project]) != null ? ref1.en : void 0 : void 0)) {
    message = "I18n error: no translation strings are available for '" + project + "'";
    console.error(message);
    if (typeof Raven !== "undefined" && Raven !== null) {
      if (typeof Raven.captureMessage === "function") {
        Raven.captureMessage(message);
      }
    }
  } else {
    versionForProject = I18n.translationsAvailable[project].en;
    return hubspot.bender.staticDomainPrefix + "/" + project + "/" + versionForProject + path;
  }
};

I18n.buildLocalePath = function(project, lang) {
  return I18n.buildStaticPath(project, "/lang/" + lang + ".js");
};

pending = {};

I18n.loadProjectLocale = function(project, locale, successCb, failureCb) {
  var fail, localeLowercased, localeMinusRegion, localeOrLangToLoad, script, success;
  if (pending[project] == null) {
    pending[project] = {};
  }
  if (pending[project][locale] != null) {
    pending[project][locale].successCallbacks.push(successCb);
    pending[project][locale].failureCallbacks.push(failureCb);
    return;
  }
  pending[project][locale] = {
    successCallbacks: [successCb],
    failureCallbacks: [failureCb]
  };
  localeLowercased = locale.toLowerCase();
  localeMinusRegion = localeLowercased.split('-')[0];
  fail = function() {
    var callbacks, i, len, message, results;
    if (localeMinusRegion !== localeLowercased) {
      message = "Locale " + locale + " (or lang " + localeMinusRegion + ") strings not available in project " + project + ", bailing";
    } else {
      message = "Lang " + locale + " strings not available in project " + project + ", bailing";
    }
    console.warn(message);
    callbacks = pending[project][locale].failureCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      failureCb = callbacks[i];
      results.push(typeof failureCb === "function" ? failureCb() : void 0);
    }
    return results;
  };
  success = function(successInfo) {
    var callbacks, i, len, results;
    callbacks = pending[project][locale].successCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      successCb = callbacks[i];
      results.push(typeof successCb === "function" ? successCb(successInfo) : void 0);
    }
    return results;
  };
  if (!I18n.translationsAvailable && !I18n.translationsAvailable[project]) {
    return fail();
  }
  if (I18n.translationsAvailable[project][localeLowercased]) {
    localeOrLangToLoad = localeLowercased;
  } else if (I18n.translationsLoaded[project][localeMinusRegion]) {
    I18n.debugLog(project + " doesn't have " + locale + " strings, but does have " + localeMinusRegion + " strings. Falling back to those (and they are already loaded).");
    return success({
      alreadyPresent: true
    });
  } else if (I18n.translationsAvailable[project][localeMinusRegion]) {
    I18n.debugLog(project + " doesn't have " + locale + " strings, but does have " + localeMinusRegion + " strings. Falling back to those.");
    localeOrLangToLoad = localeMinusRegion;
  } else {
    return fail();
  }
  if (!localeOrLangToLoad) {
    throw new Error("Assert localeOrLangToLoad is not undefined");
  }
  script = document.createElement('script');
  document.querySelector('head').appendChild(script);
  I18n.debugLog("fetching " + localeOrLangToLoad + " strings for " + project);
  script.addEventListener('load', function() {
    var callbacks, i, len, results;
    script.parentNode.removeChild(script);
    callbacks = pending[project][locale].successCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      successCb = callbacks[i];
      results.push(typeof successCb === "function" ? successCb() : void 0);
    }
    return results;
  }, false);
  script.addEventListener('error', function() {
    var callbacks, i, len, results;
    console.error("I18n error: Error loading language file");
    callbacks = pending[project][locale].failureCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      failureCb = callbacks[i];
      results.push(typeof failureCb === "function" ? failureCb() : void 0);
    }
    return results;
  }, false);
  return script.src = I18n.buildLocalePath(project, localeOrLangToLoad);
};

I18n.loadLocale = function(locale, cb, projectsToLoad, shouldLoadLocale) {
  var callbackAlreadyCalled, check, i, len, project, projects, ref, remaining;
  if (shouldLoadLocale == null) {
    shouldLoadLocale = true;
  }
  projects = projectsToLoad != null ? projectsToLoad : I18n.loadedProjects();
  remaining = projects.length;
  callbackAlreadyCalled = false;
  check = function() {
    if (remaining === 0 && callbackAlreadyCalled === false) {
      callbackAlreadyCalled = true;
      return typeof cb === "function" ? cb(locale) : void 0;
    }
  };
  for (i = 0, len = projects.length; i < len; i++) {
    project = projects[i];
    if (shouldLoadLocale && (((ref = I18n.translationsLoaded[project]) != null ? ref[locale] : void 0) == null)) {
      (function(project) {
        var failureCb, successCb;
        return I18n.loadProjectLocale(project, locale, successCb = function(options) {
          if (!(options != null ? options.alreadyPresent : void 0)) {
            I18n.debugLog(locale + " strings loaded dynamically for " + project);
          }
          remaining--;
          return check();
        }, failureCb = function() {
          I18n.debugLog(locale + " strings failed to load for " + project);
          remaining--;
          return check();
        });
      })(project);
    } else {
      I18n.debugLog(locale + " strings already loaded for " + project);
      remaining--;
    }
  }
  return check();
};

I18n.changeLocale = function(locale, cb, projectsToLoad, shouldLoadLocale) {
  var deferred, i, len, ref, updateLocaleState, whitelistLocale, whitelisted;
  if (shouldLoadLocale == null) {
    shouldLoadLocale = true;
  }
  deferred = new I18n.Promise;
  if (I18n.localeWhitelist instanceof Array) {
    whitelisted = false;
    ref = I18n.localeWhitelist;
    for (i = 0, len = ref.length; i < len; i++) {
      whitelistLocale = ref[i];
      if (locale.indexOf(whitelistLocale) === 0) {
        whitelisted = true;
        break;
      }
    }
    if (!whitelisted) {
      I18n.debugLog("change to " + locale + " prevented by I18n.localeWhitelist: " + I18n.localeWhitelist);
      if (typeof cb === "function") {
        cb(I18n.locale);
      }
      deferred.resolve();
      return deferred;
    }
  }
  updateLocaleState = function(locale) {
    var dateLocale;
    I18n.locale = locale;
    dateLocale = locale;
    if (locale === 'en-ie') {
      dateLocale = 'en-gb';
    }
    if (locale === 'en-in') {
      dateLocale = 'en-au';
    } else if (locale === 'en-nz') {
      dateLocale = 'en-au';
    } else if (locale === 'es-mx') {
      dateLocale = 'es';
    } else if (locale === 'es-ar') {
      dateLocale = 'es-do';
    } else if (locale === 'es-co') {
      dateLocale = 'es-do';
    }
    if (I18n.moment.locale != null) {
      I18n.moment.locale(dateLocale);
    } else {
      I18n.moment.lang(dateLocale);
    }
    I18n.trigger('change:locale', {
      locale: locale
    });
    deferred.resolve();
    return typeof cb === "function" ? cb(locale) : void 0;
  };
  I18n.loadLocale(locale, updateLocaleState, projectsToLoad, shouldLoadLocale);
  return deferred;
};

I18n.changeTimezone = function(timezone) {
  var e, error;
  try {
    I18n.moment.tz(timezone);
  } catch (error) {
    e = error;
    console.error("Error: '" + timezone + "' isn't in our timezone database");
    return;
  }
  I18n.timezone = timezone;
  return I18n.trigger('change:timezone', {
    timezone: timezone
  });
};
}());

(function () {
I18n.langs = {
  en: {
    label: 'English'
  },
  de: {
    label: 'Deutsch'
  },
  ja: {
    label: '日本語'
  },
  es: {
    label: 'Español'
  },
  pt: {
    label: 'Português'
  }
};
}());

(function () {
var availableIn,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

availableIn = ['en'];

I18n.urlPrefix = '';

I18n.locationIn = function(locale) {
  var path, prefixEndsWithSlash, ref, tester, urlPrefix, urlPrefixWithSlash;
  path = document.location.pathname;
  urlPrefix = urlPrefixWithSlash = (ref = I18n.urlPrefix) != null ? ref : '';
  prefixEndsWithSlash = urlPrefix[urlPrefix.length - 1] === "/";
  if (prefixEndsWithSlash) {
    urlPrefix = urlPrefix.substring(0, urlPrefix.length - 1);
  }
  if (urlPrefix) {
    urlPrefixWithSlash = urlPrefix + '/';
  }
  tester = "^/" + urlPrefixWithSlash.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + ("(" + (I18n.availableInLocales.join('|')) + ")(/|$)");
  if (new RegExp(tester).test(path)) {
    path = path.substring(3 + urlPrefixWithSlash.length) || '/';
  } else if (urlPrefixWithSlash && new RegExp("^/" + urlPrefixWithSlash).test(path)) {
    path = path.substring(urlPrefixWithSlash.length);
  }
  if (locale === 'en' || indexOf.call(I18n.availableInLocales, locale) < 0) {
    if (urlPrefixWithSlash) {
      return '/' + urlPrefix + path + document.location.search + document.location.hash;
    } else {
      return path + document.location.search + document.location.hash;
    }
  } else {
    return '/' + urlPrefixWithSlash + locale + path + document.location.search + document.location.hash;
  }
};

I18n.availableIn = function(langs, options) {
  if (options == null) {
    options = {};
  }
  availableIn = langs;
  I18n.localeInURL = options.inURL || false;
  return I18n.trigger('change:available', availableIn);
};

if (I18n.availableInLocales == null) {
  Object.defineProperty(I18n, 'availableInLocales', {
    get: function() {
      var ai;
      ai = availableIn.slice(0);
      if (ai.indexOf(I18n.lang) === -1) {
        ai.push(I18n.lang);
      }
      return ai;
    }
  });
}
}());

(function () {
if (typeof window.I18n === 'undefined') {
  window.I18n = {};
}

I18n.setPublicLangPreference = function(lang) {
  var cookieSetterFunc, ref;
  if ((typeof window !== "undefined" && window !== null ? window.Cookies : void 0) != null) {
    cookieSetterFunc = Cookies.set;
  } else if (typeof window !== "undefined" && window !== null ? (ref = window.jQuery) != null ? ref.cookie : void 0 : void 0) {
    cookieSetterFunc = jQuery.cookie;
  }
  if (cookieSetterFunc != null) {
    return cookieSetterFunc('hubspot.lang.preference', lang, {
      expires: 730,
      path: '/',
      domain: I18n.cookieDomain()
    });
  }
};

I18n.getPublicLangPreference = function() {
  var ref, ref1;
  if (typeof navigator !== "undefined" && navigator !== null ? (ref = navigator.languages) != null ? ref[0] : void 0 : void 0) {
    return navigator.languages[0];
  } else if ((typeof window !== "undefined" && window !== null ? window.Cookies : void 0) != null) {
    return Cookies.get('hubspot.lang.preference');
  } else if (typeof window !== "undefined" && window !== null ? (ref1 = window.jQuery) != null ? ref1.cookie : void 0 : void 0) {
    return window.jQuery.cookie('hubspot.lang.preference');
  }
};

I18n.cookieDomain = function() {
  if (!window) {
    return;
  }
  return window.location.hostname.split('.').slice(-2).join('.');
};
}());

(function () {
var checkLocaleInURL, getParams;

getParams = (function() {
  var map, query;
  query = location.search.substr(1);
  map = {};
  query.replace(/([^&=]+)=?([^&]*)(?:&+|$)/g, function(match, key, value) {
    return map[key] = value;
  });
  return map;
})();

I18n.manualLocale = getParams.lang || ((function() {
  try {
    return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_MANUAL_LANG : void 0;
  } catch (undefined) {}
})()) || window.I18N_MANUAL_LANG;

I18n.manualTimezone = ((function() {
  try {
    return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_TZ : void 0;
  } catch (undefined) {}
})()) || window.I18N_TZ;

if (I18n.manualLocale) {
  I18n.langEnabled = true;
}

if (I18n.manualLocale != null) {
  I18n.debugLog("locale manually set to " + I18n.manualLocale + " (and forcing localeEnabled to true)");
}

if (I18n.manualTimezone != null) {
  I18n.debugLog("timezone manually set to " + I18n.manualTimezone);
}

if (I18n.publicPage && I18n.getPublicLangPreference()) {
  I18n.locale = I18n.getPublicLangPreference();
  I18n.debugLog("initially setting locale to " + I18n.locale + " on public page (via cookie)");
} else {
  I18n.locale = I18n.manualLocale || window.I18N_RENDERED_LANG || I18n.locale || (typeof navigator !== "undefined" && navigator !== null ? navigator.language : void 0) || (typeof navigator !== "undefined" && navigator !== null ? navigator.userLanguage : void 0) || 'en';
  if (I18n.locale.indexOf('_') >= 0) {
    I18n.locale = I18n.locale.replace('_', '-');
  }
  if (typeof I18n.locale === 'string' && I18n.locale.substring(0, 2) === 'pt') {
    I18n.locale = 'pt-br';
  } else if (I18n.locale === 'noNO' || I18n.locale === 'no') {
    I18n.locale = 'no-no';
  } else if (I18n.locale === 'zh-tw') {
    I18n.locale = 'zh-hk';
  } else if (I18n.locale === 'es-co') {
    I18n.locale = 'es-ar';
  }
  I18n.debugLog("initially setting locale to " + I18n.locale);
}

I18n.timezone = I18n.manualTimezone || window.I18N_RENDERED_TZ || I18n.timezone || 'US/Eastern';

I18n.debugLog("initially setting timezone to " + I18n.timezone);

(checkLocaleInURL = function() {
  if (I18n.localeInURL) {
    if (!window.I18N_RENDERED_LANG) {
      console.error("I18N_RENDERED_LANG not found, are we rendering with Schablone and inheriting from the base template (w/ StyleGuideUI v2)?");
      return;
    }
    if (window.I18N_RENDERED_LANG !== I18n.lang) {
      I18n.debugLog("changing locale " + I18n.lang + " via checkLocaleInURL");
      return I18n.changeLocale(I18n.lang);
    }
  }
})();

I18n.on('change:available', checkLocaleInURL);

if (I18n.moment) {
  if (I18n.moment.locale != null) {
    I18n.moment.locale(I18n.locale);
  } else {
    I18n.moment.lang(I18n.locale);
  }
}
}());

(function () {
var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

hubspot.defineEager('hubspot.I18n.load', ['hubspot.carmen.client', 'hubspot.PortalIdParser'], function(Carmen, PortalIdParser) {
  var load;
  load = function(pid, loadLocaleFallback) {
    var portalID;
    portalID = pid || PortalIdParser.get({
      preserveGlobalId: true
    });
    if (!portalID || I18n.manualLocale) {
      I18n.trigger('locale:noop');
    }
    if (!portalID || I18n.manualTimezone) {
      I18n.trigger('timezone:noop');
    }
    if (!portalID) {
      return;
    }
    if (pid) {
      Carmen.setPortalIdIfNotAvailable(portalID);
    }
    return Carmen.load(function(arg) {
      var langEnabled, locale, ref, timezone;
      locale = arg.locale, timezone = arg.timezone, langEnabled = arg.langEnabled;
      I18n.debugLog("Carmen response: locale = " + locale + "  timezone = " + timezone + "  langEnabled = " + langEnabled);
      locale || (locale = I18n.locale);
      if (I18n.publicPage) {
        I18n.debugLog("Forcing langEnabled to true for public page");
        langEnabled = true;
        if (I18n.getPublicLangPreference() && I18n.availableInLocales && (ref = I18n.getPublicLangPreference, indexOf.call(I18n.availableInLocales, ref) >= 0)) {
          I18n.debugLog("setting locale from public lang preference");
          locale = I18n.getPublicLangPreference();
        } else if (I18N_RENDERED_LANG) {
          I18n.debugLog("setting locale from I18N_RENDERED_LANG on public page");
          locale = I18N_RENDERED_LANG;
        }
      }
      if (!I18n.manualLocale) {
        if (indexOf.call(I18n.availableInLocales, locale) >= 0 || !I18n.publicPage) {
          I18n.langEnabled = langEnabled;
          I18n.debugLog("Lang enabled: " + langEnabled);
          I18n.debugLog(locale + " is available locale, changing...");
          I18n.changeLocale(locale, null, null, I18n.langEnabled).then(function(locale) {
            I18n.trigger('locale:loaded', {
              locale: locale
            });
            if (pid) {
              return I18n.trigger('readyWithPortalId');
            }
          }, function() {
            return I18n.trigger('locale:failed');
          });
        }
      }
      if (I18n.publicPage && !I18n.manualTimezone) {
        if (timezone) {
          I18n.changeTimezone(timezone);
          return I18n.trigger('timezone:loaded', {
            timezone: timezone
          });
        } else {
          return I18n.trigger('timezone:loaded');
        }
      }
    }, function() {
      console.error("Error loading locale/timezone");
      I18n.trigger('locale:failed');
      return I18n.trigger('timezone:failed');
    }, loadLocaleFallback);
  };
  load();
  return load;
});
}());

(function () {
var updateClass;

updateClass = function() {
  var html;
  html = document.querySelector('html');
  html.className = html.className.replace(/(^|\b)lang-[a-z]{2}($|\b)/, '');
  html.className += " lang-" + I18n.lang;
  return html.setAttribute('lang', I18n.locale);
};

I18n.whenDOMContentLoaded(updateClass);

I18n.on('change:locale', updateClass);
}());

(function () {
I18n.on('change:locale', function() {
  var el, elements, i, len, results;
  try {
    if ((typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_SHOW_KEYS : void 0) === 'true') {
      elements = document.querySelectorAll('i18n-string');
      if (elements != null) {
        results = [];
        for (i = 0, len = elements.length; i < len; i++) {
          el = elements[i];
          results.push(el.innerHTML = I18n.html(el.getAttribute('data-key'), JSON.parse(el.getAttribute('data-options'))));
        }
        return results;
      }
    }
  } catch (undefined) {}
});
}());

(function () {
I18n.title = function(key, options) {
  if (typeof document !== "undefined" && document !== null) {
    I18n.when('ready', function() {
      return document.title = I18n.text(key, options);
    });
    return '';
  } else {
    return I18n.text(key, options);
  }
};
}());

(function () {
var debugSetting, debugString, i18nDebugEnabled, ref;

debugSetting = void 0;

debugString = ("" + ((function() {
  if ((ref = window.I18N_DEBUG) != null) {
    return ref;
  } else {
    try {
      return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_DEBUG : void 0;
    } catch (undefined) {}
  }
})())).toLowerCase();

if (debugString === 'true' || debugString === 'false') {
  debugSetting = debugString === 'true';
}

if (debugSetting === false) {
  i18nDebugEnabled = false;
} else {
  i18nDebugEnabled = debugSetting;
}

if (i18nDebugEnabled) {
  I18n.showDebugTools = true;
  window.addEventListener('load', function() {
    var script, style;
    script = document.createElement('script');
    script.src = I18n.buildStaticPath('I18n', '/bundles/debug.js');
    document.querySelector('head').appendChild(script);
    style = document.createElement('link');
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('type', 'text/css');
    style.setAttribute('href', I18n.buildStaticPath('I18n', '/bundles/debug.css'));
    return document.querySelector('head').appendChild(style);
  }, false);
}
}());

(function () {

}());


(function() {
  var module = {};
  var result = {};
  module.exports = { "cs": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hod", "hoursAndMinutes": "{{ hours }} hod {{ minutes }} min", "days": "{{ days }} d", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "shortForm": { "months": { "january": "led", "february": "úno", "march": "bře", "april": "dub", "may": "kvě", "june": "čvn", "july": "čvc", "august": "srp", "september": "zář", "october": "říj", "november": "lis", "december": "pro" } }, "monthAndDay": "{{dayNumber}}. {{monthName}} ", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "cs": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:cs', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "da": { "i18n": { "duration": { "seconds": "{{ seconds }} sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t.", "hoursAndMinutes": "{{ hours }}t. {{ minutes }}min.", "days": "{{ days }}dg", "shortForm": { "seconds": "{{ seconds }}sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t", "days": "{{ days }}dg", "hoursAndMinutes": "{{ hours }}t {{ minutes }}min." } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "Maj", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}}{{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "da": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:da', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "de": { "i18n": { "duration": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min.", "days": "{{ days }} Tage", "shortForm": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "days": "{{ days }} Tage", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min." } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mrz", "april": "Apr", "may": "Mai", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Dez" } }, "monthAndDay": "{{dayNumber}}. {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "de": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:de', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "el": { "i18n": { "duration": { "seconds": "{{ seconds }} δευτ.", "minutes": "{{ minutes }} λεπτ.", "hours": "{{ hours }} ώρ.", "hoursAndMinutes": "{{ hours }} ώρ. {{ minutes }} λεπτ.", "days": "{{ days }} ημέρες", "shortForm": { "seconds": "{{ seconds }}δ.", "minutes": "{{ minutes }}λ.", "hours": "{{ hours }}ώρ.", "days": "{{ days }}ημ.", "hoursAndMinutes": "{{ hours }}ώρ. {{ minutes }}λ." } }, "dateTime": { "shortForm": { "months": { "january": "Ιαν", "february": "Φεβ", "march": "Μάρ", "april": "Απρ", "may": "Μάι", "june": "Ιούν", "july": "Ιούλ", "august": "Αύγ", "september": "Σεπ", "october": "Οκτ", "november": "Νοέ", "december": "Δεκ" } }, "monthAndDay": "{{dayNumber}}{{monthName}} ", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "el": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:el', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "May", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Oct", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es-mx": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} días", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "ene", "february": "feb", "march": "mar", "april": "abr", "may": "mayo", "june": "jun", "july": "jul", "august": "ago", "september": "sep", "october": "oct", "november": "nov", "december": "dic" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "es-mx": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es-mx', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es": { "i18n": { "duration": { "seconds": "{{ seconds }} seg", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} días", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "ene", "february": "feb", "march": "mar", "april": "abr", "may": "may", "june": "jun", "july": "jul", "august": "ago", "september": "sep", "october": "oct", "november": "nov", "december": "dic" } }, "monthAndDay": "{{dayNumber}} de {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "es": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fi": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} vrk", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} vrk", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "shortForm": { "months": { "january": "Tammi", "february": "Helmi", "march": "Maalis", "april": "Huhti", "may": "Toukokuu", "june": "Kesä", "july": "Heinä", "august": "Elo", "september": "Syys", "october": "Loka", "november": "Marras", "december": "Joulu" } }, "monthAndDay": "{{monthName}} {{dayNumber}}.", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "fi": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fi', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fr": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} jours", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} j", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "shortForm": { "months": { "january": "jan", "february": "fév", "march": "mar", "april": "avr", "may": "mai", "june": "juin", "july": "juil", "august": "août", "september": "sep", "october": "oct", "november": "nov", "december": "déc" } }, "monthAndDay": "{{dayNumber}} {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "fr": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "it": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} gg", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}g", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Gen", "february": "Feb", "march": "Mar", "april": "Apr", "may": "Mag", "june": "Giu", "july": "Lug", "august": "Ago", "september": "Set", "october": "Ott", "november": "Nov", "december": "Dic" } }, "monthAndDay": "{{dayNumber}}{{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "it": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:it', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ja": { "i18n": { "duration": { "seconds": "{{ seconds }}秒", "minutes": "{{ minutes }}分", "hours": "{{ hours }}時間", "hoursAndMinutes": "{{ hours }}時間{{ minutes }}分", "days": "{{ days }}日", "shortForm": { "seconds": "{{ seconds }}秒", "minutes": "{{ minutes }}分", "hours": "{{ hours }}時間", "days": "{{ days }}日", "hoursAndMinutes": "{{ hours }}時間{{ minutes }}分" } }, "dateTime": { "shortForm": { "months": { "january": "1月", "february": "2月", "march": "3月", "april": "4月", "may": "5月", "june": "6月", "july": "7月", "august": "8月", "september": "9月", "october": "10月", "november": "11月", "december": "12月" } }, "monthAndDay": "{{monthName}}{{dayNumber}}日", "monthAndYear": "{{yearNumber}}年{{monthName}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ja": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ja', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}초", "minutes": "{{ minutes }}분", "hours": "{{ hours }}시간", "hoursAndMinutes": "{{ hours }}시간 {{ minutes }}분", "days": "{{ days }}일", "shortForm": { "seconds": "{{ seconds }}초", "minutes": "{{ minutes }}분", "hours": "{{ hours }}시간", "days": "{{ days }}일", "hoursAndMinutes": "{{ hours }}시간 {{ minutes }}분" } }, "dateTime": { "shortForm": { "months": { "january": "1월", "february": "2월", "march": "3월", "april": "4월", "may": "5월", "june": "6월", "july": "7월", "august": "8월", "september": "9월", "october": "10월", "november": "11월", "december": "12월" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{yearNumber}} {{monthName}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "nl": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} uur", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dagen", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mrt", "april": "Apr", "may": "Mei", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "nl": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:nl', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "no-no": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tm", "hoursAndMinutes": "{{ hours }} tm {{ minutes }} min", "days": "{{ days }} dager", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}t", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}t {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "mai", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Des" } }, "monthAndDay": "{{dayNumber}}. {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "no": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:no', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pl": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }}min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} godz", "days": "{{ days }} dn.", "hoursAndMinutes": "{{ hours }} godz. {{ minutes }} min" } }, "dateTime": { "shortForm": { "months": { "january": "styczeń", "february": "luty", "march": "marzec", "april": "kwiecień", "may": "maj", "june": "czerwiec", "july": "lipiec", "august": "sierpień", "september": "wrzesień", "october": "październik", "november": "listopad", "december": "grudzień" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "pl": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pl', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pt-br": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Fev", "march": "Mar", "april": "Abr", "may": "Maio", "june": "Jun", "july": "Jul", "august": "Ago", "september": "Set", "october": "Out", "november": "Nov", "december": "Dez" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "pt-br": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-br', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "sv": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tim", "hoursAndMinutes": "{{ hours }} tim {{ minutes }} min", "days": "{{ days }} dagar", "shortForm": { "seconds": "{{ seconds }}sek", "minutes": "{{ minutes }}min", "hours": "{{ hours }}tim", "days": "{{ days }}dagar", "hoursAndMinutes": "{{ hours }}tim {{ minutes }}min" } }, "dateTime": { "shortForm": { "months": { "january": "jan", "february": "feb", "march": "mar", "april": "apr", "may": "maj", "june": "jun", "july": "jul", "august": "aug", "september": "sep", "october": "okt", "november": "nov", "december": "dec" } }, "monthAndDay": "{{dayNumber}} {{monthName}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }} / {{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "sv": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sv', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-cn": { "i18n": { "duration": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分钟", "hours": "{{ hours }} 小时", "hoursAndMinutes": "{{ hours }} 小时 {{ minutes }} 分钟", "days": "{{ days }} 天", "shortForm": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分钟", "hours": "{{ hours }} 小时", "days": "{{ days }} 天", "hoursAndMinutes": "{{ hours }} 小时 {{ minutes }} 分钟" } }, "dateTime": { "shortForm": { "months": { "january": "1  月", "february": "2 月", "march": "3 月", "april": "4 月", "may": "5 月", "june": "6 月", "july": "7 月", "august": "8 月", "september": "9 月", "october": "10 月", "november": "11 月", "december": "12 月" } }, "monthAndDay": "{{monthName}} {{dayNumber}} 日", "monthAndYear": " {{yearNumber}} 年 {{monthName}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "zh-cn": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-cn', {version: 'static-7.465'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-hk": { "i18n": { "duration": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分鐘", "hours": "{{ hours }} 小時", "hoursAndMinutes": "{{ hours }} 小時 {{ minutes }} 分鐘", "days": "{{ days }} 日", "shortForm": { "seconds": "{{ seconds }} 秒", "minutes": "{{ minutes }} 分", "hours": "{{ hours }} 小時", "days": "{{ days }} 日", "hoursAndMinutes": "{{ hours }} 小時 {{ minutes }} 分" } }, "dateTime": { "shortForm": { "months": { "january": "1月", "february": "2月", "march": "3月", "april": "4月", "may": "5月", "june": "6月", "july": "7月", "august": "8月", "september": "9月", "october": "10月", "november": "11月", "december": "12月" } }, "monthAndDay": "{{monthName}} {{dayNumber}} 日 ", "monthAndYear": "{{yearNumber}} 年 {{monthName}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "zh-hk": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-hk', {version: 'static-7.465'}); }
})();


//! moment-timezone.js
//! version : 0.5.26
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else if (typeof define === 'function' && define.amd) {
		define(['moment'], factory);                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.26",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	loadData({
		"version": "2019b",
		"zones": [
			"Africa/Abidjan|GMT|0|0||48e5",
			"Africa/Nairobi|EAT|-30|0||47e5",
			"Africa/Algiers|CET|-10|0||26e5",
			"Africa/Lagos|WAT|-10|0||17e6",
			"Africa/Maputo|CAT|-20|0||26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010|1q0K0 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|+00 +01|0 -10|01010101010101010101010101010101010101010101|1xwo0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0|32e5",
			"Europe/Paris|CET CEST|-10 -20|0101010101010101010101010101010101010|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|11e6",
			"Africa/Johannesburg|SAST|-20|0||84e5",
			"Africa/Khartoum|EAT CAT|-30 -20|01|1Usl0|51e5",
			"Africa/Sao_Tome|GMT WAT|0 -10|010|1UQN0 2q00",
			"Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00|11e5",
			"Africa/Tunis|CET CEST|-10 -20|010101010|1q1z0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|CAT WAT|-20 -10|010101010101010101010101010|1pOo0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|HST HDT|a0 90|0101010101010101010101010101010101010|1pOA0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AKST AKDT|90 80|0101010101010101010101010101010101010|1pOz0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|30e4",
			"America/Santo_Domingo|AST|40|0||29e5",
			"America/Araguaina|-03 -02|30 20|010|1IdD0 Lz0|14e4",
			"America/Argentina/Cordoba|-03 -02|30 20|01010|1wuP0 uL0 1qN0 WL0",
			"America/Argentina/Mendoza|-03 -02|30 20|010|1wuP0 uL0",
			"America/Argentina/San_Luis|-03 -02 -04|30 20 40|0102020|1wuP0 8L0 jd0 1qN0 WL0 1qN0",
			"America/Asuncion|-03 -04|30 40|0101010101010101010101010101010101010|1pG30 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0|28e5",
			"America/Panama|EST|50|0||15e5",
			"America/Bahia_Banderas|MST MDT CDT CST|70 60 50 60|0101010101023232323232323232323232323|1pOx0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
			"America/Bahia|-03 -02|30 20|010|1FJf0 Rb0|27e5",
			"America/Fortaleza|-03|30|0||34e5",
			"America/Costa_Rica|CST|60|0||12e5",
			"America/La_Paz|-04|40|0||19e5",
			"America/Lima|-05|50|0||11e6",
			"America/Denver|MST MDT|70 60|0101010101010101010101010101010101010|1pOx0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|26e5",
			"America/Campo_Grande|-03 -04|30 40|010101010101010101010101010101|1pxD0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
			"America/Cancun|CST CDT EST|60 50 50|0101010101010101010102|1pOw0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|-04 -0430|40 4u|010|1wmv0 kqo0|29e5",
			"America/Chicago|CST CDT|60 50|0101010101010101010101010101010101010|1pOw0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|MST MDT|70 60|0101010101010101010101010101010101010|1pOx0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
			"America/Phoenix|MST|70|0||42e5",
			"America/Los_Angeles|PST PDT|80 70|0101010101010101010101010101010101010|1pOy0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|15e6",
			"America/New_York|EST EDT|50 40|0101010101010101010101010101010101010|1pOv0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|21e6",
			"America/Rio_Branco|-05 -04|50 40|010|1xFF0 d5X0|31e4",
			"America/Tijuana|PST PDT|80 70|0101010101010101010101010101010101010|1pOy0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT MST|80 70 70|0101010101010101010102|1pOy0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|EST EDT|50 40|01010101010101010101010101010101010|1sg70 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0",
			"America/Halifax|AST ADT|40 30|0101010101010101010101010101010101010|1pOu0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|39e4",
			"America/Godthab|-03 -02|30 20|0101010101010101010101010101010101010|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|17e3",
			"America/Goose_Bay|AST ADT|40 30|0101010101010101010101010101010101010|1pOs1 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|EST EDT AST|50 40 40|010101010101010101010121010101010|1pOv0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|CST CDT|60 50|010|1sri0 11z0|13e5",
			"America/Havana|CDT CST|40 50|0101010101010101010101010101010101|1tE50 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0|21e5",
			"America/Indiana/Knox|EST CDT CST|50 50 60|01212121212121212121212121212121212|1sg70 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0",
			"America/Indiana/Petersburg|EST CDT CST EDT|50 50 60 40|01210303030303030303030303030303030|1sg70 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0",
			"America/Indiana/Winamac|EST CDT CST EDT|50 50 60 40|01230303030303030303030303030303030|1sg70 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0",
			"America/Managua|CST CDT|60 50|01010|1pRi0 19X0 1o30 11y0|22e5",
			"America/Matamoros|CST CDT|60 50|0101010101010101010101010101010101010|1pOw0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|45e4",
			"America/Mexico_City|CST CDT|60 50|0101010101010101010101010101010101010|1pOw0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
			"America/Metlakatla|PST AKST AKDT|80 90 80|01212120121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|14e2",
			"America/Miquelon|-03 -02|30 20|0101010101010101010101010101010101010|1pOt0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|AST ADT|40 30|0101010101010101010101010101010101010|1pOs1 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|64e3",
			"America/Montevideo|-02 -03|20 30|0101010101010101010101|1pLE0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Noronha|-02|20|0||30e2",
			"America/North_Dakota/Beulah|MST MDT CST CDT|70 60 60 50|0101010101012323232323232323232323232|1pOx0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0",
			"America/Ojinaga|MST MDT|70 60|0101010101010101010101010101010101010|1pOx0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|23e3",
			"America/Port-au-Prince|EST EDT|50 40|0101010101010101010101010|1pOt0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|23e5",
			"Antarctica/Palmer|-03 -04|30 40|01010101010101010101010|1pG30 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"America/Resolute|CST CDT EST|60 50 50|0101210101010101010101010101010101010|1pOw0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|229",
			"America/Santarem|-04 -03|40 30|01|1xFE0|21e4",
			"America/Santiago|-03 -04|30 40|01010101010101010101010101010101010|1pG30 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|62e5",
			"America/Sao_Paulo|-02 -03|20 30|010101010101010101010101010101|1pxC0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
			"Atlantic/Azores|-01 +00|10 0|0101010101010101010101010101010101010|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e4",
			"America/St_Johns|NST NDT|3u 2u|0101010101010101010101010101010101010|1pOrv 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|11e4",
			"America/Tegucigalpa|CST CDT|60 50|010|1su60 AL0|11e5",
			"America/Winnipeg|CST CDT|60 50|0101010101010101010101010101010101010|1pOw0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|66e4",
			"Antarctica/Casey|+08 +11|-80 -b0|0101010|1ARS0 T90 40P0 KL0 blz0 3m10|10",
			"Antarctica/Davis|+07 +05|-70 -50|01010|1ART0 VB0 3Wn0 KN0|70",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Antarctica/Macquarie|AEDT AEST +11|-b0 -a0 -b0|010101010102|1pLs0 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|+06 +05|-60 -50|01|1ARU0|60",
			"Pacific/Auckland|NZDT NZST|-d0 -c0|0101010101010101010101010101010101010|1pIC0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
			"Asia/Riyadh|+03|-30|0||57e5",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|40",
			"Asia/Urumqi|+06|-60|0||32e5",
			"Asia/Amman|EET EEST|-20 -30|01010101010101010101010101010101010|1pNy0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00|25e5",
			"Asia/Kamchatka|+12 +13 +11|-c0 -d0 -b0|0101010101020|1pLq0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Tashkent|+05|-50|0||23e5",
			"Asia/Baghdad|+03 +04|-30 -40|0101010|1pNA0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Baku|+04 +05|-40 -50|01010101010101010101010|1pLA0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|+07|-70|0||15e6",
			"Asia/Barnaul|+06 +07|-60 -70|0101010101010101|1pLw0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Asia/Beirut|EET EEST|-20 -30|0101010101010101010101010101010101010|1pLy0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|22e5",
			"Asia/Bishkek|+05 +06|-50 -60|01|1pLxu|87e4",
			"Asia/Kuala_Lumpur|+08|-80|0||71e5",
			"Asia/Kolkata|IST|-5u|0||15e6",
			"Asia/Chita|+09 +10 +08|-90 -a0 -80|0101010101010120|1pLt0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|+09 +10 +08|-90 -a0 -80|0101020202|1pL50 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST|-80|0||23e6",
			"Asia/Colombo|+06 +0530|-60 -5u|01|1sl6u|22e5",
			"Asia/Dhaka|+06 +07|-60 -70|010|1A5R0 1i00|16e6",
			"Asia/Damascus|EET EEST|-20 -30|0101010101010101010101010101010101010|1pNy0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|+09|-90|0||19e4",
			"Asia/Dubai|+04|-40|0||39e5",
			"Asia/Famagusta|EET EEST +03|-20 -30 -30|010101010101010101010101201010101010|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0",
			"Asia/Gaza|EET EEST|-20 -30|0101010101010101010101010101010101010|1pTa0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0|18e5",
			"Asia/Hebron|EET EEST|-20 -30|010101010101010101010101010101010101010|1pTa0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0|25e4",
			"Asia/Hong_Kong|HKT|-80|0||73e5",
			"Asia/Hovd|+07 +08|-70 -80|010101010|1pL70 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|+08 +09|-80 -90|010101010101010|1pLu0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|EET EEST +03|-20 -30 -30|0101010101010101010101012|1pLz0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|WIB|-70|0||31e6",
			"Asia/Jayapura|WIT|-90|0||26e4",
			"Asia/Jerusalem|IST IDT|-20 -30|0101010101010101010101010101010101010|1pNA0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0|81e4",
			"Asia/Kabul|+0430|-4u|0||46e5",
			"Asia/Karachi|PKT PKST|-50 -60|01010|1xwj0 11b0 1610 1jX0|24e6",
			"Asia/Kathmandu|+0545|-5J|0||12e5",
			"Asia/Khandyga|+10 +11 +09|-a0 -b0 -90|0101010101010102|1pLs0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|+07 +08|-70 -80|010101010101010|1pLv0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Magadan|+11 +12 +10|-b0 -c0 -a0|0101010101010120|1pLr0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|WITA|-80|0||15e5",
			"Asia/Manila|PST|-80|0||24e6",
			"Europe/Athens|EET EEST|-20 -30|0101010101010101010101010101010101010|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|35e5",
			"Asia/Novokuznetsk|+07 +08 +06|-70 -80 -60|0101010101020|1pLv0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|+06 +07|-60 -70|0101010101010101|1pLw0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|+06 +07|-60 -70|010101010101010|1pLw0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Pyongyang|KST KST|-90 -8u|010|1P4D0 6BA0|29e5",
			"Asia/Qyzylorda|+06 +05|-60 -50|01|1Xei0|73e4",
			"Asia/Rangoon|+0630|-6u|0||48e5",
			"Asia/Sakhalin|+10 +11|-a0 -b0|0101010101010101|1pLs0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Seoul|KST|-90|0||23e6",
			"Asia/Srednekolymsk|+11 +12|-b0 -c0|010101010101010|1pLr0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Tbilisi|+03 +04|-30 -40|01|1pLz0|11e5",
			"Asia/Tehran|+0330 +0430|-3u -4u|010101010101010101010101010101010|1pJwu 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
			"Asia/Tokyo|JST|-90|0||38e6",
			"Asia/Tomsk|+06 +07|-60 -70|0101010101010101|1pLw0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|+08 +09|-80 -90|010101010|1pL60 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|+11 +12 +10|-b0 -c0 -a0|0101010101010102|1pLr0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|+10 +11|-a0 -b0|010101010101010|1pLs0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|+09 +10|-90 -a0|010101010101010|1pLt0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|+05 +06|-50 -60|010101010101010|1pLx0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|+04 +05|-40 -50|010101010101010|1pLy0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Europe/Lisbon|WET WEST|0 -10|0101010101010101010101010101010101010|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|27e5",
			"Atlantic/Cape_Verde|-01|10|0||50e4",
			"Atlantic/Stanley|-03 -04|30 40|0101010101010|1pU50 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEDT AEST|-b0 -a0|0101010101010101010101010101010101010|1pLs0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACDT ACST|-au -9u|0101010101010101010101010101010101010|1pLsu 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST|-a0|0||20e5",
			"Australia/Hobart|AEDT AEST|-b0 -a0|0101010101010101010101010101010101010|1pLs0 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Darwin|ACST|-9u|0||12e4",
			"Australia/Eucla|+0845 +0945|-8J -9J|0101010|1tRRf IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Lord_Howe|+11 +1030|-b0 -au|0101010101010101010101010101010101010|1pLr0 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Perth|AWST AWDT|-80 -90|0101010|1tRS0 IM0 1qM0 11A0 1o00 11A0|18e5",
			"Pacific/Easter|-05 -06|50 60|01010101010101010101010101010101010|1pG30 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|30e2",
			"Europe/Dublin|GMT IST|0 -10|0101010101010101010101010101010101010|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|12e5",
			"Etc/GMT-1|+01|-10|0|",
			"Pacific/Guadalcanal|+11|-b0|0||11e4",
			"Pacific/Tarawa|+12|-c0|0||29e3",
			"Pacific/Enderbury|+13|-d0|0||1",
			"Pacific/Kiritimati|+14|-e0|0||51e2",
			"Etc/GMT-2|+02|-20|0|",
			"Pacific/Tahiti|-10|a0|0||18e4",
			"Pacific/Niue|-11|b0|0||12e2",
			"Etc/GMT+12|-12|c0|0|",
			"Pacific/Galapagos|-06|60|0||25e3",
			"Etc/GMT+7|-07|70|0|",
			"Pacific/Pitcairn|-08|80|0||56",
			"Pacific/Gambier|-09|90|0||125",
			"Etc/UTC|UTC|0|0|",
			"Europe/Ulyanovsk|+03 +04|-30 -40|0101010101010101|1pLz0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
			"Europe/London|GMT BST|0 -10|0101010101010101010101010101010101010|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|10e6",
			"Europe/Chisinau|EET EEST|-20 -30|0101010101010101010101010101010101010|1pLA0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|67e4",
			"Europe/Kaliningrad|EET EEST +03|-20 -30 -30|010101010101020|1pLA0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kirov|+03 +04|-30 -40|010101010101010|1pLz0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Minsk|EET EEST +03|-20 -30 -30|01010101010102|1pLA0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Moscow|MSK MSD MSK|-30 -40 -40|010101010101020|1pLz0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Samara|+04 +05 +03|-40 -50 -30|0101010101020|1pLy0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|+03 +04|-30 -40|0101010101010101|1pLz0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
			"Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|010101010101010101023|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Volgograd|+03 +04|-30 -40|0101010101010101|1pLz0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5",
			"Pacific/Honolulu|HST|a0|0||37e4",
			"Indian/Mauritius|+04 +05|-40 -50|010|1yva0 11z0|15e4",
			"MET|MET MEST|-10 -20|0101010101010101010101010101010101010|1pLB0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0",
			"Pacific/Chatham|+1345 +1245|-dJ -cJ|0101010101010101010101010101010101010|1pIC0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|-11 -10 +14 +13|b0 a0 -e0 -d0|010123232323232323232323232|1Dbn0 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|+10 +11|-a0 -b0|01|1NwE0|18e4",
			"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|+12 +13|-c0 -d0|0101010101010101010101010101|1BaC0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0|88e4",
			"Pacific/Guam|ChST|-a0|0||17e4",
			"Pacific/Marquesas|-0930|9u|0||86e2",
			"Pacific/Pago_Pago|SST|b0|0||37e2",
			"Pacific/Norfolk|+1130 +11|-bu -b0|01|1PoCu|25e4",
			"Pacific/Tongatapu|+13 +14|-d0 -e0|010|1S4d0 s00|75e3"
		],
		"links": [
			"Africa/Abidjan|Africa/Accra",
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Bissau",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Monrovia",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|America/Danmarkshavn",
			"Africa/Abidjan|Atlantic/Reykjavik",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Abidjan|Etc/GMT",
			"Africa/Abidjan|Etc/GMT+0",
			"Africa/Abidjan|Etc/GMT-0",
			"Africa/Abidjan|Etc/GMT0",
			"Africa/Abidjan|Etc/Greenwich",
			"Africa/Abidjan|GMT",
			"Africa/Abidjan|GMT+0",
			"Africa/Abidjan|GMT-0",
			"Africa/Abidjan|GMT0",
			"Africa/Abidjan|Greenwich",
			"Africa/Abidjan|Iceland",
			"Africa/Cairo|Egypt",
			"Africa/Casablanca|Africa/El_Aaiun",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Ndjamena",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Juba",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|America/Juneau",
			"America/Anchorage|America/Nome",
			"America/Anchorage|America/Sitka",
			"America/Anchorage|America/Yakutat",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Cordoba|America/Argentina/Buenos_Aires",
			"America/Argentina/Cordoba|America/Argentina/Tucuman",
			"America/Argentina/Cordoba|America/Buenos_Aires",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Mendoza|America/Argentina/Catamarca",
			"America/Argentina/Mendoza|America/Argentina/ComodRivadavia",
			"America/Argentina/Mendoza|America/Argentina/Jujuy",
			"America/Argentina/Mendoza|America/Argentina/La_Rioja",
			"America/Argentina/Mendoza|America/Argentina/Rio_Gallegos",
			"America/Argentina/Mendoza|America/Argentina/Salta",
			"America/Argentina/Mendoza|America/Argentina/San_Juan",
			"America/Argentina/Mendoza|America/Argentina/Ushuaia",
			"America/Argentina/Mendoza|America/Catamarca",
			"America/Argentina/Mendoza|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Campo_Grande|America/Cuiaba",
			"America/Chicago|America/Menominee",
			"America/Chicago|America/North_Dakota/Center",
			"America/Chicago|America/North_Dakota/New_Salem",
			"America/Chicago|America/Rainy_River",
			"America/Chicago|America/Rankin_Inlet",
			"America/Chicago|CST6CDT",
			"America/Chicago|US/Central",
			"America/Chihuahua|America/Mazatlan",
			"America/Chihuahua|Mexico/BajaSur",
			"America/Costa_Rica|America/Belize",
			"America/Costa_Rica|America/El_Salvador",
			"America/Costa_Rica|America/Regina",
			"America/Costa_Rica|America/Swift_Current",
			"America/Costa_Rica|Canada/Saskatchewan",
			"America/Denver|America/Boise",
			"America/Denver|America/Cambridge_Bay",
			"America/Denver|America/Edmonton",
			"America/Denver|America/Inuvik",
			"America/Denver|America/Shiprock",
			"America/Denver|America/Yellowknife",
			"America/Denver|Canada/Mountain",
			"America/Denver|MST7MDT",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indiana/Marengo",
			"America/Fort_Wayne|America/Indiana/Vevay",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Fortaleza|America/Belem",
			"America/Fortaleza|America/Cayenne",
			"America/Fortaleza|America/Maceio",
			"America/Fortaleza|America/Paramaribo",
			"America/Fortaleza|America/Recife",
			"America/Fortaleza|Antarctica/Rothera",
			"America/Fortaleza|Etc/GMT+3",
			"America/Halifax|America/Glace_Bay",
			"America/Halifax|America/Thule",
			"America/Halifax|Atlantic/Bermuda",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Indiana/Tell_City",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Indiana/Petersburg|America/Indiana/Vincennes",
			"America/La_Paz|America/Boa_Vista",
			"America/La_Paz|America/Guyana",
			"America/La_Paz|America/Manaus",
			"America/La_Paz|America/Porto_Velho",
			"America/La_Paz|Brazil/West",
			"America/La_Paz|Etc/GMT+4",
			"America/Lima|America/Bogota",
			"America/Lima|America/Guayaquil",
			"America/Lima|Etc/GMT+5",
			"America/Los_Angeles|America/Dawson",
			"America/Los_Angeles|America/Vancouver",
			"America/Los_Angeles|America/Whitehorse",
			"America/Los_Angeles|Canada/Pacific",
			"America/Los_Angeles|Canada/Yukon",
			"America/Los_Angeles|PST8PDT",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Mexico_City|America/Merida",
			"America/Mexico_City|America/Monterrey",
			"America/Mexico_City|Mexico/General",
			"America/New_York|America/Detroit",
			"America/New_York|America/Iqaluit",
			"America/New_York|America/Kentucky/Louisville",
			"America/New_York|America/Kentucky/Monticello",
			"America/New_York|America/Louisville",
			"America/New_York|America/Montreal",
			"America/New_York|America/Nassau",
			"America/New_York|America/Nipigon",
			"America/New_York|America/Pangnirtung",
			"America/New_York|America/Thunder_Bay",
			"America/New_York|America/Toronto",
			"America/New_York|Canada/Eastern",
			"America/New_York|EST5EDT",
			"America/New_York|US/Eastern",
			"America/New_York|US/Michigan",
			"America/Noronha|Atlantic/South_Georgia",
			"America/Noronha|Brazil/DeNoronha",
			"America/Noronha|Etc/GMT+2",
			"America/Panama|America/Atikokan",
			"America/Panama|America/Cayman",
			"America/Panama|America/Coral_Harbour",
			"America/Panama|America/Jamaica",
			"America/Panama|EST",
			"America/Panama|Jamaica",
			"America/Phoenix|America/Creston",
			"America/Phoenix|America/Dawson_Creek",
			"America/Phoenix|America/Hermosillo",
			"America/Phoenix|MST",
			"America/Phoenix|US/Arizona",
			"America/Rio_Branco|America/Eirunepe",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Santo_Domingo|America/Anguilla",
			"America/Santo_Domingo|America/Antigua",
			"America/Santo_Domingo|America/Aruba",
			"America/Santo_Domingo|America/Barbados",
			"America/Santo_Domingo|America/Blanc-Sablon",
			"America/Santo_Domingo|America/Curacao",
			"America/Santo_Domingo|America/Dominica",
			"America/Santo_Domingo|America/Grenada",
			"America/Santo_Domingo|America/Guadeloupe",
			"America/Santo_Domingo|America/Kralendijk",
			"America/Santo_Domingo|America/Lower_Princes",
			"America/Santo_Domingo|America/Marigot",
			"America/Santo_Domingo|America/Martinique",
			"America/Santo_Domingo|America/Montserrat",
			"America/Santo_Domingo|America/Port_of_Spain",
			"America/Santo_Domingo|America/Puerto_Rico",
			"America/Santo_Domingo|America/St_Barthelemy",
			"America/Santo_Domingo|America/St_Kitts",
			"America/Santo_Domingo|America/St_Lucia",
			"America/Santo_Domingo|America/St_Thomas",
			"America/Santo_Domingo|America/St_Vincent",
			"America/Santo_Domingo|America/Tortola",
			"America/Santo_Domingo|America/Virgin",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Winnipeg|Canada/Central",
			"Antarctica/Palmer|America/Punta_Arenas",
			"Asia/Bangkok|Asia/Ho_Chi_Minh",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Saigon",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Bangkok|Etc/GMT-7",
			"Asia/Bangkok|Indian/Christmas",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dili|Etc/GMT-9",
			"Asia/Dili|Pacific/Palau",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Dubai|Etc/GMT-4",
			"Asia/Dubai|Indian/Mahe",
			"Asia/Dubai|Indian/Reunion",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jakarta|Asia/Pontianak",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kamchatka|Asia/Anadyr",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Brunei",
			"Asia/Kuala_Lumpur|Asia/Kuching",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Etc/GMT-8",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Rangoon|Indian/Cocos",
			"Asia/Riyadh|Antarctica/Syowa",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Bahrain",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Riyadh|Asia/Qatar",
			"Asia/Riyadh|Etc/GMT-3",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|Asia/Macao",
			"Asia/Shanghai|Asia/Macau",
			"Asia/Shanghai|Asia/Taipei",
			"Asia/Shanghai|PRC",
			"Asia/Shanghai|ROC",
			"Asia/Tashkent|Asia/Aqtau",
			"Asia/Tashkent|Asia/Aqtobe",
			"Asia/Tashkent|Asia/Ashgabat",
			"Asia/Tashkent|Asia/Ashkhabad",
			"Asia/Tashkent|Asia/Atyrau",
			"Asia/Tashkent|Asia/Dushanbe",
			"Asia/Tashkent|Asia/Oral",
			"Asia/Tashkent|Asia/Samarkand",
			"Asia/Tashkent|Etc/GMT-5",
			"Asia/Tashkent|Indian/Kerguelen",
			"Asia/Tashkent|Indian/Maldives",
			"Asia/Tehran|Iran",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Antarctica/Vostok",
			"Asia/Urumqi|Asia/Almaty",
			"Asia/Urumqi|Asia/Kashgar",
			"Asia/Urumqi|Asia/Qostanay",
			"Asia/Urumqi|Asia/Thimbu",
			"Asia/Urumqi|Asia/Thimphu",
			"Asia/Urumqi|Etc/GMT-6",
			"Asia/Urumqi|Indian/Chagos",
			"Atlantic/Azores|America/Scoresbysund",
			"Atlantic/Cape_Verde|Etc/GMT+1",
			"Australia/Adelaide|Australia/Broken_Hill",
			"Australia/Adelaide|Australia/South",
			"Australia/Adelaide|Australia/Yancowinna",
			"Australia/Brisbane|Australia/Lindeman",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Currie",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/Melbourne",
			"Australia/Sydney|Australia/NSW",
			"Australia/Sydney|Australia/Victoria",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Athens|Asia/Nicosia",
			"Europe/Athens|EET",
			"Europe/Athens|Europe/Bucharest",
			"Europe/Athens|Europe/Helsinki",
			"Europe/Athens|Europe/Kiev",
			"Europe/Athens|Europe/Mariehamn",
			"Europe/Athens|Europe/Nicosia",
			"Europe/Athens|Europe/Riga",
			"Europe/Athens|Europe/Sofia",
			"Europe/Athens|Europe/Tallinn",
			"Europe/Athens|Europe/Uzhgorod",
			"Europe/Athens|Europe/Vilnius",
			"Europe/Athens|Europe/Zaporozhye",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Atlantic/Canary",
			"Europe/Lisbon|Atlantic/Faeroe",
			"Europe/Lisbon|Atlantic/Faroe",
			"Europe/Lisbon|Atlantic/Madeira",
			"Europe/Lisbon|Portugal",
			"Europe/Lisbon|WET",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Paris|Africa/Ceuta",
			"Europe/Paris|Arctic/Longyearbyen",
			"Europe/Paris|Atlantic/Jan_Mayen",
			"Europe/Paris|CET",
			"Europe/Paris|Europe/Amsterdam",
			"Europe/Paris|Europe/Andorra",
			"Europe/Paris|Europe/Belgrade",
			"Europe/Paris|Europe/Berlin",
			"Europe/Paris|Europe/Bratislava",
			"Europe/Paris|Europe/Brussels",
			"Europe/Paris|Europe/Budapest",
			"Europe/Paris|Europe/Busingen",
			"Europe/Paris|Europe/Copenhagen",
			"Europe/Paris|Europe/Gibraltar",
			"Europe/Paris|Europe/Ljubljana",
			"Europe/Paris|Europe/Luxembourg",
			"Europe/Paris|Europe/Madrid",
			"Europe/Paris|Europe/Malta",
			"Europe/Paris|Europe/Monaco",
			"Europe/Paris|Europe/Oslo",
			"Europe/Paris|Europe/Podgorica",
			"Europe/Paris|Europe/Prague",
			"Europe/Paris|Europe/Rome",
			"Europe/Paris|Europe/San_Marino",
			"Europe/Paris|Europe/Sarajevo",
			"Europe/Paris|Europe/Skopje",
			"Europe/Paris|Europe/Stockholm",
			"Europe/Paris|Europe/Tirane",
			"Europe/Paris|Europe/Vaduz",
			"Europe/Paris|Europe/Vatican",
			"Europe/Paris|Europe/Vienna",
			"Europe/Paris|Europe/Warsaw",
			"Europe/Paris|Europe/Zagreb",
			"Europe/Paris|Europe/Zurich",
			"Europe/Paris|Poland",
			"Europe/Ulyanovsk|Europe/Astrakhan",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Enderbury|Etc/GMT-13",
			"Pacific/Galapagos|Etc/GMT+6",
			"Pacific/Gambier|Etc/GMT+9",
			"Pacific/Guadalcanal|Etc/GMT-11",
			"Pacific/Guadalcanal|Pacific/Efate",
			"Pacific/Guadalcanal|Pacific/Kosrae",
			"Pacific/Guadalcanal|Pacific/Noumea",
			"Pacific/Guadalcanal|Pacific/Pohnpei",
			"Pacific/Guadalcanal|Pacific/Ponape",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|HST",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kiritimati|Etc/GMT-14",
			"Pacific/Niue|Etc/GMT+11",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Pitcairn|Etc/GMT+8",
			"Pacific/Port_Moresby|Antarctica/DumontDUrville",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Port_Moresby|Pacific/Chuuk",
			"Pacific/Port_Moresby|Pacific/Truk",
			"Pacific/Port_Moresby|Pacific/Yap",
			"Pacific/Tahiti|Etc/GMT+10",
			"Pacific/Tahiti|Pacific/Rarotonga",
			"Pacific/Tarawa|Etc/GMT-12",
			"Pacific/Tarawa|Kwajalein",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Kwajalein",
			"Pacific/Tarawa|Pacific/Majuro",
			"Pacific/Tarawa|Pacific/Nauru",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		]
	});


	return moment;
}));


(function () {
var earlyAuthRequest, ref, setupTimezone, timezoneAlreadySetup;

timezoneAlreadySetup = false;

setupTimezone = function(arg) {
  var e, error, portal;
  portal = arg.portal;
  if (I18n.manualTimezone) {
    return;
  }
  if (timezoneAlreadySetup === true) {
    return;
  }
  try {
    if ((portal != null ? portal.timezone : void 0) && portal.timezone.id && portal.timezone['moment-data']) {
      timezoneAlreadySetup = true;
      if (!I18n.moment.tz.zone(portal.timezone.id)) {
        I18n.moment.tz.add(portal.timezone.id + "|" + portal.timezone['moment-data']);
      }
      I18n.changeTimezone(portal.timezone.id);
      return I18n.trigger('timezone:loaded');
    } else {
      return typeof Raven !== "undefined" && Raven !== null ? Raven.captureMessage("I18n failed to parse api-verify data: " + JSON.stringify(portal != null ? portal.timezone : void 0)) : void 0;
    }
  } catch (error) {
    e = error;
    console.error('Error timezone thing', e);
    return typeof Raven !== "undefined" && Raven !== null ? Raven.captureException(e) : void 0;
  }
};

earlyAuthRequest = (ref = window.earlyRequester) != null ? ref.getRequestStateByName('api-verify') : void 0;

if (earlyAuthRequest != null) {
  earlyAuthRequest.whenFinished((function(_this) {
    return function(loginVerifyData) {
      return setupTimezone(loginVerifyData);
    };
  })(this));
}

window.addEventListener('hubspot:userinfochange', function(e) {
  return setupTimezone(e);
});
}());

// Your project probably only needs the standard project bundle, which is sleeker. This
// bundle is for the few projects that need data for time zones other than the user's.
// See: HubSpot/I18n#157








//  Needs to come after moment-timezone



/*!
 * pickadate.js v3.5.0, 2014/04/13
 * By Amsul, http://amsul.ca
 * Hosted on http://amsul.github.io/pickadate.js
 * Licensed under MIT
 */

(function ( factory ) {

    // Register as an anonymous module.
    if ( typeof define === 'function' && define.amd )
        define( 'picker', ['jquery'], factory )

    // Or using browser globals.
    else this.Picker = factory( jQuery )

}(function( $ ) {

var $document = $( document )


/**
 * The picker constructor that creates a blank picker.
 */
function PickerConstructor( ELEMENT, NAME, COMPONENT, OPTIONS ) {

    // If there’s no element, return the picker constructor.
    if ( !ELEMENT ) return PickerConstructor


    var
        IS_DEFAULT_THEME = false,


        // The state of the picker.
        STATE = {
            id: ELEMENT.id || 'P' + Math.abs( ~~(Math.random() * new Date()) )
        },


        // Merge the defaults and options passed.
        SETTINGS = COMPONENT ? $.extend( true, {}, COMPONENT.defaults, OPTIONS ) : OPTIONS || {},


        // Merge the default classes with the settings classes.
        CLASSES = $.extend( {}, PickerConstructor.klasses(), SETTINGS.klass ),


        // The element node wrapper into a jQuery object.
        $ELEMENT = $( ELEMENT ),


        // Pseudo picker constructor.
        PickerInstance = function() {
            return this.start()
        },


        // The picker prototype.
        P = PickerInstance.prototype = {

            constructor: PickerInstance,

            $node: $ELEMENT,


            /**
             * Initialize everything
             */
            start: function() {

                // If it’s already started, do nothing.
                if ( STATE && STATE.start ) return P


                // Update the picker states.
                STATE.methods = {}
                STATE.start = true
                STATE.open = false
                STATE.type = ELEMENT.type


                // Confirm focus state, convert into text input to remove UA stylings,
                // and set as readonly to prevent keyboard popup.
                ELEMENT.autofocus = ELEMENT == document.activeElement
                ELEMENT.type = 'text'
                ELEMENT.readOnly = !SETTINGS.editable
                ELEMENT.id = ELEMENT.id || STATE.id


                // Create a new picker component with the settings.
                P.component = new COMPONENT(P, SETTINGS)


                // Create the picker root with a holder and then prepare it.
                P.$root = $( PickerConstructor._.node('div', createWrappedComponent(), CLASSES.picker, 'id="' + ELEMENT.id + '_root"') )
                prepareElementRoot()


                // If there’s a format for the hidden input element, create the element.
                if ( SETTINGS.formatSubmit ) {
                    prepareElementHidden()
                }


                // Prepare the input element.
                prepareElement()


                // Insert the root as specified in the settings.
                if ( SETTINGS.container ) $( SETTINGS.container ).append( P.$root )
                else $ELEMENT.after( P.$root )


                // Bind the default component and settings events.
                P.on({
                    start: P.component.onStart,
                    render: P.component.onRender,
                    stop: P.component.onStop,
                    open: P.component.onOpen,
                    close: P.component.onClose,
                    set: P.component.onSet
                }).on({
                    start: SETTINGS.onStart,
                    render: SETTINGS.onRender,
                    stop: SETTINGS.onStop,
                    open: SETTINGS.onOpen,
                    close: SETTINGS.onClose,
                    set: SETTINGS.onSet
                })


                // Once we’re all set, check the theme in use.
                IS_DEFAULT_THEME = isUsingDefaultTheme( P.$root.children()[ 0 ] )


                // If the element has autofocus, open the picker.
                if ( ELEMENT.autofocus ) {
                    P.open()
                }


                // Trigger queued the “start” and “render” events.
                return P.trigger( 'start' ).trigger( 'render' )
            }, //start


            /**
             * Render a new picker
             */
            render: function( entireComponent ) {

                // Insert a new component holder in the root or box.
                if ( entireComponent ) P.$root.html( createWrappedComponent() )
                else P.$root.find( '.' + CLASSES.box ).html( P.component.nodes( STATE.open ) )

                // Trigger the queued “render” events.
                return P.trigger( 'render' )
            }, //render


            /**
             * Destroy everything
             */
            stop: function() {

                // If it’s already stopped, do nothing.
                if ( !STATE.start ) return P

                // Then close the picker.
                P.close()

                // Remove the hidden field.
                if ( P._hidden ) {
                    P._hidden.parentNode.removeChild( P._hidden )
                }

                // Remove the root.
                P.$root.remove()

                // Remove the input class, remove the stored data, and unbind
                // the events (after a tick for IE - see `P.close`).
                $ELEMENT.removeClass( CLASSES.input ).removeData( NAME )
                setTimeout( function() {
                    $ELEMENT.off( '.' + STATE.id )
                }, 0)

                // Restore the element state
                ELEMENT.type = STATE.type
                ELEMENT.readOnly = false

                // Trigger the queued “stop” events.
                P.trigger( 'stop' )

                // Reset the picker states.
                STATE.methods = {}
                STATE.start = false

                return P
            }, //stop


            /*
             * Open up the picker
             */
            open: function( dontGiveFocus ) {

                // If it’s already open, do nothing.
                if ( STATE.open ) return P

                // Add the “active” class.
                $ELEMENT.addClass( CLASSES.active )
                aria( ELEMENT, 'expanded', true )

                // * A Firefox bug, when `html` has `overflow:hidden`, results in
                //   killing transitions :(. So add the “opened” state on the next tick.
                //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
                setTimeout( function() {

                    // Add the “opened” class to the picker root.
                    P.$root.addClass( CLASSES.opened )
                    aria( P.$root[0], 'hidden', false )

                }, 0 )

                // If we have to give focus, bind the element and doc events.
                if ( dontGiveFocus !== false ) {

                    // Set it as open.
                    STATE.open = true

                    // Prevent the page from scrolling.
                    if ( IS_DEFAULT_THEME ) {
                        $( 'html' ).
                            css( 'overflow', 'hidden' ).
                            css( 'padding-right', '+=' + getScrollbarWidth() )
                    }

                    // Pass focus to the element’s jQuery object.
                    $ELEMENT.trigger( 'focus' )

                    // Bind the document events.
                    $document.on( 'click.' + STATE.id + ' focusin.' + STATE.id, function( event ) {

                        var target = event.target

                        // If the target of the event is not the element, close the picker picker.
                        // * Don’t worry about clicks or focusins on the root because those don’t bubble up.
                        //   Also, for Firefox, a click on an `option` element bubbles up directly
                        //   to the doc. So make sure the target wasn't the doc.
                        // * In Firefox stopPropagation() doesn’t prevent right-click events from bubbling,
                        //   which causes the picker to unexpectedly close when right-clicking it. So make
                        //   sure the event wasn’t a right-click.
                        if ( target != ELEMENT && target != document && event.which != 3 ) {

                            // If the target was the holder that covers the screen,
                            // keep the element focused to maintain tabindex.
                            P.close( target === P.$root.children()[0] )
                        }

                    }).on( 'keydown.' + STATE.id, function( event ) {

                        var
                            // Get the keycode.
                            keycode = event.keyCode,

                            // Translate that to a selection change.
                            keycodeToMove = P.component.key[ keycode ],

                            // Grab the target.
                            target = event.target


                        // On escape, close the picker and give focus.
                        if ( keycode == 27 ) {
                            P.close( true )
                        }


                        // Check if there is a key movement or “enter” keypress on the element.
                        else if ( target == ELEMENT && ( keycodeToMove || keycode == 13 ) ) {

                            // Prevent the default action to stop page movement.
                            event.preventDefault()

                            // Trigger the key movement action.
                            if ( keycodeToMove ) {
                                PickerConstructor._.trigger( P.component.key.go, P, [ PickerConstructor._.trigger( keycodeToMove ) ] )
                            }

                            // On “enter”, if the highlighted item isn’t disabled, set the value and close.
                            else if ( !P.$root.find( '.' + CLASSES.highlighted ).hasClass( CLASSES.disabled ) ) {
                                P.set( 'select', P.component.item.highlight ).close()
                            }
                        }


                        // If the target is within the root and “enter” is pressed,
                        // prevent the default action and trigger a click on the target instead.
                        else if ( $.contains( P.$root[0], target ) && keycode == 13 ) {
                            event.preventDefault()
                            target.click()
                        }
                    })
                }

                // Trigger the queued “open” events.
                return P.trigger( 'open' )
            }, //open


            /**
             * Close the picker
             */
            close: function( giveFocus ) {

                // If we need to give focus, do it before changing states.
                if ( giveFocus ) {
                    // ....ah yes! It would’ve been incomplete without a crazy workaround for IE :|
                    // The focus is triggered *after* the close has completed - causing it
                    // to open again. So unbind and rebind the event at the next tick.
                    $ELEMENT.off( 'focus.' + STATE.id ).trigger( 'focus' )
                    setTimeout( function() {
                        $ELEMENT.on( 'focus.' + STATE.id, focusToOpen )
                    }, 0 )
                }

                // Remove the “active” class.
                $ELEMENT.removeClass( CLASSES.active )
                aria( ELEMENT, 'expanded', false )

                // * A Firefox bug, when `html` has `overflow:hidden`, results in
                //   killing transitions :(. So remove the “opened” state on the next tick.
                //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
                setTimeout( function() {

                    // Remove the “opened” and “focused” class from the picker root.
                    P.$root.removeClass( CLASSES.opened + ' ' + CLASSES.focused )
                    aria( P.$root[0], 'hidden', true )

                }, 0 )

                // If it’s already closed, do nothing more.
                if ( !STATE.open ) return P

                // Set it as closed.
                STATE.open = false

                // Allow the page to scroll.
                if ( IS_DEFAULT_THEME ) {
                    $( 'html' ).
                        css( 'overflow', '' ).
                        css( 'padding-right', '-=' + getScrollbarWidth() )
                }

                // Unbind the document events.
                $document.off( '.' + STATE.id )

                // Trigger the queued “close” events.
                return P.trigger( 'close' )
            }, //close


            /**
             * Clear the values
             */
            clear: function() {
                return P.set( 'clear' )
            }, //clear


            /**
             * Set something
             */
            set: function( thing, value, options ) {

                var thingItem, thingValue,
                    thingIsObject = $.isPlainObject( thing ),
                    thingObject = thingIsObject ? thing : {}

                // Make sure we have usable options.
                options = thingIsObject && $.isPlainObject( value ) ? value : options || {}

                if ( thing ) {

                    // If the thing isn’t an object, make it one.
                    if ( !thingIsObject ) {
                        thingObject[ thing ] = value
                    }

                    // Go through the things of items to set.
                    for ( thingItem in thingObject ) {

                        // Grab the value of the thing.
                        thingValue = thingObject[ thingItem ]

                        // First, if the item exists and there’s a value, set it.
                        if ( thingItem in P.component.item ) {
                            if ( thingValue === undefined ) thingValue = null
                            P.component.set( thingItem, thingValue, options )
                        }

                        // Then, check to update the element value and broadcast a change.
                        if ( thingItem == 'select' || thingItem == 'clear' ) {
                            $ELEMENT.
                                val( thingItem == 'clear' ? '' : P.get( thingItem, SETTINGS.format ) ).
                                trigger( 'change' )
                        }
                    }

                    // Render a new picker.
                    P.render()
                }

                // When the method isn’t muted, trigger queued “set” events and pass the `thingObject`.
                return options.muted ? P : P.trigger( 'set', thingObject )
            }, //set


            /**
             * Get something
             */
            get: function( thing, format ) {

                // Make sure there’s something to get.
                thing = thing || 'value'

                // If a picker state exists, return that.
                if ( STATE[ thing ] != null ) {
                    return STATE[ thing ]
                }

                // Return the value, if that.
                if ( thing == 'value' ) {
                    return ELEMENT.value
                }

                // Check if a component item exists, return that.
                if ( thing in P.component.item ) {
                    if ( typeof format == 'string' ) {
                        return PickerConstructor._.trigger(
                            P.component.formats.toString,
                            P.component,
                            [ format, P.component.get( thing ) ]
                        )
                    }
                    return P.component.get( thing )
                }
            }, //get



            /**
             * Bind events on the things.
             */
            on: function( thing, method ) {

                var thingName, thingMethod,
                    thingIsObject = $.isPlainObject( thing ),
                    thingObject = thingIsObject ? thing : {}

                if ( thing ) {

                    // If the thing isn’t an object, make it one.
                    if ( !thingIsObject ) {
                        thingObject[ thing ] = method
                    }

                    // Go through the things to bind to.
                    for ( thingName in thingObject ) {

                        // Grab the method of the thing.
                        thingMethod = thingObject[ thingName ]

                        // Make sure the thing methods collection exists.
                        STATE.methods[ thingName ] = STATE.methods[ thingName ] || []

                        // Add the method to the relative method collection.
                        STATE.methods[ thingName ].push( thingMethod )
                    }
                }

                return P
            }, //on



            /**
             * Unbind events on the things.
             */
            off: function() {
                var i, thingName,
                    names = arguments;
                for ( i = 0, namesCount = names.length; i < namesCount; i += 1 ) {
                    thingName = names[i]
                    if ( thingName in STATE.methods ) {
                        delete STATE.methods[thingName]
                    }
                }
                return P
            },


            /**
             * Fire off method events.
             */
            trigger: function( name, data ) {
                var methodList = STATE.methods[ name ]
                if ( methodList ) {
                    methodList.map( function( method ) {
                        PickerConstructor._.trigger( method, P, [ data ] )
                    })
                }
                return P
            } //trigger
        } //PickerInstance.prototype


    /**
     * Wrap the picker holder components together.
     */
    function createWrappedComponent() {

        // Create a picker wrapper holder
        return PickerConstructor._.node( 'div',

            // Create a picker wrapper node
            PickerConstructor._.node( 'div',

                // Create a picker frame
                PickerConstructor._.node( 'div',

                    // Create a picker box node
                    PickerConstructor._.node( 'div',

                        // Create the components nodes.
                        P.component.nodes( STATE.open ),

                        // The picker box class
                        CLASSES.box
                    ),

                    // Picker wrap class
                    CLASSES.wrap
                ),

                // Picker frame class
                CLASSES.frame
            ),

            // Picker holder class
            CLASSES.holder
        ) //endreturn
    } //createWrappedComponent



    /**
     * Prepare the input element with all bindings.
     */
    function prepareElement() {

        $ELEMENT.

            // Store the picker data by component name.
            data(NAME, P).

            // Add the “input” class name.
            addClass(CLASSES.input).

            // If there’s a `data-value`, update the value of the element.
            val( $ELEMENT.data('value') ?
                P.get('select', SETTINGS.format) :
                ELEMENT.value
            ).

            // On focus/click, open the picker and adjust the root “focused” state.
            on('focus.' + STATE.id + ' click.' + STATE.id, focusToOpen)


        // Only bind keydown events if the element isn’t editable.
        if ( !SETTINGS.editable ) {

            // Handle keyboard event based on the picker being opened or not.
            $ELEMENT.on('keydown.' + STATE.id, function(event) {

                var keycode = event.keyCode,

                    // Check if one of the delete keys was pressed.
                    isKeycodeDelete = /^(8|46)$/.test(keycode)

                // For some reason IE clears the input value on “escape”.
                if ( keycode == 27 ) {
                    P.close()
                    return false
                }

                // Check if `space` or `delete` was pressed or the picker is closed with a key movement.
                if ( keycode == 32 || isKeycodeDelete || !STATE.open && P.component.key[keycode] ) {

                    // Prevent it from moving the page and bubbling to doc.
                    event.preventDefault()
                    event.stopPropagation()

                    // If `delete` was pressed, clear the values and close the picker.
                    // Otherwise open the picker.
                    if ( isKeycodeDelete ) { P.clear().close() }
                    else { P.open() }
                }
            })
        }


        // Update the aria attributes.
        aria(ELEMENT, {
            haspopup: true,
            expanded: false,
            readonly: false,
            owns: ELEMENT.id + '_root' + (P._hidden ? ' ' + P._hidden.id : '')
        })
    }


    /**
     * Prepare the root picker element with all bindings.
     */
    function prepareElementRoot() {

        P.$root.

            on({

                // When something within the root is focused, stop from bubbling
                // to the doc and remove the “focused” state from the root.
                focusin: function( event ) {
                    P.$root.removeClass( CLASSES.focused )
                    event.stopPropagation()
                },

                // When something within the root holder is clicked, stop it
                // from bubbling to the doc.
                'mousedown click': function( event ) {

                    var target = event.target

                    // Make sure the target isn’t the root holder so it can bubble up.
                    if ( target != P.$root.children()[ 0 ] ) {

                        event.stopPropagation()

                        // * For mousedown events, cancel the default action in order to
                        //   prevent cases where focus is shifted onto external elements
                        //   when using things like jQuery mobile or MagnificPopup (ref: #249 & #120).
                        //   Also, for Firefox, don’t prevent action on the `option` element.
                        if ( event.type == 'mousedown' && !$( target ).is( ':input' ) && target.nodeName != 'OPTION' ) {

                            event.preventDefault()

                            // Re-focus onto the element so that users can click away
                            // from elements focused within the picker.
                            ELEMENT.focus()
                        }
                    }
                }
            }).

            // If there’s a click on an actionable element, carry out the actions.
            on( 'click', '[data-pick], [data-nav], [data-clear]', function() {

                var $target = $( this ),
                    targetData = $target.data(),
                    targetDisabled = $target.hasClass( CLASSES.navDisabled ) || $target.hasClass( CLASSES.disabled ),

                    // * For IE, non-focusable elements can be active elements as well
                    //   (http://stackoverflow.com/a/2684561).
                    activeElement = document.activeElement
                    activeElement = activeElement && ( activeElement.type || activeElement.href ) && activeElement

                // If it’s disabled or nothing inside is actively focused, re-focus the element.
                if ( targetDisabled || activeElement && !$.contains( P.$root[0], activeElement ) ) {
                    ELEMENT.focus()
                }

                // If something is superficially changed, update the `highlight` based on the `nav`.
                if ( targetData.nav && !targetDisabled ) {
                    P.set( 'highlight', P.component.item.highlight, { nav: targetData.nav } )
                }

                // If something is picked, set `select` then close with focus.
                else if ( PickerConstructor._.isInteger( targetData.pick ) && !targetDisabled ) {
                    P.set( 'select', targetData.pick ).close( true )
                }

                // If a “clear” button is pressed, empty the values and close with focus.
                else if ( targetData.clear ) {
                    P.clear().close( true )
                }
            }) //P.$root

        aria( P.$root[0], 'hidden', true )
    }


     /**
      * Prepare the hidden input element along with all bindings.
      */
    function prepareElementHidden() {

        var id,
            name

        if ( SETTINGS.hiddenName === true ) {
            id = ELEMENT.name + '_hidden'
            name = ELEMENT.name
            ELEMENT.name = ''
        }
        else {
            name = [
                typeof SETTINGS.hiddenPrefix == 'string' ? SETTINGS.hiddenPrefix : '',
                typeof SETTINGS.hiddenSuffix == 'string' ? SETTINGS.hiddenSuffix : '_submit'
            ]
            name = id = name[0] + ELEMENT.name + name[1]
        }

        P._hidden = $(
            '<input ' +
            'type=hidden ' +

            // Create the name and ID by using the original
            // input’s with a prefix and suffix.
            'name="' + name + '"' +
            'id="' + id + '"' +

            // If the element has a value, set the hidden value as well.
            (
                $ELEMENT.data('value') || ELEMENT.value ?
                    ' value="' + P.get('select', SETTINGS.formatSubmit) + '"' :
                    ''
            ) +
            '>'
        )[0]

        $ELEMENT.

            // If the value changes, update the hidden input with the correct format.
            on('change.' + STATE.id, function() {
                P._hidden.value = ELEMENT.value ?
                    P.get('select', SETTINGS.formatSubmit) :
                    ''
            }).

            // Insert the hidden input after the element.
            after(P._hidden)
    }


    // Separated for IE
    function focusToOpen( event ) {

        // Stop the event from propagating to the doc.
        event.stopPropagation()

        // If it’s a focus event, add the “focused” class to the root.
        if ( event.type == 'focus' ) {
            P.$root.addClass( CLASSES.focused )
        }

        // And then finally open the picker.
        P.open()
    }


    // Return a new picker instance.
    return new PickerInstance()
} //PickerConstructor



/**
 * The default classes and prefix to use for the HTML classes.
 */
PickerConstructor.klasses = function( prefix ) {
    prefix = prefix || 'picker'
    return {

        picker: prefix,
        opened: prefix + '--opened',
        focused: prefix + '--focused',

        input: prefix + '__input',
        active: prefix + '__input--active',

        holder: prefix + '__holder',

        frame: prefix + '__frame',
        wrap: prefix + '__wrap',

        box: prefix + '__box'
    }
} //PickerConstructor.klasses



/**
 * Check if the default theme is being used.
 */
function isUsingDefaultTheme( element ) {

    var theme,
        prop = 'position'

    // For IE.
    if ( element.currentStyle ) {
        theme = element.currentStyle[prop]
    }

    // For normal browsers.
    else if ( window.getComputedStyle ) {
        theme = getComputedStyle( element )[prop]
    }

    return theme == 'fixed'
}



/**
 * Get the width of the browser’s scrollbar.
 * Taken from: https://github.com/VodkaBears/Remodal/blob/master/src/jquery.remodal.js
 */
function getScrollbarWidth() {

    var $outer = $( '<div style="visibility:hidden;width:100px" />' ).
        appendTo( 'body' )

    // Get the width without scrollbars.
    var widthWithoutScroll = $outer[0].offsetWidth

    // Force adding scrollbars.
    $outer.css( 'overflow', 'scroll' )

    // Add the inner div.
    var $inner = $( '<div style="width:100%" />' ).appendTo( $outer )

    // Get the width with scrollbars.
    var widthWithScroll = $inner[0].offsetWidth

    // Remove the divs.
    $outer.remove()

    // Return the difference between the widths.
    return widthWithoutScroll - widthWithScroll
}



/**
 * PickerConstructor helper methods.
 */
PickerConstructor._ = {

    /**
     * Create a group of nodes. Expects:
     * `
        {
            min:    {Integer},
            max:    {Integer},
            i:      {Integer},
            node:   {String},
            item:   {Function}
        }
     * `
     */
    group: function( groupObject ) {

        var
            // Scope for the looped object
            loopObjectScope,

            // Create the nodes list
            nodesList = '',

            // The counter starts from the `min`
            counter = PickerConstructor._.trigger( groupObject.min, groupObject )


        // Loop from the `min` to `max`, incrementing by `i`
        for ( ; counter <= PickerConstructor._.trigger( groupObject.max, groupObject, [ counter ] ); counter += groupObject.i ) {

            // Trigger the `item` function within scope of the object
            loopObjectScope = PickerConstructor._.trigger( groupObject.item, groupObject, [ counter ] )

            // Splice the subgroup and create nodes out of the sub nodes
            nodesList += PickerConstructor._.node(
                groupObject.node,
                loopObjectScope[ 0 ],   // the node
                loopObjectScope[ 1 ],   // the classes
                loopObjectScope[ 2 ]    // the attributes
            )
        }

        // Return the list of nodes
        return nodesList
    }, //group


    /**
     * Create a dom node string
     */
    node: function( wrapper, item, klass, attribute ) {

        // If the item is false-y, just return an empty string
        if ( !item ) return ''

        // If the item is an array, do a join
        item = $.isArray( item ) ? item.join( '' ) : item

        // Check for the class
        klass = klass ? ' class="' + klass + '"' : ''

        // Check for any attributes
        attribute = attribute ? ' ' + attribute : ''

        // Return the wrapped item
        return '<' + wrapper + klass + attribute + '>' + item + '</' + wrapper + '>'
    }, //node


    /**
     * Lead numbers below 10 with a zero.
     */
    lead: function( number ) {
        return ( number < 10 ? '0': '' ) + number
    },


    /**
     * Trigger a function otherwise return the value.
     */
    trigger: function( callback, scope, args ) {
        return typeof callback == 'function' ? callback.apply( scope, args || [] ) : callback
    },


    /**
     * If the second character is a digit, length is 2 otherwise 1.
     */
    digits: function( string ) {
        return ( /\d/ ).test( string[ 1 ] ) ? 2 : 1
    },


    /**
     * Tell if something is a date object.
     */
    isDate: function( value ) {
        return {}.toString.call( value ).indexOf( 'Date' ) > -1 && this.isInteger( value.getDate() )
    },


    /**
     * Tell if something is an integer.
     */
    isInteger: function( value ) {
        return {}.toString.call( value ).indexOf( 'Number' ) > -1 && value % 1 === 0
    },


    /**
     * Create ARIA attribute strings.
     */
    ariaAttr: ariaAttr
} //PickerConstructor._



/**
 * Extend the picker with a component and defaults.
 */
PickerConstructor.extend = function( name, Component ) {

    // Extend jQuery.
    $.fn[ name ] = function( options, action ) {

        // Grab the component data.
        var componentData = this.data( name )

        // If the picker is requested, return the data object.
        if ( options == 'picker' ) {
            return componentData
        }

        // If the component data exists and `options` is a string, carry out the action.
        if ( componentData && typeof options == 'string' ) {
            return PickerConstructor._.trigger( componentData[ options ], componentData, [ action ] )
        }

        // Otherwise go through each matched element and if the component
        // doesn’t exist, create a new picker using `this` element
        // and merging the defaults and options with a deep copy.
        return this.each( function() {
            var $this = $( this )
            if ( !$this.data( name ) ) {
                new PickerConstructor( this, name, Component, options )
            }
        })
    }

    // Set the defaults.
    $.fn[ name ].defaults = Component.defaults
} //PickerConstructor.extend



function aria(element, attribute, value) {
    if ( $.isPlainObject(attribute) ) {
        for ( var key in attribute ) {
            ariaSet(element, key, attribute[key])
        }
    }
    else {
        ariaSet(element, attribute, value)
    }
}
function ariaSet(element, attribute, value) {
    element.setAttribute(
        (attribute == 'role' ? '' : 'aria-') + attribute,
        value
    )
}
function ariaAttr(attribute, data) {
    if ( !$.isPlainObject(attribute) ) {
        attribute = { attribute: data }
    }
    data = ''
    for ( var key in attribute ) {
        var attr = (key == 'role' ? '' : 'aria-') + key,
            attrVal = attribute[key]
        data += attrVal == null ? '' : attr + '="' + attribute[key] + '"'
    }
    return data
}



// Expose the picker constructor.
return PickerConstructor


}));






/*!
 * Date picker for pickadate.js v3.5.0
 * http://amsul.github.io/pickadate.js/date.htm
 */

(function ( factory ) {

    // Register as an anonymous module.
    if ( typeof define == 'function' && define.amd )
        define( ['picker','jquery'], factory )

    // Or using browser globals.
    else factory( Picker, jQuery )

}(function( Picker, $ ) {


/**
 * Globals and constants
 */
var DAYS_IN_WEEK = 7,
    WEEKS_IN_CALENDAR = 6,
    _ = Picker._



/**
 * The date picker constructor
 */
function DatePicker( picker, settings ) {

    var calendar = this,
        elementValue = picker.$node[ 0 ].value,
        elementDataValue = picker.$node.data( 'value' ),
        valueString = elementDataValue || elementValue,
        formatString = elementDataValue ? settings.formatSubmit : settings.format,
        isRTL = function() {
            return getComputedStyle( picker.$root[0] ).direction === 'rtl'
        }

    calendar.settings = settings
    calendar.$node = picker.$node

    // The queue of methods that will be used to build item objects.
    calendar.queue = {
        min: 'measure create',
        max: 'measure create',
        now: 'now create',
        select: 'parse create validate',
        highlight: 'parse navigate create validate',
        view: 'parse create validate viewset',
        disable: 'deactivate',
        enable: 'activate'
    }

    // The component's item object.
    calendar.item = {}

    calendar.item.clear = null
    calendar.item.disable = ( settings.disable || [] ).slice( 0 )
    calendar.item.enable = -(function( collectionDisabled ) {
        return collectionDisabled[ 0 ] === true ? collectionDisabled.shift() : -1
    })( calendar.item.disable )

    calendar.
        set( 'min', settings.min ).
        set( 'max', settings.max ).
        set( 'now' )

    // When there’s a value, set the `select`, which in turn
    // also sets the `highlight` and `view`.
    if ( valueString ) {
        calendar.set( 'select', valueString, { format: formatString })
    }

    // If there’s no value, default to highlighting “today”.
    else {
        calendar.
            set( 'select', null ).
            set( 'highlight', calendar.item.now )
    }


    // The keycode to movement mapping.
    calendar.key = {
        40: 7, // Down
        38: -7, // Up
        39: function() { return isRTL() ? -1 : 1 }, // Right
        37: function() { return isRTL() ? 1 : -1 }, // Left
        go: function( timeChange ) {
            var highlightedObject = calendar.item.highlight,
                targetDate = new Date( highlightedObject.year, highlightedObject.month, highlightedObject.date + timeChange )
            calendar.set(
                'highlight',
                [ targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate() ],
                { interval: timeChange }
            )
            this.render()
        }
    }


    // Bind some picker events.
    picker.
        on( 'render', function() {
            picker.$root.find( '.' + settings.klass.selectMonth ).on( 'change', function() {
                var value = this.value
                if ( value ) {
                    picker.set( 'highlight', [ picker.get( 'view' ).year, value, picker.get( 'highlight' ).date ] )
                    picker.$root.find( '.' + settings.klass.selectMonth ).trigger( 'focus' )
                }
            })
            picker.$root.find( '.' + settings.klass.selectYear ).on( 'change', function() {
                var value = this.value
                if ( value ) {
                    picker.set( 'highlight', [ value, picker.get( 'view' ).month, picker.get( 'highlight' ).date ] )
                    picker.$root.find( '.' + settings.klass.selectYear ).trigger( 'focus' )
                }
            })
        }).
        on( 'open', function() {
            picker.$root.find( 'button, select' ).attr( 'disabled', false )
        }).
        on( 'close', function() {
            picker.$root.find( 'button, select' ).attr( 'disabled', true )
        })

} //DatePicker


/**
 * Set a datepicker item object.
 */
DatePicker.prototype.set = function( type, value, options ) {

    var calendar = this,
        calendarItem = calendar.item

    // If the value is `null` just set it immediately.
    if ( value === null ) {
        if ( type == 'clear' ) type = 'select'
        calendarItem[ type ] = value
        return calendar
    }

    // Otherwise go through the queue of methods, and invoke the functions.
    // Update this as the time unit, and set the final value as this item.
    // * In the case of `enable`, keep the queue but set `disable` instead.
    //   And in the case of `flip`, keep the queue but set `enable` instead.
    calendarItem[ ( type == 'enable' ? 'disable' : type == 'flip' ? 'enable' : type ) ] = calendar.queue[ type ].split( ' ' ).map( function( method ) {
        value = calendar[ method ]( type, value, options )
        return value
    }).pop()

    // Check if we need to cascade through more updates.
    if ( type == 'select' ) {
        calendar.set( 'highlight', calendarItem.select, options )
    }
    else if ( type == 'highlight' ) {
        calendar.set( 'view', calendarItem.highlight, options )
    }
    else if ( type.match( /^(flip|min|max|disable|enable)$/ ) ) {
        if ( calendarItem.select && calendar.disabled( calendarItem.select ) ) {
            calendar.set( 'select', calendarItem.select, options )
        }
        if ( calendarItem.highlight && calendar.disabled( calendarItem.highlight ) ) {
            calendar.set( 'highlight', calendarItem.highlight, options )
        }
    }

    return calendar
} //DatePicker.prototype.set


/**
 * Get a datepicker item object.
 */
DatePicker.prototype.get = function( type ) {
    return this.item[ type ]
} //DatePicker.prototype.get


/**
 * Create a picker date object.
 */
DatePicker.prototype.create = function( type, value, options ) {

    var isInfiniteValue,
        calendar = this

    // If there’s no value, use the type as the value.
    value = value === undefined ? type : value


    // If it’s infinity, update the value.
    if ( value == -Infinity || value == Infinity ) {
        isInfiniteValue = value
    }

    // If it’s an object, use the native date object.
    else if ( $.isPlainObject( value ) && _.isInteger( value.pick ) ) {
        value = value.obj
    }

    // If it’s an array, convert it into a date and make sure
    // that it’s a valid date – otherwise default to today.
    else if ( $.isArray( value ) ) {
        value = new Date( value[ 0 ], value[ 1 ], value[ 2 ] )
        value = _.isDate( value ) ? value : calendar.create().obj
    }

    // If it’s a number or date object, make a normalized date.
    else if ( _.isInteger( value ) || _.isDate( value ) ) {
        value = calendar.normalize( new Date( value ), options )
    }

    // If it’s a literal true or any other case, set it to now.
    else /*if ( value === true )*/ {
        value = calendar.now( type, value, options )
    }

    // Return the compiled object.
    return {
        year: isInfiniteValue || value.getFullYear(),
        month: isInfiniteValue || value.getMonth(),
        date: isInfiniteValue || value.getDate(),
        day: isInfiniteValue || value.getDay(),
        obj: isInfiniteValue || value,
        pick: isInfiniteValue || value.getTime()
    }
} //DatePicker.prototype.create


/**
 * Create a range limit object using an array, date object,
 * literal “true”, or integer relative to another time.
 */
DatePicker.prototype.createRange = function( from, to ) {

    var calendar = this,
        createDate = function( date ) {
            if ( date === true || $.isArray( date ) || _.isDate( date ) ) {
                return calendar.create( date )
            }
            return date
        }

    // Create objects if possible.
    if ( !_.isInteger( from ) ) {
        from = createDate( from )
    }
    if ( !_.isInteger( to ) ) {
        to = createDate( to )
    }

    // Create relative dates.
    if ( _.isInteger( from ) && $.isPlainObject( to ) ) {
        from = [ to.year, to.month, to.date + from ];
    }
    else if ( _.isInteger( to ) && $.isPlainObject( from ) ) {
        to = [ from.year, from.month, from.date + to ];
    }

    return {
        from: createDate( from ),
        to: createDate( to )
    }
} //DatePicker.prototype.createRange


/**
 * Check if a date unit falls within a date range object.
 */
DatePicker.prototype.withinRange = function( range, dateUnit ) {
    range = this.createRange(range.from, range.to)
    return dateUnit.pick >= range.from.pick && dateUnit.pick <= range.to.pick
}


/**
 * Check if two date range objects overlap.
 */
DatePicker.prototype.overlapRanges = function( one, two ) {

    var calendar = this

    // Convert the ranges into comparable dates.
    one = calendar.createRange( one.from, one.to )
    two = calendar.createRange( two.from, two.to )

    return calendar.withinRange( one, two.from ) || calendar.withinRange( one, two.to ) ||
        calendar.withinRange( two, one.from ) || calendar.withinRange( two, one.to )
}


/**
 * Get the date today.
 */
DatePicker.prototype.now = function( type, value, options ) {
    value = new Date()
    if ( options && options.rel ) {
        value.setDate( value.getDate() + options.rel )
    }
    return this.normalize( value, options )
}


/**
 * Navigate to next/prev month.
 */
DatePicker.prototype.navigate = function( type, value, options ) {

    var targetDateObject,
        targetYear,
        targetMonth,
        targetDate,
        isTargetArray = $.isArray( value ),
        isTargetObject = $.isPlainObject( value ),
        viewsetObject = this.item.view/*,
        safety = 100*/


    if ( isTargetArray || isTargetObject ) {

        if ( isTargetObject ) {
            targetYear = value.year
            targetMonth = value.month
            targetDate = value.date
        }
        else {
            targetYear = +value[0]
            targetMonth = +value[1]
            targetDate = +value[2]
        }

        // If we’re navigating months but the view is in a different
        // month, navigate to the view’s year and month.
        if ( options && options.nav && viewsetObject && viewsetObject.month !== targetMonth ) {
            targetYear = viewsetObject.year
            targetMonth = viewsetObject.month
        }

        // Figure out the expected target year and month.
        targetDateObject = new Date( targetYear, targetMonth + ( options && options.nav ? options.nav : 0 ), 1 )
        targetYear = targetDateObject.getFullYear()
        targetMonth = targetDateObject.getMonth()

        // If the month we’re going to doesn’t have enough days,
        // keep decreasing the date until we reach the month’s last date.
        while ( /*safety &&*/ new Date( targetYear, targetMonth, targetDate ).getMonth() !== targetMonth ) {
            targetDate -= 1
            /*safety -= 1
            if ( !safety ) {
                throw 'Fell into an infinite loop while navigating to ' + new Date( targetYear, targetMonth, targetDate ) + '.'
            }*/
        }

        value = [ targetYear, targetMonth, targetDate ]
    }

    return value
} //DatePicker.prototype.navigate


/**
 * Normalize a date by setting the hours to midnight.
 */
DatePicker.prototype.normalize = function( value/*, options*/ ) {
    value.setHours( 0, 0, 0, 0 )
    return value
}


/**
 * Measure the range of dates.
 */
DatePicker.prototype.measure = function( type, value/*, options*/ ) {

    var calendar = this

    // If it's anything false-y, remove the limits.
    if ( !value ) {
        value = type == 'min' ? -Infinity : Infinity
    }

    // If it's an integer, get a date relative to today.
    else if ( _.isInteger( value ) ) {
        value = calendar.now( type, value, { rel: value } )
    }

    return value
} ///DatePicker.prototype.measure


/**
 * Create a viewset object based on navigation.
 */
DatePicker.prototype.viewset = function( type, dateObject/*, options*/ ) {
    return this.create([ dateObject.year, dateObject.month, 1 ])
}


/**
 * Validate a date as enabled and shift if needed.
 */
DatePicker.prototype.validate = function( type, dateObject, options ) {

    var calendar = this,

        // Keep a reference to the original date.
        originalDateObject = dateObject,

        // Make sure we have an interval.
        interval = options && options.interval ? options.interval : 1,

        // Check if the calendar enabled dates are inverted.
        isFlippedBase = calendar.item.enable === -1,

        // Check if we have any enabled dates after/before now.
        hasEnabledBeforeTarget, hasEnabledAfterTarget,

        // The min & max limits.
        minLimitObject = calendar.item.min,
        maxLimitObject = calendar.item.max,

        // Check if we’ve reached the limit during shifting.
        reachedMin, reachedMax,

        // Check if the calendar is inverted and at least one weekday is enabled.
        hasEnabledWeekdays = isFlippedBase && calendar.item.disable.filter( function( value ) {

            // If there’s a date, check where it is relative to the target.
            if ( $.isArray( value ) ) {
                var dateTime = calendar.create( value ).pick
                if ( dateTime < dateObject.pick ) hasEnabledBeforeTarget = true
                else if ( dateTime > dateObject.pick ) hasEnabledAfterTarget = true
            }

            // Return only integers for enabled weekdays.
            return _.isInteger( value )
        }).length/*,

        safety = 100*/



    // Cases to validate for:
    // [1] Not inverted and date disabled.
    // [2] Inverted and some dates enabled.
    // [3] Not inverted and out of range.
    //
    // Cases to **not** validate for:
    // • Navigating months.
    // • Not inverted and date enabled.
    // • Inverted and all dates disabled.
    // • ..and anything else.
    if ( !options || !options.nav ) if (
        /* 1 */ ( !isFlippedBase && calendar.disabled( dateObject ) ) ||
        /* 2 */ ( isFlippedBase && calendar.disabled( dateObject ) && ( hasEnabledWeekdays || hasEnabledBeforeTarget || hasEnabledAfterTarget ) ) ||
        /* 3 */ ( !isFlippedBase && (dateObject.pick <= minLimitObject.pick || dateObject.pick >= maxLimitObject.pick) )
    ) {


        // When inverted, flip the direction if there aren’t any enabled weekdays
        // and there are no enabled dates in the direction of the interval.
        if ( isFlippedBase && !hasEnabledWeekdays && ( ( !hasEnabledAfterTarget && interval > 0 ) || ( !hasEnabledBeforeTarget && interval < 0 ) ) ) {
            interval *= -1
        }


        // Keep looping until we reach an enabled date.
        while ( /*safety &&*/ calendar.disabled( dateObject ) ) {

            /*safety -= 1
            if ( !safety ) {
                throw 'Fell into an infinite loop while validating ' + dateObject.obj + '.'
            }*/


            // If we’ve looped into the next/prev month with a large interval, return to the original date and flatten the interval.
            if ( Math.abs( interval ) > 1 && ( dateObject.month < originalDateObject.month || dateObject.month > originalDateObject.month ) ) {
                dateObject = originalDateObject
                interval = interval > 0 ? 1 : -1
            }


            // If we’ve reached the min/max limit, reverse the direction, flatten the interval and set it to the limit.
            if ( dateObject.pick <= minLimitObject.pick ) {
                reachedMin = true
                interval = 1
                dateObject = calendar.create([
                    minLimitObject.year,
                    minLimitObject.month,
                    minLimitObject.date + (dateObject.pick === minLimitObject.pick ? 0 : -1)
                ])
            }
            else if ( dateObject.pick >= maxLimitObject.pick ) {
                reachedMax = true
                interval = -1
                dateObject = calendar.create([
                    maxLimitObject.year,
                    maxLimitObject.month,
                    maxLimitObject.date + (dateObject.pick === maxLimitObject.pick ? 0 : 1)
                ])
            }


            // If we’ve reached both limits, just break out of the loop.
            if ( reachedMin && reachedMax ) {
                break
            }


            // Finally, create the shifted date using the interval and keep looping.
            dateObject = calendar.create([ dateObject.year, dateObject.month, dateObject.date + interval ])
        }

    } //endif


    // Return the date object settled on.
    return dateObject
} //DatePicker.prototype.validate


/**
 * Check if a date is disabled.
 */
DatePicker.prototype.disabled = function( dateToVerify ) {

    var
        calendar = this,

        // Filter through the disabled dates to check if this is one.
        isDisabledMatch = calendar.item.disable.filter( function( dateToDisable ) {

            // If the date is a number, match the weekday with 0index and `firstDay` check.
            if ( _.isInteger( dateToDisable ) ) {
                return dateToVerify.day === ( calendar.settings.firstDay ? dateToDisable : dateToDisable - 1 ) % 7
            }

            // If it’s an array or a native JS date, create and match the exact date.
            if ( $.isArray( dateToDisable ) || _.isDate( dateToDisable ) ) {
                return dateToVerify.pick === calendar.create( dateToDisable ).pick
            }

            // If it’s an object, match a date within the “from” and “to” range.
            if ( $.isPlainObject( dateToDisable ) ) {
                return calendar.withinRange( dateToDisable, dateToVerify )
            }
        })

    // If this date matches a disabled date, confirm it’s not inverted.
    isDisabledMatch = isDisabledMatch.length && !isDisabledMatch.filter(function( dateToDisable ) {
        return $.isArray( dateToDisable ) && dateToDisable[3] == 'inverted' ||
            $.isPlainObject( dateToDisable ) && dateToDisable.inverted
    }).length

    // Check the calendar “enabled” flag and respectively flip the
    // disabled state. Then also check if it’s beyond the min/max limits.
    return calendar.item.enable === -1 ? !isDisabledMatch : isDisabledMatch ||
        dateToVerify.pick < calendar.item.min.pick ||
        dateToVerify.pick > calendar.item.max.pick

} //DatePicker.prototype.disabled


/**
 * Parse a string into a usable type.
 */
DatePicker.prototype.parse = function( type, value, options ) {

    var calendar = this,
        parsingObject = {}

    // If it’s already parsed, we’re good.
    if ( !value || typeof value != 'string' ) {
        return value
    }

    // We need a `.format` to parse the value with.
    if ( !( options && options.format ) ) {
        options = options || {}
        options.format = calendar.settings.format
    }

    // Convert the format into an array and then map through it.
    calendar.formats.toArray( options.format ).map( function( label ) {

        var
            // Grab the formatting label.
            formattingLabel = calendar.formats[ label ],

            // The format length is from the formatting label function or the
            // label length without the escaping exclamation (!) mark.
            formatLength = formattingLabel ? _.trigger( formattingLabel, calendar, [ value, parsingObject ] ) : label.replace( /^!/, '' ).length

        // If there's a format label, split the value up to the format length.
        // Then add it to the parsing object with appropriate label.
        if ( formattingLabel ) {
            parsingObject[ label ] = value.substr( 0, formatLength )
        }

        // Update the value as the substring from format length to end.
        value = value.substr( formatLength )
    })

    // Compensate for month 0index.
    return [
        parsingObject.yyyy || parsingObject.yy,
        +( parsingObject.mm || parsingObject.m ) - 1,
        parsingObject.dd || parsingObject.d
    ]
} //DatePicker.prototype.parse


/**
 * Various formats to display the object in.
 */
DatePicker.prototype.formats = (function() {

    // Return the length of the first word in a collection.
    function getWordLengthFromCollection( string, collection, dateObject ) {

        // Grab the first word from the string.
        var word = string.match( /\w+/ )[ 0 ]

        // If there's no month index, add it to the date object
        if ( !dateObject.mm && !dateObject.m ) {
            dateObject.m = collection.indexOf( word ) + 1
        }

        // Return the length of the word.
        return word.length
    }

    // Get the length of the first word in a string.
    function getFirstWordLength( string ) {
        return string.match( /\w+/ )[ 0 ].length
    }

    return {

        d: function( string, dateObject ) {

            // If there's string, then get the digits length.
            // Otherwise return the selected date.
            return string ? _.digits( string ) : dateObject.date
        },
        dd: function( string, dateObject ) {

            // If there's a string, then the length is always 2.
            // Otherwise return the selected date with a leading zero.
            return string ? 2 : _.lead( dateObject.date )
        },
        ddd: function( string, dateObject ) {

            // If there's a string, then get the length of the first word.
            // Otherwise return the short selected weekday.
            return string ? getFirstWordLength( string ) : this.settings.weekdaysShort[ dateObject.day ]
        },
        dddd: function( string, dateObject ) {

            // If there's a string, then get the length of the first word.
            // Otherwise return the full selected weekday.
            return string ? getFirstWordLength( string ) : this.settings.weekdaysFull[ dateObject.day ]
        },
        m: function( string, dateObject ) {

            // If there's a string, then get the length of the digits
            // Otherwise return the selected month with 0index compensation.
            return string ? _.digits( string ) : dateObject.month + 1
        },
        mm: function( string, dateObject ) {

            // If there's a string, then the length is always 2.
            // Otherwise return the selected month with 0index and leading zero.
            return string ? 2 : _.lead( dateObject.month + 1 )
        },
        mmm: function( string, dateObject ) {

            var collection = this.settings.monthsShort

            // If there's a string, get length of the relevant month from the short
            // months collection. Otherwise return the selected month from that collection.
            return string ? getWordLengthFromCollection( string, collection, dateObject ) : collection[ dateObject.month ]
        },
        mmmm: function( string, dateObject ) {

            var collection = this.settings.monthsFull

            // If there's a string, get length of the relevant month from the full
            // months collection. Otherwise return the selected month from that collection.
            return string ? getWordLengthFromCollection( string, collection, dateObject ) : collection[ dateObject.month ]
        },
        yy: function( string, dateObject ) {

            // If there's a string, then the length is always 2.
            // Otherwise return the selected year by slicing out the first 2 digits.
            return string ? 2 : ( '' + dateObject.year ).slice( 2 )
        },
        yyyy: function( string, dateObject ) {

            // If there's a string, then the length is always 4.
            // Otherwise return the selected year.
            return string ? 4 : dateObject.year
        },

        // Create an array by splitting the formatting string passed.
        toArray: function( formatString ) { return formatString.split( /(d{1,4}|m{1,4}|y{4}|yy|!.)/g ) },

        // Format an object into a string using the formatting options.
        toString: function ( formatString, itemObject ) {
            var calendar = this
            return calendar.formats.toArray( formatString ).map( function( label ) {
                return _.trigger( calendar.formats[ label ], calendar, [ 0, itemObject ] ) || label.replace( /^!/, '' )
            }).join( '' )
        }
    }
})() //DatePicker.prototype.formats




/**
 * Check if two date units are the exact.
 */
DatePicker.prototype.isDateExact = function( one, two ) {

    var calendar = this

    // When we’re working with weekdays, do a direct comparison.
    if (
        ( _.isInteger( one ) && _.isInteger( two ) ) ||
        ( typeof one == 'boolean' && typeof two == 'boolean' )
     ) {
        return one === two
    }

    // When we’re working with date representations, compare the “pick” value.
    if (
        ( _.isDate( one ) || $.isArray( one ) ) &&
        ( _.isDate( two ) || $.isArray( two ) )
    ) {
        return calendar.create( one ).pick === calendar.create( two ).pick
    }

    // When we’re working with range objects, compare the “from” and “to”.
    if ( $.isPlainObject( one ) && $.isPlainObject( two ) ) {
        return calendar.isDateExact( one.from, two.from ) && calendar.isDateExact( one.to, two.to )
    }

    return false
}


/**
 * Check if two date units overlap.
 */
DatePicker.prototype.isDateOverlap = function( one, two ) {

    var calendar = this

    // When we’re working with a weekday index, compare the days.
    if ( _.isInteger( one ) && ( _.isDate( two ) || $.isArray( two ) ) ) {
        return one === calendar.create( two ).day + 1
    }
    if ( _.isInteger( two ) && ( _.isDate( one ) || $.isArray( one ) ) ) {
        return two === calendar.create( one ).day + 1
    }

    // When we’re working with range objects, check if the ranges overlap.
    if ( $.isPlainObject( one ) && $.isPlainObject( two ) ) {
        return calendar.overlapRanges( one, two )
    }

    return false
}


/**
 * Flip the “enabled” state.
 */
DatePicker.prototype.flipEnable = function(val) {
    var itemObject = this.item
    itemObject.enable = val || (itemObject.enable == -1 ? 1 : -1)
}


/**
 * Mark a collection of dates as “disabled”.
 */
DatePicker.prototype.deactivate = function( type, datesToDisable ) {

    var calendar = this,
        disabledItems = calendar.item.disable.slice(0)


    // If we’re flipping, that’s all we need to do.
    if ( datesToDisable == 'flip' ) {
        calendar.flipEnable()
    }

    else if ( datesToDisable === false ) {
        calendar.flipEnable(1)
        disabledItems = []
    }

    else if ( datesToDisable === true ) {
        calendar.flipEnable(-1)
        disabledItems = []
    }

    // Otherwise go through the dates to disable.
    else {

        datesToDisable.map(function( unitToDisable ) {

            var matchFound

            // When we have disabled items, check for matches.
            // If something is matched, immediately break out.
            for ( var index = 0; index < disabledItems.length; index += 1 ) {
                if ( calendar.isDateExact( unitToDisable, disabledItems[index] ) ) {
                    matchFound = true
                    break
                }
            }

            // If nothing was found, add the validated unit to the collection.
            if ( !matchFound ) {
                if (
                    _.isInteger( unitToDisable ) ||
                    _.isDate( unitToDisable ) ||
                    $.isArray( unitToDisable ) ||
                    ( $.isPlainObject( unitToDisable ) && unitToDisable.from && unitToDisable.to )
                ) {
                    disabledItems.push( unitToDisable )
                }
            }
        })
    }

    // Return the updated collection.
    return disabledItems
} //DatePicker.prototype.deactivate


/**
 * Mark a collection of dates as “enabled”.
 */
DatePicker.prototype.activate = function( type, datesToEnable ) {

    var calendar = this,
        disabledItems = calendar.item.disable,
        disabledItemsCount = disabledItems.length

    // If we’re flipping, that’s all we need to do.
    if ( datesToEnable == 'flip' ) {
        calendar.flipEnable()
    }

    else if ( datesToEnable === true ) {
        calendar.flipEnable(1)
        disabledItems = []
    }

    else if ( datesToEnable === false ) {
        calendar.flipEnable(-1)
        disabledItems = []
    }

    // Otherwise go through the disabled dates.
    else {

        datesToEnable.map(function( unitToEnable ) {

            var matchFound,
                disabledUnit,
                index,
                isExactRange

            // Go through the disabled items and try to find a match.
            for ( index = 0; index < disabledItemsCount; index += 1 ) {

                disabledUnit = disabledItems[index]

                // When an exact match is found, remove it from the collection.
                if ( calendar.isDateExact( disabledUnit, unitToEnable ) ) {
                    matchFound = disabledItems[index] = null
                    isExactRange = true
                    break
                }

                // When an overlapped match is found, add the “inverted” state to it.
                else if ( calendar.isDateOverlap( disabledUnit, unitToEnable ) ) {
                    if ( $.isPlainObject( unitToEnable ) ) {
                        unitToEnable.inverted = true
                        matchFound = unitToEnable
                    }
                    else if ( $.isArray( unitToEnable ) ) {
                        matchFound = unitToEnable
                        if ( !matchFound[3] ) matchFound.push( 'inverted' )
                    }
                    else if ( _.isDate( unitToEnable ) ) {
                        matchFound = [ unitToEnable.getFullYear(), unitToEnable.getMonth(), unitToEnable.getDate(), 'inverted' ]
                    }
                    break
                }
            }

            // If a match was found, remove a previous duplicate entry.
            if ( matchFound ) for ( index = 0; index < disabledItemsCount; index += 1 ) {
                if ( calendar.isDateExact( disabledItems[index], unitToEnable ) ) {
                    disabledItems[index] = null
                    break
                }
            }

            // In the event that we’re dealing with an exact range of dates,
            // make sure there are no “inverted” dates because of it.
            if ( isExactRange ) for ( index = 0; index < disabledItemsCount; index += 1 ) {
                if ( calendar.isDateOverlap( disabledItems[index], unitToEnable ) ) {
                    disabledItems[index] = null
                    break
                }
            }

            // If something is still matched, add it into the collection.
            if ( matchFound ) {
                disabledItems.push( matchFound )
            }
        })
    }

    // Return the updated collection.
    return disabledItems.filter(function( val ) { return val != null })
} //DatePicker.prototype.activate


/**
 * Create a string for the nodes in the picker.
 */
DatePicker.prototype.nodes = function( isOpen ) {

    var
        calendar = this,
        settings = calendar.settings,
        calendarItem = calendar.item,
        nowObject = calendarItem.now,
        selectedObject = calendarItem.select,
        highlightedObject = calendarItem.highlight,
        viewsetObject = calendarItem.view,
        disabledCollection = calendarItem.disable,
        minLimitObject = calendarItem.min,
        maxLimitObject = calendarItem.max,


        // Create the calendar table head using a copy of weekday labels collection.
        // * We do a copy so we don't mutate the original array.
        tableHead = (function( collection, fullCollection ) {

            // If the first day should be Monday, move Sunday to the end.
            if ( settings.firstDay ) {
                collection.push( collection.shift() )
                fullCollection.push( fullCollection.shift() )
            }

            // Create and return the table head group.
            return _.node(
                'thead',
                _.node(
                    'tr',
                    _.group({
                        min: 0,
                        max: DAYS_IN_WEEK - 1,
                        i: 1,
                        node: 'th',
                        item: function( counter ) {
                            return [
                                collection[ counter ],
                                settings.klass.weekdays,
                                'scope=col title="' + fullCollection[ counter ] + '"'
                            ]
                        }
                    })
                )
            ) //endreturn
        })( ( settings.showWeekdaysFull ? settings.weekdaysFull : settings.weekdaysShort ).slice( 0 ), settings.weekdaysFull.slice( 0 ) ), //tableHead


        // Create the nav for next/prev month.
        createMonthNav = function( next ) {

            // Otherwise, return the created month tag.
            return _.node(
                'div',
                ' ',
                settings.klass[ 'nav' + ( next ? 'Next' : 'Prev' ) ] + (

                    // If the focused month is outside the range, disabled the button.
                    ( next && viewsetObject.year >= maxLimitObject.year && viewsetObject.month >= maxLimitObject.month ) ||
                    ( !next && viewsetObject.year <= minLimitObject.year && viewsetObject.month <= minLimitObject.month ) ?
                    ' ' + settings.klass.navDisabled : ''
                ),
                'data-nav=' + ( next || -1 ) + ' ' +
                _.ariaAttr({
                    role: 'button',
                    controls: calendar.$node[0].id + '_table'
                }) + ' ' +
                'title="' + (next ? settings.labelMonthNext : settings.labelMonthPrev ) + '"'
            ) //endreturn
        }, //createMonthNav


        // Create the month label.
        createMonthLabel = function() {

            var monthsCollection = settings.showMonthsShort ? settings.monthsShort : settings.monthsFull

            // If there are months to select, add a dropdown menu.
            if ( settings.selectMonths ) {

                return _.node( 'select',
                    _.group({
                        min: 0,
                        max: 11,
                        i: 1,
                        node: 'option',
                        item: function( loopedMonth ) {

                            return [

                                // The looped month and no classes.
                                monthsCollection[ loopedMonth ], 0,

                                // Set the value and selected index.
                                'value=' + loopedMonth +
                                ( viewsetObject.month == loopedMonth ? ' selected' : '' ) +
                                (
                                    (
                                        ( viewsetObject.year == minLimitObject.year && loopedMonth < minLimitObject.month ) ||
                                        ( viewsetObject.year == maxLimitObject.year && loopedMonth > maxLimitObject.month )
                                    ) ?
                                    ' disabled' : ''
                                )
                            ]
                        }
                    }),
                    settings.klass.selectMonth,
                    ( isOpen ? '' : 'disabled' ) + ' ' +
                    _.ariaAttr({ controls: calendar.$node[0].id + '_table' }) + ' ' +
                    'title="' + settings.labelMonthSelect + '"'
                )
            }

            // If there's a need for a month selector
            return _.node( 'div', monthsCollection[ viewsetObject.month ], settings.klass.month )
        }, //createMonthLabel


        // Create the year label.
        createYearLabel = function() {

            var focusedYear = viewsetObject.year,

            // If years selector is set to a literal "true", set it to 5. Otherwise
            // divide in half to get half before and half after focused year.
            numberYears = settings.selectYears === true ? 5 : ~~( settings.selectYears / 2 )

            // If there are years to select, add a dropdown menu.
            if ( numberYears ) {

                var
                    minYear = minLimitObject.year,
                    maxYear = maxLimitObject.year,
                    lowestYear = focusedYear - numberYears,
                    highestYear = focusedYear + numberYears

                // If the min year is greater than the lowest year, increase the highest year
                // by the difference and set the lowest year to the min year.
                if ( minYear > lowestYear ) {
                    highestYear += minYear - lowestYear
                    lowestYear = minYear
                }

                // If the max year is less than the highest year, decrease the lowest year
                // by the lower of the two: available and needed years. Then set the
                // highest year to the max year.
                if ( maxYear < highestYear ) {

                    var availableYears = lowestYear - minYear,
                        neededYears = highestYear - maxYear

                    lowestYear -= availableYears > neededYears ? neededYears : availableYears
                    highestYear = maxYear
                }

                return _.node( 'select',
                    _.group({
                        min: lowestYear,
                        max: highestYear,
                        i: 1,
                        node: 'option',
                        item: function( loopedYear ) {
                            return [

                                // The looped year and no classes.
                                loopedYear, 0,

                                // Set the value and selected index.
                                'value=' + loopedYear + ( focusedYear == loopedYear ? ' selected' : '' )
                            ]
                        }
                    }),
                    settings.klass.selectYear,
                    ( isOpen ? '' : 'disabled' ) + ' ' + _.ariaAttr({ controls: calendar.$node[0].id + '_table' }) + ' ' +
                    'title="' + settings.labelYearSelect + '"'
                )
            }

            // Otherwise just return the year focused
            return _.node( 'div', focusedYear, settings.klass.year )
        } //createYearLabel


    // Create and return the entire calendar.
    return _.node(
        'div',
        ( settings.selectYears ? createYearLabel() + createMonthLabel() : createMonthLabel() + createYearLabel() ) +
        createMonthNav() + createMonthNav( 1 ),
        settings.klass.header
    ) + _.node(
        'table',
        tableHead +
        _.node(
            'tbody',
            _.group({
                min: 0,
                max: WEEKS_IN_CALENDAR - 1,
                i: 1,
                node: 'tr',
                item: function( rowCounter ) {

                    // If Monday is the first day and the month starts on Sunday, shift the date back a week.
                    var shiftDateBy = settings.firstDay && calendar.create([ viewsetObject.year, viewsetObject.month, 1 ]).day === 0 ? -7 : 0

                    return [
                        _.group({
                            min: DAYS_IN_WEEK * rowCounter - viewsetObject.day + shiftDateBy + 1, // Add 1 for weekday 0index
                            max: function() {
                                return this.min + DAYS_IN_WEEK - 1
                            },
                            i: 1,
                            node: 'td',
                            item: function( targetDate ) {

                                // Convert the time date from a relative date to a target date.
                                targetDate = calendar.create([ viewsetObject.year, viewsetObject.month, targetDate + ( settings.firstDay ? 1 : 0 ) ])

                                var isSelected = selectedObject && selectedObject.pick == targetDate.pick,
                                    isHighlighted = highlightedObject && highlightedObject.pick == targetDate.pick,
                                    isDisabled = disabledCollection && calendar.disabled( targetDate ) || targetDate.pick < minLimitObject.pick || targetDate.pick > maxLimitObject.pick

                                return [
                                    _.node(
                                        'div',
                                        targetDate.date,
                                        (function( klasses ) {

                                            // Add the `infocus` or `outfocus` classes based on month in view.
                                            klasses.push( viewsetObject.month == targetDate.month ? settings.klass.infocus : settings.klass.outfocus )

                                            // Add the `today` class if needed.
                                            if ( nowObject.pick == targetDate.pick ) {
                                                klasses.push( settings.klass.now )
                                            }

                                            // Add the `selected` class if something's selected and the time matches.
                                            if ( isSelected ) {
                                                klasses.push( settings.klass.selected )
                                            }

                                            // Add the `highlighted` class if something's highlighted and the time matches.
                                            if ( isHighlighted ) {
                                                klasses.push( settings.klass.highlighted )
                                            }

                                            // Add the `disabled` class if something's disabled and the object matches.
                                            if ( isDisabled ) {
                                                klasses.push( settings.klass.disabled )
                                            }

                                            return klasses.join( ' ' )
                                        })([ settings.klass.day ]),
                                        'data-pick=' + targetDate.pick + ' ' + _.ariaAttr({
                                            role: 'gridcell',
                                            selected: isSelected && calendar.$node.val() === _.trigger(
                                                    calendar.formats.toString,
                                                    calendar,
                                                    [ settings.format, targetDate ]
                                                ) ? true : null,
                                            activedescendant: isHighlighted ? true : null,
                                            disabled: isDisabled ? true : null
                                        })
                                    ),
                                    '',
                                    _.ariaAttr({ role: 'presentation' })
                                ] //endreturn
                            }
                        })
                    ] //endreturn
                }
            })
        ),
        settings.klass.table,
        'id="' + calendar.$node[0].id + '_table' + '" ' + _.ariaAttr({
            role: 'grid',
            controls: calendar.$node[0].id,
            readonly: true
        })
    ) +

    // * For Firefox forms to submit, make sure to set the buttons’ `type` attributes as “button”.
    _.node(
        'div',
        _.node( 'button', settings.today, settings.klass.buttonToday,
            'type=button data-pick=' + nowObject.pick +
            ( isOpen ? '' : ' disabled' ) + ' ' +
            _.ariaAttr({ controls: calendar.$node[0].id }) ) +
        _.node( 'button', settings.clear, settings.klass.buttonClear,
            'type=button data-clear=1' +
            ( isOpen ? '' : ' disabled' ) + ' ' +
            _.ariaAttr({ controls: calendar.$node[0].id }) ),
        settings.klass.footer
    ) //endreturn
} //DatePicker.prototype.nodes




/**
 * The date picker defaults.
 */
DatePicker.defaults = (function( prefix ) {

    return {

        // The title label to use for the month nav buttons
        labelMonthNext: 'Next month',
        labelMonthPrev: 'Previous month',

        // The title label to use for the dropdown selectors
        labelMonthSelect: 'Select a month',
        labelYearSelect: 'Select a year',

        // Months and weekdays
        monthsFull: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
        monthsShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
        weekdaysFull: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
        weekdaysShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ],

        // Today and clear
        today: 'Today',
        clear: 'Clear',

        // The format to show on the `input` element
        format: 'd mmmm, yyyy',

        // Classes
        klass: {

            table: prefix + 'table',

            header: prefix + 'header',

            navPrev: prefix + 'nav--prev',
            navNext: prefix + 'nav--next',
            navDisabled: prefix + 'nav--disabled',

            month: prefix + 'month',
            year: prefix + 'year',

            selectMonth: prefix + 'select--month',
            selectYear: prefix + 'select--year',

            weekdays: prefix + 'weekday',

            day: prefix + 'day',
            disabled: prefix + 'day--disabled',
            selected: prefix + 'day--selected',
            highlighted: prefix + 'day--highlighted',
            now: prefix + 'day--today',
            infocus: prefix + 'day--infocus',
            outfocus: prefix + 'day--outfocus',

            footer: prefix + 'footer',

            buttonClear: prefix + 'button--clear',
            buttonToday: prefix + 'button--today'
        }
    }
})( Picker.klasses().picker + '__' )





/**
 * Extend the picker to add the date picker.
 */
Picker.extend( 'pickadate', DatePicker )


}));






/*!
 * Time picker for pickadate.js v3.5.0
 * http://amsul.github.io/pickadate.js/time.htm
 */

(function ( factory ) {

    // Register as an anonymous module.
    if ( typeof define == 'function' && define.amd )
        define( ['picker','jquery'], factory )

    // Or using browser globals.
    else factory( Picker, jQuery )

}(function( Picker, $ ) {


/**
 * Globals and constants
 */
var HOURS_IN_DAY = 24,
    MINUTES_IN_HOUR = 60,
    HOURS_TO_NOON = 12,
    MINUTES_IN_DAY = HOURS_IN_DAY * MINUTES_IN_HOUR,
    _ = Picker._



/**
 * The time picker constructor
 */
function TimePicker( picker, settings ) {

    var clock = this,
        elementValue = picker.$node[ 0 ].value,
        elementDataValue = picker.$node.data( 'value' ),
        valueString = elementDataValue || elementValue,
        formatString = elementDataValue ? settings.formatSubmit : settings.format

    clock.settings = settings
    clock.$node = picker.$node

    // The queue of methods that will be used to build item objects.
    clock.queue = {
        interval: 'i',
        min: 'measure create',
        max: 'measure create',
        now: 'now create',
        select: 'parse create validate',
        highlight: 'parse create validate',
        view: 'parse create validate',
        disable: 'deactivate',
        enable: 'activate'
    }

    // The component's item object.
    clock.item = {}

    clock.item.clear = null
    clock.item.interval = settings.interval || 30
    clock.item.disable = ( settings.disable || [] ).slice( 0 )
    clock.item.enable = -(function( collectionDisabled ) {
        return collectionDisabled[ 0 ] === true ? collectionDisabled.shift() : -1
    })( clock.item.disable )

    clock.
        set( 'min', settings.min ).
        set( 'max', settings.max ).
        set( 'now' )

    // When there’s a value, set the `select`, which in turn
    // also sets the `highlight` and `view`.
    if ( valueString ) {
        clock.set( 'select', valueString, {
            format: formatString,
            fromValue: !!elementValue
        })
    }

    // If there’s no value, default to highlighting “today”.
    else {
        clock.
            set( 'select', null ).
            set( 'highlight', clock.item.now )
    }

    // The keycode to movement mapping.
    clock.key = {
        40: 1, // Down
        38: -1, // Up
        39: 1, // Right
        37: -1, // Left
        go: function( timeChange ) {
            clock.set(
                'highlight',
                clock.item.highlight.pick + timeChange * clock.item.interval,
                { interval: timeChange * clock.item.interval }
            )
            this.render()
        }
    }


    // Bind some picker events.
    picker.
        on( 'render', function() {
            var $pickerHolder = picker.$root.children(),
                $viewset = $pickerHolder.find( '.' + settings.klass.viewset )
            if ( $viewset.length ) {
                $pickerHolder[ 0 ].scrollTop = ~~$viewset.position().top - ( $viewset[ 0 ].clientHeight * 2 )
            }
        }).
        on( 'open', function() {
            picker.$root.find( 'button' ).attr( 'disabled', false )
        }).
        on( 'close', function() {
            picker.$root.find( 'button' ).attr( 'disabled', true )
        })

} //TimePicker


/**
 * Set a timepicker item object.
 */
TimePicker.prototype.set = function( type, value, options ) {

    var clock = this,
        clockItem = clock.item

    // If the value is `null` just set it immediately.
    if ( value === null ) {
        if ( type == 'clear' ) type = 'select'
        clockItem[ type ] = value
        return clock
    }

    // Otherwise go through the queue of methods, and invoke the functions.
    // Update this as the time unit, and set the final value as this item.
    // * In the case of `enable`, keep the queue but set `disable` instead.
    //   And in the case of `flip`, keep the queue but set `enable` instead.
    clockItem[ ( type == 'enable' ? 'disable' : type == 'flip' ? 'enable' : type ) ] = clock.queue[ type ].split( ' ' ).map( function( method ) {
        value = clock[ method ]( type, value, options )
        return value
    }).pop()

    // Check if we need to cascade through more updates.
    if ( type == 'select' ) {
        clock.set( 'highlight', clockItem.select, options )
    }
    else if ( type == 'highlight' ) {
        clock.set( 'view', clockItem.highlight, options )
    }
    else if ( type == 'interval' ) {
        clock.
            set( 'min', clockItem.min, options ).
            set( 'max', clockItem.max, options )
    }
    else if ( type.match( /^(flip|min|max|disable|enable)$/ ) ) {
        if ( type == 'min' ) {
            clock.set( 'max', clockItem.max, options )
        }
        if ( clockItem.select && clock.disabled( clockItem.select ) ) {
            clock.set( 'select', clockItem.select, options )
        }
        if ( clockItem.highlight && clock.disabled( clockItem.highlight ) ) {
            clock.set( 'highlight', clockItem.highlight, options )
        }
    }

    return clock
} //TimePicker.prototype.set


/**
 * Get a timepicker item object.
 */
TimePicker.prototype.get = function( type ) {
    return this.item[ type ]
} //TimePicker.prototype.get


/**
 * Create a picker time object.
 */
TimePicker.prototype.create = function( type, value, options ) {

    var clock = this

    // If there’s no value, use the type as the value.
    value = value === undefined ? type : value

    // If it’s a date object, convert it into an array.
    if ( _.isDate( value ) ) {
        value = [ value.getHours(), value.getMinutes() ]
    }

    // If it’s an object, use the “pick” value.
    if ( $.isPlainObject( value ) && _.isInteger( value.pick ) ) {
        value = value.pick
    }

    // If it’s an array, convert it into minutes.
    else if ( $.isArray( value ) ) {
        value = +value[ 0 ] * MINUTES_IN_HOUR + (+value[ 1 ])
    }

    // If no valid value is passed, set it to “now”.
    else if ( !_.isInteger( value ) ) {
        value = clock.now( type, value, options )
    }

    // If we’re setting the max, make sure it’s greater than the min.
    if ( type == 'max' && value < clock.item.min.pick ) {
        value += MINUTES_IN_DAY
    }

    // If the value doesn’t fall directly on the interval,
    // add one interval to indicate it as “passed”.
    if ( type != 'min' && type != 'max' && (value - clock.item.min.pick) % clock.item.interval !== 0 ) {
        value += clock.item.interval
    }

    // Normalize it into a “reachable” interval.
    value = clock.normalize( type, value, options )

    // Return the compiled object.
    return {

        // Divide to get hours from minutes.
        hour: ~~( HOURS_IN_DAY + value / MINUTES_IN_HOUR ) % HOURS_IN_DAY,

        // The remainder is the minutes.
        mins: ( MINUTES_IN_HOUR + value % MINUTES_IN_HOUR ) % MINUTES_IN_HOUR,

        // The time in total minutes.
        time: ( MINUTES_IN_DAY + value ) % MINUTES_IN_DAY,

        // Reference to the “relative” value to pick.
        pick: value
    }
} //TimePicker.prototype.create


/**
 * Create a range limit object using an array, date object,
 * literal “true”, or integer relative to another time.
 */
TimePicker.prototype.createRange = function( from, to ) {

    var clock = this,
        createTime = function( time ) {
            if ( time === true || $.isArray( time ) || _.isDate( time ) ) {
                return clock.create( time )
            }
            return time
        }

    // Create objects if possible.
    if ( !_.isInteger( from ) ) {
        from = createTime( from )
    }
    if ( !_.isInteger( to ) ) {
        to = createTime( to )
    }

    // Create relative times.
    if ( _.isInteger( from ) && $.isPlainObject( to ) ) {
        from = [ to.hour, to.mins + ( from * clock.settings.interval ) ];
    }
    else if ( _.isInteger( to ) && $.isPlainObject( from ) ) {
        to = [ from.hour, from.mins + ( to * clock.settings.interval ) ];
    }

    return {
        from: createTime( from ),
        to: createTime( to )
    }
} //TimePicker.prototype.createRange


/**
 * Check if a time unit falls within a time range object.
 */
TimePicker.prototype.withinRange = function( range, timeUnit ) {
    range = this.createRange(range.from, range.to)
    return timeUnit.pick >= range.from.pick && timeUnit.pick <= range.to.pick
}


/**
 * Check if two time range objects overlap.
 */
TimePicker.prototype.overlapRanges = function( one, two ) {

    var clock = this

    // Convert the ranges into comparable times.
    one = clock.createRange( one.from, one.to )
    two = clock.createRange( two.from, two.to )

    return clock.withinRange( one, two.from ) || clock.withinRange( one, two.to ) ||
        clock.withinRange( two, one.from ) || clock.withinRange( two, one.to )
}


/**
 * Get the time relative to now.
 */
TimePicker.prototype.now = function( type, value/*, options*/ ) {

    var interval = this.item.interval,
        date = new Date(),
        nowMinutes = date.getHours() * MINUTES_IN_HOUR + date.getMinutes(),
        isValueInteger = _.isInteger( value ),
        isBelowInterval

    // Make sure “now” falls within the interval range.
    nowMinutes -= nowMinutes % interval

    // Check if the difference is less than the interval itself.
    isBelowInterval = value < 0 && interval * value + nowMinutes <= -interval

    // Add an interval because the time has “passed”.
    nowMinutes += type == 'min' && isBelowInterval ? 0 : interval

    // If the value is a number, adjust by that many intervals.
    if ( isValueInteger ) {
        nowMinutes += interval * (
            isBelowInterval && type != 'max' ?
                value + 1 :
                value
            )
    }

    // Return the final calculation.
    return nowMinutes
} //TimePicker.prototype.now


/**
 * Normalize minutes to be “reachable” based on the min and interval.
 */
TimePicker.prototype.normalize = function( type, value/*, options*/ ) {

    var interval = this.item.interval,
        minTime = this.item.min && this.item.min.pick || 0

    // If setting min time, don’t shift anything.
    // Otherwise get the value and min difference and then
    // normalize the difference with the interval.
    value -= type == 'min' ? 0 : ( value - minTime ) % interval

    // Return the adjusted value.
    return value
} //TimePicker.prototype.normalize


/**
 * Measure the range of minutes.
 */
TimePicker.prototype.measure = function( type, value, options ) {

    var clock = this

    // If it’s anything false-y, set it to the default.
    if ( !value ) {
        value = type == 'min' ? [ 0, 0 ] : [ HOURS_IN_DAY - 1, MINUTES_IN_HOUR - 1 ]
    }

    // If it’s a literal true, or an integer, make it relative to now.
    else if ( value === true || _.isInteger( value ) ) {
        value = clock.now( type, value, options )
    }

    // If it’s an object already, just normalize it.
    else if ( $.isPlainObject( value ) && _.isInteger( value.pick ) ) {
        value = clock.normalize( type, value.pick, options )
    }

    return value
} ///TimePicker.prototype.measure


/**
 * Validate an object as enabled.
 */
TimePicker.prototype.validate = function( type, timeObject, options ) {

    var clock = this,
        interval = options && options.interval ? options.interval : clock.item.interval

    // Check if the object is disabled.
    if ( clock.disabled( timeObject ) ) {

        // Shift with the interval until we reach an enabled time.
        timeObject = clock.shift( timeObject, interval )
    }

    // Scope the object into range.
    timeObject = clock.scope( timeObject )

    // Do a second check to see if we landed on a disabled min/max.
    // In that case, shift using the opposite interval as before.
    if ( clock.disabled( timeObject ) ) {
        timeObject = clock.shift( timeObject, interval * -1 )
    }

    // Return the final object.
    return timeObject
} //TimePicker.prototype.validate


/**
 * Check if an object is disabled.
 */
TimePicker.prototype.disabled = function( timeToVerify ) {

    var clock = this,

        // Filter through the disabled times to check if this is one.
        isDisabledMatch = clock.item.disable.filter( function( timeToDisable ) {

            // If the time is a number, match the hours.
            if ( _.isInteger( timeToDisable ) ) {
                return timeToVerify.hour == timeToDisable
            }

            // If it’s an array, create the object and match the times.
            if ( $.isArray( timeToDisable ) || _.isDate( timeToDisable ) ) {
                return timeToVerify.pick == clock.create( timeToDisable ).pick
            }

            // If it’s an object, match a time within the “from” and “to” range.
            if ( $.isPlainObject( timeToDisable ) ) {
                return clock.withinRange( timeToDisable, timeToVerify )
            }
        })

    // If this time matches a disabled time, confirm it’s not inverted.
    isDisabledMatch = isDisabledMatch.length && !isDisabledMatch.filter(function( timeToDisable ) {
        return $.isArray( timeToDisable ) && timeToDisable[2] == 'inverted' ||
            $.isPlainObject( timeToDisable ) && timeToDisable.inverted
    }).length

    // If the clock is "enabled" flag is flipped, flip the condition.
    return clock.item.enable === -1 ? !isDisabledMatch : isDisabledMatch ||
        timeToVerify.pick < clock.item.min.pick ||
        timeToVerify.pick > clock.item.max.pick
} //TimePicker.prototype.disabled


/**
 * Shift an object by an interval until we reach an enabled object.
 */
TimePicker.prototype.shift = function( timeObject, interval ) {

    var clock = this,
        minLimit = clock.item.min.pick,
        maxLimit = clock.item.max.pick/*,
        safety = 1000*/

    interval = interval || clock.item.interval

    // Keep looping as long as the time is disabled.
    while ( /*safety &&*/ clock.disabled( timeObject ) ) {

        /*safety -= 1
        if ( !safety ) {
            throw 'Fell into an infinite loop while shifting to ' + timeObject.hour + ':' + timeObject.mins + '.'
        }*/

        // Increase/decrease the time by the interval and keep looping.
        timeObject = clock.create( timeObject.pick += interval )

        // If we've looped beyond the limits, break out of the loop.
        if ( timeObject.pick <= minLimit || timeObject.pick >= maxLimit ) {
            break
        }
    }

    // Return the final object.
    return timeObject
} //TimePicker.prototype.shift


/**
 * Scope an object to be within range of min and max.
 */
TimePicker.prototype.scope = function( timeObject ) {
    var minLimit = this.item.min.pick,
        maxLimit = this.item.max.pick
    return this.create( timeObject.pick > maxLimit ? maxLimit : timeObject.pick < minLimit ? minLimit : timeObject )
} //TimePicker.prototype.scope


/**
 * Parse a string into a usable type.
 */
TimePicker.prototype.parse = function( type, value, options ) {

    var hour, minutes, isPM, item, parseValue,
        clock = this,
        parsingObject = {}

    // If it’s already parsed, we’re good.
    if ( !value || typeof value != 'string' ) {
        return value
    }

    // We need a `.format` to parse the value with.
    if ( !( options && options.format ) ) {
        options = options || {}
        options.format = clock.settings.format
    }

    // Convert the format into an array and then map through it.
    clock.formats.toArray( options.format ).map( function( label ) {

        var
            substring,

            // Grab the formatting label.
            formattingLabel = clock.formats[ label ],

            // The format length is from the formatting label function or the
            // label length without the escaping exclamation (!) mark.
            formatLength = formattingLabel ?
                _.trigger( formattingLabel, clock, [ value, parsingObject ] ) :
                label.replace( /^!/, '' ).length

        // If there's a format label, split the value up to the format length.
        // Then add it to the parsing object with appropriate label.
        if ( formattingLabel ) {
            substring = value.substr( 0, formatLength )
            parsingObject[ label ] = substring.match(/^\d+$/) ? +substring : substring
        }

        // Update the time value as the substring from format length to end.
        value = value.substr( formatLength )
    })

    // Grab the hour and minutes from the parsing object.
    for ( item in parsingObject ) {
        parseValue = parsingObject[item]
        if ( _.isInteger(parseValue) ) {
            if ( item.match(/^(h|hh)$/i) ) {
                hour = parseValue
                if ( item == 'h' || item == 'hh' ) {
                    hour %= 12
                }
            }
            else if ( item == 'i' ) {
                minutes = parseValue
            }
        }
        else if ( item.match(/^a$/i) && parseValue.match(/^p/i) && ('h' in parsingObject || 'hh' in parsingObject) ) {
            isPM = true
        }
    }

    // Calculate it in minutes and return.
    return (isPM ? hour + 12 : hour) * MINUTES_IN_HOUR + minutes
} //TimePicker.prototype.parse


/**
 * Various formats to display the object in.
 */
TimePicker.prototype.formats = {

    h: function( string, timeObject ) {

        // If there's string, then get the digits length.
        // Otherwise return the selected hour in "standard" format.
        return string ? _.digits( string ) : timeObject.hour % HOURS_TO_NOON || HOURS_TO_NOON
    },
    hh: function( string, timeObject ) {

        // If there's a string, then the length is always 2.
        // Otherwise return the selected hour in "standard" format with a leading zero.
        return string ? 2 : _.lead( timeObject.hour % HOURS_TO_NOON || HOURS_TO_NOON )
    },
    H: function( string, timeObject ) {

        // If there's string, then get the digits length.
        // Otherwise return the selected hour in "military" format as a string.
        return string ? _.digits( string ) : '' + ( timeObject.hour % 24 )
    },
    HH: function( string, timeObject ) {

        // If there's string, then get the digits length.
        // Otherwise return the selected hour in "military" format with a leading zero.
        return string ? _.digits( string ) : _.lead( timeObject.hour % 24 )
    },
    i: function( string, timeObject ) {

        // If there's a string, then the length is always 2.
        // Otherwise return the selected minutes.
        return string ? 2 : _.lead( timeObject.mins )
    },
    a: function( string, timeObject ) {

        // If there's a string, then the length is always 4.
        // Otherwise check if it's more than "noon" and return either am/pm.
        return string ? 4 : MINUTES_IN_DAY / 2 > timeObject.time % MINUTES_IN_DAY ? 'a.m.' : 'p.m.'
    },
    A: function( string, timeObject ) {

        // If there's a string, then the length is always 2.
        // Otherwise check if it's more than "noon" and return either am/pm.
        return string ? 2 : MINUTES_IN_DAY / 2 > timeObject.time % MINUTES_IN_DAY ? 'AM' : 'PM'
    },

    // Create an array by splitting the formatting string passed.
    toArray: function( formatString ) { return formatString.split( /(h{1,2}|H{1,2}|i|a|A|!.)/g ) },

    // Format an object into a string using the formatting options.
    toString: function ( formatString, itemObject ) {
        var clock = this
        return clock.formats.toArray( formatString ).map( function( label ) {
            return _.trigger( clock.formats[ label ], clock, [ 0, itemObject ] ) || label.replace( /^!/, '' )
        }).join( '' )
    }
} //TimePicker.prototype.formats




/**
 * Check if two time units are the exact.
 */
TimePicker.prototype.isTimeExact = function( one, two ) {

    var clock = this

    // When we’re working with minutes, do a direct comparison.
    if (
        ( _.isInteger( one ) && _.isInteger( two ) ) ||
        ( typeof one == 'boolean' && typeof two == 'boolean' )
     ) {
        return one === two
    }

    // When we’re working with time representations, compare the “pick” value.
    if (
        ( _.isDate( one ) || $.isArray( one ) ) &&
        ( _.isDate( two ) || $.isArray( two ) )
    ) {
        return clock.create( one ).pick === clock.create( two ).pick
    }

    // When we’re working with range objects, compare the “from” and “to”.
    if ( $.isPlainObject( one ) && $.isPlainObject( two ) ) {
        return clock.isTimeExact( one.from, two.from ) && clock.isTimeExact( one.to, two.to )
    }

    return false
}


/**
 * Check if two time units overlap.
 */
TimePicker.prototype.isTimeOverlap = function( one, two ) {

    var clock = this

    // When we’re working with an integer, compare the hours.
    if ( _.isInteger( one ) && ( _.isDate( two ) || $.isArray( two ) ) ) {
        return one === clock.create( two ).hour
    }
    if ( _.isInteger( two ) && ( _.isDate( one ) || $.isArray( one ) ) ) {
        return two === clock.create( one ).hour
    }

    // When we’re working with range objects, check if the ranges overlap.
    if ( $.isPlainObject( one ) && $.isPlainObject( two ) ) {
        return clock.overlapRanges( one, two )
    }

    return false
}


/**
 * Flip the “enabled” state.
 */
TimePicker.prototype.flipEnable = function(val) {
    var itemObject = this.item
    itemObject.enable = val || (itemObject.enable == -1 ? 1 : -1)
}


/**
 * Mark a collection of times as “disabled”.
 */
TimePicker.prototype.deactivate = function( type, timesToDisable ) {

    var clock = this,
        disabledItems = clock.item.disable.slice(0)


    // If we’re flipping, that’s all we need to do.
    if ( timesToDisable == 'flip' ) {
        clock.flipEnable()
    }

    else if ( timesToDisable === false ) {
        clock.flipEnable(1)
        disabledItems = []
    }

    else if ( timesToDisable === true ) {
        clock.flipEnable(-1)
        disabledItems = []
    }

    // Otherwise go through the times to disable.
    else {

        timesToDisable.map(function( unitToDisable ) {

            var matchFound

            // When we have disabled items, check for matches.
            // If something is matched, immediately break out.
            for ( var index = 0; index < disabledItems.length; index += 1 ) {
                if ( clock.isTimeExact( unitToDisable, disabledItems[index] ) ) {
                    matchFound = true
                    break
                }
            }

            // If nothing was found, add the validated unit to the collection.
            if ( !matchFound ) {
                if (
                    _.isInteger( unitToDisable ) ||
                    _.isDate( unitToDisable ) ||
                    $.isArray( unitToDisable ) ||
                    ( $.isPlainObject( unitToDisable ) && unitToDisable.from && unitToDisable.to )
                ) {
                    disabledItems.push( unitToDisable )
                }
            }
        })
    }

    // Return the updated collection.
    return disabledItems
} //TimePicker.prototype.deactivate


/**
 * Mark a collection of times as “enabled”.
 */
TimePicker.prototype.activate = function( type, timesToEnable ) {

    var clock = this,
        disabledItems = clock.item.disable,
        disabledItemsCount = disabledItems.length

    // If we’re flipping, that’s all we need to do.
    if ( timesToEnable == 'flip' ) {
        clock.flipEnable()
    }

    else if ( timesToEnable === true ) {
        clock.flipEnable(1)
        disabledItems = []
    }

    else if ( timesToEnable === false ) {
        clock.flipEnable(-1)
        disabledItems = []
    }

    // Otherwise go through the disabled times.
    else {

        timesToEnable.map(function( unitToEnable ) {

            var matchFound,
                disabledUnit,
                index,
                isRangeMatched

            // Go through the disabled items and try to find a match.
            for ( index = 0; index < disabledItemsCount; index += 1 ) {

                disabledUnit = disabledItems[index]

                // When an exact match is found, remove it from the collection.
                if ( clock.isTimeExact( disabledUnit, unitToEnable ) ) {
                    matchFound = disabledItems[index] = null
                    isRangeMatched = true
                    break
                }

                // When an overlapped match is found, add the “inverted” state to it.
                else if ( clock.isTimeOverlap( disabledUnit, unitToEnable ) ) {
                    if ( $.isPlainObject( unitToEnable ) ) {
                        unitToEnable.inverted = true
                        matchFound = unitToEnable
                    }
                    else if ( $.isArray( unitToEnable ) ) {
                        matchFound = unitToEnable
                        if ( !matchFound[2] ) matchFound.push( 'inverted' )
                    }
                    else if ( _.isDate( unitToEnable ) ) {
                        matchFound = [ unitToEnable.getFullYear(), unitToEnable.getMonth(), unitToEnable.getDate(), 'inverted' ]
                    }
                    break
                }
            }

            // If a match was found, remove a previous duplicate entry.
            if ( matchFound ) for ( index = 0; index < disabledItemsCount; index += 1 ) {
                if ( clock.isTimeExact( disabledItems[index], unitToEnable ) ) {
                    disabledItems[index] = null
                    break
                }
            }

            // In the event that we’re dealing with an overlap of range times,
            // make sure there are no “inverted” times because of it.
            if ( isRangeMatched ) for ( index = 0; index < disabledItemsCount; index += 1 ) {
                if ( clock.isTimeOverlap( disabledItems[index], unitToEnable ) ) {
                    disabledItems[index] = null
                    break
                }
            }

            // If something is still matched, add it into the collection.
            if ( matchFound ) {
                disabledItems.push( matchFound )
            }
        })
    }

    // Return the updated collection.
    return disabledItems.filter(function( val ) { return val != null })
} //TimePicker.prototype.activate


/**
 * The division to use for the range intervals.
 */
TimePicker.prototype.i = function( type, value/*, options*/ ) {
    return _.isInteger( value ) && value > 0 ? value : this.item.interval
}


/**
 * Create a string for the nodes in the picker.
 */
TimePicker.prototype.nodes = function( isOpen ) {

    var
        clock = this,
        settings = clock.settings,
        selectedObject = clock.item.select,
        highlightedObject = clock.item.highlight,
        viewsetObject = clock.item.view,
        disabledCollection = clock.item.disable

    return _.node(
        'ul',
        _.group({
            min: clock.item.min.pick,
            max: clock.item.max.pick,
            i: clock.item.interval,
            node: 'li',
            item: function( loopedTime ) {
                loopedTime = clock.create( loopedTime )
                var timeMinutes = loopedTime.pick,
                    isSelected = selectedObject && selectedObject.pick == timeMinutes,
                    isHighlighted = highlightedObject && highlightedObject.pick == timeMinutes,
                    isDisabled = disabledCollection && clock.disabled( loopedTime )
                return [
                    _.trigger( clock.formats.toString, clock, [ _.trigger( settings.formatLabel, clock, [ loopedTime ] ) || settings.format, loopedTime ] ),
                    (function( klasses ) {

                        if ( isSelected ) {
                            klasses.push( settings.klass.selected )
                        }

                        if ( isHighlighted ) {
                            klasses.push( settings.klass.highlighted )
                        }

                        if ( viewsetObject && viewsetObject.pick == timeMinutes ) {
                            klasses.push( settings.klass.viewset )
                        }

                        if ( isDisabled ) {
                            klasses.push( settings.klass.disabled )
                        }

                        return klasses.join( ' ' )
                    })( [ settings.klass.listItem ] ),
                    'data-pick=' + loopedTime.pick + ' ' + _.ariaAttr({
                        role: 'option',
                        selected: isSelected && clock.$node.val() === _.trigger(
                                clock.formats.toString,
                                clock,
                                [ settings.format, loopedTime ]
                            ) ? true : null,
                        activedescendant: isHighlighted ? true : null,
                        disabled: isDisabled ? true : null
                    })
                ]
            }
        }) +

        // * For Firefox forms to submit, make sure to set the button’s `type` attribute as “button”.
        _.node(
            'li',
            _.node(
                'button',
                settings.clear,
                settings.klass.buttonClear,
                'type=button data-clear=1' + ( isOpen ? '' : ' disabled' ) + ' ' +
                _.ariaAttr({ controls: clock.$node[0].id })
            ),
            '', _.ariaAttr({ role: 'presentation' })
        ),
        settings.klass.list,
        _.ariaAttr({ role: 'listbox', controls: clock.$node[0].id })
    )
} //TimePicker.prototype.nodes







/* ==========================================================================
   Extend the picker to add the component with the defaults.
   ========================================================================== */

TimePicker.defaults = (function( prefix ) {

    return {

        // Clear
        clear: 'Clear',

        // The format to show on the `input` element
        format: 'h:i A',

        // The interval between each time
        interval: 30,

        // Classes
        klass: {

            picker: prefix + ' ' + prefix + '--time',
            holder: prefix + '__holder',

            list: prefix + '__list',
            listItem: prefix + '__list-item',

            disabled: prefix + '__list-item--disabled',
            selected: prefix + '__list-item--selected',
            highlighted: prefix + '__list-item--highlighted',
            viewset: prefix + '__list-item--viewset',
            now: prefix + '__list-item--now',

            buttonClear: prefix + '__button--clear'
        }
    }
})( Picker.klasses().picker )





/**
 * Extend the picker to add the time picker.
 */
Picker.extend( 'pickatime', TimePicker )


}));






(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "baldric": { "today": "Today", "clear": "Clear" } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "Baldric": {
    "en": "static-1.135"
  }
};
  result.translationsAvailable = {
  "Baldric": {
    "de": "static-1.135",
    "en": "static-1.135",
    "es": "static-1.135",
    "fr": "static-1.135",
    "ja": "static-1.135",
    "pt-br": "static-1.135"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:Baldric:en', {version: 'static-1.135'}); }
})();


(function () {
hubspot.define('hubspot.baldric.theme', ['jQuery'], function($) {
  return $.fn.pickadate.defaults.klass.picker = 'baldric picker';
});
}());

(function () {
hubspot.define('hubspot.baldric.i18n', ['hubspot.baldric.localeImport'], function(localeImport) {
  var update;
  update = function() {
    if (I18n.fired && I18n.fired.ready) {
      return localeImport();
    }
  };
  if (!((typeof I18n !== "undefined" && I18n !== null ? I18n.when : void 0) || (typeof I18n !== "undefined" && I18n !== null ? I18n.isNewLoader : void 0))) {
    console.error('Baldric: Loaded before I18n, preventing localization. See https://git.hubteam.com/HubSpot/Baldric/issues/15');
  }
  if (typeof I18n !== "undefined" && I18n !== null) {
    if (typeof I18n.when === "function") {
      I18n.when('ready', update);
    }
  }
  if (typeof I18n !== "undefined" && I18n !== null) {
    if (typeof I18n.on === "function") {
      I18n.on('change:locale', update);
    }
  }
  if (typeof I18n !== "undefined" && I18n !== null ? I18n.isNewLoader : void 0) {
    return I18n.Info.then(update);
  }
});
}());

(function () {
hubspot.define('hubspot.baldric.localeImport', ['jQuery'], function($) {
  return function() {
    var code, data, e, error, error1, message;
    try {
      code = (I18n.moment.locale || I18n.moment.lang)();
      data = (I18n.moment.localeData || I18n.moment.langData)(code);
    } catch (error) {
      e = error;
      throw new Error("Baldric error: I18n.moment must exist for a locale to be imported.");
    }
    if (data == null) {
      message = "No moment locale data available for " + code + ", Baldric will not be localized";
      console.error(message);
      return typeof Raven !== "undefined" && Raven !== null ? typeof Raven.captureMessage === "function" ? Raven.captureMessage(message) : void 0 : void 0;
    } else {
      try {
        return $.extend($.fn.pickadate.defaults, {
          monthsFull: data._months,
          monthsShort: data._monthsShort,
          weekdaysFull: data._weekdays,
          weekdaysShort: data._weekdaysMin,
          firstDay: data._week.dow,
          format: data.longDateFormat('L').toLowerCase(),
          formatSubmit: 'mm/dd/yyyy',
          hiddenSuffix: '_value',
          today: I18n.text('baldric.today'),
          clear: I18n.text('baldric.clear')
        });
      } catch (error1) {
        e = error1;
        throw new Error("Baldric error: Locale " + code + " couldn't be imported");
      }
    }
  };
});
}());

// Hubspot module for this jquery plugin so we don't rely on the jQuery.fn
// namespace and instead have an explicit dep on the plugin.
//
// To use:
//
//    hubspot.require(['pickadate'], function(pickadate) {
//      pickadate($yourElement, { /* ... */ });
//    });
//
hubspot.define('pickadate', [
  'jquery',

  // Don't actually need references to these, but need to depend on them
  'hubspot.baldric.localeImport',
  'hubspot.baldric.i18n',
  'hubspot.baldric.theme'
], function($) {
  return function($element, options) {
    return $.fn.pickadate.call($element, options);
  }
});

// Alias to `baldric` as well
hubspot.define('baldric', ['pickadate'], function(alias) { return alias; });


(function () {
hubspot.require(['hubspot.baldric.theme']);
}());

(function () {
hubspot.require(['hubspot.baldric.i18n']);
}());









//  NOTE, you also need to add this to your app's `en.lyaml` file to make sure
//  that Baldric strings are correctly included (and non-english strings are
//  fetched on-the-fly when necessary)
//
//     require_lang Baldric/static-1.135/lang/*.lyaml
//
//  (I've ommitted the `#=` in front of require to prevent it from actually getting
//  inserted here)





(function() {
  var module = {};
  var result = {};
  module.exports = { "cs": { "analyticsCookiePolicy": { "privacyPolicyWording": "Tyto webové stránky do vašeho počítače ukládají soubory cookie. Soubory cookie používáme, abychom si vás pamatovali, a také ke shromažďování informací o tom, jakým způsobem využíváte naše webové stránky. Získané informace používáme za účelem vylepšování webových stránek, aby se vám s nimi pracovalo co nejlépe, a za účelem zpracování analýz a metrik týkajících se našich návštěvníků jak na těchto webových stránkách, tak v jiných médiích. Podrobnější informace o používaných souborech cookie najdete v našich zásadách ochrany osobních údajů.", "privacyDisclaimerWording": "Pokud to odmítnete, během vaší práce s těmito webovými stránkami nebudeme sledovat informace o vás. Ve vašem prohlížeči se použije jediný soubor cookie, prostřednictvím něhož se uloží informace, že se vaše informace nemají sledovat.", "privacyAcceptWording": "Přijmout", "privacyDismissWording": "Odmítnout" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "da": { "analyticsCookiePolicy": { "privacyPolicyWording": "Denne hjemmeside gemmer cookies på din computer. Disse cookies bruges til at indsamle oplysninger om, hvordan du bruger vores hjemmeside og sørger for, at vi kan huske dig. Oplysningerne bruger vi til at forbedre og tilpasse din oplevelse, så den passer til dig. Ligeledes bruger vi oplysningerne til analyser og målinger omkring besøgende på vores hjemmeside og andre medier. For at få mere at vide om de cookies, vi bruger, kan du læse vores politik om beskyttelse af personlige oplysninger.", "privacyDisclaimerWording": "Hvis du afviser, vil dine oplysninger ikke blive gemt, når du besøger denne hjemmeside. En enkelt cookie vil blive brugt i din browser for at huske dine præferencer, men der gemmes ikke andre oplysninger.", "privacyAcceptWording": "Accepter", "privacyDismissWording": "Afvis" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "de": { "analyticsCookiePolicy": { "privacyPolicyWording": "Diese Website speichert Cookies auf Ihrem Computer. Diese Cookies werden verwendet, um Informationen darüber zu sammeln, wie Sie mit unserer Website interagieren. Wir verwenden diese Informationen, um Ihre Browser-Erfahrung zu verbessern und anzupassen, sowie für Analysen und Messungen zu unseren Besuchern auf dieser Website und anderen Medien. Weitere Informationen zu den von uns verwendeten Cookies finden Sie in unseren Datenschutzbestimmungen.", "privacyDisclaimerWording": "Wenn Sie ablehnen, werden Ihre Informationen beim Besuch dieser Website nicht erfasst. Ein einzelnes Cookie wird in Ihrem Browser verwendet, um daran zu erinnern, dass Sie nicht nachverfolgt werden möchten.", "privacyAcceptWording": "Akzeptieren", "privacyDismissWording": "Ablehnen" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "el": { "analyticsCookiePolicy": { "privacyPolicyWording": "Αυτός ο ιστότοπος αποθηκεύει cookies στον υπολογιστή σας. Αυτά τα cookies χρησιμοποιούνται για τη συλλογή πληροφοριών σχετικά με το πώς αλληλεπιδράτε με τον ιστότοπό μας και μας επιτρέπει να σας θυμόμαστε. Χρησιμοποιούμε αυτές τις πληροφορίες για να βελτιώσουμε και να προσαρμόσουμε την εμπειρία περιήγησής σας και για αναλύσεις και μετρήσεις σχετικά με τους επισκέπτες μας τόσο σε αυτόν τον ιστότοπο όσο και σε άλλα μέσα ενημέρωσης. Για να μάθετε περισσότερα σχετικά με τα cookies που χρησιμοποιούμε, ανατρέξτε στην Πολιτική Προστασίας Προσωπικών Δεδομένων μας.", "privacyDisclaimerWording": "Εάν απορρίψετε την αποθήκευση των cookies, οι πληροφορίες σας δεν θα παρακολουθούνται όταν επισκέπτεστε αυτόν τον ιστότοπο. Ένα μοναδικό cookie θα χρησιμοποιηθεί στο πρόγραμμα περιήγησής σας για να θυμόμαστε ότι προτιμάτε να μην παρακολουθείστε.", "privacyAcceptWording": "Αποδοχή", "privacyDismissWording": "Απόρριψη" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "analyticsCookiePolicy": { "privacyPolicyWording": "This website stores cookies on your computer. These cookies are used to collect information about how you interact with our website and allow us to remember you. We use this information in order to improve and customize your browsing experience and for analytics and metrics about our visitors both on this website and other media. To find out more about the cookies we use, see our Privacy Policy.", "privacyDisclaimerWording": "If you decline, your information won’t be tracked when you visit this website. A single cookie will be used in your browser to remember your preference not to be tracked.", "privacyAcceptWording": "Accept", "privacyDismissWording": "Decline" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es-mx": { "analyticsCookiePolicy": { "privacyPolicyWording": "Este sitio web almacena cookies en tu computadora. Estas cookies se utilizan para recopilar información acerca de la manera en que interactúas con nuestro sitio web y nos permiten recordarte. Empleamos esta información para mejorar y personalizar tu experiencia de búsqueda, además de generar analíticas y métricas acerca de nuestros visitantes, tanto en este sitio web como en otros medios de comunicación. Para obtener más información sobre las cookies que utilizamos, consulta nuestra Política de Privacidad.", "privacyDisclaimerWording": "Si no aceptas, no se le hará seguimiento a tu información cuando visites este sitio web. Se usará una sola cookie en tu navegador para recordar tu preferencia de que no se te haga seguimiento.", "privacyAcceptWording": "Aceptar", "privacyDismissWording": "Rechazar" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es": { "analyticsCookiePolicy": { "privacyPolicyWording": "Este sitio web almacena cookies en tu ordenador. Estas cookies se utilizan para recopilar información acerca de la forma en que interactúas con nuestro sitio web y recordarlo. Usamos esta información para personalizar y mejorar tu experiencia de navegación y para realizar análisis y recuento de los visitantes, tanto en este sitio web como a través de otros medios. Para obtener más información sobre las cookies que utilizamos, consulta nuestra Política de privacidad.", "privacyDisclaimerWording": "Si no acepta, no realizaremos un seguimiento de su información cuando visite este sitio web. Se usará una única cookie en su navegador para recordar sus preferencias, no para realizar ningún seguimiento.", "privacyAcceptWording": "Aceptar", "privacyDismissWording": "Declinar" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fi": { "analyticsCookiePolicy": { "privacyPolicyWording": "Tämä verkkosivu tallentaa evästeitä tietokoneeseesi. Näitä evästeitä käytetään kerämään tietoa siitä, miten käytät verkkosivuamme, sekä auttamaan meitä muistamaan sinut. Käytämme näitä tietoja selauselämyksesi parantamiseen ja yksilöllistämiseen sekä luomaan analyyseja ja tilastoja sekä verkkosivujemme että muiden medioidemme käytöstä. Lue lisätietoja käyttämistämme evästeistä  tietosuojakäytännöstämme.", "privacyDisclaimerWording": "Jos et hyväksy tätä, tietojasi ei seurata, kun käytät tätä verkkosivua. Selaimessasi käytetään yhtä evästettä, jonka avulla muistamme, että sinua ei saa seurata.", "privacyAcceptWording": "Hyväksy", "privacyDismissWording": "Hylkää" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fr": { "analyticsCookiePolicy": { "privacyPolicyWording": "Ce site web stocke les cookies sur votre ordinateur. Ces cookies sont utilisés pour collecter des informations sur la manière dont vous interagissez avec notre site web et nous permettent de nous souvenir de vous. Nous utilisons ces informations afin d'améliorer et de personnaliser votre expérience de navigation, ainsi que pour l'analyse et les indicateurs concernant nos visiteurs à la fois sur ce site web et sur d'autres supports. Pour en savoir plus sur les cookies que nous utilisons, consultez notre politique de confidentialité.", "privacyDisclaimerWording": "Si vous refusez l'utilisation des cookies, vos informations ne seront pas suivies lors de votre visite sur ce site. Un seul cookie sera utilisé dans votre navigateur afin de se souvenir de ne pas suivre vos préférences.", "privacyAcceptWording": "Accepter", "privacyDismissWording": "Refuser" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "it": { "analyticsCookiePolicy": { "privacyPolicyWording": "Il presente sito Web archivia cookie sul computer dell'utente, che vengono utilizzati per raccogliere informazioni sull'utilizzo del sito e ricordare i comportamenti dell'utente in futuro. I cookie servono a migliorare il sito stesso e offrire un servizio più personalizzato, sia sul sito che tramite altri supporti. Per ulteriori informazioni sui cookie, consultare l'informativa sulla privacy.", "privacyDisclaimerWording": "Se non si accetta l'utilizzo, non verrà tenuta traccia del comportamento durante visita, ma verrà utilizzato un unico cookie nel browser per ricordare che si è scelto di non registrare informazioni sulla navigazione.", "privacyAcceptWording": "Accetto", "privacyDismissWording": "Rifiuto" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ja": { "analyticsCookiePolicy": { "privacyPolicyWording": "このウェブサイトでは、お客様のコンピューターにCookieを保存します。このCookieは、このウェブサイトでのやり取りに関する情報を収集し、お客様を記憶するために使用されます。この情報は、お客様のブラウジング体験を改善し、カスタマイズすること、ならびにこのウェブサイトや他のメディアの訪問者に関する解析と指標を得ることを目的として利用されます。当社で使用するCookieについての詳細は、プライバシーポリシーをご覧ください。", "privacyDisclaimerWording": "拒否した場合、ウェブサイト訪問時にお客様の情報がトラッキングされることはありません。情報のトラッキングを希望しないという指定を記憶するために小さなCookieが1つブラウザーに保存されます。", "privacyAcceptWording": "承認", "privacyDismissWording": "拒否" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ko": { "analyticsCookiePolicy": { "privacyPolicyWording": "이 웹사이트는 귀하의 컴퓨터에 쿠키를 저장합니다. 쿠키는 귀하와 웹사이트 간의 상호작용에 대한 정보를 수집하고 귀하의 방문 사실을 기억하는 데 사용됩니다. 당사는 귀하의 검색 환경을 개선하고 사용자 정의하며, 이 웹사이트와 다른 매체에서 방문자에 대한 분석 및 측정을 위해 이 정보를 사용합니다.", "privacyDisclaimerWording": "거부하는 경우에는 이 웹사이트를 방문할 때 사용자 정보가 추적되지 않습니다. 추적을 원치 않는다는 점을 기억하기 위해 브라우저에서 단일 쿠키가 사용됩니다.", "privacyAcceptWording": "수락", "privacyDismissWording": "거부" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "nl": { "analyticsCookiePolicy": { "privacyPolicyWording": "Deze website slaat cookies op je computer op. Deze cookies worden gebruikt om informatie te verzamelen over hoe je met onze website omgaat en om je te onthouden. We gebruiken deze informatie om je surfervaring te verbeteren en personaliseren, en voor analyse en meetgegevens over onze bezoekers, zowel op deze website als via andere media. Zie ons Privacybeleid voor meer informatie over de cookies die we gebruiken.", "privacyDisclaimerWording": "Als je weigert, zal je informatie niet worden gevolgd bij je bezoek aan deze website. Er wordt een kleine cookie in je browser geplaatst om te onthouden dat je niet gevolgd wilt worden.", "privacyAcceptWording": "Accepteren", "privacyDismissWording": "Weigeren" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "no-no": { "analyticsCookiePolicy": { "privacyPolicyWording": "Dette nettstedet bruker informasjonskapsler på datamaskinen din. Disse informasjonskapslene brukes til å samle inn informasjon om hvordan du bruker nettstedet vårt, og legge til rette for at vi kan huske deg. Vi bruker denne informasjonen til å forbedre og tilpasse nettopplevelsen din og til analyser og målinger av besøkende på både dette nettstedet og andre medier. For å finne ut mer om informasjonskapslene vi bruker, kan du se personvernerklæringen vår.", "privacyDisclaimerWording": "Hvis du avslår, blir ikke informasjonen din sporet når du besøker dette nettstedet. Én enkelt informasjonskapsel blir brukt til å huske preferansen din om ikke å bli sporet.", "privacyAcceptWording": "Godta", "privacyDismissWording": "Avslå" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pl": { "analyticsCookiePolicy": { "privacyPolicyWording": "Ta witryna internetowa przechowuje pliki cookie na komputerze użytkownika. Są one wykorzystywane do zbierania informacji o tym, jak użytkownik wchodzi w interakcje z naszą witryną internetową, i pozwalają nam go zapamiętać. Dane te są wykorzystywane w celu poprawy i dostosowania przeglądania strony do potrzeb użytkownika oraz w celu analizy i pomiarów osób odwiedzających naszą witrynę internetową i inne media. Więcej informacji na temat wykorzystywania plików cookie można znaleźć w naszej Polityce prywatności.", "privacyDisclaimerWording": "Jeśli odmówisz, Twoje informacje nie będą śledzone podczas odwiedzania tej witryny internetowej. Pojedynczy plik cookie zostanie użyty w przeglądarce, aby zapamiętać to ustawienie.", "privacyAcceptWording": "Zaakceptuj", "privacyDismissWording": "Odrzuć" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pt-br": { "analyticsCookiePolicy": { "privacyPolicyWording": "Este site armazena cookies em seu computador. Esses cookies são usados para coletar informações sobre como você interage com nosso site e nos permite lembrar de você. Usamos essas informações para melhorar e personalizar sua experiência e para análises e métricas sobre nossos visitantes, tanto nesse site quanto em outras mídias. Para obter mais informações sobre os cookies que usamos, leia nossa Política de Privacidade.", "privacyDisclaimerWording": "Se você recusar, suas informações não serão rastreadas quando você acessar este site. Um cookie simples será usado em seu navegador para lembrar sobre sua preferência de não ser rastreado.", "privacyAcceptWording": "Aceitar", "privacyDismissWording": "Recusar" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "sv": { "analyticsCookiePolicy": { "privacyPolicyWording": "Den här webbplatsen sparar cookie-filer på din dator. Cookie-filer används för att samla in information om hur du interagerar med vår webbplats samt för att känna ihåg dig. Vi använder cookie-filer för att förbättra och anpassa din upplevelse av webbplatsen, sammanställa statistik och göra analyser om våra besökare på webbplatsen och i andra medier. Mer information om vilka cookie-filer vi använder finns i vår sekretesspolicy.", "privacyDisclaimerWording": "Om du avböjer kommer vi inte att spåra dig när du besöker vår webbplats. För att kunna respektera dina önskemål måste vi dock placera en enda cookie-fil i din webbläsare för att våra system ska kunna se att du inte får spåras.", "privacyAcceptWording": "Acceptera", "privacyDismissWording": "Avböj" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-cn": { "analyticsCookiePolicy": { "privacyPolicyWording": "本网站会在您的计算机上存储 Cookie。这些 Cookie 用于收集与您与我们的网站互动相关的信息并让我们能够记住您。我们收集这些信息的目的在于在本网站及其他媒体上改善您的浏览体验、向您提供更具个性化的服务，以及分析和衡量访客情况。要了解与我们使用的 Cookie 有关的更多信息，请查看我们的“隐私政策”。", "privacyDisclaimerWording": "如果您拒绝，那么在您访问本网站时，系统将不会跟踪您的信息。您的浏览器中将存储一个 Cookie，以记住您的偏好（即不希望被跟踪）。", "privacyAcceptWording": "接受", "privacyDismissWording": "拒绝" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-hk": { "analyticsCookiePolicy": { "privacyPolicyWording": "此網站在你的電腦儲存 Cookie。這些 Cookie 用作收集你如何與我們網站互動的資訊，並讓我們記得你。我們會將此資訊用作改善和自訂你的瀏覽體驗，並分析和量度此網站和其他媒體的訪客數據。若要進一步了解我們使用的 Cookie，請查看我們的《私隱政策》。", "privacyDisclaimerWording": "如果你拒絕，當你造訪我們的網站時，我們不會追蹤你的資訊。我們會在你的瀏覽器使用單個 Cookie，用作記得你偏好不被追蹤。", "privacyAcceptWording": "接受", "privacyDismissWording": "拒絕" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "settings-ui-app": {
    "cs": "static-1.16253",
    "da": "static-1.16253",
    "de": "static-1.16253",
    "el": "static-1.16253",
    "en": "static-1.16253",
    "es-mx": "static-1.16253",
    "es": "static-1.16253",
    "fi": "static-1.16253",
    "fr": "static-1.16253",
    "it": "static-1.16253",
    "ja": "static-1.16253",
    "ko": "static-1.16253",
    "nl": "static-1.16253",
    "no": "static-1.16253",
    "pl": "static-1.16253",
    "pt-br": "static-1.16253",
    "sv": "static-1.16253",
    "zh-cn": "static-1.16253",
    "zh-hk": "static-1.16253"
  }
};
  hns('I18n', result);

})();









